
(function(){
const API='https://mat-group-configurator-production.up.railway.app';
const fmt=n=>'A$'+n.toLocaleString('en-AU',{minimumFractionDigits:Number.isInteger(Math.round(n*100)/100)?0:2,maximumFractionDigits:2});
const $=id=>document.getElementById(id);

// PrintPlush MM Colour Chart — EXACT colours from official chart only
// Format: [mm_code, hex, name, category]
// These are the ONLY colours available for printing
const MM=[
  // DARK backgrounds (recommended)
  ['MM114','#651D32','Deep Burgundy (PMS 7421c)','dark'],
  ['MM100','#651D32','Deep Burgundy (PMS 7421c)','dark'],
  ['MM390','#912F46','Burgundy (PMS 7637c)','dark'],
  ['MM483','#584446','Dark Plum Grey (PMS 438c)','dark'],
  ['MM442','#874B52','Dusty Burgundy (PMS 4985c)','dark'],
  ['MM112','#971B2F','Deep Red (PMS 7427c)','dark'],
  ['MM311','#A6192E','Classic Red (PMS 187c)','dark'],
  ['MM397','#7C2529','Maroon (PMS 1815c)','dark'],
  ['MM384','#4F2C1D','Dark Brown (PMS 4625c)','dark'],
  ['MM474','#85431E','Rust Brown (PMS 7517c)','dark'],
  ['MM111','#5C462B','Brown (PMS 462c)','dark'],
  ['MM399','#3D441E','Deep Olive (PMS 5747c)','dark'],
  ['MM435','#3E4827','Dark Olive (PMS 5743c)','dark'],
  ['MM110','#046A38','Forest Green (PMS 349c)','dark'],
  ['MM117','#395542','Dark Sage (PMS 7736c)','dark'],
  ['MM385','#284734','Dark Forest Green (PMS 553c)','dark'],
  ['MM432','#006A52','Dark Emerald (PMS 3298c)','dark'],
  ['MM386','#0D5257','Dark Teal (PMS 7476c)','dark'],
  ['MM423','#006269','Deep Teal (PMS 7715c)','dark'],
  ['MM369','#003D4C','Dark Teal Navy (PMS 548c)','dark'],
  ['MM420','#003E51','Deep Teal Blue (PMS 3035c)','dark'],
  ['MM121','#425563','Slate Blue-Grey (PMS 7545c)','dark'],
  ['MM308','#425563','Slate Blue-Grey (PMS 7545c)','dark'],
  ['MM421','#01426A','Deep Blue (PMS 7694c)','dark'],
  ['MM404','#004680','Dark Blue (PMS 2154c)','dark'],
  ['MM107','#004C97','Royal Blue (PMS 2945c)','dark'],
  ['MM118','#071D49','Navy (PMS 2768c)','dark'],
  ['MM398','#003DA5','Cobalt Blue (PMS 293c)','dark'],
  ['MM429','#141B4D','Deep Navy (PMS 2766c)','dark'],
  ['MM479','#500778','Deep Purple (PMS 2607c)','dark'],
  ['MM105','#470A68','Dark Purple (PMS 2617c)','dark'],
  ['MM391','#4B384C','Dark Plum (PMS 7448c)','dark'],
  ['MM454','#642667','Purple (PMS 260c)','dark'],
  ['MM392','#A20067','Deep Magenta (PMS 234c)','dark'],
  ['MM444','#55453E','Dark Taupe (PMS 4905c)','dark'],
  ['MM388','#4B4F54','Dark Grey (PMS 7540c)','dark'],
  ['MM101','#53565A','Dark Cool Grey (PMS Cool Grey 11c)','dark'],
  ['MM108','#2C2C2C','Black','dark'],
  // MEDIUM
  ['MM452','#EA5C90','Hot Pink (PMS 2039u)','medium'],
  ['MM407','#C16784','Rose Pink (PMS 7634c)','medium'],
  ['MM451','#CE0F69','Cerise Pink (PMS 214c)','medium'],
  ['MM119','#C6858F','Dusty Pink (PMS 500c)','medium'],
  ['MM440','#E40046','Raspberry Red (PMS 192c)','medium'],
  ['MM409','#E03E52','Coral Red (PMS 710c)','medium'],
  ['MM443','#D22630','Bright Red (PMS 1795c)','medium'],
  ['MM439','#B7312C','Brick Red (PMS 7620c)','medium'],
  ['MM465','#FF7865','Coral (PMS 171u)','medium'],
  ['MM471','#866761','Mocha (PMS 7615c)','medium'],
  ['MM482','#AE928C','Rosy Taupe (PMS 7614u)','medium'],
  ['MM415','#C63527','Red-Orange (PMS 7626c)','medium'],
  ['MM382','#A37F74','Taupe (PMS 7614c)','medium'],
  ['MM126','#B15533','Burnt Orange (PMS 7592c)','medium'],  ['MM477','#C0A392','Light Taupe (PMS 4735c)','medium'],
  ['MM473','#AD7C59','Caramel (PMS 4645c)','medium'],
  ['MM383','#BF9474','Warm Tan (PMS 4655c)','medium'],
  ['MM127','#FF8F1C','Orange (PMS 1495c)','medium'],
  ['MM401','#C88242','Golden Tan (PMS 722c)','medium'],
  ['MM102','#8B5B29','Medium Brown (PMS 464c)','medium'],
  ['MM475','#B79A81','Mushroom (PMS 2312c)','medium'],
  ['MM464','#EE9D26','Warm Gold (PMS 7408u)','medium'],
  ['MM103','#C69214','Deep Gold (PMS 1245c)','medium'],
  ['MM363','#9A7611','Old Gold (PMS 126c)','medium'],
  ['MM467','#AC8400','Mustard Gold (PMS 118c)','medium'],
  ['MM123','#9D9272','Khaki (PMS 7503u)','medium'],
  ['MM437','#8F7E35','Olive Gold (PMS 7768c)','medium'],
  ['MM472','#7E7D41','Olive (PMS 392u)','medium'],
  ['MM366','#84BD00','Bright Green (PMS 376c)','medium'],
  ['MM430','#6BA539','Grass Green (PMS 7737c)','medium'],
  ['MM340','#006F44','Emerald Green (PMS 7727c)','medium'],
  ['MM436','#60766F','Sage Grey (PMS 5545u)','medium'],
  ['MM402','#009CAB','Teal (PMS 32ou)','medium'],
  ['MM426','#008CA0','Ocean Teal (PMS 2230c)','medium'],
  ['MM306','#00AFD7','Cyan Blue (PMS 638c)','medium'],
  ['MM104','#007396','Petrol Blue (PMS 633c)','medium'],
  ['MM422','#81B0D2','Light Blue (PMS 2169c)','medium'],
  ['MM408','#4698CB','Medium Blue (PMS 7688c)','medium'],
  ['MM427','#7BA6DE','Cornflower Blue (PMS 7453c)','medium'],
  ['MM428','#418FDE','Bright Blue (PMS 279c)','medium'],
  ['MM478','#9FAEE5','Periwinkle (PMS 2716c)','medium'],
  ['MM413','#A7A4E0','Lavender Blue (PMS 2705c)','medium'],
  ['MM480','#7B798E','Slate Purple (PMS 2360c)','medium'],
  ['MM481','#8D89A5','Dusty Lavender (PMS 5285c)','medium'],
  ['MM393','#9991A4','Lilac Grey (PMS 7660c)','medium'],
  ['MM335','#EB6FBD','Pink (PMS 224c)','medium'],
  ['MM459','#AE2573','Magenta (PMS 675c)','medium'],
  ['MM449','#7A7B75','Stone Grey (PMS 418u)','medium'],
  ['MM115','#707372','Mid Grey (PMS 424c)','medium'],
  ['MM448','#819595','Teal Grey (PMS 5497u)','medium'],
  ['MM116','#7C878E','Blue Grey (PMS 430c)','medium'],
  ['MM411','#5B6770','Dark Blue-Grey (PMS 431c)','medium'],
  ['MM387','#768692','Steel Grey (PMS 7544c)','medium'],
  // LIGHT (caution — show dirt faster)
  ['MM460','#F5DADF','Pale Pink (PMS 705c)','light'],
  ['MM455','#F2A1B2','Light Pink (PMS 197u)','light'],
  ['MM414','#F4C3CB','Baby Pink (PMS 196u)','light'],
  ['MM453','#E1B7A7','Light Salmon (PMS 7513c)','light'],
  ['MM463','#FFB782','Peach (PMS 2017u)','light'],
  ['MM381','#F1C6A7','Light Peach (PMS 474c)','light'],
  ['MM458','#D7C4B7','Light Sand (PMS 4755c)','light'],
  ['MM469','#EFB661','Apricot (PMS 2009c)','light'],
  ['MM476','#EFD19F','Pale Sand (PMS 155c)','light'],
  ['MM418','#F0CC81','Pale Gold (PMS 7403u)','light'],
  ['MM468','#F2C75C','Light Gold (PMS 141c)','light'],
  ['MM109','#F1C400','Gold Yellow (PMS 7406c)','light'],
  ['MM128','#FEDD00','Bright Yellow (PMS Yellow c)','light'],
  ['MM395','#ECD898','Cream Gold (PMS 7402c)','light'],
  ['MM394','#F1E6B2','Cream (PMS 7499c)','light'],
  ['MM466','#D0C883','Pale Khaki (PMS 616c)','light'],
  ['MM416','#E6DE77','Pale Yellow (PMS 609c)','light'],
  ['MM433','#BABC16','Chartreuse (PMS 7744c)','light'],
  ['MM470','#D2D755','Lime Yellow (PMS 584c)','light'],
  ['MM403','#CED665','Pale Lime (PMS 584u)','light'],
  ['MM434','#CDEA80','Light Lime (PMS 373c)','light'],
  ['MM412','#C7E995','Pale Green (PMS 2282c)','light'],
  ['MM431','#ADDFB3','Mint Green (PMS 2254c)','light'],
  ['MM130','#2DCCD3','Turquoise (PMS 319c)','light'],
  ['MM406','#8DC8E8','Sky Blue (PMS 2905c)','light'],
  ['MM106','#8DC8E8','Sky Blue (PMS 2905c)','light'],
  ['MM405','#9DB4C4','Pale Blue-Grey (PMS 5435u)','light'],
  ['MM417','#92C1E9','Light Sky Blue (PMS 283c)','light'],
  ['MM457','#CBA3D8','Lilac (PMS 2563c)','light'],
  ['MM389','#E6BCD8','Pale Lilac Pink (PMS 671c)','light'],
  ['MM450','#D0C4C5','Pale Mauve Grey (PMS 434c)','light'],
  ['MM445','#E4D5D3','Pale Rose Grey (PMS 7604c)','light'],
  ['MM120','#C5B9AC','Sand Grey (PMS 7528c)','light'],
  ['MM447','#F5F0E8','Off White','light'],
  ['MM419','#DAD9D6','Very Light Grey (PMS Cool Grey 1u)','light'],
  ['MM446','#BBBCBC','Light Grey (PMS Cool Grey 4c)','light'],
  ['MM400','#D0D3D4','Pale Grey (PMS 427c)','light'],
];

// ── COLOUR QUANTISATION ENGINE ──
// Converts customer's image colours to nearest PrintPlush PMS colours
// This ensures the preview shows EXACTLY what will be printed

// Pre-compute RGB values for all MM colours for fast lookup
const MM_RGB = MM.map(([mm, hex, name, cat]) => {
  const r = parseInt(hex.slice(1,3), 16);
  const g = parseInt(hex.slice(3,5), 16);
  const b = parseInt(hex.slice(5,7), 16);
  return { mm, hex, name, cat, r, g, b };
});

function rgbToLab(r, g, b) {
  const f = v => { v /= 255; return v > 0.04045 ? Math.pow((v + 0.055) / 1.055, 2.4) : v / 12.92; };
  const R = f(r), G = f(g), B = f(b);
  const x = (R * 0.4124 + G * 0.3576 + B * 0.1805) / 0.95047, y = R * 0.2126 + G * 0.7152 + B * 0.0722, z = (R * 0.0193 + G * 0.1192 + B * 0.9505) / 1.08883;
  const t = v => v > 0.008856 ? Math.cbrt(v) : 7.787 * v + 16 / 116;
  const fx = t(x), fy = t(y), fz = t(z);
  return [116 * fy - 16, 500 * (fx - fy), 200 * (fy - fz)];
}
MM_RGB.forEach(c => { c.lab = rgbToLab(c.r, c.g, c.b); });

// CIEDE2000: perceptual colour difference, so a colour lands on the chart entry a person would pick
function deltaE2000(l1, l2) {
  const [L1, a1, b1] = l1, [L2, a2, b2] = l2;
  const C1 = Math.hypot(a1, b1), C2 = Math.hypot(a2, b2), Cm = (C1 + C2) / 2;
  const G = 0.5 * (1 - Math.sqrt(Math.pow(Cm, 7) / (Math.pow(Cm, 7) + Math.pow(25, 7))));
  const a1p = a1 * (1 + G), a2p = a2 * (1 + G);
  const C1p = Math.hypot(a1p, b1), C2p = Math.hypot(a2p, b2);
  const hh = (a, b) => { if (a === 0 && b === 0) return 0; let d = Math.atan2(b, a) * 180 / Math.PI; return d < 0 ? d + 360 : d; };
  const h1p = hh(a1p, b1), h2p = hh(a2p, b2);
  const dLp = L2 - L1, dCp = C2p - C1p;
  let dhp = 0; if (C1p * C2p !== 0) { dhp = h2p - h1p; if (dhp > 180) dhp -= 360; else if (dhp < -180) dhp += 360; }
  const dHp = 2 * Math.sqrt(C1p * C2p) * Math.sin(dhp / 2 * Math.PI / 180);
  const Lm = (L1 + L2) / 2, Cmp = (C1p + C2p) / 2;
  let Hm; if (C1p * C2p === 0) Hm = h1p + h2p; else { Hm = (h1p + h2p) / 2; if (Math.abs(h1p - h2p) > 180) Hm += Hm < 180 ? 180 : -180; }
  const T = 1 - 0.17 * Math.cos((Hm - 30) * Math.PI / 180) + 0.24 * Math.cos(2 * Hm * Math.PI / 180) + 0.32 * Math.cos((3 * Hm + 6) * Math.PI / 180) - 0.20 * Math.cos((4 * Hm - 63) * Math.PI / 180);
  const SL = 1 + 0.015 * Math.pow(Lm - 50, 2) / Math.sqrt(20 + Math.pow(Lm - 50, 2)), SC = 1 + 0.045 * Cmp, SH = 1 + 0.015 * Cmp * T;
  const RT = -2 * Math.sqrt(Math.pow(Cmp, 7) / (Math.pow(Cmp, 7) + Math.pow(25, 7))) * Math.sin(60 * Math.exp(-Math.pow((Hm - 275) / 25, 2)) * Math.PI / 180);
  return Math.sqrt(Math.pow(dLp / SL, 2) + Math.pow(dCp / SC, 2) + Math.pow(dHp / SH, 2) + RT * (dCp / SC) * (dHp / SH));
}

function findNearestPMS(r, g, b) {
  if (gradeOf().chart !== 'mm') return nearestInTable(familyTable(), r, g, b); // v2: PrintScraper / SpiralLoop / Superguard / embossed charts
  // Snap rules for common colours that JPEG compression distorts
  const luminance = 0.299*r + 0.587*g + 0.114*b;
  const saturation = Math.max(r,g,b) - Math.min(r,g,b);

  // Only snap to Off White for truly near-white colours (very high lum, very low saturation)
  if (luminance > 240 && saturation < 10) {
    return MM_RGB.find(c => c.mm === 'MM447');
  }
  // Very dark colours → Black
  if (luminance < 60 && saturation < 25) {
    return MM_RGB.find(c => c.mm === 'MM108');
  }

  const lab = rgbToLab(r, g, b);
  let minDist = Infinity;
  let nearest = MM_RGB[0];
  for (const c of familyTable()) {
    const dist = deltaE2000(lab, c.lab);
    if (dist < minDist) { minDist = dist; nearest = c; }
  }
  return nearest;
}

// Cache for colour lookups
const colourCache = {};

// ── FLOOD FILL BACKGROUND REMOVAL ──
// Removes background from corners so chosen PMS background shows through cleanly
function removeBackground(ctx, W, H) {
  const imageData = ctx.getImageData(0, 0, W, H);
  const data = imageData.data;

  // Sample background colour from top-left corner (most common case)
  // Average a small area to handle JPEG artifacts
  let rSum=0, gSum=0, bSum=0, count=0;
  const sampleSize = 5;
  for (let sy=0; sy<sampleSize; sy++) {
    for (let sx=0; sx<sampleSize; sx++) {
      const idx = (sy*W + sx)*4;
      if (data[idx+3] > 10) {
        rSum+=data[idx]; gSum+=data[idx+1]; bSum+=data[idx+2]; count++;
      }
    }
  }
  if (count === 0) return; // fully transparent already

  const bgR = Math.round(rSum/count);
  const bgG = Math.round(gSum/count);
  const bgB = Math.round(bSum/count);

  // Tolerance — how similar a pixel needs to be to be considered background
  // Lower = more precise (won't remove similar-coloured logo elements)
  // Higher = removes more (but risks removing parts of the design)
  const tolerance = 12;

  function colourMatch(r,g,b) {
    return Math.abs(r-bgR) < tolerance &&
           Math.abs(g-bgG) < tolerance &&
           Math.abs(b-bgB) < tolerance;
  }

  // Flood fill from all four corners using iterative stack (avoids stack overflow)
  const visited = new Uint8Array(W * H);
  const stack = [];

  // Seed from corners
  const corners = [0, W-1, (H-1)*W, (H-1)*W + W-1];
  corners.forEach(idx => {
    const r=data[idx*4], g=data[idx*4+1], b=data[idx*4+2], a=data[idx*4+3];
    if (a > 10 && colourMatch(r,g,b) && !visited[idx]) {
      stack.push(idx);
      visited[idx] = 1;
    }
  });

  // Also seed from edges for better coverage
  for (let x=0; x<W; x++) {
    [x, (H-1)*W+x].forEach(idx => {
      const r=data[idx*4], g=data[idx*4+1], b=data[idx*4+2], a=data[idx*4+3];
      if (a > 10 && colourMatch(r,g,b) && !visited[idx]) { stack.push(idx); visited[idx]=1; }
    });
  }
  for (let y=0; y<H; y++) {
    [y*W, y*W+W-1].forEach(idx => {
      const r=data[idx*4], g=data[idx*4+1], b=data[idx*4+2], a=data[idx*4+3];
      if (a > 10 && colourMatch(r,g,b) && !visited[idx]) { stack.push(idx); visited[idx]=1; }
    });
  }

  // Flood fill
  while (stack.length > 0) {
    const idx = stack.pop();
    // Make transparent
    data[idx*4+3] = 0;

    // Check 4 neighbours
    const x = idx % W;
    const y = Math.floor(idx / W);
    const neighbours = [];
    if (x > 0)   neighbours.push(idx - 1);
    if (x < W-1) neighbours.push(idx + 1);
    if (y > 0)   neighbours.push(idx - W);
    if (y < H-1) neighbours.push(idx + W);

    for (const n of neighbours) {
      if (!visited[n]) {
        const r=data[n*4], g=data[n*4+1], b=data[n*4+2], a=data[n*4+3];
        if (a > 10 && colourMatch(r,g,b)) {
          visited[n] = 1;
          stack.push(n);
        }
      }
    }
  }

  ctx.putImageData(imageData, 0, 0);

  // Smooth ONLY pixels that are close to the background colour
  // This cleans up JPEG antialiasing at background edges without affecting design elements
  if (bgR !== undefined) {
    const smoothed = ctx.getImageData(0, 0, W, H);
    const sd = smoothed.data;
    const orig = new Uint8ClampedArray(sd);

    // Get background PMS RGB
    const bgLum = 0.299*bgR + 0.587*bgG + 0.114*bgB;

    for (let y = 1; y < H-1; y++) {
      for (let x = 1; x < W-1; x++) {
        const i = (y * W + x) * 4;
        if (orig[i+3] < 10) continue;

        const r = orig[i], g = orig[i+1], b = orig[i+2];

        // Only smooth pixels that are close to background colour
        const distToBg = Math.abs(r-bgR) + Math.abs(g-bgG) + Math.abs(b-bgB);
        if (distToBg > 80) continue; // skip — this is a design element, not a bg edge

        // Check neighbours — if any neighbour is clearly NOT the background, skip
        const neighbours = [
          (y-1)*W+x, (y+1)*W+x, y*W+(x-1), y*W+(x+1)
        ].map(ni => ni*4);

        let hasNonBgNeighbour = false;
        neighbours.forEach(ni => {
          if(orig[ni+3] < 10) return;
          const nd = Math.abs(orig[ni]-bgR) + Math.abs(orig[ni+1]-bgG) + Math.abs(orig[ni+2]-bgB);
          if(nd > 120) hasNonBgNeighbour = true;
        });

        // If surrounded mostly by bg colour — snap this pixel to bg
        if (!hasNonBgNeighbour) {
          sd[i]   = bgR;
          sd[i+1] = bgG;
          sd[i+2] = bgB;
        }
      }
    }
    ctx.putImageData(smoothed, 0, 0);
  }
}

function quantiseImageToPMS(sourceCanvas, ctx, W, H, recordUsage) {
  const imageData = ctx.getImageData(0, 0, W, H);
  const data = imageData.data;

  // STANDARD GRADE CEILING: PrintPlush through this configurator is Standard Grade only, which
  // prints at most 12 spot colours. So the artwork is reduced to its <=12 most-prominent PMS
  // colours and EVERY pixel is remapped to that palette — the rendered preview, the on-screen
  // swatches and the cart "Design Colours" readout then only ever show the colours we actually
  // print (the dominant ones the customer sees), never a 100-colour spread of the full chart.
  const MAX_PRINT_COLOURS = (typeof logoCap === 'function') ? logoCap() : 12; // artwork colours: 11/12 Standard, 24/25 Commercial (background takes a slot), no cap High Definition (5 Oct 2026)
  const bucketSize = 8;

  // Pass 1: histogram of the artwork's OWN colours (8-level buckets), opaque pixels only. pix[] keeps
  // each pixel's bucket id (65535 = transparent) so the later passes never redo the lookup.
  const list = []; let totalPx = 0;
  const NONE = 65535, pix = new Uint16Array(W * H);
  const bucketLut = new Int32Array(33 * 33 * 33).fill(-1); // quantised (r,g,b) -> bucket id, no text keys, no object lookups (7 Oct 2026: 79 Mpx went from 79 s to a few)
  // Soft edge pixels (partly see-through) show a blend of the artwork and whatever sits behind it: on a logo whose
  // background was removed they keep a grey / tinted fringe that is not a design colour (TMG12598 Westside Cycles,
  // 7 Oct 2026: a white logo listed a second colour, Pale Mauve Grey 450). When most of the artwork is solid, the
  // soft pixels only FOLLOW the nearest colour: they never count towards coverage or shape a cluster.
  const SOLID_ALPHA = 250; let solidPx = 0, softPx = 0;
  for (let i = 3; i < data.length; i += 4) { if (data[i] >= SOLID_ALPHA) solidPx++; else if (data[i] >= 10) softPx++; }
  const softFollows = solidPx > 0 && solidPx >= softPx;
  for (let i = 0, p = 0; i < data.length; i += 4, p++) {
    if (data[i+3] < 10) { pix[p] = NONE; continue; }
    const qr = (data[i] + 4) >> 3, qg = (data[i+1] + 4) >> 3, qb = (data[i+2] + 4) >> 3; // = Math.round(v / 8), 0..32
    const key = (qr * 33 + qg) * 33 + qb;
    let id = bucketLut[key];
    if (id < 0) { id = list.length; bucketLut[key] = id; list.push({ id, r: Math.min(255, qr * bucketSize), g: Math.min(255, qg * bucketSize), b: Math.min(255, qb * bucketSize), n: 0, cl: null }); }
    if (!softFollows || data[i+3] >= SOLID_ALPHA) { list[id].n++; totalPx++; }
    pix[p] = id;
  }
  const byId = list.slice(); // bucket id -> bucket (list itself is re-ordered below)

  // Stage A: cluster the artwork's own colours BEFORE any chart lookup. Buckets are taken most-common
  // first; a bucket joins the nearest cluster when it is within CLUSTER_DE (CIEDE2000) of that
  // cluster's running centre, otherwise it starts a new cluster. A gradient, metallic or shaded
  // rendering of ONE design colour (a gold that runs light-to-deep, a JPEG-softened red) therefore
  // stays ONE colour. Snapping each pixel to the chart on its own used to scatter such a gold over
  // three or four neighbouring chart golds (TMG12567: Light Gold + Apricot + Deep Gold for one gold)
  // and the lettering rendered mottled. Genuinely different design tones (cream vs sand, ~ΔE 30)
  // are further apart than CLUSTER_DE and stay separate.
  list.sort((a, b) => b.n - a.n);
  const CLUSTER_DE = 14;
  const SEED_FLOOR = Math.max(4, totalPx * 0.0005); // only buckets this common shape a cluster; edge/noise buckets just follow
  const MAX_CLUSTERS = 48;
  const clusters = [];
  for (const bk of list) {
    bk.lab = rgbToLab(bk.r, bk.g, bk.b);
    let best = null, bestD = Infinity;
    for (const c of clusters) { const d = deltaE2000(bk.lab, c.lab); if (d < bestD) { bestD = d; best = c; } }
    if (best && bk.n < SEED_FLOOR) { bk.cl = best; best.tail += bk.n; continue; } // anti-alias edge / speckle: follows, no influence
    if (best && (bestD <= CLUSTER_DE || clusters.length >= MAX_CLUSTERS)) {
      const w = best.n + bk.n;
      best.lab = [0, 1, 2].map(k => (best.lab[k] * best.n + bk.lab[k] * bk.n) / w);
      best.r = (best.r * best.n + bk.r * bk.n) / w; best.g = (best.g * best.n + bk.g * bk.n) / w; best.b = (best.b * best.n + bk.b * bk.n) / w;
      best.n = w; bk.cl = best;
    } else {
      const c = { lab: bk.lab.slice(), r: bk.r, g: bk.g, b: bk.b, n: bk.n, tail: 0, entry: null };
      clusters.push(c); bk.cl = c;
    }
  }

  // Stage A2: anti-alias rings. Where two colours meet, the edge pixels are a BLEND of the two (black
  // lettering on gold leaves a thin dark-brown ring) and can add up to over 1% of a fine logo. Such a
  // cluster sits ON the straight line between two more-prominent clusters in Lab AND its pixels touch
  // both of them. It is not a design colour: it is dropped and its pixels follow the nearer colour. A
  // genuine third colour in between (a grey fill on a black/white logo) is a solid area that touches
  // at most one of them, so it stays.
  clusters.sort((a, b) => (b.n + b.tail) - (a.n + a.tail));
  const BLEND_DE = 10, TOUCH = 0.2;
  const cand = [];
  for (let i = 2; i < clusters.length; i++) {
    const c = clusters[i];
    for (let x = 0; x < i && !c.between; x++) for (let y = x + 1; y < i; y++) {
      const a = clusters[x].lab, b = clusters[y].lab;
      const ab = [b[0] - a[0], b[1] - a[1], b[2] - a[2]], len2 = ab[0] * ab[0] + ab[1] * ab[1] + ab[2] * ab[2];
      if (!len2) continue;
      const t = ((c.lab[0] - a[0]) * ab[0] + (c.lab[1] - a[1]) * ab[1] + (c.lab[2] - a[2]) * ab[2]) / len2;
      if (t < 0.1 || t > 0.9) continue;
      if (deltaE2000(c.lab, [a[0] + ab[0] * t, a[1] + ab[1] * t, a[2] + ab[2] * t]) <= BLEND_DE) { c.between = [clusters[x], clusters[y]]; break; }
    }
    if (c.between) cand.push(c);
  }
  if (cand.length) {
    clusters.forEach((c, i) => { c.idx = i; c.touch = {}; });
    for (let p = 0; p < pix.length; p++) {
      const id = pix[p]; if (id === NONE) continue;
      const c = byId[id].cl; if (!c.between) continue;
      const x = p % W, seen = {};
      const nb = [x > 0 ? p - 1 : -1, x < W - 1 ? p + 1 : -1, p - W, p + W];
      for (const q of nb) {
        if (q < 0 || q >= pix.length || pix[q] === NONE) continue;
        const o = byId[pix[q]].cl.idx; if (o !== c.idx && !seen[o]) { seen[o] = 1; c.touch[o] = (c.touch[o] || 0) + 1; }
      }
    }
    for (const c of cand) { const n = c.n + c.tail, [a, b] = c.between; let ta = c.touch[a.idx] || 0, tb = c.touch[b.idx] || 0; for (const o of cand) { if (o === c || o.between[0] !== a || o.between[1] !== b) continue; const t = c.touch[o.idx] || 0; ta = Math.max(ta, t); tb = Math.max(tb, t); } if (ta >= TOUCH * n && tb >= TOUCH * n) c.blend = true; }
  }

  // Stage B: 1% coverage floor on the CLUSTERS (drops anti-aliasing edges and speckle, keeps the
  // genuine design colours), most-prominent first.
  const COVERAGE_THRESHOLD = 0.01;
  let kept = clusters.filter(c => !c.blend && totalPx > 0 && (c.n + c.tail) / totalPx >= COVERAGE_THRESHOLD);
  if (!kept.length) kept = clusters.slice(0, 3); // safety floor: never an empty list (extremely sparse art)

  // PRINT GRADE stats (5 Oct 2026): how many distinct design colours the artwork has and how many of them sit
  // further than DE_OFF from every chart colour (= "no close PrintPlush match"). Drives the grade cards.
  // GRADIENT / PHOTO test (7 Oct 2026): average 4x4 blocks that sit wholly inside one colour. JPEG noise and fibre
  // texture average out, so every block of a flat colour has the same mean; a gradient or a photo keeps moving from
  // block to block. Scored on 108 real artworks and 36 JPEG saves of plain logos: the raw-colour count called 20 of 87
  // flat logos a gradient (every JPEG) and missed 4 of 11 real gradients; this gets all of them.
  let gradShare = 0, gradBlocks = 0;
  if (recordUsage && typeof S !== 'undefined' && W > 0 && H > 0 && W * H === pix.length) {
    const B = 4, nbx = Math.floor(W / B), nby = Math.floor(H / B), stride = Math.max(1, Math.ceil(Math.sqrt(nbx * nby / 60000)));
    for (const c of clusters) c.blocks = [];
    for (let by = 0; by < nby; by += stride) for (let bx = 0; bx < nbx; bx += stride) {
      const p0 = by * B * W + bx * B, id0 = pix[p0]; if (id0 === NONE) continue; const c = byId[id0].cl; let ok = true, r = 0, g = 0, b = 0;
      for (let y = 0; y < B && ok; y++) for (let x = 0, p = p0 + y * W; x < B; x++, p++) { const id = pix[p], i = p * 4; if (id === NONE || byId[id].cl !== c || (softFollows && data[i + 3] < SOLID_ALPHA)) { ok = false; break; } r += data[i]; g += data[i + 1]; b += data[i + 2]; }
      if (!ok) continue; c.blocks.push(rgbToLab(r / 16, g / 16, b / 16)); gradBlocks++;
    }
    let off = 0; const med = a => { const t = a.slice().sort((x, y) => x - y); return t[t.length >> 1]; };
    for (const c of clusters) { if (c.blocks.length) { const m = [0, 1, 2].map(k => med(c.blocks.map(v => v[k]))); for (const v of c.blocks) if (deltaE2000(v, m) > GRADIENT_BLOCK_DE) off++; } c.blocks = null; }
    gradShare = gradBlocks ? Math.round(off / gradBlocks * 1000) / 10 : 0;
  }
  if (recordUsage && typeof S !== 'undefined') {
    const hx = v => '#' + [v.r, v.g, v.b].map(x => Math.max(0, Math.min(255, Math.round(x))).toString(16).padStart(2, '0')).join('').toUpperCase();
    const offList = [];
    for (const c of kept) {
      const pms = findNearestPMS(Math.round(c.r), Math.round(c.g), Math.round(c.b));
      const de = deltaE2000(c.lab, pms.lab);
      if (de > DE_OFF) offList.push({ hex: hx(c), near: { hex: pms.hex, name: pms.name, mm: pms.mm }, de: Math.round(de * 10) / 10 });
    }
    offList.sort((a, b) => b.de - a.de);
    // buckets = distinct 8-level colours before clustering: a flat logo has tens to a few hundred, a gradient or
    // photo has thousands even when the clusterer folds it into a handful of design colours.
    S.colourStats = { fileRef: S.file, distinct: kept.length, off: offList.length, offList, buckets: softFollows ? list.reduce((n, b) => n + (b.n > 0 ? 1 : 0), 0) : list.length, grad: gradShare, gradBlocks }; // soft edge pixels are not raw colours either
  }
  // High Definition prints the artwork exactly as supplied: no remap, no palette.
  if (typeof isHD === 'function' && asSupplied()) {
    if (recordUsage && typeof S !== 'undefined') {
      const tot = kept.reduce((s, c) => s + c.n + (c.tail || 0), 0) || 1;
      const toHex = c => '#' + [c.r, c.g, c.b].map(x => Math.max(0, Math.min(255, Math.round(x))).toString(16).padStart(2, '0')).join('').toUpperCase();
      S.actualPmsUsed = kept.slice().sort((a, b) => (b.n + (b.tail || 0)) - (a.n + (a.tail || 0))).filter(c => (c.n + (c.tail || 0)) / tot >= 0.02).slice(0, 12).map(c => { const hex = toHex(c); return { mm: '', hex, name: hex, raw: true, share: Math.round((c.n + (c.tail || 0)) / tot * 100) }; });
    }
    return;
  }

  // Stage C: ONE chart lookup per kept cluster (its weighted centre), then fold clusters that land on
  // the same or a near-identical chart entry (ΔE <= MERGE_DE, e.g. MM100/MM114 share a hex) so one
  // visual colour is never listed twice; HARD-CAP to 12. This palette is the single source of truth
  // for the render, the swatches and the cart readout.
  const MERGE_DE = 5;
  const palette = []; const matched = {}; // matched = the chart colours the artwork matched BEFORE any customer change
  const nearestEntry = lab => { let e = palette[0], bd = Infinity; for (const p of palette) { const d = deltaE2000(lab, p.lab); if (d < bd) { bd = d; e = p; } } return e; };
  for (const c of kept) {
    const rawPms = findNearestPMS(Math.round(c.r), Math.round(c.g), Math.round(c.b)); if (rawPms) matched[rawPms.mm] = 1;
    const pms = applyColourOverride(rawPms); // v2: the customer may have picked another chart colour
    let entry = palette.find(p => p.mm === pms.mm || deltaE2000(p.lab, pms.lab) <= MERGE_DE);
    if (!entry) {
      if (palette.length >= MAX_PRINT_COLOURS) entry = nearestEntry(pms.lab); // over the 12-colour ceiling: nearest printable colour
      else { entry = { mm: pms.mm, hex: pms.hex, name: pms.name, r: pms.r, g: pms.g, b: pms.b, lab: pms.lab, pms: !!pms.pms }; palette.push(entry); }
    }
    entry.n = (entry.n || 0) + c.n + (c.tail || 0); // coverage, for the order line
    c.entry = entry;
  }
  for (const c of clusters) if (!c.entry) { c.entry = nearestEntry(c.lab); if (c.entry) c.entry.n = (c.entry.n || 0) + c.n + (c.tail || 0); } // dropped (sub-1%) clusters follow the nearest printable colour
  // onecolour1016: keep the outlines when the cap merges colours. On a cut or embossed mat the base shows between shapes, so where
  // two DIFFERENT design colours were folded into the SAME mat colour, a gap of the family's minimum width is left along the line
  // where they meet (a red disc with white lettering reduced to one colour keeps the letters; two touching shapes stay two shapes).
  function keepMergedOutlines() {
    if (typeof isCut !== 'function' || !(isCut() || isRaised()) || MAX_PRINT_COLOURS > 4 || palette.length >= kept.length) return;
    const keptSet = new Set(kept); // every cluster stands for its nearest KEPT design colour (blend rings and specks follow)
    for (const c of clusters) { if (keptSet.has(c)) { c.rep = c; continue; } let best = kept[0], bd = Infinity; for (const k of kept) { const d = deltaE2000(c.lab, k.lab); if (d < bd) { bd = d; best = k; } } c.rep = best; }
    const inner = new Map(), tot = new Map(); let opq = 0;
    for (let y = 1; y < H - 1; y++) for (let x = 1; x < W - 1; x++) { const p = y * W + x, id = pix[p]; if (id === NONE) continue; opq++; const a = byId[id].cl.rep; tot.set(a, (tot.get(a) || 0) + 1); const n4 = [p - 1, p + 1, p - W, p + W]; if (n4.every(q => pix[q] !== NONE && byId[pix[q]].cl.rep === a)) inner.set(a, (inner.get(a) || 0) + 1); }
    const solid = k => (tot.get(k) || 0) >= opq * 0.01 && (inner.get(k) || 0) >= (tot.get(k) || 1) * 0.2; // coirbase1016: soft edges and specks never get a gap
    const merged = new Set(); const byEntry = new Map(); for (const k of kept) { if (!solid(k)) continue; const l = byEntry.get(k.entry) || []; l.push(k); byEntry.set(k.entry, l); }
    for (const l of byEntry.values()) if (l.length > 1) l.forEach(k => merged.add(k));
    if (!merged.size) return;
    const repOf = new Array(byId.length); for (let k = 0; k < byId.length; k++) repOf[k] = byId[k].cl.rep;
    const gapMm = (familyCheckOpts().gapMinMm || 5), r = Math.max(1, Math.round(gapMm / 2 / Math.max(0.05, artMmPerPx)));
    const mask = new Uint8Array(W * H); let any = 0;
    for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
      const p = y * W + x, id = pix[p]; if (id === NONE) continue; const a = repOf[id]; if (!merged.has(a)) continue;
      const q1 = x < W - 1 ? p + 1 : -1, q2 = y < H - 1 ? p + W : -1;
      for (const q of [q1, q2]) { if (q < 0 || pix[q] === NONE) continue; const b = repOf[pix[q]]; if (b !== a && b.entry === a.entry) { mask[p] = 1; mask[q] = 1; any = 1; } }
    }
    if (!any) return;
    // widen the boundary line to the gap width (separable box dilation)
    const tmp = new Uint8Array(W * H);
    for (let y = 0; y < H; y++) { let run = -1e9; for (let x = 0; x < W; x++) { if (mask[y * W + x]) run = x; if (x - run <= r) tmp[y * W + x] = 1; } run = 1e9; for (let x = W - 1; x >= 0; x--) { if (mask[y * W + x]) run = x; if (run - x <= r) tmp[y * W + x] = 1; } }
    mask.fill(0);
    for (let x = 0; x < W; x++) { let run = -1e9; for (let y = 0; y < H; y++) { if (tmp[y * W + x]) run = y; if (y - run <= r) mask[y * W + x] = 1; } run = 1e9; for (let y = H - 1; y >= 0; y--) { if (tmp[y * W + x]) run = y; if (run - y <= r) mask[y * W + x] = 1; } }
    for (let p = 0; p < W * H; p++) if (mask[p] && pix[p] !== NONE) { pix[p] = NONE; data[p * 4 + 3] = 0; }
  }

  const psd = familyTileData();
  const artMmPerPx = (0.8 * (S.matWmm || parseInt((S.size || '850x1150').split('x')[0], 10))) / W; // the artwork spans ~80% of the mat width
  const psK = psd ? ((psd.tile / psd.mmPerTile) * artMmPerPx) : 1; // tile px per artwork px
  try { keepMergedOutlines(); } catch (e) { console.warn('[onecolour1016]', e); } // needs artMmPerPx
  // Pass 2: paint EVERY opaque pixel with its cluster's chart colour, so the rendered artwork itself
  // uses only the printable colours (true Standard Grade output) and a shaded colour prints flat.
  if (palette.length) {
    // per-bucket paint colour in flat arrays: one typed-array read per channel instead of three object hops per pixel
    const nb = byId.length, pr = new Uint8Array(nb), pg = new Uint8Array(nb), pb = new Uint8Array(nb);
    for (let k = 0; k < nb; k++) { const e = byId[k].cl.entry; pr[k] = e.r; pg[k] = e.g; pb[k] = e.b; }
    for (let i = 0, p = 0; i < data.length; i += 4, p++) {
      const id = pix[p]; if (id === NONE) continue;
      if (!psd) { data[i] = pr[id]; data[i+1] = pg[id]; data[i+2] = pb[id]; continue; }
      const pc = byId[id].cl.entry;
      if (psd) { // v2: paint the photographed fibre / yarn / loop of this chart colour instead of a flat fill
        const pos = psd.map[pc.mm];
        if (pos) { const x = p % W, y = (p / W) | 0, ti = ((pos.y + (Math.floor(y * psK) % psd.tile)) * psd.w + (pos.x + (Math.floor(x * psK) % psd.tile))) * 4; data[i] = psd.data[ti]; data[i+1] = psd.data[ti+1]; data[i+2] = psd.data[ti+2]; continue; }
      }
      data[i] = pc.r; data[i+1] = pc.g; data[i+2] = pc.b;
    }
  }

  if (palette.length) finishArtworkPixels(data, pix, NONE, id => byId[id].cl.entry, W, H, artMmPerPx, sourceCanvas); // v2: cut seams / raised bevel
  ctx.putImageData(imageData, 0, 0);

  // recordUsage GATE: only an AUTHORITATIVE, full-resolution pass may write the colour readout —
  // the native-size uploaded logo, or the full AI-composited artwork. Downscaled mini/preview
  // passes must NOT overwrite it (downsampling consolidates texture/anti-alias noise and can bury
  // a genuine accent colour). The palette is already capped to <=12, so the readout is too.
  if (recordUsage && typeof S !== 'undefined') {
    const covTot = palette.reduce((s, p) => s + (p.n || 0), 0) || 1;
    S.matchedMms = matched;
    S.actualPmsUsed = palette.slice().sort((a, b) => (b.n || 0) - (a.n || 0)).map(({ mm, hex, name, n, pms }) => ({ mm, hex, name, pms: !!pms, share: Math.round((n || 0) / covTot * 100) })); // most coverage first
  }
}

let S={file:null,validation:null,selectedBg:null,pricing:null,step:1,size:'850x1500',qty:1,bgType:null,grade:'standard',colourStats:null,placement:'inside',drainage:null,edging:null,showOther:false};

// ── PRINT GRADES (5 Oct 2026): Standard / Commercial / High Definition inside the Design Your Own flow ──
// Shared verbatim between the live template (templates/page.configurator.liquid) and the UX mock page.
// Rules (Zac, 5 Oct):
//  - The mat background counts as one printed colour: a logo on a chosen background gets 11 colours on Standard and
//    24 on Commercial; a design that fills the mat (or an AI design) gets 12 / 25. The quantiser keeps the MOST USED.
//  - The grade DEFAULTS to the cheapest one that prints the artwork as it is. Upgrading is always free of questions.
//  - Picking a grade that would reduce the artwork shows ONE confirmation line inside the cards, nothing else.
// ── LOGO MAT FAMILIES v2 (DRAFT, 5 Oct 2026): every logo mat in one flow ──
// Replaces the live GRADES module wholesale (build-v2.js swaps the block). The PrintPlush grades keep the live rules.
// One "grade" = one card = one product family (or one PrintPlush grade). Each card maps to variants on the Design Your
// Own product (option1 Size, option2 Grade = opt, option3 Colour where the family's variant carries a colour), with the
// family's REAL SKUs and prices, so the order line, SKU and Cin7 routing are what the product pages produce today.
//  - PLACEMENT: one question on Configure (Inside or undercover / Outside in the weather / Wet area or over a drain).
//    Each placement lists its cards; "Other mat types" adds the rest. Default = the cheapest card that makes the artwork
//    as supplied; cards that drop colours confirm first; cards that cannot make it at all are greyed, never hidden.
//  - CHARTS: PrintPlush = MM chart; PrintScraper = its 50 codes; SpiralLoop / Superguard / Embossed = their own named
//    swatches (window.TMG_CHARTS, sampled from the product-page swatch photos); as-supplied families print the file.
//  - RENDER: one renderer, per-family SURFACE (plush / scraper fibre tiles / loop tiles / yarn tiles / coir / flock /
//    rubber / felt), EDGE (nitrile / bevel / vinyl / raised / thin / none), COLOUR (flat chart, tiles, cut seams, raised
//    emboss, as supplied).
//  - VALIDATION: printed carpet = the live calibrated thresholds; cut inlays = 8 mm cutter minimum, 10 mm gaps, 50 mm
//    text, no gradients; embossed = same as inlay; as-supplied rasters = resolution warning; Promotional = white warn.
// ── Coir Logo Inlay (14 Oct 2026): every open decision in one place ──
const COIR_INLAY = {
  lead: '3–4 weeks',               // source: Cin7 sales SO-115002 / SO-120735 'approx 3-4wks' + PandaDoc ZB 12670 / ZB 11800 (was 4 weeks from the original Coir Inlay Logo Mat product (coir-inlay-logo-mat) + Coir Embossed lead-time tabs, approx. 4 weeks from proof + payment; the 3 custom-size pages say 3-5 days (copied from plain coir matting, wrong for a laser-cut logo)
  maxLogoColours: 1,               // source: coir-inlay-logo-mat 'Colour Combinations' = base + ONE inlay colour (6 combos), and every product / in-situ photo has one inlay colour
  strokeMinMm: 8, strokeWarnMm: 6, textMinMm: 30, textWarnMm: 25, gapMinMm: 8, gapWarnMm: 6, // no written rule (spec sheet TMG00097 silent): measured on the in-situ photos - INSITU_006 'MALOLO ISLAND' small caps ~25-30 mm and 004 script swashes ~8 mm survive the cut
  rateByBase: { Natural: 137.5, Grey: 170.5, Black: 170.5 }, // per m2 inc GST = the 3 products' custom.rate_per_sqm, what the Railway pricer charges (Cin7 17MM COIR- M2 rows: Natural 120 / Grey 155 / Black 149 ex GST)
  edgeRate: 29.7, logoSmall: 407, logoLarge: 586.3,          // edging per metre of perimeter; logo charge = Cin7 INLAY LOGO SMALL 370 / INLAY LOGO LARGE 533 ex GST (under / from 2 m2)
  wmin: 500, wmax: 2000,
  handleByBase: { Natural: 'coir-logo-inlay-mat', Grey: 'coir-logo-inlay-mat-grey-custom-size', Black: 'coir-logo-inlay-mat-black-custom-size' },
  variantByBase: { Natural: 51039550439591, Grey: 51335781154983, Black: 51335781187751 },
  discounts: true                  // Zac 14 Oct 2026: 'the discounts apply to every single design your own logo mat' - same 2/3/5 + $600/$1,000 ladder; the 3 products still have to be added to the Shopify discounts (see report)
};
const GRADES = {
  standard:   { key:'standard', edgeMm:20, safeMm:25,   opt:'Standard Grade',   title:'PrintPlush Standard',   family:'printplush', cap:12, chart:'mm', bgChart:'mm', surface:'plush', edge:'nitrile',
                tag:'Everyday entrance mat', bullets:['Up to 12 PMS colours','Natural &amp; nitrile blend backing','Spot clean'],
                spec:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/TMG00027_Printplush_STANDARD_Logo_Mat_Spec_Sheet_MAY26.pdf?v=1779682436',
                cart:'Standard Grade PrintPlush (up to 12 PMS colours, spot clean)' },
  commercial: { key:'commercial', edgeMm:20, safeMm:25, opt:'Commercial Grade', title:'PrintPlush Commercial', family:'printplush', cap:25, chart:'mm', bgChart:'mm', surface:'plush', edge:'nitrile',
                tag:'Heavier traffic, launderable', bullets:['Up to 25 PMS colours','Nitrile rubber backing','Commercially launderable'],
                spec:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/Printplush_Logo_Mat_Spec_Sheet_DIRECT_email.pdf?v=1747788919',
                cart:'Commercial Grade PrintPlush (up to 25 PMS colours, commercially launderable)' },
  hd:         { key:'hd', edgeMm:20, safeMm:25,         opt:'High Definition',  title:'High Definition Print', family:'printplush', cap:0, asSupplied:true, chart:'none', bgChart:'mm', surface:'plush', edge:'nitrile',
                tag:'Photos, gradients, exact colours', bullets:['Your exact colours, no limit','Gradients &amp; photos (up to 76 dpi)','Nitrile rubber backing, launderable'],
                spec:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/HighDefPrintedLogoMat_Spec_Sheet_lowres_d7702139-7d19-4d21-941f-4b39cde784e5.pdf?v=1718147265',
                cart:'High Definition Print (full colour, printed exactly as supplied, launderable)' },
  printscraper: { key:'printscraper', edgeMm:20, safeMm:25, opt:'PrintScraper', title:'PrintScraper', family:'printscraper', cap:0, chartOnly:true, chart:'ps', bgChart:'ps', surface:'scraper', edge:'nitrile', tiled:true, tileMm:55,
                tag:'Heavy duty: outside or busy entrances', bullets:['Coarse scraper fibre, hose it clean','Chart colours, fully launderable','Drainage holes for the weather'],
                spec:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/Printscraper_logo_Spec_Sheet_lowres.pdf?v=1674522747',
                chartUrl:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/PrintScraper_colourchart_AUG24_email.pdf?v=1724913033',
                extras:['drainage'], cart:'PrintScraper (heavy-duty scraper mat, PrintScraper chart colours, Gripper backing)' },
  rubberscraper: { key:'rubberscraper', edgeMm:25, opt:'Rubber Scraper', title:'Rubber Scraper', family:'rubberscraper', cap:0, asSupplied:true, chart:'none', bgChart:'mm', surface:'rubber', edge:'raised', studs:true, noFill:true, safeMm:100,
                sizes:['600x850','850x1150','850x1500','850x3000','1150x1800','1800x1800','1800x2400'],
                tag:'Toughest: all rubber, any weather', bullets:['100% rubber, inside or out','Full colour print, your exact colours','Raised border traps dirt and water'],
                spec:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/RubberScraperLogo_Spec_Sheet_lowres.pdf?v=1679595483',
                cart:'Rubber Scraper (all-rubber scraper mat, full colour printed as supplied, raised containment border)' },
  spiralloop: { key:'spiralloop', edgeMm:20, safeMm:40, opt:'SpiralLoop Inlay', title:'SpiralLoop Inlay', family:'spiralloop', cap:3, bgSeparate:true, cut:true, chart:'sl', bgChart:'sl', surface:'loop', edge:'vinyl', tiled:true, tileMm:40,
                sizes:['600x850','850x1200','850x1500','850x3000','1150x1800','1150x2400'],
                tag:'Wet areas, pools, over drains', bullets:['PVC loop, UV stable, drains through','Logo cut and inlaid, up to 3 colours','Edged, or open for a drain'],
                spec:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/TMG_Design_Guidelines_SpiralLoopInlayMat_EMAIL.pdf',
                chartUrl:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/SpiralLoop_colourchart_DIRECT_email.pdf?v=1744592700',
                extras:['edging'], edgeOpts:['Edged','No edge (drain / recess)'], cart:'SpiralLoop Inlay (PVC loop wet-area mat, logo cut and inlaid in chart colours, up to 3 colours)' },
  superguard: { key:'superguard', edgeMm:40, edgeMmSmall:27, safeMm:40, opt:'Superguard Inlay', title:'Superguard Inlay', family:'superguard', cap:4, bgSeparate:true, cut:true, chart:'sg', bgChart:'sgbase', surface:'yarn', edge:'bevel', tiled:true, tileMm:50, option3:'base',
                sizes:['600x900','850x1200','850x1500','850x3000','1150x1800','1150x2400'],
                tag:'Our most durable, made in Melbourne', bullets:['Logo cut and inlaid, never fades','Up to 4 colours on 15 base colours','Bevelled edge, or cut to fit a recess'],
                spec:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/TMG00057_SuperguardLogoInlay_SpecSheet_DIRECT_email.pdf?v=1784524183',
                chartUrl:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/Superguard_colourchart_DIRECT_email.pdf?v=1764727652',
                extras:['edging'], edgeOpts:['Bevelled edge','Fits a recess (no edge)'], cart:'Superguard Logo Inlay (cut and inlaid in Melbourne, up to 4 colours, most durable)' },
  coirembossed: { key:'coirembossed', edgeMm:25, safeMm:40, opt:'Coir Embossed', title:'Coir Embossed', family:'coirembossed', cap:1, bgSeparate:true, raised:true, chart:'emb', bgChart:'coir', surface:'coir', edge:'vinyl', option3:'coir', extras:['edging'], edgeOpts:['Edged', 'No edging'], edgeDefault:false, edgeCharge:{ rate: 29.7, variantId: 51465975922855, sku: 'PVC SAFETY EDGING SUPPLY & FIT - Black' },
                sizes:['500x850','650x1200','1000x1200','1000x1500'],
                tag:'Natural coir, classic entrance look', bullets:['Natural, grey or black coir','One embossed logo colour','Eco, biodegradable fibre'],
                spec:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/Embossed_Colour_Chart_DIRECT_email_6563b0d5-c795-4667-86dc-c63c59169abf.pdf?v=1773622385',
                chartUrl:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/Embossed_Colour_Chart_DIRECT_email_6563b0d5-c795-4667-86dc-c63c59169abf.pdf?v=1773622385',
                cart:'Coir Embossed Logo Mat (natural coir, one embossed logo colour from the embossed chart)' },
  coirinlay: { key:'coirinlay', edgeMm:25, safeMm:40, opt:'Coir Inlay', title:'Coir Logo Inlay', family:'coirinlay', cap:COIR_INLAY.maxLogoColours, bgSeparate:true, cut:true, inlayFlush:true, dropBg:true, baseByName:true, alwaysMint:true, noDiscount:!COIR_INLAY.discounts, noGen:true,
                chart:'coir', bgChart:'coir', surface:'coir', edge:'nitrile', option3:'coir', extras:['edging'], edgeOpts:['Black rubber edging', 'No edging (fits a recess)'], edgeDefault:false,
                sizes:['500x850','650x1200','1000x1200','1000x1500'],
                tag:'Logo laser-cut and inlaid in coir', bullets:['Logo cut into the coir, never wears off','Natural, grey or black base, one logo colour','Made to measure, up to 2 m wide'],
                spec:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/TMG00097_CoirLogoInlay_SpecSheet_FA.pdf?v=1790130577',
                cart:'Coir Logo Inlay Mat (17 mm laser-cut coir, logo inlaid flush in natural / grey / black coir)' },
  dirtstopper: { key:'dirtstopper', edgeMm:25, safeMm:40, opt:'DirtStopper', title:'DirtStopper', family:'dirtstopper', cap:2, bgSeparate:true, raised:true, chart:'emb', bgChart:'dsbase', surface:'flock', edge:'none', option3:'dsbase',
                sizes:['600x900','900x1200'],
                tag:'Raised embossed logo, extra sharp', bullets:['Logo stands proud of the mat','1 or 2 logo colours on black or charcoal','Indoors, 2 sizes'],
                spec:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/Embossed_Colour_Chart_DIRECT_email_6563b0d5-c795-4667-86dc-c63c59169abf.pdf?v=1773622385',
                chartUrl:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/Embossed_Colour_Chart_DIRECT_email_6563b0d5-c795-4667-86dc-c63c59169abf.pdf?v=1773622385',
                cart:'DirtStopper Logo Mat (raised embossed logo, embossed chart colours)' },
  promotional: { key:'promotional', edgeMm:0, safeMm:30, opt:'Promotional', title:'Promotional', family:'promotional', cap:0, asSupplied:true, chart:'none', bgChart:'mm', surface:'felt', edge:'thin', whiteWarn:true,
                sizes:['450x700','580x900','800x1200','800x1450'],
                tag:'Thin and sharp, for events and giveaways', bullets:['Full colour, very fine detail prints','2 mm felt top, rubber back','Short-term use, marks easily'],
                spec:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/Promotional_logo_Spec_Sheet_lowres.pdf?v=1787884516',
                cart:'Promotional Logo Mat (felt top, full colour printed as supplied, short term)' },
  rubberpromotional: { key:'rubberpromotional', edgeMm:25, safeMm:30, opt:'Rubber Promotional', title:'Rubber Promotional', family:'rubberpromotional', cap:0, asSupplied:true, chart:'none', bgChart:'mm', surface:'rubber', edge:'thin', weave:true,
                sizes:['450x700','600x850','850x1200','850x1500','850x3000','1150x1800'],
                tag:'Photo print on thin rubber', bullets:['Full colour photo print','Flat, low profile, lies anywhere','Max width 1200 mm'],
                spec:'https://cdn.shopify.com/s/files/1/0565/5216/1447/files/RubberPromotionalLogo_Spec_Sheet_lowres.pdf?v=1679595476',
                cart:'Rubber Promotional Mat (thin rubber, full colour photo print as supplied)' }
};
// Lead time per mat, from each product page's Lead Time tab (5 Oct 2026): most are "approx. 4 weeks", SpiralLoop and
// Rubber Promotional 4-5 weeks from payment and proof approval, Promotional 2-3 weeks, PrintScraper 3-4 weeks plus shipping.
const LEAD = { standard: '4 weeks', commercial: '4 weeks', hd: '4 weeks', printscraper: '3–4 weeks', rubberscraper: '4 weeks', spiralloop: '4–5 weeks', superguard: '4 weeks', coirembossed: '4 weeks', coirinlay: COIR_INLAY.lead, dirtstopper: '4 weeks', promotional: '2–3 weeks', rubberpromotional: '4–5 weeks' };
function leadOf(k){ return LEAD[k || S.grade] || '4 weeks'; }
const GRADE_ORDER = Object.keys(GRADES);
const GRADE_OPT_RE = { standard: /^standard/i, commercial: /^commercial/i, hd: /^high/i, printscraper: /^printscraper$/i, rubberscraper: /^rubber scraper/i, spiralloop: /^spiralloop/i, superguard: /^superguard/i, coirembossed: /^coir(?! inlay)/i, coirinlay: /^coir inlay/i, dirtstopper: /^dirtstopper/i, promotional: /^promotional/i, rubberpromotional: /^rubber promotional/i };
// The 50 colours the PrintScraper supplier prints (chart PrintScraper_colourchart_AUG24). 396 Bright Orange is on this
// chart even though the Standard Grade table dropped it, so it is appended for this family only.
const PS_CODES = ['419','116','387','388','108','118','369','404','107','398','408','306','406','417','130','402','104','386','385','117','340','366','412','403','128','416','109','418','394','363','126','103','127','396','409','311','112','397','100','392','335','389','381','120','123','111','384','391','105','413'];
const PS_EXTRA_ROWS = [['MM396', '#FF5D00', 'Bright Orange (PMS Bright Orange c)', 'medium']];
for (const [mm, hex, name, cat] of PS_EXTRA_ROWS) if (typeof MM_RGB !== 'undefined' && !MM_RGB.some(c => c.mm === mm)) MM_RGB.push({ mm, hex, name, cat, r: parseInt(hex.slice(1,3),16), g: parseInt(hex.slice(3,5),16), b: parseInt(hex.slice(5,7),16), lab: (typeof rgbToLab === 'function' ? rgbToLab(parseInt(hex.slice(1,3),16), parseInt(hex.slice(3,5),16), parseInt(hex.slice(5,7),16)) : null) });
const PLACEMENTS = {
  inside:  { key:'inside',  title:'Inside or undercover', sub:'Foyers, shops, offices', ico:'&#8962;', grades:['standard','commercial','hd','superguard','coirembossed','coirinlay'], label:'Choose your mat' },
  outside: { key:'outside', title:'Outside, in the weather', sub:'Open entrances, rain and sun', ico:'&#9729;', grades:['printscraper','rubberscraper','spiralloop'], label:'Your heavy-duty mat' },
  wet:     { key:'wet',     title:'Wet area or over a drain', sub:'Pools, change rooms, car washes', ico:'&#8767;', grades:['spiralloop','rubberscraper','printscraper'], label:'Your wet-area mat' }
};
const OTHER_GRADES = ['dirtstopper','promotional','rubberpromotional'];
const DE_OFF = 8; // CIEDE2000 above this = "no close chart match" (a clearly visible difference)
const GRADIENT_BUCKETS = 400; // old test, kept only as the fallback when a colour readout carries no block measure
const GRADIENT_SHARE = 9, GRADIENT_BLOCK_DE = 4, GRADIENT_MIN_BLOCKS = 40; // block-mean test (7 Oct 2026): % of 4x4 one-colour blocks more than dE 4 from their colour's median block
function gradeOf(){ return GRADES[S.grade] || GRADES.standard; }
function isHD(){ return S.grade === 'hd'; }
function asSupplied(){ return !!gradeOf().asSupplied; }   // the file prints as it is: no chart, no palette
function isPS(){ return S.grade === 'printscraper'; }
function isCut(){ return !!gradeOf().cut; }                 // cut-and-inlaid: SpiralLoop, Superguard
function isRaised(){ return !!gradeOf().raised; }           // embossed, stands proud: DirtStopper, Coir Embossed
function placementOf(){ return PLACEMENTS[S.placement] || PLACEMENTS.inside; }
function visibleGrades(){
  if (S.genUsed && !S.genFamily) return ['standard','commercial']; // legacy generated designs (no mat chosen) are PrintPlush chart artwork
  if (S.genUsed && S.genFamily && GRADES[S.genFamily]) { const list = placementOf().grades.slice(); if (list.indexOf(S.genFamily) < 0) list.unshift(S.genFamily); if (S.showOther) for (const k of GRADE_ORDER) if (list.indexOf(k) < 0) list.push(k); return list; }
  const base = placementOf().grades.slice();
  if (S.showOther) for (const k of GRADE_ORDER) if (base.indexOf(k) < 0) base.push(k); // every mat we make
  return base;
}
function baseGrade(){ return visibleGrades()[0]; }          // the card the others' "+A$" is measured against
function gradeCap(){ const g = gradeOf(); return g.cap || 999; }
function bgTakesASlot(){ return !S.useArtworkAsBg && !S.genUsed && !gradeOf().bgSeparate; } // a printed background is one printed colour; a base mat colour is not
function logoCapFor(k){ const g = GRADES[k] || GRADES.standard; if (!g.cap) return 999; return g.cap - ((!S.useArtworkAsBg && !S.genUsed && !g.bgSeparate) ? 1 : 0); }
function logoCap(){ return logoCapFor(S.grade || 'standard'); }
function mmNum(mm){ const s = String(mm || ''); return /^MM\d/.test(s) ? s.replace(/^MM/, '') : ''; } // chart number for MM codes, nothing for named swatches
// Label form of the chart number. PrintScraper's chart names its swatches number + grid reference ("419/E6"), and that is
// how production finds them, so on that family every label carries both (12 Oct 2026, TMG12664). Elsewhere just the number.
function psGridFor(num){ const rows = (typeof window !== 'undefined' && window.TMG_CHARTS && window.TMG_CHARTS.printscraper) || []; const row = rows.find(r => String(r.code) === String(num)); return row && row.grid ? String(row.grid) : ''; }
function mmRef(mm){ const n = mmNum(mm); if (!n) return ''; const g = gradeOf(); if (g.chart === 'ps' || g.bgChart === 'ps') { const grid = psGridFor(n); if (grid) return n + '/' + grid; } return n; }
// Audit trail (Zac, 7 Oct 2026, TMG12642): what was set and by whom, carried on the cart line as hidden fields.
function trail(kind, text){ if (!S.trail) S.trail = {}; const a = S.trail[kind] || (S.trail[kind] = []); if (a[a.length - 1] === text) return; a.push(text); if (a.length > 12) a.splice(1, a.length - 12); }
function trailBgName(mm, name){ const n = mmRef(mm); return (name || mm || '?') + (n ? ' (' + n + ')' : ''); }
function trailProps(props){ const t = S.trail || {}; const put = (k, key) => { if (!t[k] || !t[k].length) return; let v = t[k].join(' > '); if (v.length > 480) v = '...' + v.slice(-477); props[key] = v; };
  put('bg', '_Background trail'); put('grade', '_Grade trail'); put('colour', '_Colour trail'); put('asis', '_As-is trail'); }

// ── Charts: one lookup table per chart key, same entry shape as MM_RGB ({mm, hex, name, cat, r, g, b, lab}) ──
const _tables = {};
function lum(r, g, b){ return 0.299 * r + 0.587 * g + 0.114 * b; }
function catFor(r, g, b){ const l = lum(r, g, b); return l > 170 ? 'light' : l < 80 ? 'dark' : 'medium'; }
function entryFrom(prefix, name, hex, extra){
  const r = parseInt(hex.slice(1,3),16), g = parseInt(hex.slice(3,5),16), b = parseInt(hex.slice(5,7),16);
  return Object.assign({ mm: prefix + ':' + name, hex: hex.toUpperCase(), name, cat: catFor(r, g, b), r, g, b, lab: rgbToLab(r, g, b) }, extra || {});
}
function chartTable(key){
  if (_tables[key]) return _tables[key];
  const C = window.TMG_CHARTS || {};
  let t;
  if (key === 'mm') t = MM_RGB.filter(c => !PS_EXTRA_ROWS.some(r => r[0] === c.mm));
  else if (key === 'ps') { // the 50 PrintScraper codes, named as the PrintScraper chart names them: PMS + grid reference (12 Oct 2026)
    const set = new Set(PS_CODES), rows = (C.printscraper || []);
    t = MM_RGB.filter(c => set.has(c.mm.replace(/^MM/, ''))).map(c => { const row = rows.find(r => String(r.code) === c.mm.replace(/^MM/, '')); return row ? Object.assign({}, c, { name: friendlyName(c.name) || row.pms || c.name, grid: row.grid || '' }) : c; });
  }
  else if (key === 'sl') t = (C.spiralloop || []).map(c => entryFrom('SL', c.name, c.hex, { tile: c }));
  else if (key === 'sg') t = (C.superguard_logo || []).concat((C.superguard_base || []).filter(b => !(C.superguard_logo || []).some(l => l.name === b.name))).map(c => entryFrom('SG', c.name, c.hex, { tile: c }));
  else if (key === 'sgbase') { // the 15 base mat colours the Superguard product is made in: 5 base yarns + 10 logo yarns also offered as a base
    const names = ['Black','Charcoal','Mid Grey','Denim','Sterling','White','Gold','Orange','Bright Red','Royal Blue','Kelly Green','American Green','Purple','Natural Beige','Camel'];
    const all = (C.superguard_base || []).concat(C.superguard_logo || []);
    t = names.map(n => all.find(c => c.name === n)).filter(Boolean).map(c => entryFrom('SGB', c.name, c.hex, { tile: c }));
  }
  else if (key === 'emb') t = (C.embossed || []).map(c => entryFrom('EMB', c.name, c.hex));
  else if (key === 'coir') t = [['Natural', '#B98F52'], ['Grey', '#6F6C66'], ['Black', '#2B2A28']].map(([n, h]) => entryFrom('COIR', n, h));
  else if (key === 'dsbase') t = [['Black', '#141414'], ['Charcoal', '#3A3A3A']].map(([n, h]) => entryFrom('DSB', n, h));
  else t = [];
  return (_tables[key] = t);
}
function familyTable(){ return chartTable(gradeOf().chart === 'none' ? 'mm' : gradeOf().chart); }   // what the artwork is matched to
function familyChart(){ return chartTable(gradeOf().bgChart || 'mm').map(c => [c.mm, c.hex, c.name, c.cat]); } // what the background / base picker shows
function familyAllows(mm){ return familyTable().some(c => c.mm === mm); }
function hueOf(lab){ return Math.atan2(lab[2], lab[1]) * 180 / Math.PI; }
function chromaOf(lab){ return Math.sqrt(lab[1] * lab[1] + lab[2] * lab[2]); }
// Nearest swatch for the named yarn / loop / embossed charts. The swatch photos read darker and duller than the real
// yarn, so plain CIEDE2000 lands a navy on purple and a black on grey. Lightness counts half, hue counts extra when both
// colours are clearly chromatic: a navy goes to Royal Blue, a maroon to Burgundy, a dark red to Bright Red.
// On a cut or embossed mat the logo is laid INTO the base colour, so a logo colour that matches the base would vanish
// (Zac, 5 Oct 2026: coir embossed "embossed my artwork to one colour which was the colour of the coir, logo disappeared").
// Those chart colours are never offered for the logo; the nearest colour that stands off the base is used instead.
function baseLab(){
  const g = gradeOf(); if (!(g.cut || g.raised) || !S.selectedBg || !S.selectedBg.hex || S.useArtworkAsBg) return null;
  const h = S.selectedBg.hex; return rgbToLab(parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16));
}
const BASE_CLEAR_DE = 25;
function tooCloseToBase(entry){ if (gradeOf().baseByName) return !!(baseLab() && entry.mm === S.selectedBg.mm); const bl = baseLab(); return !!bl && deltaE2000(entry.lab, bl) < BASE_CLEAR_DE; } // coir inlay: only the base colour itself is off limits (3 colours, Grey and Black sit close)
function nearestInTable(table, r, g, b){
  const lab = rgbToLab(r, g, b); let best = null, bd = Infinity;
  const ch = chromaOf(lab), h = hueOf(lab);
  for (const c of table) {
    if (tooCloseToBase(c)) continue;
    const dL = (lab[0] - c.lab[0]) * 0.5, da = lab[1] - c.lab[1], db = lab[2] - c.lab[2];
    let d = Math.sqrt(dL * dL + da * da + db * db);
    if (ch > 15 && chromaOf(c.lab) > 15) { let dh = Math.abs(h - hueOf(c.lab)); if (dh > 180) dh = 360 - dh; d += 0.8 * dh; }
    else if ((ch > 15) !== (chromaOf(c.lab) > 15)) d += 12; // a coloured logo should not land on a grey, nor a grey on a colour
    if (d < bd) { bd = d; best = c; }
  }
  if (!best) { const bl = baseLab(); best = table[0]; let far = -1; for (const c of table) { const d = bl ? deltaE2000(c.lab, bl) : 0; if (d > far) { far = d; best = c; } } } // every colour sits on the base: take the one furthest from it
  return best;
}
// Cut and embossed mats have no printed background: the artwork's own flat background has to go so the logo shapes sit
// straight on the base. Corner flood fill first (the live routine); if that removed nothing because the background is
// noisy or the corners are not clean, the colour that dominates the picture's border ring is dropped everywhere.
function cornerNearBase(ctx, W, H){
  const bl = baseLab(); if (!bl) return false;
  try { const d = ctx.getImageData(0, 0, Math.min(6, W), Math.min(6, H)).data; let r = 0, g = 0, b = 0, c = 0; for (let i = 0; i < d.length; i += 4) { if (d[i+3] < 10) continue; r += d[i]; g += d[i+1]; b += d[i+2]; c++; } if (!c) return false; return deltaE2000(rgbToLab(r / c, g / c, b / c), bl) < BASE_CLEAR_DE; } catch(e) { return false; }
}
function dropArtworkBackground(ctx, W, H){ try { S.removedBgRGB = null; } catch (e) {} // coirbase1016: never a stale colour from an earlier artwork
  // Cut inlays keep the artwork as supplied: a rectangle of colour with the logo in it is a normal inlay panel. Only a
  // background that is the base colour anyway is dropped (it would merge with the base and waste a logo colour).
  // Embossed mats always drop it: a solid embossed rectangle is never what a customer wants.
  if (isCut() && !gradeOf().dropBg && !(S.whiteBgAuto && S.dropLogoBg) && !cornerNearBase(ctx, W, H)) return; // 14 Oct 2026: a see-through white panel is dropped on inlays too // coir inlay drops it like embossed: a coir panel behind the logo is never what is meant
  try {
    const before = ctx.getImageData(0, 0, W, H).data; let opaque0 = 0; for (let i = 3; i < before.length; i += 4) if (before[i] > 10) opaque0++;
    if (opaque0 < W * H * 0.5) return; // already a cut-out (transparent PNG)
    removeBackground(ctx, W, H);
    const id = ctx.getImageData(0, 0, W, H), d = id.data; let opaque1 = 0; for (let i = 3; i < d.length; i += 4) if (d[i] > 10) opaque1++;
    try { let r = 0, g = 0, b = 0, n = 0; for (let i = 0; i < d.length; i += 4) if (before[i+3] > 10 && d[i+3] <= 10) { r += before[i]; g += before[i+1]; b += before[i+2]; n++; } S.removedBgRGB = n > W * H * 0.05 ? [r / n, g / n, b / n] : null; } catch (e) {} // coirbase1016: the background colour taken off, for dropDominantFill
    // the anti-alias fringe where the logo met its background is a blend of both: two one-pixel erosions take it off (6 Oct 2026)
    const erodeEdge = (d) => { for (let pass = 0; pass < 2; pass++) { const al = new Uint8Array(W * H); for (let p = 0; p < W * H; p++) al[p] = d[p * 4 + 3] > 10 ? 1 : 0; for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) { const p = y * W + x; if (!al[p]) continue; if ((x > 0 && !al[p - 1]) || (x < W - 1 && !al[p + 1]) || (y > 0 && !al[p - W]) || (y < H - 1 && !al[p + W])) d[p * 4 + 3] = 0; } } };
    if (opaque1 < opaque0 * 0.9) { if (gradeOf().dropBg || (S.whiteBgAuto && S.dropLogoBg)) dropEnclosedBg(before, d); /* 14 Oct 2026: letter counters of a see-through white background go too */ erodeEdge(d); ctx.putImageData(id, 0, 0); return; } // the flood fill did its job
    // border ring histogram (colours bucketed to 16 levels)
    const ring = new Map(); const bw = Math.max(1, Math.round(Math.min(W, H) * 0.03));
    const push = (x, y) => { const i = (y * W + x) * 4; if (d[i+3] < 10) return; const k = ((d[i] >> 4) << 8) | ((d[i+1] >> 4) << 4) | (d[i+2] >> 4); ring.set(k, (ring.get(k) || 0) + 1); };
    for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) if (x < bw || y < bw || x >= W - bw || y >= H - bw) push(x, y);
    let top = null, n = 0, total = 0; for (const [k, c] of ring) { total += c; if (c > n) { n = c; top = k; } }
    if (top == null || n < total * 0.6) return; // no single background colour around the edge: leave it
    const tr = ((top >> 8) & 15) * 16 + 8, tg = ((top >> 4) & 15) * 16 + 8, tb = (top & 15) * 16 + 8;
    let dropped = 0;
    for (let i = 0; i < d.length; i += 4) { if (d[i+3] < 10) continue; if (Math.abs(d[i] - tr) <= 40 && Math.abs(d[i+1] - tg) <= 40 && Math.abs(d[i+2] - tb) <= 40) { d[i+3] = 0; dropped++; } }
    if (dropped > opaque1 * 0.98) return; // it would delete the whole picture (a single flat colour): keep it
    // the anti-alias fringe where the logo met its background is a blend of both: two one-pixel erosions take it off (6 Oct 2026)
    erodeEdge(d);
    ctx.putImageData(id, 0, 0);
  } catch(e) {}
}
// Coir inlay (14 Oct 2026): the counters of letters (the holes in D, a, o) are background the corner flood cannot reach;
// the base coir shows through them on the real mat, so the leftover pixels of the removed background colour go too.
function dropEnclosedBg(before, d){ let r = 0, g = 0, b = 0, n = 0; for (let i = 0; i < d.length; i += 4) if (before[i+3] > 10 && d[i+3] <= 10) { r += before[i]; g += before[i+1]; b += before[i+2]; n++; } if (!n) return; r /= n; g /= n; b /= n;
  for (let i = 0; i < d.length; i += 4) if (d[i+3] > 10 && Math.abs(d[i] - r) <= 40 && Math.abs(d[i+1] - g) <= 40 && Math.abs(d[i+2] - b) <= 40) d[i+3] = 0; }
// A badge-style logo (a disc or panel with marks on it) reduced to one or two colours must keep the MARKS, not the fill
// (Zac, 5 Oct 2026: "it takes the colour of the background and just makes a solid colour circle"). After the background
// is gone: while the picture still has more colours than the mat can take and one colour covers over half of what is
// left, that colour is a fill, not the logo: drop it, as long as a real logo remains.
function dropDominantFill(ctx, W, H, cap){ // onecolour1016: keeps a ring of the dropped fill
  if (!cap || cap > 4 || (isCut() && !gradeOf().dropBg)) return; // embossed mats (and coir inlay) only
  try {
    const id = ctx.getImageData(0, 0, W, H), d = id.data;
    for (let round = 0; round < 3; round++) {
      const hist = new Map(); let opaque = 0;
      for (let i = 0; i < d.length; i += 4) { if (d[i+3] < 10) continue; opaque++; const k = ((d[i] >> 4) << 8) | ((d[i+1] >> 4) << 4) | (d[i+2] >> 4); hist.set(k, (hist.get(k) || 0) + 1); }
      if (opaque < 500) return;
      const sig = [...hist.entries()].filter(([, n]) => n >= opaque * 0.02).sort((a, b) => b[1] - a[1]);
      if (sig.length <= cap) { if (round) ctx.putImageData(id, 0, 0); return; }
      const [top, n] = sig[0]; if (n < opaque * 0.5) { if (round) ctx.putImageData(id, 0, 0); return; }
      const tr = ((top >> 8) & 15) * 16 + 8, tg = ((top >> 4) & 15) * 16 + 8, tb = (top & 15) * 16 + 8; let dropped = 0;
      // Zac 5 Oct: the dominant colour is only dropped when it is a flat FILL. Writing and logo marks are thin: most of
      // their pixels sit on an edge. A colour whose pixels are mostly edges IS the logo and is kept, whatever its share.
      const isTop = i => d[i+3] >= 10 && Math.abs(d[i] - tr) <= 40 && Math.abs(d[i+1] - tg) <= 40 && Math.abs(d[i+2] - tb) <= 40;
      let edges = 0, members = 0;
      for (let y = 1; y < H - 1; y++) for (let x = 1; x < W - 1; x++) { const i = (y * W + x) * 4; if (!isTop(i)) continue; members++; if (!isTop(i - 4) || !isTop(i + 4) || !isTop(i - W * 4) || !isTop(i + W * 4)) edges++; }
      if (members && edges / members > 0.3) { if (round) ctx.putImageData(id, 0, 0); return; } // mostly edges = writing / line art: keep it
      // onecolour1016: only a fill that WRAPS AROUND the other marks (a badge disc behind its lettering, a panel behind a logo) is a
      // background. A big shape that sits beside or overlaps another shape (a circle over a square) is part of the logo: keep it
      // solid, the merged-colour gap in quantiseImageToPMS keeps the two shapes apart. Test: of the other-colour pixels, how many
      // have the fill on all four sides (left, right, up, down)?
      const leftoverBg = !!(S.removedBgRGB && Math.abs(S.removedBgRGB[0] - tr) <= 40 && Math.abs(S.removedBgRGB[1] - tg) <= 40 && Math.abs(S.removedBgRGB[2] - tb) <= 40); // coirbase1016: the picture's own background left inside the logo
      if (!leftoverBg) { let other = 0, wrapped = 0; const fillAt = (x, y) => isTop((y * W + x) * 4);
        for (let y = 2; y < H - 2; y += 5) for (let x = 2; x < W - 2; x += 5) { const i = (y * W + x) * 4; if (d[i+3] < 10 || isTop(i)) continue; other++;
          let l = 0, r2 = 0, u = 0, dn = 0; for (let k = x - 1; k >= 0; k--) if (fillAt(k, y)) { l = 1; break; } for (let k = x + 1; k < W; k++) if (fillAt(k, y)) { r2 = 1; break; }
          for (let k = y - 1; k >= 0; k--) if (fillAt(x, k)) { u = 1; break; } for (let k = y + 1; k < H; k++) if (fillAt(x, k)) { dn = 1; break; } if (l && r2 && u && dn) wrapped++; }
        if (!other || wrapped < other * 0.6) { if (round) ctx.putImageData(id, 0, 0); return; } }
      // onecolour1016: keep the OUTLINE of the dropped fill (a ring of the family's minimum stroke along its outside edge), so a badge
      // reduced to one colour still reads as a badge: ring + marks, with the base colour where the fill was.
      const ringMm = (familyCheckOpts().strokeMinMm || 8), mmPx = (0.8 * (S.matWmm || parseInt((S.size || '850x1150').split('x')[0], 10))) / W, ringPx = Math.max(2, Math.round(ringMm / Math.max(0.05, mmPx)));
      let edgeHits = 0, edgeAll = 0; for (let x = 0; x < W; x++) for (const y of [0, H - 1]) { edgeAll++; if (isTop((y * W + x) * 4)) edgeHits++; } for (let y = 0; y < H; y++) for (const x of [0, W - 1]) { edgeAll++; if (isTop((y * W + x) * 4)) edgeHits++; }
      const isPictureBg = leftoverBg || edgeHits > edgeAll * 0.05; // coirbase1016: runs to the picture's edge = the artwork's background: drop it whole, no ring
      const keep = new Uint8Array(W * H); let outside = new Uint8Array(W * H);
      for (let p = 0; p < W * H; p++) outside[p] = d[p * 4 + 3] < 10 ? 1 : 0;
      for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) if (x === 0 || y === 0 || x === W - 1 || y === H - 1) outside[y * W + x] = 1;
      if (!isPictureBg) for (let k = 0; k < ringPx; k++) { const nxt = outside.slice(); for (let y = 1; y < H - 1; y++) for (let x = 1; x < W - 1; x++) { const p = y * W + x; if (outside[p]) continue; if (outside[p - 1] || outside[p + 1] || outside[p - W] || outside[p + W]) { nxt[p] = 1; if (isTop(p * 4)) keep[p] = 1; } } outside = nxt; }
      let fillN = 0; for (let i = 0; i < d.length; i += 4) if (d[i+3] >= 10 && Math.abs(d[i] - tr) <= 40 && Math.abs(d[i+1] - tg) <= 40 && Math.abs(d[i+2] - tb) <= 40) fillN++;
      if (opaque - fillN < opaque * 0.08) return; // same decision as before the ring: this fill IS the logo, keep it whole
      for (let i = 0, p = 0; i < d.length; i += 4, p++) { if (d[i+3] < 10 || keep[p]) continue; if (Math.abs(d[i] - tr) <= 40 && Math.abs(d[i+1] - tg) <= 40 && Math.abs(d[i+2] - tb) <= 40) { d[i+3] = 0; dropped++; } }
      if (opaque - dropped < opaque * 0.08) { for (let i = 0; i < d.length; i += 4) {} return; } // nothing meaningful would be left: this fill IS the logo
      if (round === 2) ctx.putImageData(id, 0, 0);
    }
    ctx.putImageData(id, 0, 0);
  } catch(e) {}
}
function bgLabelText(){ const b = gradeOf().bgChart; return b === 'sgbase' ? 'Choose the base mat colour' : b === 'coir' ? 'Choose the coir colour' : b === 'dsbase' ? 'Choose the base mat colour' : 'Choose mat background colour'; }
function chartLabel(){ const c = gradeOf().chart; return c === 'ps' ? 'PrintScraper' : c === 'sl' ? 'SpiralLoop' : c === 'sg' ? 'Superguard' : c === 'emb' ? 'embossed' : c === 'coir' ? 'coir' : 'PrintPlush'; }

// ── Sizes: each family is made in its own sizes; the card shows the size it will be made at when it differs ──
function familySizes(k){ const g = GRADES[k] || GRADES.standard; return g.sizes || TMG_BASE_SIZES; }
// size1020 (20 Oct 2026): S.pickSize = the size the customer chose from the list. Cards that snap never overwrite it, so a
// family that makes the picked size gets it back when its card is tapped again. A made-to-measure family makes ANY picked size.
function stdPick(){ return (!isCustomSize() && S.pickSize && /^\d+x\d+$/.test(S.pickSize)) ? S.pickSize : null; }
function setPickSize(s){ S.size = s; S.pickSize = (/^\d+x\d+$/.test(s || '') ? s : null); }
function madeToMeasure(k){ k = k || S.grade; if (!customOf(k)) return false; if (isCustomSize() || alwaysMint(k)) return true; const s = familySize(k); return /^\d+x\d+$/.test(s) && familySizes(k).indexOf(s) < 0; }
// size1029 (29 Oct 2026, TMG12758 / TMG12917 / TMG12921): a typed custom size is the customer's pick as well. Cards made in
// standard sizes snap FROM it (DirtStopper then Rubber Scraper used to chain 1250x1800 -> 900x1200 -> 850x1150) and a made-to-
// measure card gets it back, so S.size (preview, print check, 'Mat Size') never drifts from the size the line is priced at.
function customPick(){ return isCustomSize() ? S.custom.L + 'x' + S.custom.W : null; }
function familySize(k, size){
  const s = size || customPick() || stdPick() || S.size, list = familySizes(k); if (list.indexOf(s) > -1) return s;
  if (customOf(k) && /^\d+x\d+$/.test(s)) return s; // made to measure: a custom size or any picked standard size
  const [w0, h0] = s.split('x').map(Number), w = Math.min(w0, h0), h = Math.max(w0, h0); let best = list[0], bd = Infinity;
  for (const x of list) { const [a, b] = x.split('x').map(Number); const d = Math.abs(a - w) + Math.abs(b - h); if (d < bd) { bd = d; best = x; } }
  return best;
}
function sizeLabel(s){ return s.replace('x', ' × ') + 'mm'; }
function ensureSizeOption(s){
  const sel = $('tmgSize'); if (!sel || !s) return;
  if (![...sel.options].some(o => o.value === s)) { const o = document.createElement('option'); o.value = s; o.textContent = sizeLabel(s); sel.appendChild(o); }
  sel.value = s;
}

// ── Variant colour (option3) for families whose variant carries a colour ──
function dsColourQty(){ const st = colourStatsNow(); const n = st ? Math.min(2, Math.max(1, st.distinct)) : 1; return n; }
function variantColour(k){
  const g = GRADES[k]; if (!g || !g.option3) return null;
  const bg = S.selectedBg && S.selectedBg.name;
  if (g.option3 === 'base') { const b = bg || 'Black'; return b === 'Camel' ? 'Camel (Coir Colour Substitute)' : b; }
  if (g.option3 === 'coir') return (S.selectedBg && /^COIR:/.test(S.selectedBg.mm || '')) ? bg : 'Natural'; // coirbase1016
  if (g.option3 === 'dsbase') return (bg || 'Black') + ' - ' + dsColourQty() + ' Colour Print';
  return null;
}

// Prices for every visible card at the chosen size (the REAL Shopify variants add-to-cart uses).
async function gradePrices(){
  const out = {};
  S._priceFrom = {};
  for (const k of visibleGrades()) { try { const v = await getMatchedVariant(k); out[k] = v ? Number(v.price)/100 : null; } catch(e) { out[k] = null; }
    if (out[k] == null) { try { const f = await fromPriceFor(k); if (f != null) { out[k] = f; S._priceFrom[k] = true; } } catch (e) {} } } // 14 Oct 2026: never a dash
  return out;
}
// the cheapest base colour of mat k at its size (the card shows "from" when the chosen background is not one of its bases)
async function fromPriceFor(k){ const g = GRADES[k]; if (!g || !_dyoProduct) return null; const [sw, sh] = familySize(k).split('x'); const a = (sw + 'mm x ' + sh + 'mm').toLowerCase(), b = (sw + ' x ' + sh + 'mm').toLowerCase(), opt = String(g.opt || '').toLowerCase();
  const ps = (_dyoProduct.variants || []).filter(v => v.option1 && v.option2 && (v.option1.toLowerCase() === a || v.option1.toLowerCase() === b) && String(v.option2).toLowerCase().indexOf(opt) === 0).map(v => Number(v.price) / 100).filter(p => p > 0);
  return ps.length ? Math.min.apply(null, ps) : null; }
function gradeDelta(p, k){ const b = baseGrade(); if (p[k] == null || p[b] == null) return ''; const d = p[k] - p[b]; return (d >= 0 ? '+' : '-') + fmt(Math.abs(d)); }

function colourStatsNow(){ return (S.colourStats && S.colourStats.fileRef === S.file) ? S.colourStats : null; }
function isGradientArt(st){ if (!st) return false; if (st.grad != null) return st.gradBlocks >= GRADIENT_MIN_BLOCKS && st.grad >= GRADIENT_SHARE; return (st.buckets || 0) > GRADIENT_BUCKETS; }
// Can card k make this artwork without changing it? As-supplied: always. Cut / raised: never a gradient or photo.
function gradeFits(k, st){ if (!st || (S.genUsed && !S.genFamily)) return true; const g = GRADES[k]; if (g.asSupplied) return true; if (isGradientArt(st)) return false; if (!g.cap) return true; return st.distinct <= logoCapFor(k); }
// A card that cannot make the artwork at all (cut or embossed from a photo / gradient) is shown greyed, not offered.
function gradeBlocked(k, st){ const g = GRADES[k]; return !!st && !(S.genUsed && !S.genFamily) && (g.cut || g.raised) && isGradientArt(st); }
// The cheapest VISIBLE card that makes the artwork as it is (never a blocked one).
function defaultGradeFor(st){ const vis = visibleGrades().filter(k => !gradeBlocked(k, st)); for (const k of vis) if (gradeFits(k, st)) return k; return vis[vis.length - 1] || visibleGrades()[0]; }

function gradeAnalysis(){
  const st = colourStatsNow(), rec = {}, notes = {};
  let msg = '';
  if (S.genUsed && !S.genFamily) { msg = 'Designed in PrintPlush chart colours. Every grade prints it as shown.'; return { msg, rec, notes, st }; }
  if (!st) { msg = 'Checking your colours against our colour charts&hellip;'; return { msg, rec, notes, st }; }
  const N = st.distinct, off = st.off, s = n => n === 1 ? '' : 's';
  const fit = defaultGradeFor(st);
  const sel = S.grade || 'standard', selG = GRADES[sel];
  const grad = isGradientArt(st);
  const art = grad ? 'Your artwork has gradients or photographic tones' : 'Your artwork uses ' + N + ' colour' + s(N);
  for (const k of visibleGrades()) {
    const g = GRADES[k];
    if (gradeBlocked(k, st)) notes[k] = 'Needs a flat logo: this mat is ' + (g.cut ? 'cut and inlaid' : 'embossed') + ', so photos and gradients cannot be made';
    else if (g.cap && !gradeFits(k, st)) notes[k] = (g.cut ? 'Cuts' : g.raised ? 'Embosses' : 'Reduces') + ' your artwork to ' + g.cap + ' colour' + s(g.cap) + (bgTakesASlot() && !g.bgSeparate ? ' including the background' : '');
    if (g.whiteWarn && S.selectedBg && S.selectedBg.hex && lum(parseInt(S.selectedBg.hex.slice(1,3),16), parseInt(S.selectedBg.hex.slice(3,5),16), parseInt(S.selectedBg.hex.slice(5,7),16)) > 235) notes[k] = 'White backgrounds mark easily on this mat; a colour background lasts longer';
  }
  const chart = chartLabel();
  if (selG.asSupplied) {
    msg = art + '. ' + selG.title + ' prints it exactly as supplied, every colour.';
  } else if (selG.cut || selG.raised) {
    msg = art + '. ' + selG.title + ' is ' + (selG.cut ? 'cut and inlaid' : 'embossed') + ' in up to ' + selG.cap + ' ' + chart + ' chart colour' + s(selG.cap) + ' on the base colour you choose.';
    if (!gradeFits(sel, st)) msg += ' It keeps the ' + logoCapFor(sel) + ' most used and matches the rest to them.';
  } else if (sel === 'printscraper') {
    msg = art + '. PrintScraper prints it in its chart colours: the fibre is flecked, so colours read a shade lighter than on screen.';
    if (grad) { msg += ' Gradients print as flat colours; for a photographic print choose Rubber Scraper or an indoor High Definition mat.'; notes.printscraper = 'Gradients print as flat chart colours'; }
  } else if (gradeFits(sel, st)) {
    msg = art + ', within ' + selG.title + ' (up to ' + selG.cap + (bgTakesASlot() ? ' including the background' : '') + ').';
    if (sel !== fit && GRADES[fit]) msg += ' ' + GRADES[fit].title + ' would print it as well.';
  } else {
    msg = art + '. ' + selG.title + ' prints up to ' + selG.cap + (bgTakesASlot() ? ' including the background' : '') + ', so it keeps the ' + logoCapFor(sel) + ' most used colours and matches the rest to them.';
    msg += (fit === 'hd') ? ' High Definition prints every colour as supplied.' : (GRADES[fit] ? ' ' + GRADES[fit].title + ' prints all of them.' : '');
  }
  if (off && !selG.asSupplied && !selG.inlayFlush) { // coir inlay: every colour lands on one of three coirs by design, the chips show which
    msg += ' ' + off + ' colour' + s(off) + ' ' + (off > 1 ? 'have' : 'has') + ' no close match on the ' + chart + ' chart, so the preview shows the nearest ' + (selG.cut ? 'yarn' : 'print colour') + '.';
    if (visibleGrades().indexOf('hd') > -1 && sel !== 'hd') { msg += ' High Definition prints your exact colours.'; rec.hd = 'Exact colours'; }
  }
  return { msg, rec, notes, st };
}

// Called whenever fresh colour stats land: choose the default card once per artwork + placement (a manual pick is respected).
function applyDefaultGrade(){
  const st = colourStatsNow(); if (!st) return false;
  const key = JSON.stringify([st.fileRef && st.fileRef.name, st.fileRef && st.fileRef.size, bgTakesASlot(), S.placement || 'inside']);
  if (S.gradeManual || S.gradeAutoKey === key) return false;
  S.gradeAutoKey = key;
  const fit = defaultGradeFor(st);
  if (S.genUsed && fit === 'hd') return false;
  if (S.grade !== fit) { S.grade = fit; trail('grade', 'auto ' + gradeOf().title + ' (suits the artwork)'); onGradeChanged(); return true; }
  return false;
}
// The card must belong to the placement; if not (placement just changed), move to that placement's default.
function reconcileGradeWithPlacement(){
  if (visibleGrades().indexOf(S.grade) > -1) return false;
  S.gradeManual = false; S.gradeAutoKey = null;
  const st = colourStatsNow(); S.grade = st ? defaultGradeFor(st) : visibleGrades()[0];
  trail('grade', 'auto ' + gradeOf().title + ' (placement ' + (S.placement || 'inside') + ')');
  onGradeChanged();
  return true;
}
// Whenever the card changes: snap the mat size to one the family makes, keep the edge/drainage defaults sane.
function onGradeChanged(){
  const g = gradeOf();
  const s = familySize(S.grade); if (s !== S.size) { S.size = s; if (isCustomSize()) syncSizeSelect(); else ensureSizeOption(s); } // size1029: a typed size keeps the list on "Custom size ..."
  if (g.extras && g.extras.indexOf('edging') > -1 && (S.edging == null || S.edgeFamily !== g.key)) { S.edging = g.edgeDefault !== false; S.edgeFamily = g.key; }
  if (isPS() && S.drainage == null) S.drainage = S.placement !== 'inside';
}

let _gradeRenderSeq = 0;
async function renderGradeCards(){
  const block = $('tmgGradeBlock'); if (!block) return; uxiCss();
  if (S.step !== 2) { // 13 Oct 2026 perf: not on the Background step - keep the grade rules, rebuild the cards when the customer comes back
    S._cardsDirty = true;
    if (S.genUsed && !S.genFamily && S.grade === 'hd') S.grade = 'standard';
    if (reconcileGradeWithPlacement() || applyDefaultGrade()) { refreshArtworkForBudget(); fetchPricing(); }
    if ($('tmgPG')) $('tmgPG').textContent = gradeOf().title;
    return;
  }
  if (S.genUsed && !S.genFamily && S.grade === 'hd') S.grade = 'standard';
  if (reconcileGradeWithPlacement() || applyDefaultGrade()) { refreshArtworkForBudget(); fetchPricing(); return; }
  const seq = ++_gradeRenderSeq;
  const a = gradeAnalysis();
  const prices = await gradePrices();
  if (seq !== _gradeRenderSeq) return;
  const msgEl = $('tmgGradeMsg');
  if (msgEl) {
    let html = '<div>' + a.msg + '</div>';
    if (a.st && a.st.off && !(S.genUsed && !S.genFamily) && a.st.offList && a.st.offList.length && !asSupplied()) {
      html += '<div class="tmg-offlist">' + a.st.offList.slice(0, 4).map(o =>
        '<span class="tmg-offpair" title="Your colour ' + o.hex + ' prints as ' + o.near.name + '"><i style="background:' + o.hex + '"></i><b>&rarr;</b><i style="' + swatchCss(o.near.mm, o.near.hex) + '"></i><span>' + o.near.name + '</span></span>').join('') + '</div>';
    }
    msgEl.innerHTML = html;
  }
  const lbl = block.querySelector('.tmg-slbl'); if (lbl) lbl.textContent = (S.genUsed && !S.genFamily) ? 'Choose your print grade' : placementOf().label;
  const wrap = $('tmgGrades'); if (!wrap) return;
  const base = baseGrade();
  wrap.innerHTML = visibleGrades().filter(k => S.showOther || k === S.grade || !gradeBlocked(k, a.st)).map(k => { // Zac 13 Oct: a mat that cannot make the design is not an option - only under "See all mat types"
    const g = GRADES[k], sel = (S.grade || 'standard') === k, p = prices[k], blocked = gradeBlocked(k, a.st);
    const price = p == null ? '&mdash;' : (S._priceFrom && S._priceFrom[k]) ? '<span class="tmg-grade-from">from</span> ' + fmt(p) : (k === base ? fmt(p) : gradeDelta(prices, k));
    const fs = familySize(k), want = customPick() || stdPick() || S.size, sizeNote = (isCustomSize() && customOf(k)) ? '<span class="tmg-grade-size">made to measure ' + customSizeLabel() + '</span>' : fs !== want ? '<span class="tmg-grade-size">made ' + sizeLabel(fs) + (isCustomSize() ? ' (nearest standard size)' : ' (you chose ' + sizeLabel(want) + ')') + '</span>' : (customOf(k) && familySizes(k).indexOf(fs) < 0) ? '<span class="tmg-grade-size">made to measure ' + sizeLabel(fs) + '</span>' : '';
    const sub = (k !== base && p != null && !(S._priceFrom && S._priceFrom[k])) ? '<span class="tmg-grade-abs">' + fmt(p) + '</span>' : '';
    const extra = sel ? extrasHtml(g) : '';
    return '<div class="tmg-grade' + (sel ? ' sel' : '') + (a.rec[k] ? ' rec' : '') + (blocked ? ' dim' : '') + (/* ux1014k: a picked card never widens */ '') + '" data-g="' + k + '" role="radio" aria-checked="' + sel + '" aria-disabled="' + blocked + '" tabindex="0">' +
      (a.rec[k] ? '<div class="tmg-grade-badge">' + a.rec[k] + '</div>' : '') +
      (S.file ? '<canvas class="tmg-grade-prev" width="240" height="160" aria-hidden="true"></canvas>' : '') +
      '<button type="button" class="tmg-grade-info" data-info="' + k + '" aria-label="About ' + g.title + '">i</button>' +
      '<div class="tmg-grade-top"><span class="tmg-grade-name">' + g.title + '</span><span class="tmg-grade-price">' + price + sub + sizeNote + '</span></div>' +
      '<div class="tmg-grade-tag">' + g.tag + '</div>' + colourNoteHtml(k) +
      '<ul class="tmg-grade-list">' + g.bullets.map(b => '<li>' + b + '</li>').join('') + '</ul>' +
      (a.notes[k] ? '<div class="tmg-grade-note">' + a.notes[k] + '</div>' : '') +
      '<div class="tmg-grade-lead">Lead time approx. ' + leadOf(k) + ' from proof approval</div>' +
      extra +
      '<a class="tmg-grade-spec" href="' + g.spec + '" target="_blank" rel="noopener">Spec sheet (PDF) &rarr;</a>' +
      (g.chartUrl ? ' <a class="tmg-grade-spec" href="' + g.chartUrl + '" target="_blank" rel="noopener">Colour chart &rarr;</a>' : '') +
      '<span class="tmg-grade-check">' + (sel ? '&#10003;' : '') + '</span></div>';
  }).join('') + placementSwitchHtml();
  wrap.querySelectorAll('.tmg-grade').forEach(el => {
    const pick = () => selectGrade(el.dataset.g);
    el.addEventListener('click', e => { if (e.target.closest('a') || e.target.closest('.tmg-drain') || e.target.closest('[data-info]')) return; pick(); });
    el.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { if (e.target.closest('.tmg-drain')) return; e.preventDefault(); pick(); } });
  });
  wrap.querySelectorAll('.tmg-drain-opt[data-x="drainage"]').forEach(el => el.addEventListener('click', e => { e.stopPropagation(); setDrainage(el.dataset.v === '1'); }));
  wrap.querySelectorAll('.tmg-drain-opt[data-x="edging"]').forEach(el => { el.addEventListener('click', e => { e.stopPropagation(); S._edgeHover = undefined; setEdging(el.dataset.v === '1'); });
    const mini = () => { if (miniPreviewVisible()) renderMiniCanvas('tmgStep2Canvas'); }; // hover previews the band (Zac, 12 Oct 2026)
    el.addEventListener('mouseenter', () => { const v = el.dataset.v === '1'; if (v !== (S.edging !== false)) { S._edgeHover = v; mini(); } });
    el.addEventListener('mouseleave', () => { if (S._edgeHover !== undefined) { S._edgeHover = undefined; mini(); } }); });
  wrap.querySelectorAll('.tmg-place-switch').forEach(sw => sw.addEventListener('click', e => { e.preventDefault(); const to = sw.dataset.to; if (to === 'other') { S.showOther = !S.showOther; renderGradeCards(); } else setPlacement(to); }));
  hideGradeConfirm();
  if ($('tmgPG')) $('tmgPG').textContent = gradeOf().title;
  renderCardPreviews();
}
// ── Mat previews on the cards (Zac, 13 Oct 2026): every card shows the customer's design on THAT mat, painted with the
//    same per-family renderer as the Configure mini preview (edge band, surface tiles, chart colours, colour cap), one
//    card per animation frame, cached by (file, mat, background, edging, drainage, fill mode, size). S is swapped to the
//    card's family for the paint and restored before anything else runs (all synchronous).
const _cardPrev = { map: new Map(), seq: 0 };
function overridesKey(k){ const o = S.colourOverrides, ch = GRADES[k] && GRADES[k].chart; return (o && o.map && o.chart === ch && Object.keys(o.map).length) ? [o.chart, o.map] : null; } // 14 Oct 2026: only the overrides that apply to mat k (an empty record's chart label flips as mats change)
function cardPrevKey(k){ const f = S.file || {}, b = S.selectedBg || {}; return JSON.stringify([f.name, f.size, f.lastModified, k, b.mm, b.hex, b.name, S.edging, S.drainage, !!S.useArtworkAsBg, !!S.dropLogoBg, S.size, S.matWmm, S.matHmm, !!S.genUsed, overridesKey(k)]); }
function nearestChartRowFor(hex){ // the current family's nearest chart colour to a hex (how afterFamilyChange carries a base across)
  try { const rows = familyChart(); if (!hex || !rows || !rows.length) return null;
    if (gradeOf().bgChart === 'coir') return rows.find(r => r[2] === 'Natural') || rows[0]; // coirbase1016: coir starts on Natural, never the nearest to a printed-mat colour
    const want = rgbToLab(parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)); let near = null, bd = Infinity;
    for (const r of rows) { const lab = rgbToLab(parseInt(r[1].slice(1, 3), 16), parseInt(r[1].slice(3, 5), 16), parseInt(r[1].slice(5, 7), 16)); const d = deltaE2000(want, lab); if (d < bd) { bd = d; near = r; } }
    return near; } catch (e) { return null; }
}
// 14 Oct 2026: small renders (mat cards, mini preview) process the logo at >= SS_MIN px and shrink the result, so thin
// strokes survive the background clean-up and the edges stay sharp (see patch-ux1014m.js)
const SS_MIN = 560;
function superSample(off, drawFn, procFn){
  const L = Math.max(off.width, off.height), s = L >= SS_MIN ? 1 : Math.min(4, SS_MIN / L);
  const octx = off.getContext('2d', { willReadFrequently: true });
  if (s === 1) { octx.clearRect(0, 0, off.width, off.height); drawFn(octx, off.width, off.height); procFn(off, octx, off.width, off.height); return; }
  const wk = document.createElement('canvas'); wk.width = Math.round(off.width * s); wk.height = Math.round(off.height * s);
  const wctx = wk.getContext('2d', { willReadFrequently: true }); wctx.imageSmoothingEnabled = true; wctx.imageSmoothingQuality = 'high';
  drawFn(wctx, wk.width, wk.height); procFn(wk, wctx, wk.width, wk.height);
  const shrink = (src, dst) => { const x = dst.getContext('2d', { willReadFrequently: true }); x.clearRect(0, 0, dst.width, dst.height); x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high'; x.drawImage(src, 0, 0, dst.width, dst.height); return dst; };
  shrink(wk, off);
  const sh = artCanvas(wk); off.__shaded = null;
  if (sh && sh !== wk) { const c = document.createElement('canvas'); c.width = off.width; c.height = off.height; off.__shaded = shrink(sh, c); }
  if (S.shaded && S.shaded.src === wk) S.shaded = off.__shaded ? { src: off, canvas: off.__shaded } : null;
}
function paintCardPreview(k, cv, img){
  const W = cv.width, H = cv.height, ctx = cv.getContext('2d', { willReadFrequently: true });
  const saved = { grade: S.grade, bg: S.selectedBg, used: S.actualPmsUsed, matched: S.matchedMms, shaded: S.shaded, cached: cachedLogo, stats: S.colourStats };
  S.grade = k;
  try {
    if (S.selectedBg && S.selectedBg.mm && !S.useArtworkAsBg && !familyChart().some(r => r[0] === S.selectedBg.mm)) { const near = nearestChartRowFor(S.selectedBg.hex); if (near) S.selectedBg = { mm: near[0], hex: near[1], name: near[2] }; }
    ctx.clearRect(0, 0, W, H);
    const edgePx = Math.round(W * (20 / 900)), ins = edgeInsetPx(W, edgePx), mmPerPx = (S.matWmm || 900) / W;
    if (S.selectedBg && S.selectedBg.hex) drawMatBg(ctx, W, H, S.selectedBg.hex, true, mmPerPx); else { ctx.fillStyle = '#e4e4e4'; ctx.fillRect(0, 0, W, H); drawEdge(ctx, W, H, edgePx); }
    const off = document.createElement('canvas'), octx = off.getContext('2d', { willReadFrequently: true });
    if (S.useArtworkAsBg) { off.width = Math.max(1, W - ins * 2); off.height = Math.max(1, H - ins * 2); drawCover(octx, img, 0, 0, off.width, off.height); }
    else { let dw = img.width, dh = img.height; const mw = W * 0.9, mh = H * 0.9; if (dw > mw) { dh *= mw / dw; dw = mw; } if (dh > mh) { dw *= mh / dh; dh = mh; } off.width = Math.max(1, Math.round(dw)); off.height = Math.max(1, Math.round(dh)); octx.drawImage(img, 0, 0, off.width, off.height); }
    superSample(off, (x, w, h) => { if (S.useArtworkAsBg) drawCover(x, img, 0, 0, w, h); else x.drawImage(img, 0, 0, w, h); }, (off, octx, W2, H2) => {
    if (!asSupplied()) { try { if (isCut() || isRaised() || dropBgNow()) { dropArtworkBackground(octx, W2, H2); dropDominantFill(octx, W2, H2, logoCap()); } quantiseImageToPMS(off, octx, W2, H2); } catch (e) {} } else if (dropBgNow()) { try { dropArtworkBackground(octx, W2, H2); } catch (e) {} } /* 14 Oct 2026: as-supplied mats see through the white too */
    }); // ux1014m: processed at >= SS_MIN px, then shrunk
    if (S.useArtworkAsBg) ctx.drawImage(artCanvas(off), ins, ins); else ctx.drawImage(artCanvas(off), Math.round((W - off.width) / 2), Math.round((H - off.height) / 2));
    drawStudRelief(ctx, W, H, mmPerPx);
  } catch (e) { console.warn('[TMG] card preview ' + k + ': ' + (e && e.message)); }
  finally { S.grade = saved.grade; S.selectedBg = saved.bg; S.actualPmsUsed = saved.used; S.matchedMms = saved.matched; S.shaded = saved.shaded; cachedLogo = saved.cached; S.colourStats = saved.stats; }
}
function nextFrame(fn){ if (document.hidden || typeof requestAnimationFrame !== "function") setTimeout(fn, 0); else requestAnimationFrame(fn); } // a hidden tab never gets animation frames
function renderCardPreviews(){
  const wrap = $('tmgGrades'); if (!wrap || !S.file) return;
  const seq = ++_cardPrev.seq;
  const cards = Array.prototype.slice.call(wrap.querySelectorAll('.tmg-grade[data-g]')); if (!cards.length) return;
  loadSourceImage(S.file, img => {
    if (seq !== _cardPrev.seq) return;
    let i = 0;
    const step = () => {
      if (seq !== _cardPrev.seq) return;
      const card = cards[i++]; if (!card) return;
      const cv = card.querySelector('canvas.tmg-grade-prev'), k = card.dataset.g;
      if (cv && GRADES[k]) {
        const key = cardPrevKey(k); let src = _cardPrev.map.get(key);
        if (!src) { src = document.createElement('canvas'); src.width = cv.width; src.height = cv.height; paintCardPreview(k, src, img); if (_cardPrev.map.size > 80) _cardPrev.map.clear(); _cardPrev.map.set(key, src); }
        cv.getContext('2d').drawImage(src, 0, 0); cv.classList.add('on');
      }
      if (cards[i]) nextFrame(step);
    };
    nextFrame(step);
  });
}
function extrasHtml(g){
  let h = '';
  (g.extras || []).forEach(x => { if (x === 'drainage') h += drainageToggleHtml(); if (x === 'edging') h += edgingToggleHtml(g); });
  return h;
}

// ── Placement (Configure step tiles) ──
function placementTilesHtml(){
  return Object.values(PLACEMENTS).map(p => '<button type="button" class="tmg-place' + ((S.placement || 'inside') === p.key ? ' sel' : '') + '" data-p="' + p.key + '"><span class="tmg-place-ico">' + p.ico + '</span><span class="tmg-place-t">' + p.title + '</span><span class="tmg-place-s">' + p.sub + '</span></button>').join('');
}
function renderPlacement(){
  familyTiles('ps'); // start loading the fibre sprites early so the first textured render already has them
  const w = $('tmgPlacement'); if (!w) return;
  w.innerHTML = placementTilesHtml();
  w.querySelectorAll('.tmg-place').forEach(b => b.addEventListener('click', () => setPlacement(b.dataset.p)));
}
function setPlacement(k){
  if (!PLACEMENTS[k] || S.placement === k) return;
  S.placement = k; S.showOther = false;
  if (k !== 'inside' && S.drainage == null) S.drainage = true; // outside / wet: holes on by default, the customer can turn them off
  renderPlacement();
  if (reconcileGradeWithPlacement()) { refreshArtworkForBudget(); fetchPricing(); }
  else renderGradeCards();
}
function placementSwitchHtml(){
  const p = S.placement || 'inside';
  const links = [];
  if (p === 'inside') links.push(['outside', 'Busy entrance or outside? Show the heavy-duty mats']);
  else links.push(['inside', 'Need an indoor mat instead? Show PrintPlush and Superguard']);
  if (!(S.genUsed && !S.genFamily)) links.push(['other', S.showOther ? 'Show fewer mats' : 'See all ' + GRADE_ORDER.length + ' mat types']);
  return links.map(([to, t]) => '<a href="#" class="tmg-place-switch" data-to="' + to + '">' + t + '</a>').join('');
}

// ── In-card extras: drainage holes (PrintScraper, free) and edging (SpiralLoop / Superguard) ──
function drainageOn(){ return isPS() && !!S.drainage; }
function drainageToggleHtml(){
  const on = !!S.drainage;
  return '<div class="tmg-drain" role="radiogroup" aria-label="Drainage holes">' +
    '<div class="tmg-drain-lbl">Drainage holes <span>free, for mats that get rained on</span></div>' +
    '<div class="tmg-drain-opts">' +
      '<button type="button" class="tmg-drain-opt' + (on ? '' : ' sel') + '" data-x="drainage" data-v="0" role="radio" aria-checked="' + !on + '"><span class="tmg-drain-swatch"></span>Solid</button>' +
      '<button type="button" class="tmg-drain-opt' + (on ? ' sel' : '') + '" data-x="drainage" data-v="1" role="radio" aria-checked="' + on + '"><span class="tmg-drain-swatch tmg-drain-holes"></span>With holes</button>' +
    '</div></div>';
}
function setDrainage(on){
  S.drainage = !!on;
  const wrap = $('tmgGrades'); if (wrap) wrap.querySelectorAll('.tmg-drain-opt[data-x="drainage"]').forEach(el => { const sel = (el.dataset.v === '1') === S.drainage; el.classList.toggle('sel', sel); el.setAttribute('aria-checked', sel); });
  if (S.step === 4) renderCanvas();
}
function edgingOn(){ const g = gradeOf(); return !!(g.extras && g.extras.indexOf('edging') > -1) && S.edging !== false; }
function hasEdging(){ const g = gradeOf(); return !!(g.extras && g.extras.indexOf('edging') > -1); }
function edgeMetres(k){ const s = familySize(k || S.grade); const [a, b] = String(s).split('x').map(Number); return Math.ceil(2 * (a + b) / 1000); } // whole metres of perimeter
function edgingSurcharge(){ const g = gradeOf(); if (!g.edgeCharge || !edgingOn()) return 0; return Math.round(edgeMetres(g.key) * g.edgeCharge.rate * 100) / 100; } // per mat
function renderEdgePriceRow(){ const row = $('tmgEDGR'); if (!row) return; const g = gradeOf(); const on = !!(g.edgeCharge && edgingOn()); row.style.display = on ? 'flex' : 'none'; if (on) $('tmgEDGV').innerHTML = edgeMetres(g.key) + ' m &times; ' + fmt(g.edgeCharge.rate) + ' = ' + fmt(edgingSurcharge()) + (S.qty > 1 ? ' a mat' : ''); }
function edgingCartItems(mainProps){ const g = gradeOf(); if (!g.edgeCharge || !edgingOn()) return []; const m = edgeMetres(g.key); return [{ id: g.edgeCharge.variantId, quantity: m * (S.qty || 1), properties: { 'For': g.title + ' ' + (mainProps['Mat Size'] || '') + ' x ' + (S.qty || 1), 'Edging': m + ' m a mat', 'SKU': g.edgeCharge.sku, 'Configurator': 'Yes' } }]; }
function edgePriceNote(g){
  if (g.edgeCharge) return ' <small class="tmg-edge-price">+' + fmt(Math.round(edgeMetres(g.key) * g.edgeCharge.rate * 100) / 100) + ' (' + edgeMetres(g.key) + ' m &times; ' + fmt(g.edgeCharge.rate) + ')</small>';
  const c = typeof customOf === 'function' ? customOf(g.key) : null;
  if (typeof isCustomSize === 'function' && (isCustomSize() || alwaysMint(g.key)) && c && c.edgeRate) return ' <small class="tmg-edge-price">+' + fmt(c.edgeRate) + ' per metre</small>';
  return ' <small class="tmg-edge-price">included</small>';
}
function edgingToggleHtml(g){
  const on = S.edging !== false, o = g.edgeOpts || ['Edged', 'No edge'];
  return '<div class="tmg-drain" role="radiogroup" aria-label="Edge">' +
    '<div class="tmg-drain-lbl">Edge <span>' + (g.key === 'superguard' ? 'recess fit for a mat well' : g.edgeCharge ? 'PVC edging around the coir, optional' : 'leave open over a drain or in a recess') + '</span></div>' +
    '<div class="tmg-drain-opts">' +
      '<button type="button" class="tmg-drain-opt' + (on ? ' sel' : '') + '" data-x="edging" data-v="1" role="radio" aria-checked="' + on + '"><span class="tmg-drain-swatch tmg-edge-on"></span>' + o[0] + edgePriceNote(g) + '</button>' +
      '<button type="button" class="tmg-drain-opt' + (on ? '' : ' sel') + '" data-x="edging" data-v="0" role="radio" aria-checked="' + !on + '"><span class="tmg-drain-swatch tmg-edge-off"></span>' + o[1] + '</button>' +
    '</div></div>';
}
function setEdging(on){
  S.edging = !!on;
  if (typeof fetchPricing === 'function' && ((typeof isCustomSize === 'function' && isCustomSize()) || gradeOf().edgeCharge || gradeOf().alwaysMint)) fetchPricing(); // edging is priced per metre on a custom size, and always on coir
  const wrap = $('tmgGrades'); if (wrap) wrap.querySelectorAll('.tmg-drain-opt[data-x="edging"]').forEach(el => { const sel = (el.dataset.v === '1') === S.edging; el.classList.toggle('sel', sel); el.setAttribute('aria-checked', sel); });
  if (S.step === 4) renderCanvas();
  if (miniPreviewVisible()) renderMiniCanvas('tmgStep2Canvas');
}

// One-line confirmation, shown only when the chosen card would drop colours from the artwork.
function hideGradeConfirm(){ const c = $('tmgGradeConfirm'); if (c) { c.style.display = 'none'; c.innerHTML = ''; } }
function showGradeConfirm(k){
  const c = $('tmgGradeConfirm'); const st = colourStatsNow(); if (!c || !st) return applyGrade(k);
  const g = GRADES[k], bgNote = (bgTakesASlot() && !g.bgSeparate) ? ', including the background' : '';
  const verb = g.cut ? 'cuts' : g.raised ? 'embosses' : 'prints';
  const what = isGradientArt(st) ? 'has gradients that print as flat colours' : 'uses ' + st.distinct + ' colours';
  c.innerHTML = '<div class="tmg-gc-text"><b>' + g.title + '</b> ' + verb + ' up to ' + g.cap + ' colour' + (g.cap === 1 ? '' : 's') + bgNote + '. Your artwork ' + what + ', so we would keep the ' + logoCapFor(k) + ' most used and match the rest to ' + (logoCapFor(k) === 1 ? 'it' : 'them') + '.</div>' +
    '<div class="tmg-gc-btns"><button type="button" class="tmg-gc-yes" id="tmgGcYes">Reduce to ' + g.cap + ' colour' + (g.cap === 1 ? '' : 's') + '</button><button type="button" class="tmg-gc-no" id="tmgGcNo">Keep ' + gradeOf().title + '</button></div>';
  c.style.display = 'block';
  $('tmgGcYes').addEventListener('click', () => applyGrade(k));
  $('tmgGcNo').addEventListener('click', hideGradeConfirm);
  try { c.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch(e) {}
}
function applyGrade(k){
  S.grade = k; S.gradeManual = true; trail('grade', 'customer picked ' + gradeOf().title);
  onGradeChanged();
  hideGradeConfirm();
  refreshArtworkForBudget();
  fetchPricing();
}
function selectGrade(k){
  if (!GRADES[k] || S.grade === k) return;
  if (gradeBlocked(k, colourStatsNow())) return;
  if (GRADES[k].cap && !gradeFits(k, colourStatsNow())) return showGradeConfirm(k);
  applyGrade(k);
}

// The family changed: the background / base picker shows that family's chart, a background the family cannot make is
// dropped so the customer picks again, and the labels say which chart the artwork was matched to.
function afterFamilyChange(){
  const bgl = $('tmgBgLabelText'); if (bgl) bgl.textContent = bgLabelText();
  const tg = $('tmgBgToggleText'); if (tg) tg.textContent = bgLabelText().replace(/^Choose /, 'Change ').replace('mat background colour', 'Background Colour');
  if (typeof buildGrid === 'function' && $('tmgBgGrid')) buildGrid('all');
  if (S.selectedBg && S.selectedBg.mm && !S.useArtworkAsBg && !familyChart().some(r => r[0] === S.selectedBg.mm)) {
    // carry the choice across: the nearest colour this family is made in (Zac 5 Oct: a Superguard custom order went through with no base colour)
    const want = S.selectedBg.hex ? rgbToLab(parseInt(S.selectedBg.hex.slice(1, 3), 16), parseInt(S.selectedBg.hex.slice(3, 5), 16), parseInt(S.selectedBg.hex.slice(5, 7), 16)) : null;
    let near = null, bd = Infinity; if (want) for (const r of familyChart()) { const lab = rgbToLab(parseInt(r[1].slice(1, 3), 16), parseInt(r[1].slice(3, 5), 16), parseInt(r[1].slice(5, 7), 16)); const d = deltaE2000(want, lab); if (d < bd) { bd = d; near = r; } }
    if (gradeOf().bgChart === 'coir') { near = familyChart().find(r => r[2] === 'Natural') || near; S.bgSrc = 'coir default'; } // coirbase1016: coir starts on Natural
    if (near && typeof selectBg === 'function') { S.bgSrc = 'nearest on the ' + gradeOf().title + ' chart'; selectBg(near[0], near[1], near[2], near[3] === 'light'); return; }
    trail('bg', 'cleared (not made on ' + gradeOf().title + ')'); S.selectedBg = null; if ($('tmgSelDisp')) $('tmgSelDisp').classList.remove('vis'); if ($('tmgTo3')) $('tmgTo3').disabled = true; if ($('tmgBgCurrentLabel')) $('tmgBgCurrentLabel').textContent = '';
    if ($('tmgBgCollapsible')) $('tmgBgCollapsible').style.display = '';
  }
  const noFill = isCut() || isRaised() || !!gradeOf().noFill; // cut / embossed mats, and Rubber Scraper (print stays 100 mm inside the rubber edge)
  const ua = $('tmgUseAsIs'); if (ua) ua.style.display = noFill ? 'none' : 'flex'; // flex is the button's own layout
  if (noFill && S.useArtworkAsBg) { S.useArtworkAsBg = false; if ($('tmgUseAsIsCheck')) $('tmgUseAsIsCheck').textContent = ''; if (ua) ua.style.background = 'var(--sf2)'; if ($('tmgBgToggle')) $('tmgBgToggle').style.display = 'flex';
    if (S.selectedBg && S.selectedBg.isArtworkBg) { S.selectedBg = null; if ($('tmgBgCollapsible')) $('tmgBgCollapsible').style.display = ''; if ($('tmgTo3')) $('tmgTo3').disabled = true; } } // the stand-in background of a full design is not a choice: the customer picks one
  const nt = $('tmgPmsNoticeText'); if (nt) nt.textContent = asSupplied() ? '🎨 Your artwork prints exactly as supplied' : '🎨 Your artwork has been matched to the ' + chartLabel() + ' colour chart';
}
function s2LabelText(){ return asSupplied() ? 'Your Artwork (printed exactly as supplied)' : isCut() ? 'Your Artwork (cut in ' + chartLabel() + ' colours)' : isRaised() ? 'Your Artwork (embossed in chart colours)' : isPS() ? 'Your Artwork (PrintScraper chart colours)' : 'Your Artwork (PMS Adjusted)'; }
function bannerText(){ return gradeOf().inlayFlush ? '🎨 Colours matched to the three coir colours. The logo is laser-cut from solid dyed coir and inlaid flush, so it never wears off.' : isCut() ? '🎨 Colours matched to the ' + chartLabel() + ' chart. The logo is cut from solid yarn, so every colour prints flat and sharp.' : isRaised() ? '🎨 Colours matched to the embossed chart. The logo stands proud of the mat.' : isPS() ? '🎨 Colours matched to the PrintScraper chart. The fibre is flecked, so colours read a shade lighter than on screen.' : '🎨 Colours matched to PrintPlush PMS range.'; }
// The quantised artwork depends on the card AND on whether a background takes a colour slot: rebuild it.
function refreshArtworkForBudget(){
  if (typeof updateTranspBtn === 'function') updateTranspBtn();
  afterFamilyChange();
  cachedLogo = null; S.actualPmsUsed = [];
  renderGradeCards();
  if (S.file) {
    if (typeof showPmsNotice === 'function') showPmsNotice(S.validation);
    if (miniPreviewVisible()) renderMiniCanvas('tmgStep2Canvas');
  }
}

// ── Textures: real swatch photos per chart colour (PrintScraper sheet + the product-page swatch sprites), procedural
//    tiles for coir / flock / rubber / felt. One sheet per chart key: { img|canvas, map(mm -> {x,y}), tile, ready, mmPerTile }.
const _tiles = {};
function familyTiles(key){
  if (_tiles[key]) return _tiles[key];
  const A = window.TMG_ASSETS || {};
  const t = _tiles[key] = { ready: false, map: {}, tile: 128, img: null, mmPerTile: 50 };
  const onReady = () => { t.ready = true; _tileData[key] = null; try { _cardPrev.map.clear(); renderCardPreviews(); } catch (e) {} if (gradeOf().chart === key || gradeOf().bgChart === key) { cachedLogo = null; S.actualPmsUsed = []; if (S.step === 2 && $('tmgStep2Canvas')) { renderMiniCanvas('tmgStep2Canvas'); if (typeof showPmsNotice === 'function') showPmsNotice(S.validation); } if (S.step === 4) renderCanvas(); } };
  if (key === 'ps') {
    const P = window.TMG_PS_TILES || {}; t.tile = P.tile || 128; t.mmPerTile = 55;
    for (const code in (P.codes || {})) t.map['MM' + code] = { x: P.codes[code].x, y: P.codes[code].y };
    t.img = new Image(); t.img.crossOrigin = 'anonymous'; t.img.onload = onReady; t.img.onerror = () => console.warn('[TMG] PrintScraper tile sprite failed to load'); t.img.src = A.psTiles || '';
    return t;
  }
  // SpiralLoop / Superguard: the 512 px tiles cut from the print colour charts (assets/superguard-tiles.jpg,
  // spiralloop-tiles.jpg); the product-page sprites are the fallback when the sheets are not on the theme.
  const HI = key === 'sg' ? (window.TMG_SG_TILES || null) : key === 'sl' ? (window.TMG_SL_TILES || null) : null;
  const hiUrl = key === 'sg' ? A.sgTiles : key === 'sl' ? A.slTiles : '';
  if (HI && HI.codes && hiUrl) {
    t.tile = HI.tile || 512; t.mmPerTile = HI.mm || (key === 'sg' ? 55 : 48);
    for (const name in HI.codes) { const p = { x: HI.codes[name].x, y: HI.codes[name].y }; if (key === 'sg') { t.map['SG:' + name] = p; t.map['SGB:' + name] = p; } else t.map['SL:' + name] = p; }
    t.img = new Image(); t.img.crossOrigin = 'anonymous'; t.img.onload = onReady; t.img.onerror = () => console.warn('[TMG] ' + key + ' tile sheet failed to load'); t.img.src = hiUrl;
    return t;
  }
  const table = key === 'sl' ? chartTable('sl') : key === 'sg' ? chartTable('sg').concat(chartTable('sgbase')) : [];
  const bands = {}; table.forEach(c => { if (c.tile && c.tile.band) bands[c.tile.band] = null; });
  const names = Object.keys(bands); if (!names.length) return t;
  t.tile = key === 'sg' ? 144 : 96; t.mmPerTile = key === 'sg' ? 50 : 40;
  let left = names.length;
  names.forEach(n => { const im = new Image(); im.crossOrigin = 'anonymous'; im.onload = im.onerror = () => { bands[n] = im.naturalWidth ? im : null; if (--left === 0) compose(); }; im.src = (A.swatches || '') + n + '.jpg'; });
  function compose(){
    const cols = 10, rows = Math.ceil(table.length / cols);
    const cv = document.createElement('canvas'); cv.width = cols * t.tile; cv.height = rows * t.tile; const x = cv.getContext('2d');
    table.forEach((c, i) => {
      const dx = (i % cols) * t.tile, dy = Math.floor(i / cols) * t.tile, im = bands[c.tile.band];
      if (im) { const w = im.naturalWidth / c.tile.count; x.drawImage(im, c.tile.idx * w, 0, w, im.naturalHeight, dx, dy, t.tile, t.tile); } else { x.fillStyle = c.hex; x.fillRect(dx, dy, t.tile, t.tile); }
      t.map[c.mm] = { x: dx, y: dy };
    });
    t.img = cv; onReady();
  }
  return t;
}
const _tileData = {};
function familyTileData(){
  const g = gradeOf(); if (!g.tiled) return null;
  const key = g.chart; if (_tileData[key]) return _tileData[key];
  const tl = familyTiles(key); if (!tl.ready || !tl.img) return null;
  try { const w = tl.img.naturalWidth || tl.img.width, h = tl.img.naturalHeight || tl.img.height; const c = document.createElement('canvas'); c.width = w; c.height = h; const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(tl.img, 0, 0); _tileData[key] = { data: x.getImageData(0, 0, w, h).data, w, tile: tl.tile, map: tl.map, mmPerTile: tl.mmPerTile }; } catch(e) { return null; }
  return _tileData[key];
}
// Kept for the live call sites: PrintScraper tile data + scale helpers now route through the family versions.
function psTileData(){ return familyTileData(); }
const PS_TILE_MM = 55;
function tileScale(mmPerPx){ const g = gradeOf(); const t = familyTiles(g.chart === 'sgbase' ? 'sg' : g.chart); return (t.mmPerTile / t.tile) / Math.max(0.05, mmPerPx || 1); }
function psTileScale(mmPerPx){ return tileScale(mmPerPx); }
// 14 Oct 2026 (ux1014m): a tile pre-shrunk with high-quality smoothing for patterns drawn below full size, cached per tile + size;
// sx / sy restore the exact repeat period after rounding the shrunk tile to whole pixels
const _smoothTiles = new WeakMap();
function smoothTile(c, scale){ try { const tw = Math.max(2, Math.round(c.width * scale)), th = Math.max(2, Math.round(c.height * scale)); let m = _smoothTiles.get(c); if (!m) { m = new Map(); _smoothTiles.set(c, m); } const k = tw + 'x' + th; let s = m.get(k);
  if (!s) { let src = c; while (src.width / 2 > tw * 1.05) { const h = document.createElement('canvas'); h.width = Math.ceil(src.width / 2); h.height = Math.ceil(src.height / 2); const hx = h.getContext('2d'); hx.imageSmoothingEnabled = true; hx.imageSmoothingQuality = 'high'; hx.drawImage(src, 0, 0, h.width, h.height); src = h; }
    s = document.createElement('canvas'); s.width = tw; s.height = th; const sx = s.getContext('2d'); sx.imageSmoothingEnabled = true; sx.imageSmoothingQuality = 'high'; sx.drawImage(src, 0, 0, tw, th); if (m.size > 24) m.clear(); m.set(k, s); }
  return { c: s, sx: (c.width * scale) / tw, sy: (c.height * scale) / th }; } catch (e) { return null; } }
// A CanvasPattern of the surface for one chart entry (null until the sheet has loaded or if the entry has no tile).
function tilePattern(ctx, mm, scale){
  const g = gradeOf(); const key = g.chart === 'sg' || g.bgChart === 'sgbase' ? 'sg' : g.chart;
  const t = familyTiles(key); if (!t.ready || !t.img) return null;
  const pos = t.map[mm]; if (!pos) return null;
  const r = (key === 'sg' || key === 'sl') ? cleanTileRect(t.img, pos.x, pos.y, t.tile) : null; // 14 Oct 2026: chart-gap strips on tile edges drew lines at every repeat
  const c = r ? mirrorTile(t.img, r.x, r.y, r.w, r.h, t.tile) : mirrorTile(t.img, pos.x, pos.y, t.tile, t.tile);
  if (scale && scale < 0.95) { const sm = smoothTile(c, scale); if (sm) { const p2 = ctx.createPattern(sm.c, 'repeat'); if (p2 && p2.setTransform) { try { p2.setTransform(new DOMMatrix().scale(sm.sx, sm.sy)); } catch(e) {} return p2; } } } // ux1014m: no speckle when drawn small
  const p = ctx.createPattern(c, 'repeat');
  if (p && p.setTransform && scale && scale !== 1) { try { p.setTransform(new DOMMatrix().scale(scale)); } catch(e) {} }
  return p;
}
function psPattern(ctx, mm, scale){ return tilePattern(ctx, mm, scale); }
// A 2 x 2 mirrored copy of a swatch: every edge meets its own reflection, so the repeat has no visible seams or grid.
const _mirrorCache = new Map();
// 14 Oct 2026: the clean part of a chart tile - edge rows / columns whose mean luma is off the middle 40% of the tile (the white
// or light gap between swatches on the printed chart) are trimmed, up to 15% per side. Cached per tile.
const _cleanRect = new Map();
function cleanTileRect(img, sx, sy, T){
  const key = (img.src || img.width + 'c') + ':' + sx + ',' + sy + ',' + T; if (_cleanRect.has(key)) return _cleanRect.get(key);
  let r = null;
  try {
    const c = document.createElement('canvas'); c.width = T; c.height = T; const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, sx, sy, T, T, 0, 0, T, T);
    const d = x.getImageData(0, 0, T, T).data, L = (px, py) => { const o = (py * T + px) * 4; return 0.299 * d[o] + 0.587 * d[o + 1] + 0.114 * d[o + 2]; };
    const row = y => { let s = 0; for (let i = 0; i < T; i++) s += L(i, y); return s / T; }, col = xx => { let s = 0; for (let i = 0; i < T; i++) s += L(xx, i); return s / T; };
    let mid = 0, n = 0; for (let y = Math.floor(T * 0.3); y < T * 0.7; y++) { mid += row(y); n++; } mid /= n;
    const MAX = Math.floor(T * 0.15), TOL = 18; let t = 0, b = 0, l = 0, rr = 0;
    while (t < MAX && Math.abs(row(t) - mid) > TOL) t++; while (b < MAX && Math.abs(row(T - 1 - b) - mid) > TOL) b++;
    while (l < MAX && Math.abs(col(l) - mid) > TOL) l++; while (rr < MAX && Math.abs(col(T - 1 - rr) - mid) > TOL) rr++;
    if (t || b || l || rr) { const m = 2; t = t ? t + m : 0; b = b ? b + m : 0; l = l ? l + m : 0; rr = rr ? rr + m : 0; r = { x: sx + l, y: sy + t, w: T - l - rr, h: T - t - b }; } // +2 px past the band's soft edge
  } catch (e) { r = null; }
  _cleanRect.set(key, r); return r;
}
function mirrorTile(img, sx, sy, w, h, out){ // out: draw the (trimmed) source rect at this square size (default = the rect itself)
  const ow = out || w, oh = out || h;
  const key = (img.src || img.width + 'c') + ':' + sx + ',' + sy + ',' + w + 'x' + h + (out ? '>' + out : ''); const hit = _mirrorCache.get(key); if (hit) return hit;
  const c = document.createElement('canvas'); c.width = ow * 2; c.height = oh * 2; const x = c.getContext('2d');
  x.drawImage(img, sx, sy, w, h, 0, 0, ow, oh);
  x.save(); x.translate(ow * 2, 0); x.scale(-1, 1); x.drawImage(img, sx, sy, w, h, 0, 0, ow, oh); x.restore();
  x.save(); x.translate(0, oh * 2); x.scale(1, -1); x.drawImage(img, sx, sy, w, h, 0, 0, ow, oh); x.restore();
  x.save(); x.translate(ow * 2, oh * 2); x.scale(-1, -1); x.drawImage(img, sx, sy, w, h, 0, 0, ow, oh); x.restore();
  _mirrorCache.set(key, c); return c;
}
// Coir: a real photo of natural coir (assets/coir-natural.jpg, cut from the Coir Embossed product photo, already mirrored
// seamless, ~930 mm across). Grey and black coir are the same fibre toned to the dyed colour.
let _coir = null; const _coirTinted = {}; const _coirPhotos = {};
// Each coir colour has its own photographed strip when the theme carries one (TMG_ASSETS.coirBlack / coirGrey); the
// strip's real-world width in mm sets the fibre scale. Natural = the original strip.
const COIR_PHOTO_MM = { Natural: 930, Black: 660, Grey: 660 };
function coirPhotoFor(name){
  const k = name || 'Natural'; if (k === 'Natural') return coirPhoto();
  if (_coirPhotos[k]) return _coirPhotos[k];
  const src = (window.TMG_ASSETS || {})[k === 'Grey' ? 'coirGrey' : 'coirBlack']; if (!src) return null;
  const t = _coirPhotos[k] = { ready: false, img: new Image(), mm: COIR_PHOTO_MM[k] || 660 };
  t.img.crossOrigin = 'anonymous';
  t.img.onload = () => { t.ready = true; delete _coirTinted[k]; try { _cardPrev.map.clear(); } catch (e) {} if (gradeOf().inlayFlush) { cachedLogo = null; S.actualPmsUsed = []; } if (gradeOf().surface === 'coir') { if (typeof buildGrid === 'function' && $('tmgBgGrid')) buildGrid('all'); if (S.step === 2 && $('tmgStep2Canvas')) renderMiniCanvas('tmgStep2Canvas'); if (S.step === 4) renderCanvas(); } };
  t.img.onerror = () => { console.warn('[TMG] coir ' + k + ' photo failed to load; tinted natural used'); _coirPhotos[k] = { ready: false, failed: true }; };
  t.img.src = src;
  return t;
}
function coirPhoto(){
  if (_coir) return _coir;
  const t = _coir = { ready: false, img: new Image(), mm: 930 };
  t.img.crossOrigin = 'anonymous';
  t.img.onload = () => { t.ready = true; try { _cardPrev.map.clear(); } catch (e) {} if (gradeOf().inlayFlush) { cachedLogo = null; S.actualPmsUsed = []; } if (gradeOf().surface === 'coir') { if (typeof buildGrid === 'function' && $('tmgBgGrid')) buildGrid('all'); if (S.step === 2 && $('tmgStep2Canvas')) renderMiniCanvas('tmgStep2Canvas'); if (S.step === 4) renderCanvas(); } };
  t.img.onerror = () => console.warn('[TMG] coir photo failed to load; generated texture used');
  t.img.src = (window.TMG_ASSETS && window.TMG_ASSETS.coir) || '';
  return t;
}
function coirTile(name){
  const k = name || 'Natural'; if (_coirTinted[k]) return _coirTinted[k];
  const own = k !== 'Natural' ? coirPhotoFor(k) : null; // the colour's own photo when it exists (and has loaded)
  if (own && !own.failed && !own.ready) return null;    // loading: wait for the real photo rather than show a tint first
  const t = (own && own.ready) ? own : coirPhoto(); if (!t.ready) return null;
  const w = t.img.naturalWidth, h = t.img.naturalHeight; const c = document.createElement('canvas'); c.width = w; c.height = h; const x = c.getContext('2d', { willReadFrequently: true });
  x.drawImage(t.img, 0, 0); c.mm = t.mm;
  if (k !== 'Natural' && !(own && own.ready)) { // no photo for this colour: tone the natural fibre // tone the natural fibre to the dyed colour, keeping the fibre light and shade
    const tint = k === 'Grey' ? [118, 115, 108] : [48, 46, 44], id = x.getImageData(0, 0, w, h), d = id.data;
    for (let i = 0; i < d.length; i += 4) { const l = (0.299 * d[i] + 0.587 * d[i+1] + 0.114 * d[i+2]) / 185; d[i] = Math.min(255, tint[0] * l); d[i+1] = Math.min(255, tint[1] * l); d[i+2] = Math.min(255, tint[2] * l); }
    x.putImageData(id, 0, 0);
  }
  _coirTinted[k] = c; return c;
}
const _coirDisp = {};
function coirPattern(ctx, name, mmPerPx){
  const c = coirTile(name); if (!c) return null;
  const scale = ((c.mm || coirPhoto().mm) / c.width) / Math.max(0.05, mmPerPx || 1); // display px per tile px
  if (scale >= 0.95) { const p = ctx.createPattern(c, 'repeat'); if (p && p.setTransform) { try { p.setTransform(new DOMMatrix().scale(scale)); } catch(e) {} } return p; }
  // the whole-mat preview: scatter soft patches of the photo over the canvas (random offset / rotation / flip), then lift the grain
  const W = ctx.canvas.width, H = ctx.canvas.height;
  const key = (name || 'Natural') + '@' + Math.round(scale * 40) + '@' + W + 'x' + H;
  let d = _coirDisp[key];
  if (!d) {
    d = document.createElement('canvas'); d.width = W; d.height = H; const x = d.getContext('2d', { willReadFrequently: true }); x.imageSmoothingQuality = 'high';
    const src = Math.min(c.height, 200), dst = Math.max(24, Math.round(src * scale)), step = Math.max(12, Math.round(dst * 0.55));
    let seed = 1234; const rnd = () => { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; };
    // a soft round mask so patch edges melt into each other
    const m = document.createElement('canvas'); m.width = m.height = dst; const mx = m.getContext('2d');
    const gr = mx.createRadialGradient(dst / 2, dst / 2, dst * 0.15, dst / 2, dst / 2, dst / 2); gr.addColorStop(0, 'rgba(0,0,0,1)'); gr.addColorStop(1, 'rgba(0,0,0,0)');
    const patch = document.createElement('canvas'); patch.width = patch.height = dst; const px = patch.getContext('2d'); px.imageSmoothingQuality = 'high';
    // base coat first (no gaps anywhere), then the scattered patches
    const base = x.createPattern(c, 'repeat'); if (base && base.setTransform) { try { base.setTransform(new DOMMatrix().scale(scale)); } catch(e) {} } x.fillStyle = base || '#b07a4a'; x.fillRect(0, 0, W, H);
    for (let yy = -dst / 2; yy < H + dst / 2; yy += step) for (let xx = -dst / 2; xx < W + dst / 2; xx += step) {
      const sx = Math.floor(rnd() * (c.width - src)), sy = Math.floor(rnd() * (c.height - src)), rot = Math.floor(rnd() * 4), flip = rnd() < 0.5;
      px.clearRect(0, 0, dst, dst); px.save(); px.translate(dst / 2, dst / 2); px.rotate(rot * Math.PI / 2); if (flip) px.scale(-1, 1); px.drawImage(c, sx, sy, src, src, -dst / 2, -dst / 2, dst, dst); px.restore();
      px.globalCompositeOperation = 'destination-in'; px.fillStyle = gr; px.fillRect(0, 0, dst, dst); px.globalCompositeOperation = 'source-over';
      x.drawImage(patch, Math.round(xx + (rnd() - 0.5) * step * 0.6), Math.round(yy + (rnd() - 0.5) * step * 0.6));
    }
    // the downscale softens the fibre: a modest lift of the contrast about the mean, more when drawn smaller
    const id = x.getImageData(0, 0, W, H), p = id.data, n = p.length / 4; let m0 = 0, m1 = 0, m2 = 0;
    for (let i = 0; i < p.length; i += 4) { m0 += p[i]; m1 += p[i+1]; m2 += p[i+2]; } m0 /= n; m1 /= n; m2 /= n;
    const gain = Math.min(1.6, 1.15 + (1 - scale) * 0.6);
    for (let i = 0; i < p.length; i += 4) { p[i] = Math.max(0, Math.min(255, m0 + (p[i] - m0) * gain)); p[i+1] = Math.max(0, Math.min(255, m1 + (p[i+1] - m1) * gain)); p[i+2] = Math.max(0, Math.min(255, m2 + (p[i+2] - m2) * gain)); }
    x.putImageData(id, 0, 0); _coirDisp[key] = d;
  }
  return ctx.createPattern(d, 'no-repeat');
}
// Procedural surface tiles (cached per surface + colour): coir fibre, flock, rubber stipple, felt.
const _procTiles = {};
function procPattern(ctx, surface, hex, scale){
  const key = surface + hex; let c = _procTiles[key];
  if (!c) {
    const T = 160; c = document.createElement('canvas'); c.width = c.height = T; const x = c.getContext('2d');
    const r = parseInt(hex.slice(1,3),16), g = parseInt(hex.slice(3,5),16), b = parseInt(hex.slice(5,7),16);
    x.fillStyle = hex; x.fillRect(0, 0, T, T);
    const id = x.getImageData(0, 0, T, T), d = id.data;
    let seed = 7; const rnd = () => { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; };
    for (let y = 0; y < T; y++) for (let xx = 0; xx < T; xx++) {
      const i = (y * T + xx) * 4; let n = 0;
      if (surface === 'coir') n = (rnd() - .5) * 90 + Math.sin(xx * 0.7 + Math.sin(y * 0.11) * 3) * 22 + (rnd() > 0.93 ? 40 : 0); // bristly, streaky
      else if (surface === 'flock') n = (rnd() - .5) * 18;
      else if (surface === 'rubber') n = (rnd() - .5) * 8; // smooth moulded rubber; the stud relief is drawn over the artwork (drawStudRelief)
      else if (surface === 'felt') n = (rnd() - .5) * 10;
      else n = (rnd() - .5) * 14;
      d[i] = Math.max(0, Math.min(255, r + n)); d[i+1] = Math.max(0, Math.min(255, g + n)); d[i+2] = Math.max(0, Math.min(255, b + n));
    }
    x.putImageData(id, 0, 0); _procTiles[key] = c;
  }
  const p = ctx.createPattern(c, 'repeat');
  if (p && p.setTransform && scale && scale !== 1) { try { p.setTransform(new DOMMatrix().scale(scale)); } catch(e) {} }
  return p;
}
// Every swatch chip is a photo of the real material: the product-page sprites (PrintPlush / embossed), the chart tiles
// (PrintScraper / Superguard / SpiralLoop) or the coir photo. Falls back to the flat colour when an asset is missing.
const _coirThumb = {};
function swatchCss(mm, hex){
  const A = window.TMG_ASSETS || {}; const code = String(mm || '');
  const grid = (url, ix, iy, cols, rows) => 'background-color:' + hex + ';background-clip:padding-box;background-image:url(' + url + ');background-repeat:no-repeat;background-size:' + (cols * 100) + '% ' + (rows * 100) + '%;background-position:' + (cols > 1 ? ix / (cols - 1) * 100 : 0) + '% ' + (rows > 1 ? iy / (rows - 1) * 100 : 0) + '%;';
  try {
    if (/^MM\d/.test(code)) {
      const c = code.slice(2);
      if (gradeOf().chart === 'ps' && A.psTiles && window.TMG_PS_TILES && window.TMG_PS_TILES.codes[c]) { const p = window.TMG_PS_TILES.codes[c]; return grid(A.psTiles, p.x / 128, p.y / 128, 10, 5); }
      const sp = (window.TMG_PP_SPRITES || {})[c]; if (sp && A.swatches) return grid(A.swatches + 'sprite-hd-' + sp.b + '.jpg', sp.i, 0, sp.n, 1);
    }
    const nm = code.replace(/^[A-Z]+:/, '');
    if (/^SGB?:/.test(code) && window.TMG_SG_TILES && A.sgTiles) { const p = window.TMG_SG_TILES.codes[nm]; if (p) return grid(A.sgTiles, p.x / 512, p.y / 512, 5, 4); }
    if (/^SL:/.test(code) && window.TMG_SL_TILES && A.slTiles) { const p = window.TMG_SL_TILES.codes[nm]; if (p) return grid(A.slTiles, p.x / 512, p.y / 512, 5, 5); }
    if (/^EMB:/.test(code)) { const e = ((window.TMG_CHARTS || {}).embossed || []).find(x => x.name === nm); if (e && A.swatches) return grid(A.swatches + e.band + '.jpg', e.idx, 0, e.count, 1); }
    if (/^COIR:/.test(code)) { const c = coirTile(nm); if (c) { const k = 'coir' + nm; if (!_coirThumb[k]) { const t = document.createElement('canvas'); t.width = 120; t.height = 120; t.getContext('2d').drawImage(c, 0, 0, 240, 240, 0, 0, 120, 120); _coirThumb[k] = t.toDataURL('image/jpeg', 0.8); } return 'background:' + hex + ' url(' + _coirThumb[k] + ') center/cover;background-clip:padding-box;'; } }
  } catch(e) {}
  return 'background:' + hex + ';';
}
// Fill for the mat surface in the chosen background / base colour, at the right physical scale.
function surfaceFill(ctx, hex, mmPerPx){
  const g = gradeOf();
  if (g.tiled && S.selectedBg && S.selectedBg.mm) { const p = tilePattern(ctx, S.selectedBg.mm, tileScale(mmPerPx)); if (p) return p; }
  if (g.inlayFlush) { const p = coirBasePattern(ctx, S.selectedBg && /^COIR:/.test(S.selectedBg.mm || '') ? S.selectedBg.name : 'Natural', mmPerPx); if (p) return p; } // coir inlay: the same coir as the logo pieces
  if (g.surface === 'coir') { const p = coirPattern(ctx, S.selectedBg && S.selectedBg.name, mmPerPx); if (p) return p; }
  if (g.surface === 'coir' || g.surface === 'flock' || g.surface === 'rubber' || g.surface === 'felt') return procPattern(ctx, g.surface, hex, (60 / 160) / Math.max(0.05, mmPerPx || 1));
  return hex;
}
// The edge band: style per family (nitrile black, bevelled rubber, vinyl strip, raised containment border, thin, none).
function drawEdge(ctx, W, H, edgePx){
  const g = gradeOf(); const style = hasEdging() && !edgingOn() ? 'none' : g.edge;
  if (style === 'none') return;
  if (style === 'bevel') { const gr = ctx.createLinearGradient(0, 0, 0, edgePx); gr.addColorStop(0, '#3a3a3a'); gr.addColorStop(1, '#161616'); ctx.fillStyle = '#1e1e1e'; ctx.fillRect(0, 0, W, H); ctx.fillStyle = gr; ctx.fillRect(0, 0, W, edgePx); ctx.fillStyle = 'rgba(255,255,255,.10)'; ctx.fillRect(0, 0, W, Math.max(1, edgePx * .15)); ctx.fillRect(0, 0, Math.max(1, edgePx * .15), H); return; }
  if (style === 'vinyl') { ctx.fillStyle = '#4b5057'; ctx.fillRect(0, 0, W, H); ctx.strokeStyle = 'rgba(255,255,255,.12)'; ctx.lineWidth = Math.max(1, edgePx * .12); ctx.strokeRect(edgePx * .5, edgePx * .5, W - edgePx, H - edgePx); return; }
  if (style === 'raised') { drawRaisedRim(ctx, W, H, edgePx); return; }
  if (style === 'thin') { ctx.fillStyle = gradeOf().weave ? '#262626' : '#222'; ctx.fillRect(0, 0, W, H); return; }
  ctx.fillStyle = '#1a1a1a'; ctx.fillRect(0, 0, W, H);
}
function edgeInsetPx(W, edgePx){ const g = gradeOf(); const style = hasEdging() && !edgingOn() ? 'none' : g.edge; return style === 'none' ? 0 : style === 'thin' ? Math.round(edgePx * .4) : edgePx; }
// Rubber Scraper (12 Oct 2026): the real mat is a moulded black rubber sheet with a grid of raised round studs (about 9 mm
// across on a 12.5 mm pitch) inside a flat raised rim, and the artwork is printed over studs and base alike. This is a
// lighting overlay drawn AFTER the artwork at real physical scale: the printed colour stays on the stud tops, the base
// between them sits darker, each stud throws a small shadow (light from the top-left) and gets a dome highlight.
const _studTiles = {};
function studTile(T, r){
  const key = T + ':' + Math.round(r * 10); let tile = _studTiles[key];
  if (tile) return tile;
  tile = document.createElement('canvas'); tile.width = tile.height = T;
  const x = tile.getContext('2d'), cx = T / 2, cy = T / 2, rr = Math.min(r, T * 0.42);
  x.fillStyle = 'rgba(0,0,0,0.34)'; x.fillRect(0, 0, T, T);                                   // recessed base between the studs
  x.fillStyle = 'rgba(0,0,0,0.35)'; x.beginPath(); x.arc(cx + rr * 0.22, cy + rr * 0.28, rr, 0, Math.PI * 2); x.fill(); // cast shadow
  x.globalCompositeOperation = 'destination-out'; x.beginPath(); x.arc(cx, cy, rr, 0, Math.PI * 2); x.fill();   // stud top shows the print
  x.globalCompositeOperation = 'source-over';
  const gr = x.createRadialGradient(cx - rr * 0.35, cy - rr * 0.35, rr * 0.1, cx, cy, rr);
  gr.addColorStop(0, 'rgba(255,255,255,0.16)'); gr.addColorStop(0.55, 'rgba(255,255,255,0)'); gr.addColorStop(1, 'rgba(0,0,0,0.32)');
  x.fillStyle = gr; x.beginPath(); x.arc(cx, cy, rr, 0, Math.PI * 2); x.fill();                 // dome shading
  const lw = Math.max(0.6, rr * 0.12);
  x.strokeStyle = 'rgba(0,0,0,0.25)'; x.lineWidth = lw; x.beginPath(); x.arc(cx, cy, rr - lw / 2, 0, Math.PI * 2); x.stroke(); // moulded rim
  if (rr >= 5) {                                                                               // grip texture on the stud top
    let seed = 11; const rnd = () => (seed = seed * 16807 % 2147483647, (seed - 1) / 2147483646);
    for (let i = 0, n = rr * rr * 0.9; i < n; i++) { const a = rnd() * Math.PI * 2, d = Math.sqrt(rnd()) * rr * 0.85; x.fillStyle = rnd() > 0.5 ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.09)'; x.fillRect(cx + Math.cos(a) * d, cy + Math.sin(a) * d, 1, 1); }
  }
  return (_studTiles[key] = tile);
}
// Rubber Promotional (12 Oct 2026): a thin moulded rubber sheet with a fine fabric-like weave (about 1.4 mm) and a flat border
// a shade lighter than the field; the print is matte and sits on the texture. Drawn AFTER the artwork at real scale, over
// the border too (the real mat is textured edge to edge). Small renders get a fine speckle instead of the weave.
const _weaveTiles = {};
function weaveTile(T){
  let tile = _weaveTiles[T]; if (tile) return tile;
  tile = document.createElement('canvas'); tile.width = tile.height = T; const x = tile.getContext('2d');
  if (T < 4) { // too small for threads: a seeded speckle, dark pits and lit tops
    const N = 64; tile.width = tile.height = N; let seed = 23; const rnd = () => (seed = seed * 16807 % 2147483647, (seed - 1) / 2147483646);
    for (let i = 0; i < N * N * 0.55; i++) { x.fillStyle = rnd() > 0.42 ? 'rgba(0,0,0,0.16)' : 'rgba(255,255,255,0.07)'; x.fillRect(Math.floor(rnd() * N), Math.floor(rnd() * N), 1, 1); }
    return (_weaveTiles[T] = tile);
  }
  const t = Math.max(1, Math.round(T * 0.42)), g = T - t * 2; // two threads per pitch with a dark gap between them
  x.fillStyle = 'rgba(0,0,0,0.22)'; x.fillRect(0, 0, T, T);                                  // the gaps
  const thread = (vert, off) => { const gr = vert ? x.createLinearGradient(off, 0, off + t, 0) : x.createLinearGradient(0, off, 0, off + t);
    gr.addColorStop(0, 'rgba(0,0,0,0.10)'); gr.addColorStop(0.45, 'rgba(255,255,255,0.10)'); gr.addColorStop(1, 'rgba(0,0,0,0.14)');
    x.fillStyle = gr; if (vert) x.fillRect(off, 0, t, T); else x.fillRect(0, off, T, t); };
  thread(false, 0); thread(true, t + g); thread(false, t + g); thread(true, 0);               // over-under weave
  x.fillStyle = 'rgba(0,0,0,0.10)'; x.fillRect(0, t, T, g); x.fillRect(t, 0, g, T);           // the gap lines stay a touch darker
  return (_weaveTiles[T] = tile);
}
function drawWeaveRelief(ctx, W, H, mmPerPx){
  try {
    const mm = Math.max(0.05, mmPerPx || 1), T = Math.max(1, Math.round(1.4 / mm));
    const p = ctx.createPattern(weaveTile(T), 'repeat');
    if (p) { ctx.save(); ctx.fillStyle = p; ctx.fillRect(0, 0, W, H); ctx.restore(); }
    const edgePx = Math.round(W * (20 / 900)), ins = edgeInsetPx(W, edgePx);
    if (ins > 0) { // the flat border: a soft sheen on the band and the step where the field starts
      ctx.save(); ctx.fillStyle = 'rgba(255,255,255,0.045)';
      ctx.fillRect(0, 0, W, ins); ctx.fillRect(0, H - ins, W, ins); ctx.fillRect(0, 0, ins, H); ctx.fillRect(W - ins, 0, ins, H);
      ctx.strokeStyle = 'rgba(0,0,0,0.5)'; ctx.lineWidth = 1; ctx.strokeRect(ins + 0.5, ins + 0.5, W - ins * 2 - 1, H - ins * 2 - 1);
      ctx.strokeStyle = 'rgba(255,255,255,0.10)'; ctx.strokeRect(0.5, 0.5, W - 1, H - 1); ctx.restore();
    }
  } catch(e) {}
}
// Rubber Promotional (14 Oct 2026, Zac: "looks like it's printed on carpet/fabric not rubber" / "rubber scraper looks like it's
// actually printed on rubber"): the Rubber Scraper stud-top finish spread over a flat sheet - the same fine grip speckle, a
// soft moulded sheen with the light from the top-left, a touch of matte (ink on rubber is never fully saturated), and a thin
// moulded rim. No studs, no weave.
let _rubberGrainTile = null;
function rubberGrainTile(){
  if (_rubberGrainTile) return _rubberGrainTile;
  const N = 96, c = document.createElement('canvas'); c.width = c.height = N; const x = c.getContext('2d');
  let seed = 11; const rnd = () => (seed = seed * 16807 % 2147483647, (seed - 1) / 2147483646);
  for (let i = 0, n = N * N * 0.29; i < n; i++) { x.fillStyle = rnd() > 0.5 ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.09)'; x.fillRect(Math.floor(rnd() * N), Math.floor(rnd() * N), 1, 1); }
  return (_rubberGrainTile = c);
}
function drawRubberPrintRelief(ctx, W, H, mmPerPx){
  try {
    const edgePx = Math.round(W * (20 / 900)), ins = edgeInsetPx(W, edgePx);
    ctx.save();
    try { ctx.globalCompositeOperation = 'saturation'; ctx.fillStyle = 'rgba(128,128,128,0.05)'; ctx.fillRect(ins, ins, W - ins * 2, H - ins * 2); } catch (e) {} // matte ink on rubber
    ctx.globalCompositeOperation = 'source-over';
    const p = ctx.createPattern(rubberGrainTile(), 'repeat'); if (p) { ctx.fillStyle = p; ctx.fillRect(0, 0, W, H); }
    const gr = ctx.createLinearGradient(0, 0, W, H); gr.addColorStop(0, 'rgba(255,255,255,0.08)'); gr.addColorStop(0.45, 'rgba(255,255,255,0)'); gr.addColorStop(1, 'rgba(0,0,0,0.12)');
    ctx.fillStyle = gr; ctx.fillRect(0, 0, W, H);
    const rg = ctx.createRadialGradient(W * 0.3, H * 0.22, 0, W * 0.3, H * 0.22, Math.max(W, H) * 0.75); rg.addColorStop(0, 'rgba(255,255,255,0.06)'); rg.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = rg; ctx.fillRect(0, 0, W, H);
    ctx.restore();
    if (ins > 0) drawRaisedRim(ctx, W, H, ins); // the thin moulded rim, lit top-left, shaded bottom-right
  } catch(e) {}
}
// Promotional (14 Oct 2026, Zac: "more vibrant, photo realistic ... it looks like digital colours"): a dye-sublimated felt top.
// The dye sits IN the fibre: richer colour (vibrance lifts the duller colours most, so brand colours never go neon), deeper
// blacks (gentle S-curve), a fine short-fibre nap over everything, a soft sheen, and the thin rubber backing showing as a
// border with a slight bevel.
let _feltNapTile = null, _feltCurve = null;
function feltNapTile(){
  if (_feltNapTile) return _feltNapTile;
  const N = 128, c = document.createElement('canvas'); c.width = c.height = N; const x = c.getContext('2d');
  let seed = 31; const rnd = () => (seed = seed * 16807 % 2147483647, (seed - 1) / 2147483646);
  x.lineWidth = 1; x.lineCap = 'round';
  for (let i = 0; i < 900; i++) { const px = rnd() * N, py = rnd() * N, a = rnd() * Math.PI * 2, l = 2 + rnd() * 5; x.strokeStyle = rnd() > 0.5 ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.07)'; x.beginPath(); x.moveTo(px, py); x.lineTo(px + Math.cos(a) * l, py + Math.sin(a) * l); x.stroke(); }
  return (_feltNapTile = c);
}
function drawFeltPrintRelief(ctx, W, H, mmPerPx){
  try {
    const edgePx = Math.round(W * (20 / 900)), ins = edgeInsetPx(W, edgePx), iw = W - ins * 2, ih = H - ins * 2; if (iw < 4 || ih < 4) return;
    if (!_feltCurve) { _feltCurve = new Uint8ClampedArray(256); for (let v = 0; v < 256; v++) { const t = v / 255; _feltCurve[v] = Math.round(255 * (t - 0.028 * Math.sin(2 * Math.PI * t))); } }
    const id = ctx.getImageData(ins, ins, iw, ih), d = id.data, cv = _feltCurve;
    for (let i = 0; i < d.length; i += 4) {
      const r = d[i], g = d[i+1], b = d[i+2], mx = Math.max(r, g, b), mn = Math.min(r, g, b), sat = mx ? (mx - mn) / mx : 0, avg = (r + g + b) / 3, k = 1 + 0.40 * sat * (1 - sat); // vibrance peaks at mid saturation: greys and dull mat colours stay put, mid colours get the dye-sub richness
      d[i] = cv[Math.max(0, Math.min(255, Math.round(avg + (r - avg) * k)))]; d[i+1] = cv[Math.max(0, Math.min(255, Math.round(avg + (g - avg) * k)))]; d[i+2] = cv[Math.max(0, Math.min(255, Math.round(avg + (b - avg) * k)))];
    }
    ctx.putImageData(id, ins, ins);
    ctx.save(); ctx.beginPath(); ctx.rect(ins, ins, iw, ih); ctx.clip();
    const p = ctx.createPattern(feltNapTile(), 'repeat');
    if (p) { const sc = (6 / 128) / Math.max(0.02, mmPerPx || 1); if (p.setTransform && sc < 4) { try { p.setTransform(new DOMMatrix().scale(Math.max(0.35, sc))); } catch (e) {} } ctx.fillStyle = p; ctx.fillRect(ins, ins, iw, ih); }
    const gr = ctx.createLinearGradient(0, 0, W, H); gr.addColorStop(0, 'rgba(255,255,255,0.06)'); gr.addColorStop(0.5, 'rgba(255,255,255,0)'); gr.addColorStop(1, 'rgba(0,0,0,0.08)');
    ctx.fillStyle = gr; ctx.fillRect(ins, ins, iw, ih); ctx.restore();
    if (ins > 0) { // the rubber backing as a thin border: lit outer bevel top-left, shaded bottom-right, a dark lip where the felt starts
      ctx.save(); const bv = Math.max(1, ins * 0.3);
      ctx.fillStyle = 'rgba(255,255,255,0.14)'; ctx.fillRect(0, 0, W, bv); ctx.fillRect(0, 0, bv, H);
      ctx.fillStyle = 'rgba(0,0,0,0.40)'; ctx.fillRect(0, H - bv, W, bv); ctx.fillRect(W - bv, 0, bv, H);
      ctx.strokeStyle = 'rgba(0,0,0,0.55)'; ctx.lineWidth = 1; ctx.strokeRect(ins + 0.5, ins + 0.5, iw - 1, ih - 1); ctx.restore();
    }
  } catch(e) {}
}
// PrintPlush Standard / Commercial (14 Oct 2026, Zac: "doesn't encapsulate the fabric ... as photo realistic as possible"):
// dye-injected cut pile. The dye sits down in the tufts, so the whole field - background AND logo - carries the pile: ~1 mm
// tufts with lit tips and dark gaps (tile corrected so the mean colour stays the chart colour), print edges softened by about
// half a millimetre where the dye wicks into the pile, a faint directional nap, and the nitrile border's lit outer bevel.
let _pileTile = null;
function pileTile(){
  if (_pileTile) return _pileTile;
  // an opaque grey height map (128 = no change) applied with soft-light, so the pile modulates every colour without moving its mean
  const N = 160, c = document.createElement('canvas'); c.width = c.height = N; const x = c.getContext('2d', { willReadFrequently: true });
  x.fillStyle = '#808080'; x.fillRect(0, 0, N, N);
  let seed = 53; const rnd = () => (seed = seed * 16807 % 2147483647, (seed - 1) / 2147483646); const tuft = N / 20; // 20 mm of pile per tile, tufts 1.2-2.6 mm across
  for (let i = 0; i < 900; i++) {
    const px = rnd() * N, py = rnd() * N, r = tuft * (0.6 + rnd() * 0.7), lit = rnd();
    for (const ox of [-N, 0, N]) for (const oy of [-N, 0, N]) { const gx = px + ox, gy = py + oy; if (gx < -r || gy < -r || gx > N + r || gy > N + r) continue; // seamless
      const gr = x.createRadialGradient(gx - r * 0.3, gy - r * 0.3, 0, gx, gy, r);
      gr.addColorStop(0, 'rgba(255,255,255,' + (0.22 + lit * 0.33).toFixed(3) + ')'); gr.addColorStop(0.55, 'rgba(255,255,255,0)'); gr.addColorStop(1, 'rgba(0,0,0,' + (0.25 + (1 - lit) * 0.30).toFixed(3) + ')');
      x.fillStyle = gr; x.beginPath(); x.arc(gx, gy, r, 0, Math.PI * 2); x.fill(); }
  }
  for (let i = 0; i < N * N * 0.35; i++) { x.fillStyle = rnd() > 0.5 ? 'rgba(255,255,255,0.10)' : 'rgba(0,0,0,0.12)'; x.fillRect(Math.floor(rnd() * N), Math.floor(rnd() * N), 1, 1); } // single fibre ends
  try { // exact mean 128: shift every pixel by the measured offset
    const id = x.getImageData(0, 0, N, N), d = id.data; let m = 0; for (let i = 0; i < d.length; i += 4) m += d[i]; m /= (d.length / 4); const dm = Math.round(128 - m);
    if (dm) { for (let i = 0; i < d.length; i += 4) { const v = Math.max(0, Math.min(255, d[i] + dm)); d[i] = d[i+1] = d[i+2] = v; d[i+3] = 255; } x.putImageData(id, 0, 0); }
  } catch (e) {}
  return (_pileTile = c);
}
function drawPileRelief(ctx, W, H, mmPerPx){
  try {
    const edgePx = Math.round(W * (20 / 900)), ins = edgeInsetPx(W, edgePx), iw = W - ins * 2, ih = H - ins * 2; if (iw < 4 || ih < 4) return;
    const mm = Math.max(0.05, mmPerPx || 1), blur = 0.5 / mm;
    ctx.save(); ctx.beginPath(); ctx.rect(ins, ins, iw, ih); ctx.clip();
    if (false && blur >= 0.35 && 'filter' in ctx) { /* ux1014i: no wicking blur - logo edges stay crisp */ const t = document.createElement('canvas'); t.width = iw; t.height = ih; t.getContext('2d').drawImage(ctx.canvas, ins, ins, iw, ih, 0, 0, iw, ih); ctx.filter = 'blur(' + Math.min(2, blur).toFixed(2) + 'px)'; ctx.drawImage(t, ins, ins); ctx.filter = 'none'; } // dye wicking into the tufts
    const p = ctx.createPattern(pileTile(), 'repeat');
    if (p) { if (p.setTransform) { try { p.setTransform(new DOMMatrix().scale((20 / 160) / mm)); } catch (e) {} } ctx.globalCompositeOperation = 'soft-light'; ctx.fillStyle = p; ctx.fillRect(ins, ins, iw, ih); ctx.globalCompositeOperation = 'source-over'; }
    const nap = ctx.createLinearGradient(ins, ins, ins + iw, ins + ih * 0.35); // a faint directional nap: broad light / dark lanes across the pile
    nap.addColorStop(0, 'rgba(255,255,255,0.018)'); nap.addColorStop(0.35, 'rgba(0,0,0,0.015)'); nap.addColorStop(0.7, 'rgba(255,255,255,0.012)'); nap.addColorStop(1, 'rgba(0,0,0,0.015)');
    ctx.fillStyle = nap; ctx.fillRect(ins, ins, iw, ih);
    ctx.restore();
    if (ins > 0) { // the nitrile border: lit outer bevel top-left, shaded bottom-right, a dark lip where the pile starts
      ctx.save(); const bv = Math.max(1, ins * 0.22);
      ctx.fillStyle = 'rgba(255,255,255,0.10)'; ctx.fillRect(0, 0, W, bv); ctx.fillRect(0, 0, bv, H);
      ctx.fillStyle = 'rgba(0,0,0,0.35)'; ctx.fillRect(0, H - bv, W, bv); ctx.fillRect(W - bv, 0, bv, H);
      ctx.strokeStyle = 'rgba(0,0,0,0.45)'; ctx.lineWidth = 1; ctx.strokeRect(ins + 0.5, ins + 0.5, iw - 1, ih - 1); ctx.restore();
    }
  } catch(e) {}
}
// The edge band's width written on the band (Zac, 12 Oct 2026) - on-screen previews only, never the proof.
function drawEdgeDim(ctx, W, H, mmPerPx){
  try {
    const g = gradeOf(); const edgePx = Math.round(W * (20 / 900)), ins = edgeInsetPx(W, edgePx); if (!ins) return;
    const style = g.edge; if (g.edgeMm === 0) return; // no band on this family (felt Promotional bleeds to the edge)
    const longMm = Math.max(S.matWmm || 0, S.matHmm || 0) || Math.round(W * (mmPerPx || 1));
    const mmv = (g.edgeMmSmall && longMm <= 900) ? g.edgeMmSmall : (g.edgeMm || (style === 'thin' ? 8 : 20)); // the family's real band (see scripts/patch-edge-mm.js), not the drawn one
    const label = (style === 'raised' ? 'Rim ' : style === 'vinyl' ? 'Edging ' : style === 'bevel' ? 'Bevelled edge ' : 'Edge ') + mmv + ' mm';
    const fs = Math.max(9, Math.min(13, Math.round(W / 60))), y = Math.round(H * 0.5) + 0.5;
    ctx.save(); ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(255,255,255,0.95)';
    ctx.beginPath(); ctx.moveTo(0.5, y); ctx.lineTo(ins - 0.5, y); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(0.5, y - 4); ctx.lineTo(0.5, y + 4); ctx.moveTo(ins - 0.5, y - 4); ctx.lineTo(ins - 0.5, y + 4); ctx.stroke();
    ctx.font = '600 ' + fs + 'px Montserrat, Arial, sans-serif'; ctx.textBaseline = 'middle';
    const tw = ctx.measureText(label).width, px = ins + 6, ph = fs + 6;
    ctx.fillStyle = 'rgba(0,0,0,0.62)'; ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(px, y - ph / 2, tw + 10, ph, 4); else ctx.rect(px, y - ph / 2, tw + 10, ph); ctx.fill();
    ctx.fillStyle = '#fff'; ctx.fillText(label, px + 5, y); ctx.restore();
  } catch(e) {}
}
function drawStudRelief(ctx, W, H, mmPerPx){
  try {
    const g = gradeOf();
    if (g.key === 'rubberpromotional') { drawRubberPrintRelief(ctx, W, H, mmPerPx); return; } // 14 Oct 2026: printed on rubber, not fabric
    if (g.key === 'promotional') { drawFeltPrintRelief(ctx, W, H, mmPerPx); return; }            // 14 Oct 2026: dye-sub felt
    if (g.key === 'standard' || g.key === 'commercial') { drawPileRelief(ctx, W, H, mmPerPx); return; } // 14 Oct 2026: printed cut pile
    if (g.weave) { drawWeaveRelief(ctx, W, H, mmPerPx); return; } if (!g.studs) return;
    const edgePx = Math.round(W * (20 / 900)), ins = edgeInsetPx(W, edgePx);
    const mm = Math.max(0.05, mmPerPx || 1), pitchPx = 12.5 / mm, r = 4.5 / mm;
    if (pitchPx >= 3) {
      const T = Math.max(3, Math.round(pitchPx)), iw = W - ins * 2, ih = H - ins * 2;
      const p = ctx.createPattern(studTile(T, r), 'repeat');
      if (p) {
        ctx.save(); ctx.beginPath(); ctx.rect(ins, ins, iw, ih); ctx.clip();
        if (p.setTransform) { try { p.setTransform(new DOMMatrix().translate(ins + ((iw % T) / 2), ins + ((ih % T) / 2))); } catch(e) {} } // whole studs against the rim
        ctx.fillStyle = p; ctx.fillRect(ins, ins, iw, ih); ctx.restore();
      }
    }
    if (g.edge === 'raised' && !(hasEdging() && !edgingOn())) drawRaisedRim(ctx, W, H, edgePx); // on top of the artwork, so the as-is proof gets it too
  } catch(e) {}
}
// The flat moulded rubber rim: lit top face, bevelled outer edge, a dark groove where the stud field steps down.
function drawRaisedRim(ctx, W, H, edgePx){
  const e = Math.max(2, edgePx), bev = Math.max(1, e * 0.18), groove = Math.max(1, e * 0.14);
  ctx.save();
  ctx.fillStyle = '#1c1d1f';
  ctx.fillRect(0, 0, W, e); ctx.fillRect(0, H - e, W, e); ctx.fillRect(0, 0, e, H); ctx.fillRect(W - e, 0, e, H);
  ctx.fillStyle = 'rgba(255,255,255,0.05)';                                                    // top face sheen
  ctx.fillRect(bev, bev, W - bev * 2, e - bev - groove); ctx.fillRect(bev, bev, e - bev - groove, H - bev * 2);
  ctx.fillStyle = 'rgba(255,255,255,0.16)'; ctx.fillRect(0, 0, W, bev); ctx.fillRect(0, 0, bev, H);          // outer bevel, lit
  ctx.fillStyle = 'rgba(0,0,0,0.45)'; ctx.fillRect(0, H - bev, W, bev); ctx.fillRect(W - bev, 0, bev, H);    // outer bevel, shaded
  ctx.lineWidth = groove;
  ctx.strokeStyle = 'rgba(0,0,0,0.75)'; ctx.strokeRect(e - groove / 2, e - groove / 2, W - 2 * e + groove, H - 2 * e + groove); // groove at the rim's inner lip
  ctx.strokeStyle = 'rgba(0,0,0,0.28)'; ctx.strokeRect(e + groove / 2, e + groove / 2, W - 2 * e - groove, H - 2 * e - groove); // its shadow on the stud field
  ctx.restore();
}
// Draws the drainage-hole grid over the inner mat area (preview only; production punches the real pattern).
function drawDrainageHoles(ctx, x, y, w, h, mmPerPx){
  const pitch = Math.max(6, 50 / mmPerPx), r = Math.max(1.2, 4 / mmPerPx);
  ctx.save(); ctx.fillStyle = 'rgba(20,20,20,0.55)';
  for (let yy = y + pitch; yy < y + h - pitch / 2; yy += pitch) for (let xx = x + pitch; xx < x + w - pitch / 2; xx += pitch) { ctx.beginPath(); ctx.arc(xx, yy, r, 0, Math.PI * 2); ctx.fill(); }
  ctx.restore();
}
// Cut seams (inlays) and raised bevels (embossed) on the quantised artwork pixels. ids = cluster id per pixel (NONE =
// transparent), ent(id) = chart entry. mmPerPx = millimetres per ARTWORK pixel.
function finishArtworkPixels(data, ids, NONE, ent, W, H, mmPerPx, sourceCanvas){
  const g = gradeOf(); if (sourceCanvas) sourceCanvas.__shaded = null; if (!g.cut && !g.raised) { S.shaded = null; return; }
  if (g.inlayFlush) { coirInlayFinish(data, ids, NONE, ent, W, H, mmPerPx, sourceCanvas); return; } // coir inlay: flush, photographed coir
  const deep = g.key === 'dirtstopper'; // 14 Oct 2026 (Zac): DirtStopper reads more obviously raised; Coir Embossed unchanged
  const bw = deep ? Math.max(1, Math.min(14, Math.round(6 / Math.max(0.05, mmPerPx)))) : Math.max(1, Math.min(6, Math.round((g.cut ? 1.2 : 3) / Math.max(0.05, mmPerPx)))); // raised: a 3 mm lit / shaded face (DirtStopper 4.5 mm)
  let fseed = 97; const fib = () => (fseed = fseed * 16807 % 2147483647, (fseed - 1) / 2147483646);
  const same = (p, q) => q < 0 || q >= ids.length ? false : (ids[q] === NONE ? false : ent(ids[p]) === ent(ids[q]));
  const out = new Uint8ClampedArray(data);
  for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
    const p = y * W + x; if (ids[p] === NONE) continue;
    const i = p * 4;
    if (g.cut) { // dark seam where the cut meets another colour or the base
      let seam = false;
      for (let d = 1; d <= bw && !seam; d++) { if (x - d < 0 || !same(p, p - d)) seam = true; else if (y - d < 0 || !same(p, p - d * W)) seam = true; }
      if (seam) { out[i] = data[i] * .55; out[i+1] = data[i+1] * .55; out[i+2] = data[i+2] * .55; }
    } else { // raised: a flocked pile standing proud - fibre grain on top, a lit top-left face, a shaded bottom-right face
      let hi = false, sh = false;
      for (let d = 1; d <= bw; d++) { if (x - d < 0 || y - d < 0 || !same(p, p - d) || !same(p, p - d * W)) hi = true; if (x + d >= W || y + d >= H || !same(p, p + d) || !same(p, p + d * W)) sh = true; }
      let n = (fib() - .5) * 34 + Math.sin(x * 0.9 + Math.sin(y * 0.13) * 2) * 7; // the fibre grain (seeded, so every render matches)
      if (data[i] + data[i+1] + data[i+2] < 180) n = Math.abs(n) * 1.15; // a dark pile catches the light: lighter fibre tips only
      let r = data[i] + n, gg = data[i+1] + n, b = data[i+2] + n;
      if (deep) { // graded side walls: brightest right at the lit edge, darkest right at the shaded edge
        let dh = 0, ds = 0; for (let d = 1; d <= bw; d++) { if (!dh && (x - d < 0 || y - d < 0 || !same(p, p - d) || !same(p, p - d * W))) dh = d; if (!ds && (x + d >= W || y + d >= H || !same(p, p + d) || !same(p, p + d * W))) ds = d; }
        if (dh && (!ds || dh <= ds)) { const f = 1 - (dh - 1) / bw; r += 110 * f; gg += 110 * f; b += 110 * f; }
        else if (ds) { const f = 1 - (ds - 1) / bw, m = 1 - 0.62 * f; r *= m; gg *= m; b *= m; }
      } else if (hi && !sh) { r += 70; gg += 70; b += 70; } else if (sh && !hi) { r *= .55; gg *= .55; b *= .55; }
      out[i] = Math.max(0, Math.min(255, r)); out[i+1] = Math.max(0, Math.min(255, gg)); out[i+2] = Math.max(0, Math.min(255, b));
    }
  }
  // The shaded copy is only for looking at: the FLAT quantised pixels stay on the source canvas, so the print check
  // measures the real shapes (a 1 mm seam is not a "thin line") and the colour readout lists only chart colours.
  S.shaded = null;
  try {
    const c = document.createElement('canvas'); c.width = W; c.height = H; const x = c.getContext('2d');
    if (x && x.createImageData) { const id = x.createImageData(W, H); id.data.set(out);
      if (g.raised) { // the pile throws a soft shadow onto the mat (look only): draw the shaded pixels back with a canvas shadow at the mat's scale
        const tmp = document.createElement('canvas'); tmp.width = W; tmp.height = H; const tx = tmp.getContext('2d'); tx.putImageData(id, 0, 0);
        const px = 1 / Math.max(0.05, mmPerPx);
        if (deep) { // a tight contact shadow where the pile meets the base, then a longer soft cast shadow
          x.save(); x.shadowColor = 'rgba(0,0,0,0.6)'; x.shadowBlur = Math.min(24, 1.6 * px); x.shadowOffsetX = Math.min(12, 1.2 * px); x.shadowOffsetY = Math.min(12, 1.2 * px); x.drawImage(tmp, 0, 0); x.restore();
          x.save(); x.shadowColor = 'rgba(0,0,0,0.62)'; x.shadowBlur = Math.min(96, 10 * px); x.shadowOffsetX = Math.min(60, 6.5 * px); x.shadowOffsetY = Math.min(60, 6.5 * px); x.drawImage(tmp, 0, 0); x.restore();
        } else { x.save(); x.shadowColor = 'rgba(0,0,0,0.5)'; x.shadowBlur = Math.min(64, 6 * px); x.shadowOffsetX = Math.min(40, 3.5 * px); x.shadowOffsetY = Math.min(40, 3.5 * px); x.drawImage(tmp, 0, 0); x.restore(); }
      } else x.putImageData(id, 0, 0);
      S.shaded = { src: sourceCanvas, canvas: c }; if (sourceCanvas) sourceCanvas.__shaded = c; }
  } catch(e) { S.shaded = null; }
}
// ── Coir Logo Inlay render (14 Oct 2026). From the product photos: the inlay sits at the SAME height as the base (no
// bevel, no shadow), each piece is its own cut of dyed coir with its own grain, fibres of both pieces lean over the cut
// by 2-3 mm so the edge is soft and ragged, and a faint darker line sits in the joint. Base and inlay are made by the
// same coir synthesis: the fine-grained natural coir photo (the grey / black strips are macro shots, far coarser than
// the real fibre), warped and blended from two copies so the photo strip's mirror motif never shows, in the coir's own
// colour; dark coir keeps lighter fibre tips. Detail fades with the display scale, as the eye sees a mat from further away.
const COIR_INLAY_RENDER = { fuzzMm: 3.2, strandMm: 0.45, strandLenMm: 4, jointAlpha: 0.30, tileMm: 930, cellMm: 930 / 24, // 24 bombing cells per 930 mm = the photo strip width: the coir repeats seamlessly on 930 mm
  // measured on the product photos (14 Oct 2026, regions clear of the logo): natural = INSITU_004 201,131,76 / INSITU_003 inlay
  // 164,122,84; grey = the Clyde Hotel mat 76,77,80; black = INSITU_003 21,30,37. Fibre contrast (luminance SD) 30 / 18 / 8.
  rgb: { Natural: [182, 127, 80], Grey: [77, 78, 81], Black: [24, 29, 35] }, sd: { Natural: 30, Grey: 21, Black: 13 }, tipLift: { Natural: 1, Grey: 1.2, Black: 2.2 } };
let _coirTexData = null;
function coirTexData(){
  const c = coirTile('Natural'); if (!c) return null;
  if (_coirTexData && _coirTexData.c === c) return _coirTexData;
  try {
    const d0 = c.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, c.width, c.height).data, W = c.width, H = c.height;
    // the photo strip was lit unevenly: keep its fibre (high-pass, ~12 mm box) and only a third of its broad shading, so no blotches repeat
    const rad = Math.max(2, Math.round(12 * W / (c.mm || 930))), tmp = new Float32Array(d0.length), bl = new Float32Array(d0.length), d = new Uint8ClampedArray(d0.length);
    for (let y = 0; y < H; y++) for (let ch = 0; ch < 3; ch++) { let acc = 0; for (let k = -rad; k <= rad; k++) acc += d0[(y * W + ((k % W) + W) % W) * 4 + ch]; for (let x = 0; x < W; x++) { tmp[(y * W + x) * 4 + ch] = acc / (2 * rad + 1); acc += d0[(y * W + (x + rad + 1) % W) * 4 + ch] - d0[(y * W + ((x - rad) % W + W) % W) * 4 + ch]; } }
    for (let x = 0; x < W; x++) for (let ch = 0; ch < 3; ch++) { let acc = 0; for (let k = -rad; k <= rad; k++) acc += tmp[((((k % H) + H) % H) * W + x) * 4 + ch]; for (let y = 0; y < H; y++) { bl[(y * W + x) * 4 + ch] = acc / (2 * rad + 1); acc += tmp[(((y + rad + 1) % H) * W + x) * 4 + ch] - tmp[((((y - rad) % H) + H) % H * W + x) * 4 + ch]; } }
    let r = 0, g = 0, b = 0; const n = d0.length / 4; for (let i = 0; i < d0.length; i += 4) { r += d0[i]; g += d0[i+1]; b += d0[i+2]; } const mean = [r / n, g / n, b / n];
    for (let i = 0; i < d0.length; i += 4) { for (let ch = 0; ch < 3; ch++) d[i + ch] = mean[ch] + (d0[i + ch] - bl[i + ch]) + 0.35 * (bl[i + ch] - mean[ch]); d[i + 3] = 255; }
    const ml = 0.299 * r / n + 0.587 * g / n + 0.114 * b / n; let v2 = 0; for (let i = 0; i < d.length; i += 4) { const l = 0.299 * d[i] + 0.587 * d[i+1] + 0.114 * d[i+2] - ml; v2 += l * l; }
    return (_coirTexData = { c, d, w: c.width, h: c.height, pxPerMm: c.width / (c.mm || 930), mr: r / n, mg: g / n, mb: b / n, ml, sdl: Math.sqrt(v2 / n) });
  } catch (e) { return null; }
}
function coirTexReady(){ return coirTile('Natural') ? 1 : 0; } // part of the quantise cache key: a render made before the photo landed is never reused
function coirHash(x, y, s){ let h = (Math.imul(x | 0, 374761393) + Math.imul(y | 0, 668265263) + Math.imul(s | 0, 1442695041)) | 0; h = Math.imul(h ^ (h >>> 13), 1274126177); return ((h ^ (h >>> 16)) >>> 0) / 4294967296; }
function coirSmooth(x, y, s){ const x0 = Math.floor(x), y0 = Math.floor(y), fx = x - x0, fy = y - y0, sx = fx * fx * (3 - 2 * fx), sy = fy * fy * (3 - 2 * fy);
  const a = coirHash(x0, y0, s), b = coirHash(x0 + 1, y0, s), c = coirHash(x0, y0 + 1, s), d = coirHash(x0 + 1, y0 + 1, s);
  return a + (b - a) * sx + (c - a) * sy + (a - b - c + d) * sx * sy; }
function coirSamp(t, u, v, o){ const u0 = Math.floor(u), v0 = Math.floor(v), fu = u - u0, fv = v - v0, a0 = ((u0 % t.w) + t.w) % t.w, a1 = (a0 + 1) % t.w, b0 = ((v0 % t.h) + t.h) % t.h, b1 = (b0 + 1) % t.h, d = t.d;
  const i00 = (b0 * t.w + a0) * 4, i10 = (b0 * t.w + a1) * 4, i01 = (b1 * t.w + a0) * 4, i11 = (b1 * t.w + a1) * 4, w00 = (1 - fu) * (1 - fv), w10 = fu * (1 - fv), w01 = (1 - fu) * fv, w11 = fu * fv;
  o[0] = d[i00] * w00 + d[i10] * w10 + d[i01] * w01 + d[i11] * w11; o[1] = d[i00 + 1] * w00 + d[i10 + 1] * w10 + d[i01 + 1] * w01 + d[i11 + 1] * w11; o[2] = d[i00 + 2] * w00 + d[i10 + 2] * w10 + d[i01 + 2] * w01 + d[i11 + 2] * w11; }
// One coir pixel at (xm, ym) mm in the colour of the named coir; seed = which cut of coir (base or a logo piece). Texture bombing: every
// ~40 mm cell takes the photo from its own random spot, quarter turn and flip; the 4 cells round a pixel are blended with
// variance-keeping weights, so neither the strip's mirror motif nor a repeat can show and the fibre keeps its contrast.
const _cs = [0, 0, 0];
function coirPixel(t, xm, ym, seed, name, scaleFade, o){
  const RC = COIR_INLAY_RENDER, ppm = t.pxPerMm, C = RC.cellMm, fx = xm / C - 0.5, fy = ym / C - 0.5, ix = Math.floor(fx), iy = Math.floor(fy);
  let tx = fx - ix, ty = fy - iy; tx = tx * tx * tx * (tx * (tx * 6 - 15) + 10); ty = ty * ty * ty * (ty * (ty * 6 - 15) + 10);
  let ar = 0, ag = 0, ab = 0, ww = 0;
  for (let b = 0; b < 2; b++) for (let a = 0; a < 2; a++) {
    const w = (a ? tx : 1 - tx) * (b ? ty : 1 - ty); if (w < 0.002) continue;
    const cx = (((ix + a) % 24) + 24) % 24, cy = (((iy + b) % 24) + 24) % 24, h1 = coirHash(cx, cy, 101 + seed), h2 = coirHash(cx, cy, 211 + seed), h3 = coirHash(cx, cy, 307 + seed);
    let u = xm * ppm, v = ym * ppm; const rot = (h3 * 8) | 0;
    if (rot & 1) { const q = u; u = -v; v = q; } if (rot & 2) { u = -u; v = -v; } if (rot & 4) u = -u;
    coirSamp(t, u + h1 * t.w, v + h2 * t.h, _cs);
    ar += w * (_cs[0] - t.mr); ag += w * (_cs[1] - t.mg); ab += w * (_cs[2] - t.mb); ww += w * w;
  }
  const n = ww > 0 ? 1 / Math.sqrt(ww) : 1; ar *= n; ag *= n; ab *= n;
  const c = RC.rgb[name] || RC.rgb.Natural, k = ((RC.sd[name] || 30) / Math.max(1, t.sdl)) * scaleFade;
  if (name === 'Natural') { o[0] = c[0] + ar * k; o[1] = c[1] + ag * k; o[2] = c[2] + ab * k; return; } // the photo's own strand colours, centred on the measured tan
  let dl = (0.299 * ar + 0.587 * ag + 0.114 * ab) * k; if (dl > 0) dl *= (RC.tipLift[name] || 1); // dyed coir: lighter fibre tips catch the light
  o[0] = c[0] + dl; o[1] = c[1] + dl; o[2] = c[2] + dl * 1.04;
}
function coirScaleFade(mmPerPx){ return Math.min(1, Math.sqrt(1.3 / Math.max(0.05, mmPerPx))); }
// The coir inlay mat's base surface, made the same way as the inlay pieces, as ONE seamless 930 mm tile per colour: the
// bombing grid (24 cells) and the photo strip both repeat on 930 mm, so the tile joins invisibly. Made once at the photo's
// own detail (0.8 mm a pixel), then halved for small views; every render after that is a pattern fill (the 3000 px proof
// used to take 2 s to fill pixel by pixel).
const _coirBase = new Map();
function coirBaseTile(name, mmPerPx){
  const t = coirTexData(); if (!t) return null; const nm = name || 'Natural';
  let lvl = 0.8; while (lvl * 2 <= mmPerPx && lvl < 6.4) lvl *= 2;
  const key = nm + '|' + lvl; let tile = _coirBase.get(key); if (tile) return tile;
  if (lvl > 0.8) { const up = coirBaseTile(nm, lvl / 2); if (!up) return null; const c = document.createElement('canvas'); c.width = Math.max(1, Math.round(up.c.width / 2)); c.height = c.width; const x = c.getContext('2d'); x.imageSmoothingQuality = 'high'; x.drawImage(up.c, 0, 0, c.width, c.height); tile = { c, mm: COIR_INLAY_RENDER.tileMm / c.width }; }
  else { const job = coirTileJob(nm); if (!job) return null; coirTileRows(job, Infinity); tile = { c: job.c, mm: job.step }; } // finishes whatever the idle warm-up has not done yet
  _coirBase.set(key, tile); return tile;
}
// The 0.8 mm tiles are built in row chunks: in idle time (coirWarmTiles, started once the photo is in) or, for rows still
// missing, at the moment one is needed. No tap ever waits for a whole tile.
const _coirJobs = {};
function coirTileJob(nm){
  if (_coirJobs[nm]) return _coirJobs[nm]; const t = coirTexData(); if (!t) return null;
  const N = Math.round(COIR_INLAY_RENDER.tileMm / 0.8), c = document.createElement('canvas'); c.width = c.height = N;
  const x = c.getContext('2d'), id = x.createImageData(N, N);
  return (_coirJobs[nm] = { nm, t, N, c, x, id, step: COIR_INLAY_RENDER.tileMm / N, row: 0 });
}
function coirTileRows(job, rows){
  if (job.row >= job.N) return true; const { t, N, nm, step } = job, d = job.id.data, o = [0, 0, 0], end = Math.min(N, job.row + rows);
  for (let y = job.row; y < end; y++) for (let xx = 0; xx < N; xx++) { coirPixel(t, xx * step, y * step, 9, nm, 1, o); const i = (y * N + xx) * 4; d[i] = o[0]; d[i + 1] = o[1]; d[i + 2] = o[2]; d[i + 3] = 255; }
  job.row = end; if (end >= N) { job.x.putImageData(job.id, 0, 0); job.id = null; return true; } return false;
}
let _coirWarmOn = false;
function coirWarmTiles(){
  if (_coirWarmOn || !coirTexData()) return; _coirWarmOn = true;
  const order = ['Natural', 'Black', 'Grey'], idle = cb => (window.requestIdleCallback && !document.hidden) ? requestIdleCallback(cb, { timeout: 2000 }) : setTimeout(cb, 120);
  const step = () => { const nm = order.find(n => !_coirBase.get(n + '|0.8') && !(_coirJobs[n] && _coirJobs[n].row >= _coirJobs[n].N)); if (!nm) return; const job = coirTileJob(nm); if (!job) return; if (coirTileRows(job, 40)) _coirBase.set(nm + '|0.8', { c: job.c, mm: job.step }); idle(step); }; // ~40 rows = a few tens of ms
  idle(step);
}
function coirBasePattern(ctx, name, mmPerPx){ coirWarmTiles(); const tile = coirBaseTile(name, mmPerPx); if (!tile) return null; const p = ctx.createPattern(tile.c, 'repeat'); if (p && p.setTransform) { try { p.setTransform(new DOMMatrix().scale(tile.mm / Math.max(0.05, mmPerPx))); } catch (e) {} } return p; }
function coirInlayFinish(data, ids, NONE, ent, W, H, mmPerPx, sourceCanvas){
  const N = W * H, mm = Math.max(0.05, mmPerPx), RC = COIR_INLAY_RENDER, names = [], lab = new Int8Array(N), flat = [];
  for (let p = 0; p < N; p++) { if (ids[p] === NONE) { lab[p] = -1; continue; } const e = ent(ids[p]); const nm = (e && e.name) || 'Natural'; let k = names.indexOf(nm); if (k < 0) { k = names.length; names.push(nm); flat.push(e ? [e.r, e.g, e.b] : [185, 143, 82]); } lab[p] = k; }
  // 1. where the cut runs: every pixel within the fibre reach of a boundary between two pieces (or a piece and the base)
  const R = Math.max(0.8, Math.min(18, RC.fuzzMm / mm)), Ri = Math.ceil(R), near = new Uint8Array(N);
  { const b = new Uint8Array(N), t = new Uint8Array(N);
    for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) { const p = y * W + x; if ((x + 1 < W && lab[p] !== lab[p + 1]) || (y + 1 < H && lab[p] !== lab[p + W])) b[p] = 1; }
    for (let y = 0; y < H; y++) { const o = y * W; let r = -1e9; for (let x = 0; x < W; x++) { if (b[o + x]) r = x; if (x - r <= Ri) t[o + x] = 1; } r = 1e9; for (let x = W - 1; x >= 0; x--) { if (b[o + x]) r = x; if (r - x <= Ri) t[o + x] = 1; } }
    for (let x = 0; x < W; x++) { let r = -1e9; for (let y = 0; y < H; y++) { if (t[y * W + x]) r = y; if (y - r <= Ri) near[y * W + x] = 1; } r = 1e9; for (let y = H - 1; y >= 0; y--) { if (t[y * W + x]) r = y; if (r - y <= Ri) near[y * W + x] = 1; } } }
  // 2. fibres across the cut: pixels sit on short strands (direction from a slow field); each strand slides along itself by
  //    up to the reach, so strands of either piece lie over the other one (seeded: every render matches)
  const fl = new Int8Array(lab), sw = Math.max(0.7, RC.strandMm / mm), sl = Math.max(1.5, RC.strandLenMm / mm), fp = Math.max(4, 6 / mm);
  for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
    const p = y * W + x; if (!near[p]) continue;
    const ang = coirSmooth(x / fp, y / fp, 7) * Math.PI * 3, ca = Math.cos(ang), sa = Math.sin(ang);
    const sid = Math.floor((-x * sa + y * ca) / sw), seg = Math.floor((x * ca + y * sa) / sl + coirHash(sid, 0, 5) * 3);
    const len = (coirHash(sid, seg, 11) - 0.5) * 2 * R;
    const qx = Math.max(0, Math.min(W - 1, Math.round(x + ca * len))), qy = Math.max(0, Math.min(H - 1, Math.round(y + sa * len)));
    fl[p] = lab[qy * W + qx];
  }
  // 3. colour: each piece is its own cut of coir (own seed: own grain and offset); a darker line in the joint
  const t = coirTexData(), out = new Uint8ClampedArray(N * 4), o = [0, 0, 0], fade = coirScaleFade(mm);
  const joint = p => { const k = fl[p], x = p % W; return (x + 1 < W && fl[p + 1] !== k) || (x > 0 && fl[p - 1] !== k) || (p + W < N && fl[p + W] !== k) || (p - W >= 0 && fl[p - W] !== k); };
  for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
    const p = y * W + x, i = p * 4, k = fl[p];
    if (k < 0) { if (near[p] && joint(p)) { out[i + 3] = Math.round(255 * RC.jointAlpha * 0.6); } continue; } // the base shows; a soft dark line in the joint
    let r, g, b;
    if (t) { coirPixel(t, x * mm, y * mm, k + 1, names[k], fade, o); r = o[0]; g = o[1]; b = o[2]; }
    else { const f = flat[k], n = (coirHash(x, y, 3) - 0.5) * 60; r = f[0] + n; g = f[1] + n; b = f[2] + n; } // photo still loading: the flat coir colour with a bristle noise
    if (near[p] && joint(p)) { const jm = 1 - RC.jointAlpha * 0.7; r *= jm; g *= jm; b *= jm; }
    out[i] = r; out[i + 1] = g; out[i + 2] = b; out[i + 3] = 255;
  }
  S.shaded = null;
  try { const c = document.createElement('canvas'); c.width = W; c.height = H; const x = c.getContext('2d'); const id = x.createImageData(W, H); id.data.set(out); x.putImageData(id, 0, 0); S.shaded = { src: sourceCanvas, canvas: c }; if (sourceCanvas) sourceCanvas.__shaded = c; } catch (e) { S.shaded = null; }
}
// The canvas to DRAW for a quantised artwork canvas: the shaded copy when one exists for it, else the canvas itself.
function artCanvas(c){ return (c && c.__shaded) ? c.__shaded : (S.shaded && S.shaded.src === c && S.shaded.canvas) ? S.shaded.canvas : c; } // 12 Oct 2026: S.shaded is one slot, so the mini preview's quantise used to steal the Preview step's bevel

// ── Validation per family ──
// Thresholds live in data/thresholds.json (baked in as window.TMG_THRESHOLDS); the numbers here are the fallback copy.
const THRESH_FALLBACK = {
  cut:         { strokeMinMm: 10, strokeWarnMm: 8, textMinMm: 50, textWarnMm: 50, gapMinMm: 10, gapWarnMm: 8, checkBorder: false },
  raised:      { strokeMinMm: 8,  strokeWarnMm: 4, textMinMm: 50, textWarnMm: 30, gapMinMm: 5,  gapWarnMm: 4, checkBorder: false },
  coirinlay:   { strokeMinMm: COIR_INLAY.strokeMinMm, strokeWarnMm: COIR_INLAY.strokeWarnMm, textMinMm: COIR_INLAY.textMinMm, textWarnMm: COIR_INLAY.textWarnMm, gapMinMm: COIR_INLAY.gapMinMm, gapWarnMm: COIR_INLAY.gapWarnMm, checkBorder: false },
  promotional: { strokeMinMm: 3,  strokeWarnMm: 2, textMinMm: 20, textWarnMm: 15, gapMinMm: 2, gapWarnMm: 2 }
};
function threshClass(g){ return g.inlayFlush ? 'coirinlay' : g.cut ? 'cut' : g.raised ? 'raised' : g.key === 'promotional' ? 'promotional' : 'printed'; }
function familyCheckOpts(){
  const g = gradeOf(), cls = threshClass(g);
  if (cls === 'printed') return {}; // the live printed rules (fitted to real proofs)
  const t = (typeof window !== 'undefined' && window.TMG_THRESHOLDS && window.TMG_THRESHOLDS[cls]) || THRESH_FALLBACK[cls];
  const o = {}; for (const k in t) if (/Mm$|^checkBorder$/.test(k)) o[k] = t[k];
  return o;
}
// what the check ran with, for the learning loop (hidden cart line, never shown to the customer)
// How sure the check is that we can make this mat as designed, 0-100. Backend only (hidden cart line), never shown to
// the customer. Deductions: failed / warned print-check rows, soft resolution, colours over the family's cap, off-chart
// colours, photo / gradient art on a cut or embossed mat, a white background on a floor mat. Calibrated over time by
// learn/recalibrate-v2.js against what production did (score band vs production-changed rate).
function validityScore(){
  const g = gradeOf(); let s = 100; const why = [];
  const pc = S.printCheck;
  if (pc) {
    if (pc.ok === false) { s -= 25; why.push('fail'); }
    if (pc.warnCount) { s -= Math.min(30, pc.warnCount * 10); why.push('warn' + pc.warnCount); }
    if (pc.noteCount) { s -= Math.min(10, pc.noteCount * 3); }
    if (pc.pxPerMm != null && pc.pxPerMm < 2) { s -= pc.pxPerMm < 1 ? 25 : 12; why.push('res' + pc.pxPerMm); }
    if (pc.passesAt === false) { s -= 10; why.push('nosize'); }
  }
  const st = S.colourStats;
  if (st && !g.asSupplied) {
    const cap = g.cap || 12;
    if (st.distinct > cap) { s -= Math.min(20, (st.distinct - cap) * 4); why.push('over' + (st.distinct - cap)); }
    if (st.off) { s -= Math.min(15, st.off * 3); why.push('off' + st.off); }
    if ((g.cut || g.raised) && typeof isGradientArt === 'function' && isGradientArt(st)) { s -= 40; why.push('gradient'); }
  }
  if (typeof whiteBgWarn === 'function' && whiteBgWarn()) { s -= 5; why.push('whitebg'); }
  return { score: Math.max(0, Math.min(100, Math.round(s))), why: why.join(',') };
}
function checkTag(){ const g = gradeOf(), o = familyCheckOpts(), v = validityScore(); return '[v2 ' + g.key + ' t' + (o.textMinMm || 30) + '/s' + (o.strokeMinMm || 8) + '/g' + (o.gapMinMm || 3) + ' score=' + v.score + (v.why ? ' ' + v.why : '') + ']'; }
// As-supplied files print pixel for pixel: under 2 px per mm at the chosen size they print soft (the team's third most
// common bounce: "not high enough resolution"). Adds a warn line to the print-check summary.
function resolutionCheck(pc){
  if (!asSupplied() || !cachedLogo || !S.logoDw || !S.matWmm || !S.canvasW) return pc;
  if (S.file && /svg/i.test(S.file.type || '')) return pc;
  const mmPerPx = S.matWmm / S.canvasW, logoMm = S.logoDw * mmPerPx, pxPerMm = cachedLogo.w / Math.max(1, logoMm);
  pc.pxPerMm = Math.round(pxPerMm * 10) / 10;
  if (pxPerMm >= 2) return pc;
  const line = 'The file is ' + cachedLogo.w + ' px wide, printed at ' + Math.round(logoMm) + ' mm: about ' + pc.pxPerMm + ' px per mm, so edges will print a little soft (2 px per mm or more prints crisp). A larger file, or a vector PDF, prints sharper.';
  pc.lines = (pc.lines || []).concat([line]); pc.ok = false; pc.warnCount = (pc.warnCount || 0) + 1;
  pc.summary = (/^Passed/.test(pc.summary || '') ? 'ADJUST BEFORE PRINT at ' + pc.size + ': ' : (pc.summary || '') + '; ') + 'low resolution ' + pc.pxPerMm + ' px/mm (needs 2)';
  pc.summary = pc.summary.slice(0, 400);
  return pc;
}
function whiteBgWarn(){ const g = gradeOf(); if (!g.whiteWarn || !S.selectedBg || !S.selectedBg.hex || S.useArtworkAsBg) return ''; const h = S.selectedBg.hex; return lum(parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16)) > 235 ? 'white background (marks easily on Promotional)' : ''; }
function placementName(){ return S.placement === 'outside' ? 'Outside' : S.placement === 'wet' ? 'Wet area' : 'Inside'; }
// Family-specific cart line fields, on top of the common ones (Mat Size, Orientation, Design Colours, Background Colour, Artwork File, Mat Preview, SKU, Print Grade).
function familyCartProps(props){
  const g = gradeOf();
  props['Placement'] = placementName();
  if (!props['Floor Type']) delete props['Floor Type']; // Floor Type only when the customer chose one (Zac 6 Oct)
  props['Lead time'] = 'Approx. ' + leadOf(g.key) + ' from proof approval and payment';
  if (S.sourceNote) props['Artwork File note'] = S.sourceNote;
  if (typeof overrideSummary === 'function') { const oc = overrideSummary(); if (oc) props['Colour changes (customer)'] = oc; }
  if (typeof pmsCount === 'function' && pmsCount()) props['PMS colour matching'] = pmsCount() + ' colour' + (pmsCount() > 1 ? 's' : '') + ': ' + pmsSummary() + ' (' + fmt(PMS_MATCH.price) + ' each, charged as a separate PMS COLOUR MATCH line)';
  if (S.sourceFile) props['Artwork original'] = S.sourceFile.name + ' (' + (S.sourceFile.size / 1048576).toFixed(1) + ' MB, previewed from a rendered copy)';
  if (isPS()) props['Drainage holes'] = drainageOn() ? 'Yes' : 'No';
  if (hasEdging()) props['Edging'] = edgingOn() ? (g.edgeCharge ? 'With edging (' + edgeMetres(g.key) + ' m a mat at ' + fmt(g.edgeCharge.rate) + '/m, charged as a separate PVC SAFETY EDGING line)' : 'With edging') : 'No edging';
  if (g.option3) { const bc = (S.selectedBg && S.selectedBg.name) || variantColour(g.key); if (bc) { props['Base Mat Colour'] = bc; delete props['Background Colour']; } }
  if (g.key === 'dirtstopper') props['Colour Quantity'] = dsColourQty() + ' Colour Print';
  if (g.asSupplied) props['Design Colours'] = 'Printed as supplied from the artwork file' + (g.key === 'hd' ? ' (High Definition)' : ' (digital print)'); // no colour list: these mats work off the image (Zac, 7 Oct 2026)
  const ww = whiteBgWarn(); if (ww) props['_Print Check'] = ((props['_Print Check'] || '') + (props['_Print Check'] ? '; ' : 'NOTE: ') + ww).slice(0, 400);
  if (!g.asSupplied) props['_Print Check'] = ((props['_Print Check'] || 'no warnings') + ' ' + checkTag()).slice(0, 480);
  return props;
}

// ── Custom sizes (made to measure), v2 ──
// Five cards price a custom size exactly the way their product pages do today (per m², plus edging per metre and a
// logo charge on Superguard): the live rates come from the products' custom.* metafields (Liquid fills
// window.TMG_CUSTOM_RATES; the numbers below are the 5 Oct 2026 values as a fallback), and add-to-cart calls the same
// Railway pricer the product pages call, which mints the priced variant on the family's OWN product (real SKU, lands in
// Cin7 the way every custom PrintPlush order has). Every other card is made in its nearest standard size.
const CUSTOM_API = 'https://tmg-custom-pricing2-production.up.railway.app/custom-variant';
const CR = (typeof window !== 'undefined' && window.TMG_CUSTOM_RATES) || {};
const CUSTOM = {
  standard:     { handle: 'printplush-logo-mat',       variantId: 51450460864679, rate: Number(CR.standard) || 377.3 },
  commercial:   { handle: 'printplush-logo-mat',       variantId: 51450047135911, rate: Number(CR.commercial) || 416.9 },
  hd:           { handle: 'high-def-printed-mat',      variantId: 51449811140775, rate: Number(CR.hd) || 416.9 },
  printscraper: { handle: 'printscraper-logo-mat',     variantId: 51449786106023, rate: Number(CR.printscraper) || 537.9 },
  coirinlay:    { handleByBase: COIR_INLAY.handleByBase, variantByBase: COIR_INLAY.variantByBase, rateByBase: COIR_INLAY.rateByBase, rate: COIR_INLAY.rateByBase.Natural, edgeRate: COIR_INLAY.edgeRate, logoSmall: COIR_INLAY.logoSmall, logoLarge: COIR_INLAY.logoLarge, wmin: COIR_INLAY.wmin, wmax: COIR_INLAY.wmax },
  superguard:   { handle: 'superguard-logo-inlay-mat', rate: Number(CR.superguard) || 206.8, edgeRate: Number(CR.superguardEdge) || 29.7, logoSmall: Number(CR.superguardLogoSmall) || 407, logoLarge: Number(CR.superguardLogoLarge) || 586.3, wmax: 2000,
                  variantIds: { 'Black': 51449708216487, 'Charcoal': 51449708249255, 'Mid Grey': 51449708282023, 'Denim': 51449708314791, 'Sterling': 51449708347559, 'White': 51449708380327, 'Gold': 51449708413095, 'Orange': 51449708445863, 'Bright Red': 51449708478631, 'Royal Blue': 51449708511399, 'Kelly Green': 51449708544167, 'American Green': 51449708576935, 'Purple': 51449708609703, 'Natural Beige': 51449708642471, 'Camel (Coir Colour Substitute)': 51449708675239 } }
};
const CUSTOM_MIN = 200, CUSTOM_MAX = 20000;
function customOf(k){ return CUSTOM[k || S.grade] || null; }
// 14 Oct 2026: Coir Logo Inlay has no Design Your Own variants - every size, the standard presets too, is priced by the
// formula and minted on the base colour's own product.
function alwaysMint(k){ const g = GRADES[k || S.grade]; return !!(g && g.alwaysMint); }
function mintDims(k){ if (isCustomSize()) return { L: S.custom.L, W: S.custom.W }; const s = String(familySize(k || S.grade)); const [a, b] = s.split('x').map(Number); return { L: Math.max(a, b), W: Math.min(a, b) }; }
function coirBaseOf(k){ // the base coir colour family k is made in: the chosen coir colour, else the nearest of the three to the chosen background
  const b = S.selectedBg; if (!b || S.useArtworkAsBg) return 'Natural'; if (/^COIR:/.test(b.mm || '')) return b.name;
  return 'Natural'; // coirbase1016: a printed-mat colour never picks the coir; only a chosen coir colour does
}
function customHandle(k){ const c = customOf(k); return c ? (c.handleByBase ? c.handleByBase[coirBaseOf(k)] || c.handleByBase.Natural : c.handle) : null; }
function isCustomSize(){ return !!(S.custom && S.custom.L && S.custom.W); }
function customLimits(k){ const c = customOf(k); return { lmin: CUSTOM_MIN, lmax: CUSTOM_MAX, wmin: (c && c.wmin) || CUSTOM_MIN, wmax: (c && c.wmax) || CUSTOM_MAX }; }
function customValidFor(k){ if (!isCustomSize()) return !!customOf(k); const L = customLimits(k); return S.custom.L >= L.lmin && S.custom.L <= L.lmax && S.custom.W >= L.wmin && S.custom.W <= L.wmax; }
// Same formula as the product page wizard (customPriceFull): rate x m², plus edging per metre of perimeter when edged, plus the logo charge
function customPriceFor(k){
  const c = customOf(k); if (!c || !customValidFor(k)) return null;
  const dm = mintDims(k), a = dm.L * dm.W / 1e6; let p = (c.rateByBase ? (c.rateByBase[coirBaseOf(k)] || c.rate) : c.rate) * a;
  if (c.edgeRate && S.edging !== false && !(alwaysMint(k) && S.edging == null && GRADES[k].edgeDefault === false)) p += c.edgeRate * (2 * (dm.L + dm.W) / 1000);
  if (c.logoSmall) p += a < 2 ? c.logoSmall : (c.logoLarge || c.logoSmall);
  return Math.round(p * 100) / 100;
}
function customBaseVariantId(k){ const c = customOf(k); if (!c) return null; if (c.variantByBase) return c.variantByBase[coirBaseOf(k)] || c.variantByBase.Natural; if (c.variantIds) { const n = variantColour(k); return c.variantIds[n] || c.variantIds[Object.keys(c.variantIds)[0]]; } return c.variantId; }
function customSizeLabel(){ return isCustomSize() ? S.custom.L + ' × ' + S.custom.W + 'mm' : ''; }
// The custom variant the card is priced on (no product fetch: the price is computed, the variant is minted at add-to-cart)
function customVariantFor(k){ const p = customPriceFor(k); if (p == null) return null; const dm = mintDims(k); return { id: 'custom:' + k, custom: true, price: Math.round(p * 100), sku: 'custom size', title: (isCustomSize() ? 'Custom size ' : '') + dm.L + ' × ' + dm.W + 'mm', compare_at_price: null }; }
// Dimensions typed on the Configure step. A pair that equals a standard size is simply that size (real variant, nothing minted).
function setCustomDims(L, W){
  L = Math.round(Number(L) || 0); W = Math.round(Number(W) || 0);
  if (!S.custom && /^\d+x\d+$/.test(S.size || '')) S.stdSizeBefore = stdPick() || S.size; // remembered so closing the section goes back to it
  S.custom = (L >= CUSTOM_MIN && W >= CUSTOM_MIN) ? { L, W } : null;
  if (!S.custom) return;
  const std = Math.min(L, W) + 'x' + Math.max(L, W);
  if (TMG_BASE_SIZES.indexOf(std) > -1 || familySizes(S.grade).indexOf(std) > -1) { S.custom = null; setPickSize(std); }
  else { S.size = L + 'x' + W; S.pickSize = null; }
  const ori = $('tmgOri'); if (ori) ori.value = L >= W ? 'landscape' : 'portrait';
  onGradeChanged();
  renderCustomHint();
}
function renderCustomHint(){
  const h = $('tmgCustHint'); if (!h) return;
  const sel = $('tmgSize'); if (!sel || sel.value !== 'custom') return;
  const L = customLimits(S.grade);
  if (!S.custom && S.size && /^\d+x\d+$/.test(S.size) && $('tmgCustL') && $('tmgCustL').value) h.textContent = 'That is one of our standard sizes: priced and made as ' + sizeLabel(S.size) + '.';
  else if (S.custom && !customValidFor(S.grade)) h.textContent = (customOf(S.grade) ? 'Please keep it between ' + L.lmin + ' mm and ' + (L.lmax / 1000) + ' m long and ' + L.wmin + ' mm to ' + (L.wmax / 1000) + ' m wide.' : 'Any size from ' + CUSTOM_MIN + ' mm to ' + (CUSTOM_MAX / 1000) + ' m.');
  else if (S.custom && customOf(S.grade)) h.textContent = gradeOf().title + ' is made to measure at ' + customSizeLabel() + '.';
  else if (S.custom) h.textContent = gradeOf().title + ' is made in standard sizes only, so it will be made at ' + sizeLabel(familySize(S.grade)) + ' (the nearest). PrintPlush, High Definition, PrintScraper, Superguard and Coir Logo Inlay are made to measure.';
  else h.textContent = 'Any size from ' + CUSTOM_MIN + ' mm to ' + (CUSTOM_MAX / 1000) + ' m. PrintPlush, High Definition, PrintScraper, Superguard and Coir Logo Inlay are made to measure; other mats are made in their nearest standard size.';
}
let _custTimer = null;
const DIAGRAM_CDN = { landscape: 'https://thematgroup.com.au/cdn/shop/t/34/assets/orientation-landscape.png', portrait: 'https://thematgroup.com.au/cdn/shop/t/34/assets/orientation-portrait.png' };
function customDiagram(){
  const im = $('tmgCustDiagram'); if (!im) return;
  const portrait = S.custom ? S.custom.W > S.custom.L : ($('tmgOri') && $('tmgOri').value === 'portrait');
  const want = (portrait ? im.dataset.portrait : im.dataset.landscape) || DIAGRAM_CDN[portrait ? 'portrait' : 'landscape'];
  if (im.getAttribute('src') !== want) im.src = want;
  im.onerror = () => { im.onerror = null; im.src = DIAGRAM_CDN[portrait ? 'portrait' : 'landscape']; };
}
function openCustomSize(open){
  const wrap = $('tmgCustomWrap'), tg = $('tmgCustomToggle'); if (!wrap) return;
  wrap.style.display = open ? '' : 'none';
  if (tg) { tg.setAttribute('aria-expanded', open ? 'true' : 'false'); tg.classList.toggle('on', !!open); }
  if (!open && isCustomSize()) { // closing the section = back to a standard size, price and cards follow
    S.custom = null; if ($('tmgCustL')) $('tmgCustL').value = ''; if ($('tmgCustW')) $('tmgCustW').value = '';
    setPickSize(S.stdSizeBefore || familySize(S.grade, TMG_BASE_SIZES[0])); syncSizeSelect(); renderCustomHint(); customDiagram();
    if (typeof fetchPricing === 'function') fetchPricing(); if (typeof renderGradeCards === 'function') renderGradeCards(); if (S.step === 4 && typeof reAnalyse === 'function') reAnalyse();
  }
  if (open) { customDiagram(); renderCustomHint(); const L = $('tmgCustL'); if (L && !L.value) try { L.focus(); } catch(e) {} }
}
// The size list shows "Custom size 1300 × 900mm" while a custom size is typed; picking a standard size clears it.
function syncSizeSelect(){
  const sel = $('tmgSize'), opt = $('tmgSizeCustomOpt'); if (!sel || !opt) return;
  if (isCustomSize()) { opt.hidden = false; opt.textContent = 'Custom size ' + customSizeLabel(); sel.value = 'custom'; }
  else if (S.size && /^\d+x\d+$/.test(S.size)) { ensureSizeOption(S.size); opt.hidden = true; }
}
function bindCustomSize(){
  const sel = $('tmgSize'), wrap = $('tmgCustomWrap'), tg = $('tmgCustomToggle'); if (!sel || !wrap) return;
  if (tg) tg.addEventListener('click', () => openCustomSize(wrap.style.display === 'none'));
  sel.addEventListener('change', () => { if (sel.value !== 'custom') { if ($('tmgCustL')) $('tmgCustL').value = ''; if ($('tmgCustW')) $('tmgCustW').value = ''; openCustomSize(false); } });
  const onInput = () => { clearTimeout(_custTimer); _custTimer = setTimeout(() => { setCustomDims($('tmgCustL').value, $('tmgCustW').value); syncSizeSelect(); renderCustomHint(); customDiagram(); fetchPricing(); renderGradeCards(); if (S.step === 4) reAnalyse(); }, 450); };
  ['tmgCustL', 'tmgCustW'].forEach(id => { const el = $(id); if (el) el.addEventListener('input', onInput); });
  const ori = $('tmgOri'); if (ori) ori.addEventListener('change', customDiagram);
}
// Add-to-cart for a custom size: the family's product page pricer mints the priced variant on the family's own product;
// we wait until the storefront serves it with a SKU and price (the wizard's waitForSku), then add that variant.
// 7 Oct 2026: the priced custom variant is minted when the Preview step opens (mintEarly) and reused by the click
// while family, size and edging are unchanged. { key, promise }
let _mintPending = null;
// size1029: the size this line is priced, minted and made at (what getMatchedVariant / mintCustomVariant use)
function lineSize(){ const g = S.grade; if ((isCustomSize() || alwaysMint(g)) && customOf(g)) { const d = mintDims(g); return d.L + 'x' + d.W; } return familySize(g); }
function samePair(a, b){ const p = s => String(s || '').split('x').map(Number).sort((x, y) => x - y).join('x'); return p(a) === p(b); }
// One size per line: if anything let S.size drift from lineSize(), the preview is redrawn at the made size before the proof,
// print check and 'Mat Size' are taken. Returns what changed (hidden '_Size check' on the line), '' when nothing did.
function syncLineSize(){
  const made = lineSize(); if (!made || !/^\d+x\d+$/.test(made) || samePair(made, S.size)) return '';
  const was = S.size; S.size = made; if (isCustomSize()) syncSizeSelect(); else ensureSizeOption(made);
  try { renderCanvas(); } catch(e) {}
  return 'preview redrawn at ' + made.replace('x', ' x ') + 'mm (was ' + String(was).replace('x', ' x ') + 'mm)';
}
function mintKey(){ if (!isCustomSize() && !alwaysMint(S.grade)) return ''; const d = mintDims(S.grade); return [S.grade, d.L, d.W, S.edging !== false ? 'E' : 'N', customHandle(S.grade)].join('|'); }
function mintEarly(){ if (!madeToMeasure(S.grade) || !customOf(S.grade) || !customValidFor(S.grade)) return; const key = mintKey(); if (_mintPending && _mintPending.key === key) return; _mintPending = { key, promise: mintCustomVariant(true).catch(() => null) }; }
async function mintCustomVariant(fresh){
  if (!fresh && _mintPending && _mintPending.key === mintKey()) { const m = await _mintPending.promise; if (m) return m; }
  const k = S.grade, c = customOf(k); if (!c || !customValidFor(k)) return null;
  const dm = mintDims(k), handle = customHandle(k);
  const body = { handle: handle, lengthMm: dm.L, widthMm: dm.W, edging: c.edgeRate ? (S.edging !== false ? 'Yes' : 'No') : 'No', fabric: '', aluminium: '', variantId: customBaseVariantId(k) };
  console.info('[TMG] custom size: minting', JSON.stringify(body), 'via', CUSTOM_API);
  const r = await fetch(CUSTOM_API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  const j = await r.json();
  console.info('[TMG] custom size: pricer said', JSON.stringify(j));
  const vid = j.variantId || j.variant_id || j.id; if (!vid) throw new Error(j.error || 'no variant');
  const v = await waitForMintedVariant(handle, vid); if (!v) throw new Error('VARIANT_NOT_READY');
  return { id: vid, sku: v.sku, price: Number(v.price), configured: j.price, handle: handle };
}
async function waitForMintedVariant(handle, vid){
  let good = 0;
  for (let i = 0; i < 30; i++) {
    try {
      const p = await (await fetch('/products/' + handle + '.js?_cb=' + vid + '-' + i + '-' + Date.now(), { cache: 'no-store' })).json();
      const v = (p.variants || []).find(x => String(x.id) === String(vid));
      if (v && v.sku && Number(v.price) > 0 && ++good >= 2) return v;
    } catch(e) {}
    await new Promise(res => setTimeout(res, 700));
  }
  return null;
}

// ── Artwork file formats, v2 (5 Oct 2026 evening) ──
// The pipeline (quantiser, preview, print check) works on a raster. Vector and document files are converted first:
//  - SVG, PDF, AI, EPS: the ORIGINAL is uploaded to Cloudinary (the same unsigned preset the page already uses; Cloudinary
//    reads Illustrator, EPS, PDF and SVG) and a PNG rendition (f_png, 2400 px) is fetched back for the pipeline. The order
//    carries the original file's URL as "Artwork File" (production wants the vector), the proof is the rendered preview.
//  - SVG also has a browser fallback (drawn straight to a canvas) if the upload fails.
//  - Rasters over Cloudinary's 10 MB ceiling cannot be uploaded here: a reduced copy (longest side 4000 px, JPEG) goes
//    through the pipeline and the order line says the original must be emailed. Files are never silently lost.
const CLOUD_UPLOAD = 'https://api.cloudinary.com/v1_1/dmqkxg0qo/auto/upload';
const CLOUD_PRESET = 'mat config';
const CLOUD_MAX_BYTES = 10 * 1024 * 1024; // Cloudinary's per-file ceiling on this account (tested 6 Oct 2026)
const RASTER_MAX_BYTES = 50 * 1024 * 1024; // what we accept: previewed in the browser, the original attached when it fits Cloudinary
const RASTER_MAX_SIDE = 6000;              // over this the pipeline works on a reduced copy (speed), the original is still the order file
const RASTER_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'image/bmp', 'image/avif'] // decoded by the browser;
const VECTOR_EXT = /\.(svg|pdf|ai|eps)$/i;
const CONVERT_EXT = /\.(heic|heif|tiff?|psd)$/i; // rasters the browser cannot decode: Cloudinary converts them (7 Oct 2026)
const CONVERT_TYPES = ['image/heic', 'image/heif', 'image/heic-sequence', 'image/heif-sequence', 'image/tiff', 'image/vnd.adobe.photoshop', 'application/photoshop', 'application/psd', 'image/x-photoshop'];
function fileKind(f){
  const name = (f && f.name) || '';
  if (RASTER_TYPES.indexOf(f.type) > -1) return 'raster';
  if (/\.svg$/i.test(name) || f.type === 'image/svg+xml') return 'svg';
  if (/\.pdf$/i.test(name) || f.type === 'application/pdf') return 'pdf';
  if (/\.ai$/i.test(name) || f.type === 'application/illustrator') return 'ai';
  if (/\.eps$/i.test(name) || f.type === 'application/postscript' || f.type === 'image/x-eps') return 'eps';
  if (CONVERT_TYPES.indexOf(f.type) > -1 || CONVERT_EXT.test(name)) return 'convert';
  if (/\.(jpe?g|png|webp|gif|bmp|avif)$/i.test(name)) return 'raster';
  return null;
}
function uploadStatus(msg){ const el = $('tmgUploadStatus'); if (!el) return; el.style.display = msg ? 'block' : 'none'; el.textContent = msg || ''; }
async function cloudinaryUpload(file){
  const fd = new FormData(); fd.append('file', file); fd.append('upload_preset', CLOUD_PRESET); fd.append('folder', 'mat-configurator');
  const res = await fetch(CLOUD_UPLOAD, { method: 'POST', body: fd });
  const data = await res.json();
  if (!res.ok || !data.secure_url) throw new Error((data.error && data.error.message) || ('upload failed ' + res.status));
  return data;
}
function renditionUrl(secureUrl, width, limit){
  return secureUrl.replace('/upload/', '/upload/f_png,w_' + (width || 2400) + (limit ? ',c_limit' : '') + '/').replace(/\.(ai|eps|pdf|svg|heic|heif|tiff?|psd)$/i, '.png');
}
async function urlToFile(url, name){
  const res = await fetch(url, { mode: 'cors' }); if (!res.ok) throw new Error('rendition ' + res.status);
  const blob = await res.blob(); return new File([blob], name, { type: blob.type || 'image/png' });
}
async function svgToPng(file, width){
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = url; });
    const w = img.naturalWidth || 1200, h = img.naturalHeight || 800, W = width || 2400, H = Math.round(h * W / w);
    const c = document.createElement('canvas'); c.width = W; c.height = H; c.getContext('2d').drawImage(img, 0, 0, W, H);
    const blob = await new Promise(r => c.toBlob(r, 'image/png'));
    return new File([blob], file.name.replace(/\.svg$/i, '') + '.png', { type: 'image/png' });
  } finally { URL.revokeObjectURL(url); }
}
async function rasterDims(file){
  const url = URL.createObjectURL(file);
  try { const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = url; }); return { w: img.naturalWidth, h: img.naturalHeight }; }
  catch (e) { return null; } finally { URL.revokeObjectURL(url); }
}
async function shrinkRaster(file, maxSide){
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = url; });
    const w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, (maxSide || 4000) / Math.max(w, h));
    const c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k); c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    const isPng = /png|gif/.test(file.type);
    const blob = await new Promise(r => c.toBlob(r, isPng ? 'image/png' : 'image/jpeg', 0.92));
    return new File([blob], file.name.replace(/\.[^.]+$/, '') + (isPng ? '-reduced.png' : '-reduced.jpg'), { type: blob.type });
  } finally { URL.revokeObjectURL(url); }
}
// Entry point for every upload (the file input and the drop zone). Converts, then hands a raster to the live flow.
async function prepareArtwork(f){
  if (!f) return;
  if (!S.genUsed && typeof genConfigureLayout === 'function') genConfigureLayout(); // an upload gets the full Configure step
  const kind = fileKind(f);
  if (!kind) { alert('Please upload a JPG, PNG, HEIC, WebP, GIF, BMP, AVIF, TIFF, PSD, SVG, PDF, AI or EPS file.'); return; }
  S.sourceFile = null; S.sourceUrl = null; S.sourceNote = null;
  try {
    if (kind === 'raster') {
      if (f.size > RASTER_MAX_BYTES) { alert('That file is ' + (f.size / 1048576).toFixed(0) + ' MB. Please upload a version under 50 MB.'); return; }
      const dims = await rasterDims(f);
      const big = dims && Math.max(dims.w, dims.h) > RASTER_MAX_SIDE;
      if (f.size > CLOUD_MAX_BYTES) { S.sourceFile = f; S.sourceNote = 'ORIGINAL ' + (f.size / 1048576).toFixed(1) + ' MB ' + f.name + ' is over our 10 MB attachment limit: the mat preview is attached, ask the customer to email the original if production needs it'; uploadStatus('Large file (' + (f.size / 1048576).toFixed(0) + ' MB): previewing it here; we may ask you to email the original after you order.'); }
      else uploadStatus('');
      if (big) { const small = await shrinkRaster(f, RASTER_MAX_SIDE); if (!S.sourceFile) S.sourceFile = f; handleFileReady(small); return; }
      handleFileReady(f); return;
    }
    // vector / document: original to Cloudinary, PNG rendition back
    if (f.size > CLOUD_MAX_BYTES) {
      if (kind === 'svg') { const png = await svgToPng(f, 2400); S.sourceNote = 'ORIGINAL NOT UPLOADED (' + (f.size / 1048576).toFixed(1) + ' MB ' + f.name + '): ask the customer to email it'; uploadStatus('Previewing a rendered copy; we will ask you to email the original SVG after you order.'); handleFileReady(png); return; }
      alert('That file is ' + (f.size / 1048576).toFixed(1) + ' MB. Please export a smaller version (under 10 MB), or email the file to us and order with a JPG or PNG of the logo.'); return;
    }
    const label = kind === 'convert' ? (f.name.match(/\.([a-z0-9]+)$/i) || [, 'image'])[1].toUpperCase() : kind.toUpperCase();
    uploadStatus('Converting your ' + label + ' for the preview…');
    let data;
    try { data = await cloudinaryUpload(f); }
    catch (e) {
      if (kind === 'svg') { const png = await svgToPng(f, 2400); S.sourceFile = f; uploadStatus(''); handleFileReady(png); return; }
      if (kind === 'convert') { uploadStatus(''); alert('We could not convert that ' + label + ' file. Please export it as a JPG or PNG and upload that instead.'); return; }
      throw e;
    }
    S.sourceFile = f; S.sourceUrl = data.secure_url;
    // a converted raster keeps its own pixels (no upscaling, capped at 4,000 px); a vector is rendered at 2,400 px as before
    const png = await urlToFile(kind === 'convert' ? renditionUrl(data.secure_url, 4000, true) : renditionUrl(data.secure_url, 2400), f.name.replace(/\.[^.]+$/, '') + '.png');
    uploadStatus('');
    handleFileReady(png);
  } catch (e) {
    console.warn('[TMG] artwork conversion failed', e);
    uploadStatus('');
    alert('We could not read that file. Please try a JPG, PNG, PDF or SVG export, or call 1800 300 311.');
  }
}
// The artwork link for the order: the original vector / document when there is one, otherwise the raster the flow has.
async function artworkUrlForOrder(){
  if (S.sourceUrl) return S.sourceUrl;
  if (S.sourceFile && S.sourceFile.size <= CLOUD_MAX_BYTES) { try { const d = await cloudinaryUpload(S.sourceFile); S.sourceUrl = d.secure_url; return S.sourceUrl; } catch(e) {} }
  return (await artworkUploadFor(S.file)) || (await uploadArtworkToShopify(S.file)) || (S.file && S.file.name) || '';
}

function handleFile(f){ prepareArtwork(f); } // every upload goes through the format step first
// ── Change a matched colour, v2 (Zac, 5 Oct 2026: "give them the option to change a colour to something we can print") ──
// Every chip in "Your artwork has been matched" and in the preview legend opens a picker with the mat's own chart (photo
// swatches). Picking a colour records an override keyed by the colour the matcher chose, so every part of the artwork
// that matched that colour is re-rendered in the new one; the proof and the cart line follow. Overrides clear when the
// artwork or the mat changes (a different chart). Colours that would vanish on the chosen base are shown but disabled.
function overridesFor(){ if (!S.colourOverrides || S.colourOverrides.chart !== gradeOf().chart) S.colourOverrides = { chart: gradeOf().chart, map: {} }; return S.colourOverrides.map; }
function applyColourOverride(entry){
  if (!entry) return entry;
  const to = overridesFor()[entry.mm]; if (!to) return entry;
  if (typeof to === 'object' && to.pms) return pmsEntry(to); // a Pantone colour the customer asked for
  const t = familyTable().find(c => c.mm === to); return t || entry;
}
function overrideSummary(){ const m = overridesFor(); const out = []; for (const from in m) { if (S.matchedMms && !S.matchedMms[from]) continue; const a = familyTable().find(c => c.mm === from); if (!a) continue; if (m[from] && m[from].pms) { out.push(a.name + ' -> Pantone ' + pmsKey(m[from].pms).slice(4) + ' (colour matched)'); continue; } const b = familyTable().find(c => c.mm === m[from]); if (b) out.push(a.name + ' -> ' + b.name); } return out.join('; '); }
// Every matched colour the customer has pointed at the same chart colour shows as ONE chip, so a further change (or
// "Back to the matched colour") applies to all of them, plus that chart colour itself where the artwork also has it.
function overrideGroup(mm){ const m = overridesFor(), to = m[mm]; if (!to || typeof to !== 'string') return [mm]; const g = Object.keys(m).filter(k => m[k] === to); if (S.matchedMms && S.matchedMms[to] && g.indexOf(to) < 0) g.push(to); return g; }
function closeColourPick(){ const p = $('tmgColourPick'); if (p) p.remove(); document.removeEventListener('click', _cpOutside, true); }
function _cpOutside(e){ const p = $('tmgColourPick'); if (p && !p.contains(e.target)) closeColourPick(); }
function openColourPick(mm, anchorEl){
  closeColourPick();
  const cur = familyTable().find(c => c.mm === mm); if (!cur) return;
  const map = overridesFor(); const chosen = (map[mm] && map[mm].pms) ? null : (map[mm] || mm); const group = overrideGroup(mm); const head = (group.length > 1 && familyTable().find(c => c.mm === map[mm])) || cur;
  const g = gradeOf();
  const panel = document.createElement('div'); panel.id = 'tmgColourPick'; panel.className = 'tmg-cpick'; panel.setAttribute('role', 'dialog');
  const list = familyTable().filter(c => !(g.chart === 'mm' && PS_EXTRA_ROWS.some(r => r[0] === c.mm)));
  panel.innerHTML = '<div class="tmg-cpick-head"><span>Print <b>' + head.name + '</b> as</span><button type="button" class="tmg-cpick-x" aria-label="Close">&times;</button></div>' +
    '<div class="tmg-cpick-grid">' + list.map(c => { const off = tooCloseToBase(c); return '<button type="button" class="tmg-cpick-sw' + (c.mm === chosen ? ' sel' : '') + (off ? ' off' : '') + '" data-mm="' + c.mm + '" title="' + c.name + (off ? ' (too close to the base colour)' : '') + '" ' + (off ? 'disabled' : '') + '><i style="' + swatchCss(c.mm, c.hex) + '"></i><span>' + c.name + '</span></button>'; }).join('') + '</div>' +
    pmsPickerFoot(mm) +
    (map[mm] ? '<button type="button" class="tmg-cpick-reset">Back to the matched colour</button>' : '');
  const host = anchorEl.closest('.tmg-pms-notice-body') || anchorEl.parentElement;
  host.style.position = 'relative'; host.appendChild(panel);
  panel.querySelector('.tmg-cpick-x').addEventListener('click', closeColourPick);
  const reset = panel.querySelector('.tmg-cpick-reset'); if (reset) reset.addEventListener('click', () => { group.forEach(k => { delete map[k]; }); closeColourPick(); afterOverrideChange(); });
  panel.querySelectorAll('.tmg-cpick-sw').forEach(b => b.addEventListener('click', () => { const to = b.dataset.mm; group.forEach(k => { if (to === k) delete map[k]; else map[k] = to; }); closeColourPick(); afterOverrideChange(); }));
  bindPmsFoot(panel, mm);
  setTimeout(() => document.addEventListener('click', _cpOutside, true), 0);
}
function afterOverrideChange(){
  trail('colour', overrideSummary() || 'none (back to the matched colours)');
  cachedLogo = null; S.actualPmsUsed = []; S.shaded = null;
  if (S.file && typeof showPmsNotice === 'function') showPmsNotice(S.validation);
  if (miniPreviewVisible()) renderMiniCanvas('tmgStep2Canvas');
  if (S.step === 4) renderCanvas();
  if (typeof fetchPricing === 'function') fetchPricing(); // the Pantone surcharge lives in the total
}
// One listener for both chip strips; chips carry data-mm.
function bindColourPick(){
  const sw = $('tmgPmsSwatches');
  if (sw) { let h = $('tmgChipHint'); if (!h) { h = document.createElement('div'); h.id = 'tmgChipHint'; h.className = 'tmg-chip-hint'; sw.insertAdjacentElement('afterend', h); }
    h.style.display = asSupplied() ? 'none' : 'block'; h.textContent = gradeOf().surface === 'coir' ? 'Tap the colour to print your logo in a different coir colour.' : 'Tap a colour to print it as a different chart colour.'; }
  ['tmgPmsSwatches', 'tmgCR'].forEach(id => { const el = $(id); if (!el || el.dataset.cpBound) return; el.dataset.cpBound = '1';
    el.addEventListener('click', e => { const chip = e.target.closest('[data-mm]'); if (!chip || asSupplied()) return; e.preventDefault(); const key = overrideKeyFor(chip.dataset.mm); if (key) openColourPick(key, chip); }); });
}
// The order line's colour list: most coverage first, chart / PMS reference when matched, raw hex + nearest chart colour
// when the mat prints as supplied. Pantone-matched colours carry their Pantone reference in the name already.
function colourReport(){
  const pal = designPalette(); if (!pal.length) return '';
  return pal.map(c => (c.raw ? c.name : paletteLabelCode(c)) + (c.share != null ? ' ' + c.share + '%' : '')).join(', ');
}
function chipHint(){ return asSupplied() ? '' : '<div class="tmg-chip-hint">Tap a colour to print it as a different chart colour.</div>'; }

// ── Pantone colour matching, v2 (Zac, 5 Oct 2026): PrintPlush and DirtStopper logo colours can be matched to ANY Pantone
// reference for $275 + GST per colour ($302.50 inc). Not on PrintScraper / Superguard / inlays / embossed (no PMS
// matching there, Katie). Kept quiet: a small "Need an exact Pantone colour?" link at the foot of the colour picker, the
// price shown only once it is opened. Each PMS colour is a separate cart line (variant "Per colour / PMS colour match",
// SKU "PMS COLOUR MATCH" = the Cin7 service item) so the order, Cin7 and production all see the charge.
const PMS_MATCH = { price: 302.5, exGst: 275, variantId: 51463740358823, sku: 'PMS COLOUR MATCH', grades: ['standard', 'commercial', 'dirtstopper'] };
function pmsAllowed(){ return PMS_MATCH.grades.indexOf(gradeOf().key) > -1 && !asSupplied(); }
function pmsKey(code){ return 'PMS:' + String(code || '').toUpperCase().replace(/^(PMS|PANTONE)\s*/i, '').replace(/\s+/g, ''); }
function pmsEntry(o){
  const key = pmsKey(o.pms); const hex = o.hex || '#888888';
  const r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
  return { mm: key, hex: hex, name: 'Pantone ' + key.slice(4) + ' (colour matched)', r: r, g: g, b: b, lab: rgbToLab(r, g, b), pms: true };
}
// the PMS overrides in play: [{from: chart mm, pms, hex}]
function pmsOverrides(){ const m = overridesFor(); const out = []; for (const k in m) if (m[k] && typeof m[k] === 'object' && m[k].pms) out.push({ from: k, pms: m[k].pms, hex: m[k].hex }); return out; }
function pmsCount(){ return pmsAllowed() ? pmsOverrides().length : 0; }
function pmsSurcharge(){ return pmsCount() * PMS_MATCH.price; }
function pmsSummary(){ return pmsOverrides().map(o => { const a = familyTable().find(c => c.mm === o.from); return (a ? a.name : o.from) + ' -> Pantone ' + pmsKey(o.pms).slice(4); }).join('; '); }
// which override key a chip belongs to (a PMS chip carries the PMS key, not the chart colour it replaced)
function overrideKeyFor(mm){ const m = overridesFor(); if (!/^PMS:/.test(mm)) { for (const k in m) if (m[k] === mm && k !== mm) return k; return mm; } for (const k in m) if (m[k] && m[k].pms && pmsKey(m[k].pms) === mm) return k; return null; }
function renderPmsPriceRow(){
  const row = $('tmgPMSR'); if (!row) return; const n = pmsCount();
  row.style.display = n ? 'flex' : 'none';
  if (n) $('tmgPMSV').innerHTML = n + ' colour' + (n > 1 ? 's' : '') + ' &times; ' + fmt(PMS_MATCH.price) + ' = ' + fmt(n * PMS_MATCH.price);
}
// the extra cart line: one "PMS colour match" line, quantity = number of matched colours (charged once per colour, not per mat)
function pmsCartItems(mainProps){
  const n = pmsCount(); if (!n) return [];
  return [{ id: PMS_MATCH.variantId, quantity: n, properties: { 'For': 'Design Your Own logo mat ' + (mainProps['Mat Size'] || '') + ' (' + gradeOf().title + ')', 'Pantone colours': pmsSummary(), 'SKU': PMS_MATCH.sku, 'Configurator': 'Yes' } }];
}
function cartPayload(variantId, props){
  const items = [{ id: variantId, quantity: S.qty, properties: props }].concat(pmsCartItems(props)).concat(typeof edgingCartItems === 'function' ? edgingCartItems(props) : []);
  return items.length === 1 ? items[0] : { items: items };
}
// the quiet foot of the colour picker
function pmsPickerFoot(fromMm){
  if (!pmsAllowed()) return '';
  const cur = overridesFor()[fromMm]; const have = cur && cur.pms ? cur : null;
  const base = familyTable().find(c => c.mm === fromMm) || { hex: '#888888' };
  return '<div class="tmg-cpick-pms">' +
    '<button type="button" class="tmg-cpick-pmslink">' + (have ? 'Pantone ' + pmsKey(have.pms).slice(4) + ' (colour matched) &middot; change' : 'Need an exact Pantone colour?') + '</button>' +
    '<div class="tmg-cpick-pmsform" style="display:none">' +
      '<div class="tmg-cpick-pmsnote">We can match any Pantone reference exactly. Colour matching is ' + fmt(PMS_MATCH.exGst) + ' + GST per colour (' + fmt(PMS_MATCH.price) + ' inc), charged once per colour, not per mat.</div>' +
      '<div class="tmg-cpick-pmsrow"><label>Pantone code <input type="text" class="tmg-cpick-pmscode" placeholder="e.g. 2965 U" maxlength="14" value="' + (have ? pmsKey(have.pms).slice(4) : '') + '"></label>' +
      '<label>Preview colour <input type="color" class="tmg-cpick-pmshex" value="' + (have ? have.hex : base.hex) + '"></label>' +
      '<button type="button" class="tmg-cpick-pmsuse">Use this Pantone colour</button></div>' +
      '<div class="tmg-cpick-pmshint">The preview shows the colour you pick here; the printed mat is matched to the Pantone reference.</div>' +
    '</div></div>';
}
function bindPmsFoot(panel, fromMm){
  const link = panel.querySelector('.tmg-cpick-pmslink'); if (!link) return;
  const form = panel.querySelector('.tmg-cpick-pmsform');
  link.addEventListener('click', () => { form.style.display = form.style.display === 'none' ? 'block' : 'none'; if (form.style.display === 'block') form.querySelector('.tmg-cpick-pmscode').focus(); });
  panel.querySelector('.tmg-cpick-pmsuse').addEventListener('click', () => {
    const codeEl = form.querySelector('.tmg-cpick-pmscode'); const code = codeEl.value.trim(); const hex = form.querySelector('.tmg-cpick-pmshex').value;
    if (!/^(\d{2,5}|[A-Za-z][A-Za-z ]{2,})\s*[A-Za-z]{0,3}$/.test(code)) { codeEl.style.borderColor = '#c00'; codeEl.focus(); return; }
    overridesFor()[fromMm] = { pms: code, hex: hex }; closeColourPick(); afterOverrideChange();
  });
}

// ── Generate from a description, per mat (Zac, 6 Oct 2026: "let them choose the mat ... generate a mat from their
// description for the mat they chose") ──
// In Generate mode the customer picks the mat first. The request to the backend carries that mat's context (family, how
// it is made, colour cap, its colour chart, base colour, print-check thresholds, size) so the prompt, the Ideogram palette
// and the candidate scoring are built for it; the result then runs through the same family checks as an upload.
function genFamilyKey(){ return S.genFamily || 'standard'; }
function genBase(){
  const g = GRADES[genFamilyKey()]; if (!g) return null;
  if (S.selectedBg && S.selectedBg.hex) return { name: S.selectedBg.name, hex: S.selectedBg.hex };
  if (g.bgChart && g.bgChart !== 'mm') { const rows = chartTable(g.bgChart === 'sgbase' ? 'sgbase' : g.bgChart === 'coir' ? 'coir' : g.bgChart === 'dsbase' ? 'dsbase' : g.bgChart) || []; const r = rows[0]; if (r) return { name: r.name, hex: r.hex }; }
  return null;
}
function genMatContext(){
  const k = genFamilyKey(), g = GRADES[k] || GRADES.standard;
  const prevGrade = S.grade; S.grade = k; // the helpers read the current grade
  let chart = null, check = null, cap = g.cap || 12, cls = g.asSupplied ? 'asSupplied' : g.cut ? 'cut' : g.raised ? 'raised' : k === 'promotional' ? 'promotional' : 'printed';
  try {
    const t = asSupplied() ? [] : familyTable();
    chart = t.slice(0, 60).map(c => ({ name: c.name, hex: c.hex, code: mmNum(c.mm) || '' }));
    const o = familyCheckOpts(); check = { strokeMinMm: o.strokeMinMm || 8, textMinMm: o.textMinMm || 30, gapMinMm: o.gapMinMm || 3 };
    if (typeof logoCap === 'function') cap = logoCap() || cap;
  } catch (e) {}
  S.grade = prevGrade;
  const [w, h] = String(S.size || '850x1200').split('x').map(Number);
  const landscape = (S.genOrientation || 'landscape') === 'landscape';
  return { family: k, title: g.title, cls, cap, chart, base: genBase(), check, W: landscape ? Math.max(w, h) : Math.min(w, h), H: landscape ? Math.min(w, h) : Math.max(w, h) };
}
function renderGenMats(){
  const wrap = $('tmgGenMats'); if (!wrap) return;
  const keys = (typeof GRADE_ORDER !== 'undefined' ? GRADE_ORDER : Object.keys(GRADES)).filter(k => GRADES[k] && !GRADES[k].noGen);
  wrap.innerHTML = keys.map(k => { const g = GRADES[k]; const sel = k === genFamilyKey(); return '<button type="button" class="tmg-genmat' + (sel ? ' sel' : '') + '" data-k="' + k + '" role="radio" aria-checked="' + sel + '"><b>' + g.title + '</b><span>' + (g.tag || '') + (g.cap ? ' · up to ' + g.cap + ' colour' + (g.cap > 1 ? 's' : '') : ' · full colour') + '</span></button>'; }).join('');
  wrap.querySelectorAll('.tmg-genmat').forEach(b => b.addEventListener('click', () => setGenFamily(b.dataset.k)));
}
function setGenFamily(k){
  if (!GRADES[k]) return;
  S.genFamily = k; S.grade = k; S.gradeManual = true; trail('grade', 'customer picked ' + gradeOf().title + ' (generated design)');
  const wrap = $('tmgGenMats'); if (wrap) wrap.querySelectorAll('.tmg-genmat').forEach(b => { const sel = b.dataset.k === k; b.classList.toggle('sel', sel); b.setAttribute('aria-checked', sel); });
  if (typeof onGradeChanged === 'function') onGradeChanged();
  renderGenBase(); // base chips follow the mat
  renderGenEdge(); // edging choice for mats that charge for it
  const hint = $('tmgGenMatHint'); if (hint) { const c = genMatContext(); hint.textContent = c.cls === 'cut' ? 'Cut and inlaid: the design will use big simple shapes in up to ' + c.cap + ' colours.' : c.cls === 'raised' ? 'Embossed: one bold logo colour on the coir.' : c.cls === 'asSupplied' ? 'Printed in full colour exactly as generated.' : 'Printed in up to ' + c.cap + ' flat chart colours.'; }
  if (S.genUsed && $('tmgGenBtn')) $('tmgGenBtn').textContent = '✨ Regenerate for ' + GRADES[k].title;
}
function bindGenMats(){ renderGenMats(); if (!S.genFamily) setGenFamily('standard'); else { renderGenBase(); renderGenEdge(); } }
// Zac 6 Oct: a generated design already chose its mat and size, so the Configure step only asks what it still needs
// (floor type, notes). The placement tiles and the size block are hidden; the Background step still lets them switch mats.
function genConfigureLayout(){
  const on = !!(S.genUsed && S.genFamily);
  const show = (el, yes) => { if (el) el.style.display = yes ? '' : 'none'; };
  show($('tmgPlacementWrap'), !on);
  const sizeField = $('tmgSize') ? $('tmgSize').closest('.tmg-field') : null; show(sizeField, !on);
  show($('tmgCustomToggle'), !on); if (on) show($('tmgCustomWrap'), false);
  show($('tmgSizeLockNote'), !on);
  const lbl = $('tmgSizeNotesLbl'); if (lbl) lbl.textContent = on ? 'Floor type and notes' : 'Size and notes';
}
// Zac 6 Oct ("it stretched the car" / "it zoomed in and cropped my logo"): a design that fills the mat is never distorted
// and never cropped. When its shape differs from the mat by more than 3% it is scaled to fit whole, and the strip left
// over is filled with the design's own edge colour (S.logoBg, read when the file loaded) so it still looks edge to edge.
// Without an edge colour to use, the old edge-to-edge stretch stands (the customer chose "fills the whole mat").
function drawCover(ctx, src, x, y, w, h){
  const sw = src.width || src.naturalWidth || 0, sh = src.height || src.naturalHeight || 0;
  if (!sw || !sh || !w || !h) return;
  const ra = sw / sh, rb = w / h;
  if (Math.abs(ra - rb) / rb <= 0.03 || !S.logoBg) { ctx.drawImage(src, x, y, w, h); return; }
  const k = Math.min(w / sw, h / sh), dw = Math.round(sw * k), dh = Math.round(sh * k);
  const row = (typeof logoBgChartRow === 'function' && !asSupplied()) ? logoBgChartRow(S.logoBg) : null; // the chart colour the artwork background prints as, so the strip matches it exactly
  ctx.save(); ctx.fillStyle = row ? row[1] : 'rgb(' + S.logoBg.r + ',' + S.logoBg.g + ',' + S.logoBg.b + ')'; ctx.fillRect(x, y, w, h); ctx.restore();
  ctx.drawImage(src, x + Math.round((w - dw) / 2), y + Math.round((h - dh) / 2), dw, dh);
}

// Zac 6 Oct: the mat's base colour is chosen with the mat, before generating (coir / Superguard / SpiralLoop /
// DirtStopper have a base; PrintPlush designs fill the mat). Photo chips from the family's base chart; the choice
// is S.selectedBg so the generator, the render and the order all use it. No mat or base change after generating.
function renderGenBase(){
  const wrap = $('tmgGenBase'); if (!wrap) return;
  const g = GRADES[genFamilyKey()] || GRADES.standard;
  const rows = (g.bgSeparate && g.bgChart && g.bgChart !== 'mm') ? (chartTable(g.bgChart) || []) : [];
  if (!rows.length) { wrap.style.display = 'none'; wrap.innerHTML = ''; return; }
  wrap.style.display = '';
  const cur = S.selectedBg && rows.some(r => r.mm === S.selectedBg.mm) ? S.selectedBg.mm : rows[0].mm;
  if (!S.selectedBg || S.selectedBg.mm !== cur) { const r = rows.find(x => x.mm === cur); S.selectedBg = { mm: r.mm, hex: r.hex, name: r.name, is_light: false }; trail('bg', 'default base ' + r.name); }
  wrap.innerHTML = '<div style="font-size:11px;color:var(--muted);margin-bottom:6px">Base mat colour</div><div class="tmg-genbase">' + rows.map(r => '<button type="button" class="tmg-genbase-sw' + (r.mm === cur ? ' sel' : '') + '" data-mm="' + r.mm + '" title="' + r.name + '"><i style="' + swatchCss(r.mm, r.hex) + '"></i><span>' + r.name + '</span></button>').join('') + '</div>';
  wrap.querySelectorAll('.tmg-genbase-sw').forEach(b => b.addEventListener('click', () => { const r = rows.find(x => x.mm === b.dataset.mm); if (!r) return; S.selectedBg = { mm: r.mm, hex: r.hex, name: r.name, is_light: false }; trail('bg', 'customer clicked base ' + r.name); wrap.querySelectorAll('.tmg-genbase-sw').forEach(x => x.classList.toggle('sel', x === b)); }));
}
// Zac 6 Oct: on a mat with a base (Superguard / SpiralLoop / coir / DirtStopper) the generated image's background becomes
// the chosen base colour, exactly. The image generator treats the palette as a suggestion, so the region connected to
// the borders (the background, within a colour tolerance of the corner colour) is recoloured here, deterministically.
// The inlay / emboss pipeline then sees a background equal to the base and drops it, leaving the real base material.
function applyGenBase(ctx, W, H, hex){
  try {
    const id = ctx.getImageData(0, 0, W, H), d = id.data;
    const br = parseInt(hex.slice(1, 3), 16), bg = parseInt(hex.slice(3, 5), 16), bb = parseInt(hex.slice(5, 7), 16);
    // reference = the median of the four corners (robust to a motif touching one corner)
    const pick = (x, y) => { const i = (y * W + x) * 4; return [d[i], d[i+1], d[i+2]]; };
    const cs = [pick(2, 2), pick(W - 3, 2), pick(2, H - 3), pick(W - 3, H - 3)].sort((a, b) => (a[0]+a[1]+a[2]) - (b[0]+b[1]+b[2]));
    const ref = cs[1]; const TOL = 42;
    const near = i => Math.abs(d[i] - ref[0]) <= TOL && Math.abs(d[i+1] - ref[1]) <= TOL && Math.abs(d[i+2] - ref[2]) <= TOL;
    const seen = new Uint8Array(W * H); const stack = [];
    for (let x = 0; x < W; x++) { stack.push(x, 0, x, H - 1); } for (let y = 0; y < H; y++) { stack.push(0, y, W - 1, y); }
    let n = 0;
    while (stack.length) { const y = stack.pop(), x = stack.pop(); if (x < 0 || y < 0 || x >= W || y >= H) continue; const p = y * W + x; if (seen[p]) continue; seen[p] = 1; const i = p * 4; if (!near(i)) continue; d[i] = br; d[i+1] = bg; d[i+2] = bb; n++; stack.push(x + 1, y, x - 1, y, x, y + 1, x, y - 1); }
    if (n < W * H * 0.05) return false; // the borders are not a flat background: leave the image alone
    ctx.putImageData(id, 0, 0); return true;
  } catch (e) { return false; }
}
// Zac 6 Oct ("there's still no edging for coir"): the edging choice is offered wherever the customer is, not only inside
// the selected card at the Background step: in Generate mode beside the base colour, and on the Preview step beside
// the price, for every mat that charges for edging (coir). Both call setEdging, so the price, cart and render follow.
function edgeChoiceHtml(cls){
  const g = gradeOf(); if (!g.edgeCharge || !hasEdging()) return '';
  const on = edgingOn(), m = edgeMetres(g.key), cost = Math.round(m * g.edgeCharge.rate * 100) / 100;
  return '<div class="' + cls + '"><span class="tmg-edgec-lbl">PVC edging</span>' +
    '<button type="button" class="tmg-edgec-opt' + (!on ? ' sel' : '') + '" data-v="0">No edging</button>' +
    '<button type="button" class="tmg-edgec-opt' + (on ? ' sel' : '') + '" data-v="1">Edged <small>+' + fmt(cost) + ' (' + m + ' m &times; ' + fmt(g.edgeCharge.rate) + ')</small></button></div>';
}
function bindEdgeChoice(wrap, after){
  if (!wrap) return;
  wrap.querySelectorAll('.tmg-edgec-opt').forEach(b => b.addEventListener('click', () => { setEdging(b.dataset.v === '1'); wrap.querySelectorAll('.tmg-edgec-opt').forEach(x => x.classList.toggle('sel', x === b)); if (after) after(); }));
}
function renderGenEdge(){
  const wrap = $('tmgGenEdge'); if (!wrap) return;
  const prev = S.grade; S.grade = genFamilyKey(); if (typeof onGradeChanged === 'function') onGradeChanged();
  const html = edgeChoiceHtml('tmg-edgec'); S.grade = prev;
  wrap.style.display = html ? '' : 'none'; wrap.innerHTML = html; bindEdgeChoice(wrap, null);
}
// Quantity at the Add to Cart step (Zac, 7 Oct 2026). The hidden #tmgQty and S.qty stay the one source the price and the
// cart line read; the stepper only writes to them.
const QTY_MAX = 999;
function setQty(n){ n = Math.max(1, Math.min(QTY_MAX, parseInt(n, 10) || 1)); S.qty = n; const h = $('tmgQty'); if (h) h.value = n; renderPreviewPrice(); fetchPricing(); }
function qtyCss(){ if ($('tmgQtyCss')) return; const st = document.createElement('style'); st.id = 'tmgQtyCss';
  st.textContent = '.tmg-qty-row{display:flex;align-items:center;gap:12px;margin-top:10px;padding-top:10px;border-top:1px solid var(--bd)}' +
    '.tmg-qty-lbl{font-size:13px;font-weight:600;color:var(--txt);margin:0}' +
    '.tmg-qty{display:inline-flex;align-items:stretch;border:1px solid var(--bd);border-radius:8px;overflow:hidden;background:var(--sf2)}' +
    '.tmg-qty-btn{width:44px;height:44px;border:0;background:transparent;color:var(--txt);font-size:20px;line-height:1;cursor:pointer;padding:0}' +
    '.tmg-qty-btn:hover:not(:disabled){background:rgba(240,83,34,.12)}.tmg-qty-btn:disabled{opacity:.35;cursor:default}' +
    '.tmg-qty-in{width:56px;height:44px;border:0;border-left:1px solid var(--bd);border-right:1px solid var(--bd);border-radius:0;background:transparent;color:var(--txt);text-align:center;font-size:16px;font-weight:600;padding:0;margin:0;-moz-appearance:textfield;appearance:textfield}' +
    '.tmg-qty-in::-webkit-outer-spin-button,.tmg-qty-in::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}' +
    '.tmg-qty-in:focus,.tmg-qty-btn:focus-visible{outline:2px solid var(--gold);outline-offset:-2px}' +
    '.tmg-qty-each{margin-left:auto;font-size:12px;color:var(--muted)}';
  document.head.appendChild(st); }
function renderPreviewPrice(){
  const el = $('tmgPreviewPrice'); if (!el) return;
  qtyCss(); const act = document.activeElement, foc = act && el.contains(act) ? (act.dataset.d || (act.classList.contains('tmg-qty-in') ? 'in' : '')) : ''; const q = S.qty || 1;
  const g = gradeOf(); const size = (typeof isCustomSize === 'function' && isCustomSize() && customOf(g.key)) ? (S.custom.L + ' × ' + S.custom.W + 'mm') : String(familySize(g.key) || S.size).replace('x', ' × ') + 'mm';
  const total = S.totalPrice != null ? fmt(S.totalPrice) : '—';
  const extras = [];
  if (typeof pmsCount === 'function' && pmsCount()) extras.push('Pantone matching ' + fmt(pmsSurcharge()));
  if (g.edgeCharge && edgingOn()) extras.push('edging ' + fmt(edgingSurcharge() * (S.qty || 1)));
  el.innerHTML = '<div class="tmg-pp-line"><span>' + g.title + ' &middot; ' + size + ' &middot; ' + (S.qty || 1) + ' mat' + ((S.qty || 1) > 1 ? 's' : '') + '</span><b>' + total + '</b></div>' +
    '<div class="tmg-qty-row"><label class="tmg-qty-lbl" for="tmgQtyIn">Quantity</label><div class="tmg-qty" role="group" aria-label="Quantity">' +
    '<button type="button" class="tmg-qty-btn" data-d="-1" aria-label="One fewer mat"' + (q <= 1 ? ' disabled' : '') + '>&minus;</button>' +
    '<input id="tmgQtyIn" class="tmg-qty-in" type="number" inputmode="numeric" min="1" max="' + QTY_MAX + '" step="1" value="' + q + '" aria-label="Number of mats">' +
    '<button type="button" class="tmg-qty-btn" data-d="1" aria-label="One more mat"' + (q >= QTY_MAX ? ' disabled' : '') + '>+</button></div>' +
    '<span class="tmg-qty-each">' + (q > 1 && S.unitPrice ? fmt(S.unitPrice) + ' each' : '') + '</span></div>' +
    (extras.length ? '<div class="tmg-pp-sub">Includes ' + extras.join(' and ') + '</div>' : '') +
    edgeChoiceHtml('tmg-edgec tmg-edgec-preview') +
    (typeof tierTableHtml === 'function' ? tierTableHtml() : '');
  if (typeof bindTiers === 'function') bindTiers(el);
  el.querySelectorAll('.tmg-qty-btn').forEach(b => b.addEventListener('click', () => setQty((S.qty || 1) + parseInt(b.dataset.d, 10))));
  const qi = el.querySelector('.tmg-qty-in'); if (qi) { qi.addEventListener('change', () => setQty(qi.value)); qi.addEventListener('focus', () => { try { qi.select(); } catch (e) {} }); qi.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); qi.blur(); } }); }
  if (foc && foc !== 'in') { const back = el.querySelector('.tmg-qty-btn[data-d="' + foc + '"]:not(:disabled)') || qi; if (back) back.focus(); } // a re-render must not drop the keyboard user out of the stepper
  bindEdgeChoice(el, () => { if (S.step === 4) renderCanvas(); });
}

// ── Default background = the logo's own background (Zac, 6 Oct 2026, order TMG12578: a white G on a blue square was
// printed as a lighter-blue box on a darker Royal Blue mat) ──
// An opaque logo whose edge ring is one colour has that colour as the mat's DEFAULT background (nearest chart colour),
// so by default the mat is the logo as supplied: no box. The customer must actively pick a different background; when
// they do, the logo's own background is dropped from the artwork so it can never become a box. Transparent PNGs, logos
// without a single edge colour, flat single-colour images, cut inlays (a panel is normal) and mats with a separate base
// are untouched.
function edgeRingColour(ctx, W, H, data){
  try {
    const d = data || ctx.getImageData(0, 0, W, H).data, ring = Math.max(2, Math.round(Math.min(W, H) * 0.02));
    const hist = new Map(); let total = 0, opaque = 0;
    const add = (x, y) => { const i = (y * W + x) * 4; total++; if (d[i+3] < 200) return; opaque++; const k = ((d[i] >> 4) << 8) | ((d[i+1] >> 4) << 4) | (d[i+2] >> 4); let e = hist.get(k); if (!e) { e = { n: 0, r: 0, g: 0, b: 0 }; hist.set(k, e); } e.n++; e.r += d[i]; e.g += d[i+1]; e.b += d[i+2]; };
    for (let x = 0; x < W; x++) for (let y = 0; y < ring; y++) { add(x, y); add(x, H - 1 - y); }
    for (let y = ring; y < H - ring; y++) for (let x = 0; x < ring; x++) { add(x, y); add(W - 1 - x, y); }
    if (!total || opaque / total < 0.95) return null;                  // a transparent-edged logo: nothing to default
    let best = null; for (const e of hist.values()) if (!best || e.n > best.n) best = e;
    if (!best || best.n / opaque < 0.6) return null;                     // no single edge colour
    const tr = best.r / best.n, tg = best.g / best.n, tb = best.b / best.n; let same = 0, all = 0;
    for (let i = 0; i < d.length; i += 16) { all++; if (d[i+3] >= 200 && Math.abs(d[i] - tr) <= 40 && Math.abs(d[i+1] - tg) <= 40 && Math.abs(d[i+2] - tb) <= 40) same++; }
    if (same / all > 0.97) return null;                                   // a flat single-colour image, not a logo on a background
    return { r: Math.round(tr), g: Math.round(tg), b: Math.round(tb), share: best.n / opaque, cover: same / all };
  } catch (e) { return null; }
}
// the background-chart row (mm, hex, name, cat) that the logo's background will print as
function logoBgChartRow(col){
  if (!col) return null;
  const rows = familyChart(); if (!rows.length) return null;
  const pms = findNearestPMS(col.r, col.g, col.b);                       // the design-chart entry the quantiser will give it
  let row = pms && rows.find(r => r[0] === pms.mm);
  if (!row) { const lab = rgbToLab(col.r, col.g, col.b); let bd = Infinity; for (const r of rows) { const rl = rgbToLab(parseInt(r[1].slice(1, 3), 16), parseInt(r[1].slice(3, 5), 16), parseInt(r[1].slice(5, 7), 16)); const dd = deltaE2000(lab, rl); if (dd < bd) { bd = dd; row = r; } } }
  return row || null;
}
function logoBgEligible(){ const g = gradeOf(); return !S.genUsed && !S.useArtworkAsBg && !g.bgSeparate && !isCut() && !isRaised() && !asSupplied(); }
// read the colour when the file loads (stored), apply it when the background step opens
function readLogoBg(ctx, W, H, data){
  if (S.logoBgFile === S.file) return;                                   // once per file: a re-decode after a background change must not reset the choice
  S.logoBgFile = S.file; S.logoBg = edgeRingColour(ctx, W, H, data); S.bgFromLogo = null; S.dropLogoBg = false;
  whiteBgRule(ctx, W, H, data); // 14 Oct 2026: a white background around a flat logo is see-through by default
  applyLogoBgDefault();
  updateTranspBtn();                                                   // the background step may already be open (fast flows): apply now as well as when it opens
}
function applyLogoBgDefault(){
  if (S.whiteBgAuto && S.dropLogoBg) { // 14 Oct 2026: the white is see-through, so the mat gets a colour that makes the logo stand out
    if ((!S.selectedBg || (S.aiBgMm && S.selectedBg.mm === S.aiBgMm)) && !S.useArtworkAsBg) { const row = pickBgForPalette(S.whiteLogoPal); /* 14 Oct 2026 (also as-supplied mats): an AI-suggested background is replaced (it was the logo's own navy once), a customer pick never is */ if (row) { S.whiteBgPickMm = row[0]; S.bgSrc = 'auto: white artwork background treated as transparent'; selectBg(row[0], row[1], row[2], row[3] === 'light'); } }
    logoBgNote(); updateTranspBtn(); return;
  }
  if (!S.logoBg || S.selectedBg || !logoBgEligible()) { logoBgNote(); return; }
  const row = logoBgChartRow(S.logoBg); if (!row) return;
  S.bgFromLogo = { mm: row[0], hex: row[1], name: row[2] };
  S.bgSrc = 'matched the logo\'s own background'; selectBg(row[0], row[1], row[2], row[3] === 'light');
  logoBgNote();
}
function logoBgNote(){
  let nt = $('tmgBgFromLogoNote');
  if (!nt) { const tg = $('tmgBgToggle'); if (!tg) return; nt = document.createElement('div'); nt.id = 'tmgBgFromLogoNote'; nt.className = 'tmg-bg-from-logo'; tg.insertAdjacentElement('afterend', nt); }
  if (S.whiteBgAuto && S.dropLogoBg && S.selectedBg && !S.useArtworkAsBg && S.whiteBgPickMm === S.selectedBg.mm) { nt.style.display = 'block'; const num = mmRef(S.selectedBg.mm); nt.textContent = 'The white around your logo is see-through on the mat, so we picked ' + S.selectedBg.name.split('(')[0].trim() + ' to make it stand out. Change it if you like.'; return; }
  const on = !!(S.bgFromLogo && S.selectedBg && S.selectedBg.mm === S.bgFromLogo.mm && !S.dropLogoBg);
  nt.style.display = on ? 'block' : 'none';
  if (on) { const num = mmRef(S.selectedBg.mm); nt.textContent = 'Background set to match your logo: ' + S.selectedBg.name.split('(')[0].trim() + '. Change it if you want a different colour.'; }
}
// the customer picked a background on purpose: the logo's own background drops out (and comes back if they return to it)
function onBgPicked(mm){
  if (!S.bgFromLogo) return;
  const drop = mm !== S.bgFromLogo.mm;
  if (drop !== !!S.dropLogoBg) { S.dropLogoBg = drop; cachedLogo = null; S.actualPmsUsed = []; S.shaded = null; if (S.file && typeof showPmsNotice === 'function') showPmsNotice(S.validation); }
  logoBgNote();
}

// ── White artwork background = see-through (Zac, 14 Oct 2026) ──
// A logo of a few flat colours on a white background almost always means "no background": the white edge ring is dropped
// (border flood fill, so white letters inside the logo stay) and the mat gets a colour that contrasts with every logo
// colour. Photos, gradients, as-is designs and AI designs are untouched. The customer can restore the white (button).
function isWhiteish(c){ if (!c) return false; const l = rgbToLab(c.r, c.g, c.b); return l[0] >= 92 && Math.hypot(l[1], l[2]) <= 8; }
function flatLogoPalette(ctx, W, H, data){ // the logo's own colours when it is a few flat colours, else null (photo / gradient)
  try {
    const d = data || ctx.getImageData(0, 0, W, H).data, st = Math.max(1, Math.floor(W * H / 250000)), hist = new Map(); let op = 0, nw = 0;
    for (let p = 0; p < W * H; p += st) { const i = p * 4; if (d[i+3] < 200) continue; op++; const r = d[i], g = d[i+1], b = d[i+2], mn = Math.min(r, g, b), mx = Math.max(r, g, b);
      if (mn > 200 && mx - mn < 25) continue; // white and its anti-alias fringe
      nw++; const k = ((r >> 4) << 8) | ((g >> 4) << 4) | (b >> 4); let e = hist.get(k); if (!e) { e = { n: 0, r: 0, g: 0, b: 0 }; hist.set(k, e); } e.n++; e.r += r; e.g += g; e.b += b; }
    if (!op || nw < op * 0.003) return null;
    const raw = [...hist.values()].sort((x, y) => y.n - x.n), rawSig = raw.filter(e => e.n >= nw * 0.01); // flat art keeps most pixels in a few buckets; a photo / gradient spreads thin
    if (rawSig.length > 14 || rawSig.reduce((s, e) => s + e.n, 0) < nw * 0.75) return null;
    const cl = []; for (const e of raw) { const r = e.r / e.n, g = e.g / e.n, b = e.b / e.n; const k = cl.find(c => Math.abs(c.sr - r) <= 48 && Math.abs(c.sg - g) <= 48 && Math.abs(c.sb - b) <= 48); if (k) { k.n += e.n; k.r += e.r; k.g += e.g; k.b += e.b; } else cl.push({ n: e.n, r: e.r, g: e.g, b: e.b, sr: r, sg: g, sb: b }); } // merged against the seed colour, so a gradient cannot chain
    const sig = cl.filter(c => c.n >= nw * 0.03); if (!sig.length || sig.length > 5) return null;
    if (sig.reduce((s, c) => s + c.n, 0) < nw * 0.7) return null;
    return sig.map(c => ({ r: c.r / c.n, g: c.g / c.n, b: c.b / c.n, share: c.n / nw }));
  } catch (e) { return null; }
}
function whiteBgRule(ctx, W, H, data){
  S.whiteBgDetected = false; S.whiteBgAuto = false; S.whiteBgKept = false; S.whiteLogoPal = null; S.whiteBgPickMm = null;
  if (S.genUsed || !S.logoBg || !isWhiteish(S.logoBg) || S.logoBg.share < 0.85) return;
  const pal = flatLogoPalette(ctx, W, H, data); if (!pal) return;
  S.whiteBgDetected = true; S.whiteLogoPal = pal; S.whiteBgAuto = true; S.dropLogoBg = true;
  trail('bg', 'white artwork background treated as transparent (' + pal.length + ' logo colour' + (pal.length > 1 ? 's' : '') + ')');
}
// the chart colour that contrasts best with every logo colour: neutral first, dark under a light/mid logo, light under a dark one
const DARK_BG_MIN_DE = 30; // 14 Oct 2026 (Zac): dark backgrounds are the recommendation - this is the "logo still clearly readable" bar
function pickBgForPalette(pal){ // dark-first automatic background (see DARK_BG_MIN_DE)
  const rows = familyChart(); if (!rows.length || !pal || !pal.length) return null;
  const labs = pal.map(c => rgbToLab(c.r, c.g, c.b));
  const info = rows.map(r => { const l = rgbToLab(parseInt(r[1].slice(1, 3), 16), parseInt(r[1].slice(3, 5), 16), parseInt(r[1].slice(5, 7), 16)); let mn = Infinity; for (const x of labs) mn = Math.min(mn, deltaE2000(l, x)); return { r, L: l[0], ch: Math.hypot(l[1], l[2]), mn, cat: r[3] }; });
  const tone = x => (x.cat === 'dark' || x.cat === 'medium' || x.cat === 'light') ? x.cat : (x.L < 40 ? 'dark' : x.L < 65 ? 'medium' : 'light');
  const neutral = x => x.ch < 12 && x.L < 90;
  const dark = info.filter(x => tone(x) === 'dark' && neutral(x)).sort((a, b) => b.mn - a.mn);
  if (dark[0] && dark[0].mn >= DARK_BG_MIN_DE) return dark[0].r;
  const med = info.filter(x => tone(x) === 'medium' && neutral(x) && x.mn >= DARK_BG_MIN_DE).sort((a, b) => (Math.round(a.L / 4) - Math.round(b.L / 4)) || (a.ch - b.ch)); /* darkest first; equally dark -> the most neutral grey */
  if (med[0]) return med[0].r;
  const darkAny = info.filter(x => tone(x) === 'dark' && x.mn >= DARK_BG_MIN_DE).sort((a, b) => a.ch - b.ch);
  if (darkAny[0]) return darkAny[0].r;
  const light = info.filter(x => x.ch < 6 && x.L < 90).sort((a, b) => b.mn - a.mn);
  if (light[0]) return light[0].r;
  return info.sort((a, b) => b.mn - a.mn)[0].r;
}
function dropBgNow(){ return !!S.dropLogoBg && !S.useArtworkAsBg; }
function alignHeightArrow(){ // ux1015b: the left height arrow spans exactly the render, not the whole column (adjust panel, hint, legend)
  const a = $('tmgHeightArrow'), c = $('tmgCanvas'); if (!a || !c || a.style.display === 'none') return;
  const wrap = c.closest('.tmg-cvwrap'), col = wrap && wrap.parentElement; if (!col) return;
  const place = () => { const cr = c.getBoundingClientRect(), kr = col.getBoundingClientRect(); if (!cr.height) return; a.style.alignSelf = 'flex-start'; a.style.marginTop = Math.max(0, Math.round(cr.top - kr.top)) + 'px'; a.style.height = Math.round(cr.height) + 'px'; a.style.justifyContent = 'center'; };
  place(); setTimeout(place, 60);
}
window.addEventListener('resize', () => { try { alignHeightArrow(); } catch (e) {} });
function logoAdjustable(){ return !S.useArtworkAsBg && !!((S.validation && S.validation.has_transparent_background) || S.clientDetectedTransparency || S.bgRemoved || (S.whiteBgDetected && S.dropLogoBg)); } // ux1015a: see-through logo = position + size adjustable // a design that fills the mat keeps every pixel
// The "Make my logo background transparent" button says what is already true (Zac, 14 Oct 2026)
function updateTranspBtn(){
  const b = $('tmgRemoveWhite'); if (!b) return; const t = b.querySelector('span'); if (!t) return;
  if (b.dataset.origHtml == null) b.dataset.origHtml = t.innerHTML;
  const chk = $('tmgRemoveWhiteCheck'), sub = s => '<span style="display:block;font-weight:400;font-size:11px;color:var(--muted);margin-top:2px">' + s + '</span>';
  let mode = 'default';
  if (S.bgRemoved) mode = 'ai';
  else if (S.whiteBgDetected && S.dropLogoBg && !S.useArtworkAsBg) mode = 'auto';
  else if (S.clientDetectedTransparency && !S.whiteBgDetected) mode = 'png';
  else if (S.whiteBgDetected && S.whiteBgKept) mode = 'kept';
  if (mode === 'ai') return; // the remove.bg states own the button
  const done = mode === 'auto' || mode === 'png';
  b.style.opacity = done ? '0.62' : '1'; b.style.background = done ? 'var(--sf)' : 'var(--sf2)'; b.style.borderColor = done ? 'var(--bd)' : 'var(--gold)';
  b.style.cursor = mode === 'png' ? 'default' : 'pointer'; b.setAttribute('aria-pressed', done ? 'true' : 'false'); if (mode === 'png') b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
  if (chk) chk.textContent = '';
  if (mode === 'auto') t.innerHTML = '&#10003; Logo background is transparent' + sub('We made the white around your logo see-through. <u style="color:var(--gold);font-weight:600">Restore original background</u>');
  else if (mode === 'png') t.innerHTML = '&#10003; Logo background is transparent' + sub('Your file has no background, so there is nothing to remove');
  else if (mode === 'kept') t.innerHTML = '&#10024; Make my logo background transparent' + sub('Your original white background is kept. Tap to make it see-through again');
  else t.innerHTML = b.dataset.origHtml;
}
// a white background is handled locally (no remove.bg call): restore it, or make it see-through again
function transpLocalToggle(){
  if (S.bgRemoved) return false;
  if (S.clientDetectedTransparency && !S.whiteBgDetected) { updateTranspBtn(); return true; } // already transparent: nothing to do
  if (!S.whiteBgDetected) return false;
  if (S.dropLogoBg) {
    S.dropLogoBg = false; S.whiteBgAuto = false; S.whiteBgKept = true; trail('bg', 'customer restored the original white background');
    const row = logoBgChartRow(S.logoBg); if (row && logoBgEligible()) { S.bgFromLogo = { mm: row[0], hex: row[1], name: row[2] }; S.bgSrc = 'original white background restored'; selectBg(row[0], row[1], row[2], row[3] === 'light'); }
  } else {
    S.dropLogoBg = true; S.whiteBgAuto = true; S.whiteBgKept = false; S.bgFromLogo = null; trail('bg', 'white background made see-through again');
    if (!S.useArtworkAsBg) { const row = pickBgForPalette(S.whiteLogoPal); if (row) { S.whiteBgPickMm = row[0]; S.bgSrc = 'auto: white artwork background treated as transparent'; selectBg(row[0], row[1], row[2], row[3] === 'light'); } }
  }
  cachedLogo = null; S.actualPmsUsed = []; S.shaded = null;
  if (typeof refreshArtworkForBudget === 'function') refreshArtworkForBudget();
  if (S.file && typeof showPmsNotice === 'function') showPmsNotice(S.validation);
  if (S.step === 4 && typeof renderCanvas === 'function') renderCanvas();
  logoBgNote(); updateTranspBtn(); return true;
}

// ── Download the mat preview (Zac, 6 Oct 2026) ──
// A "Download" button beside "Expand" on the Preview step saves the mat preview as a PNG (the same hi-res render the
// order carries as Mat Preview, capped at 2400 px wide; the on-screen canvas if that is not available).
// ── Colours per mat (Zac, 14 Oct 2026): the same artwork reads differently on each mat because each mat can only be made in
// its own chart (PrintPlush 127 colours, PrintScraper 50 flecked, SpiralLoop 24, Superguard 20, DirtStopper 2, Coir 1;
// HD / Rubber Scraper / Promotional / Rubber Promotional print as supplied). Every tile and card says which, and the
// about-this-mat sheet lists each of the customer's colours with the colour that mat makes it in.
const _artPal = { key: null, pal: null };
function artPalette(){ // the artwork's own colours (2% or more of the logo), from a small copy of the source image; cached per file + rule
  if (!S.file || !_srcImg || _srcImg.fileRef !== S.file || !_srcImg.img.naturalWidth) return null;
  const key = S.file.name + ':' + S.file.size + ':' + (dropBgNow() ? 1 : 0) + ':' + (S.useArtworkAsBg ? 1 : 0); if (_artPal.key === key) return _artPal.pal;
  try {
    const img = _srcImg.img, sc = Math.min(1, 240 / Math.max(img.width, img.height)), w = Math.max(1, Math.round(img.width * sc)), h = Math.max(1, Math.round(img.height * sc));
    const c = document.createElement('canvas'); c.width = w; c.height = h; const x = c.getContext('2d', { willReadFrequently: true }); x.imageSmoothingEnabled = false; x.drawImage(img, 0, 0, w, h); // nearest-neighbour: no invented blend colours at the edges
    const d = x.getImageData(0, 0, w, h).data, bg = (dropBgNow() && S.logoBg) ? S.logoBg : null, hist = new Map(); let n = 0;
    for (let i = 0; i < d.length; i += 4) { if (d[i+3] < 200) continue; if (bg && Math.abs(d[i] - bg.r) <= 40 && Math.abs(d[i+1] - bg.g) <= 40 && Math.abs(d[i+2] - bg.b) <= 40) continue; n++;
      const k = ((d[i] >> 4) << 8) | ((d[i+1] >> 4) << 4) | (d[i+2] >> 4); let e = hist.get(k); if (!e) { e = { n: 0, r: 0, g: 0, b: 0 }; hist.set(k, e); } e.n++; e.r += d[i]; e.g += d[i+1]; e.b += d[i+2]; }
    const cl = []; for (const e of [...hist.values()].sort((p, q) => q.n - p.n)) { const r = e.r / e.n, g = e.g / e.n, b = e.b / e.n; const k = cl.find(o => Math.abs(o.sr - r) <= 40 && Math.abs(o.sg - g) <= 40 && Math.abs(o.sb - b) <= 40); if (k) { k.n += e.n; k.r += e.r; k.g += e.g; k.b += e.b; } else cl.push({ n: e.n, r: e.r, g: e.g, b: e.b, sr: r, sg: g, sb: b }); }
    const pal = n ? cl.filter(o => o.n >= n * 0.03).slice(0, 12).map(o => ({ r: o.r / o.n, g: o.g / o.n, b: o.b / o.n, share: o.n / n })) : [];
    _artPal.key = key; _artPal.pal = pal; return pal;
  } catch (e) { return null; }
}
const _cmapCache = new Map();
function colourMapFor(k){
  const g = GRADES[k]; if (!g) return null; if (g.asSupplied) return { kind: 'exact', label: 'Exact colours', rows: [] };
  const pal = artPalette(); if (!pal || !pal.length) return null;
  const ck = _artPal.key + '|' + k + '|' + logoCapFor(k); if (_cmapCache.has(ck)) return _cmapCache.get(ck);
  const chart = chartTable(g.chart) || [];
  const rows = pal.map(p => { const pl = rgbToLab(p.r, p.g, p.b); let best = null, bd = Infinity;
    for (const c of chart) { const hx = c.hex; if (!hx) continue; const dd = deltaE2000(pl, rgbToLab(parseInt(hx.slice(1, 3), 16), parseInt(hx.slice(3, 5), 16), parseInt(hx.slice(5, 7), 16))); if (dd < bd) { bd = dd; best = c; } }
    return { from: '#' + [p.r, p.g, p.b].map(v => Math.round(v).toString(16).padStart(2, '0')).join(''), to: best ? best.hex : '#888888', name: best ? (friendlyName(best.name) || best.name || '') : '', de: bd, share: p.share }; });
  const M = rows.length, cap = logoCapFor(k), close = rows.filter(r => r.de <= 8).length;
  const kind = cap < M ? 'reduced' : close === M ? 'matched' : 'nearest';
  const out = { kind, rows, cap, label: kind === 'reduced' ? 'Made in ' + cap + ' colour' + (cap === 1 ? '' : 's') : kind === 'matched' ? 'Matched to chart' : (close ? 'Nearest colours (' + close + ' of ' + M + ' exact)' : 'Nearest colours') };
  if (_cmapCache.size > 200) _cmapCache.clear(); _cmapCache.set(ck, out); return out;
}
function colCss(){ if ($('tmgColCss')) return; const st = document.createElement('style'); st.id = 'tmgColCss';
  st.textContent = '.tmg-colnote{display:block;font-size:9px;line-height:1.2;margin:2px 0 1px;font-style:normal;font-weight:600;color:#bdbdbd}.tmg-colnote-matched{color:#9fd98a}.tmg-colnote-nearest,.tmg-colnote-reduced{color:#f2b36b}' +
    '.tmg-grade .tmg-colnote{font-size:11px;margin:3px 0 2px;color:var(--muted)}.tmg-grade .tmg-colnote-matched{color:#3f8a24}.tmg-grade .tmg-colnote-nearest,.tmg-grade .tmg-colnote-reduced{color:#b25e00}' +
    '.tmg-mi-cmap{margin:10px 0 6px;font-size:12px}.tmg-mi-cmap b{display:block;margin-bottom:4px}.tmg-mi-cmap-n{color:var(--muted,#666);font-size:11px;margin-bottom:4px}.tmg-mi-cmap-r{display:flex;align-items:center;gap:6px;margin:3px 0}.tmg-mi-cmap-r i{width:18px;height:18px;border-radius:4px;box-shadow:inset 0 0 0 1px rgba(0,0,0,.18);display:inline-block;flex:0 0 18px}.tmg-mi-cmap-r em{font-style:normal}' +
    '@media(max-width:640px){.tmg-colnote{font-size:8px}}';
  document.head.appendChild(st); }
function colourNoteHtml(k){ const m = colourMapFor(k); if (!m) return ''; colCss(); return '<span class="tmg-colnote tmg-colnote-' + m.kind + '">' + m.label + '</span>'; }
function colourMapHtml(k){
  const m = colourMapFor(k); if (!m) return ''; colCss();
  if (m.kind === 'exact') return '<div class="tmg-mi-cmap"><b>Your colours</b><div class="tmg-mi-cmap-n">Printed exactly as supplied, every colour</div></div>';
  const sw = h => '<i style="background:' + h + '"></i>';
  return '<div class="tmg-mi-cmap"><b>Your colours on this mat</b>' + (m.kind === 'reduced' ? '<div class="tmg-mi-cmap-n">Made in ' + m.cap + ' colour' + (m.cap === 1 ? '' : 's') + ': the closest of your colours are combined</div>' : '') +
    m.rows.map(r => '<div class="tmg-mi-cmap-r">' + sw(r.from) + '<span aria-hidden="true">&rarr;</span>' + sw(r.to) + '<em>' + lbEsc(r.name) + (r.de > 8 ? ' (nearest)' : '') + '</em></div>').join('') + '</div>';
}
function downloadPreview(){
  try {
    const hi = (typeof buildHiResPreviewCanvas === 'function' && buildHiResPreviewCanvas(2400)) || $('tmgCanvas');
    if (!hi || !hi.width) return;
    const g = gradeOf(); const size = (typeof isCustomSize === 'function' && isCustomSize() && customOf(g.key)) ? (S.custom.L + 'x' + S.custom.W) : String(familySize(g.key) || S.size);
    const name = 'mat-preview-' + g.key + '-' + size + 'mm.png';
    hi.toBlob(b => { if (!b) return; const u = URL.createObjectURL(b); const a = document.createElement('a'); a.href = u; a.download = name; document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(u), 4000); }, 'image/png');
  } catch (e) { console.warn('[TMG] preview download failed', e); }
}
function bindDownloadPreview(){ const b = $('tmgDownloadBtn'); if (b && !b.dataset.bound && typeof downloadPreviewNamed !== 'function') { b.dataset.bound = '1'; b.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); downloadPreview(); }); } }

// Upload
// Get Started button
$('tmgStartBtn').addEventListener('click', () => {
  $('tmgGetStarted').style.display = 'none';
  $('tmgUploadSection').style.display = 'block';
  // Reveal the header + horizontal step indicator now that the flow starts
  if($('tmgHdr')) $('tmgHdr').style.display = 'flex';
  if($('tmgSteps')) $('tmgSteps').style.display = 'flex';
});

$('tmgFile').addEventListener('change',e=>{
  if (!e.target.files[0]) return;
  // A real upload takes over from any generated design, BUT we preserve the generated
  // file so that if the user removes this upload, we can restore the generated design.
  if (S.genUsed && S.file) {
    S.preservedGenFile = S.file;
    S.preservedGenState = {
      genSeed: S.genSeed,
      genOriginalUrl: S.genOriginalUrl,
      genRawImageDataUrl: S.genRawImageDataUrl,
      genCachedPromptText: S.genCachedPromptText,
      genTranslated: S.genTranslated,
      genNegative: S.genNegative,
      genPmsColors: S.genPmsColors,
      genOverlayText: S.genOverlayText,
      genOrientation: S.genOrientation,
      size: S.size,
    };
  }
  
  // Upload now becomes the active artwork
  S.genUsed = false;
  S.genAutoBg = null;
  S.genSeed = null;
  S.genCachedPromptText = null;
  S.genTranslated = null;
  S.genNegative = null;
  // Re-show + re-enable orientation dropdown (uploads can change orientation freely)
  if ($('tmgOri')) {
    $('tmgOri').disabled = false;
    $('tmgOri').style.opacity = '1';
    $('tmgOri').title = '';
    const oriField = $('tmgOri').closest('.tmg-field');
    if (oriField) oriField.style.display = '';
  }
  // Unlock the size dropdown — uploads can be any size
  if ($('tmgSize')) {
    $('tmgSize').disabled = false;
    $('tmgSize').style.opacity = '1';
    $('tmgSize').style.cursor = '';
    $('tmgSize').title = '';
    if ($('tmgSizeLockNote')) $('tmgSizeLockNote').style.display = 'none';
  }
  handleFile(e.target.files[0]);
});

// Mode toggle: Upload vs Generate
$('tmgModeUpload').addEventListener('click', () => {
  S.genFamily = null; if (typeof genConfigureLayout === 'function') genConfigureLayout(); // an upload is not for a pre-chosen mat
  S.genMode = false;
  $('tmgModeUpload').style.background = 'var(--gold)';
  $('tmgModeUpload').style.color = '#000';
  $('tmgModeGen').style.background = 'transparent';
  $('tmgModeGen').style.color = 'var(--txt)';
  $('tmgUploadMode').style.display = 'block';
  $('tmgGenMode').style.display = 'none';
  // Re-evaluate Continue button state based on whether upload has a file
  $('tmgTo2').disabled = !S.file;
});
$('tmgModeGen').addEventListener('click', () => {
  if (!S.genFamily && typeof setGenFamily === 'function') setGenFamily('standard'); // Generate mode always has a mat
  S.genMode = true;
  $('tmgModeGen').style.background = 'var(--gold)';
  $('tmgModeGen').style.color = '#000';
  $('tmgModeUpload').style.background = 'transparent';
  $('tmgModeUpload').style.color = 'var(--txt)';
  $('tmgUploadMode').style.display = 'none';
  $('tmgGenMode').style.display = 'block';
  // Continue button enabled only if there's already a generated file
  $('tmgTo2').disabled = !S.file || !S.genUsed;
});

// Enable generate button when prompt has content
// Also: clear cached seed since the prompt is now different (forces fresh design)
$('tmgGenPrompt').addEventListener('input', e => {
  $('tmgGenBtn').disabled = e.target.value.trim().length < 5;
  // Prompt changed → invalidate the seed so the next generation is a fresh design
  if (S.genCachedPromptText !== e.target.value.trim()) {
    S.genSeed = null;
  }
});

// AI gen orientation toggle (default: landscape)
S.genOrientation = 'landscape';

// Helper: regenerate with the cached seed (same design composition at new aspect ratio)
async function regenerateWithSeed() {
  if (!S.genSeed || !S.genTranslated) return;
  
  $('tmgGenBtn').disabled = true;
  $('tmgGenBtn').style.opacity = '0.5';
  $('tmgGenStatus').style.display = 'block';
  $('tmgGenStatus').textContent = '✨ Flipping your design to ' + S.genOrientation + '... (10-15 seconds)';
  $('tmgGenTW').style.display = 'none';
  
  try {
    const res = await fetch(API + '/preview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        // Reuse all the things we already worked out — no Claude re-translation
        image_gen_prompt: S.genTranslated,
        negative_prompt:  S.genNegative || '',
        pms_colors:       S.genPmsColors || [],
        overlay_text:     S.genOverlayText || null,
        seed:             S.genSeed,
        orientation:      S.genOrientation,
        mat:              genMatContext(), // the flip is checked with the chosen mat's rules too
      }),
    });
    if (!res.ok) throw new Error('Reuse generation failed');
    const data = await res.json();
    if (!data.preview_url) throw new Error('No image returned');
    
    // Reuse the same compositing path as the main generate handler
    await applyAiResult(data);
  } catch (e) {
    console.warn('Orientation flip failed:', e);
    $('tmgGenStatus').textContent = 'Could not flip orientation: ' + (e.message || 'please regenerate');
    $('tmgGenStatus').style.color = '#f05322';
    $('tmgGenBtn').disabled = false;
    $('tmgGenBtn').style.opacity = '1';
  }
}

// ── AI-gen orientation + size selection ──
// PrintPlush sizes are stored as base "WxH" (smaller dimension first).
// Portrait = taller (H>W), Landscape = wider (W>H). We flip the dimensions for landscape.
const TMG_BASE_SIZES = [
  '450x700','600x850','850x1150','850x1500','850x3000',
  '1150x1800','1150x2400','1150x3000','1150x3600',
  '1500x1800','1500x2400','1500x3000','1500x3600','1500x4000',
  '1800x1800','1800x3000'
];

S.genOrientation = 'portrait';

function populateGenSizes(orientation) {
  const sel = $('tmgGenSize');
  if (!sel) return;
  sel.innerHTML = '';
  TMG_BASE_SIZES.forEach(base => {
    const [a, b] = base.split('x').map(Number);
    const small = Math.min(a, b), large = Math.max(a, b);
    let w, h, label;
    if (small === large) {
      w = h = small; label = `${small} × ${small}mm (square)`;
    } else if (orientation === 'landscape') {
      w = large; h = small; label = `${large} × ${small}mm`;
    } else {
      w = small; h = large; label = `${small} × ${large}mm`;
    }
    const opt = document.createElement('option');
    opt.value = `${w}x${h}`;
    opt.textContent = label;
    sel.appendChild(opt);
  });
  // Default-select 850×1150 (or its landscape equivalent)
  const defaultVal = orientation === 'landscape' ? '1500x850' : '850x1500'; // 13 Oct 2026: 850x1500 default
  if ([...sel.options].some(o => o.value === defaultVal)) sel.value = defaultVal;
  setPickSize(sel.value);
}

// Initial population
populateGenSizes('portrait');

function setGenOrientation(ori) {
  const prevOri = S.genOrientation;
  S.genOrientation = ori;
  const portBtn = $('tmgGenOriPortrait'), landBtn = $('tmgGenOriLandscape');
  if (ori === 'portrait') {
    portBtn.style.background = 'var(--gold)'; portBtn.style.color = '#000';
    landBtn.style.background = 'transparent'; landBtn.style.color = 'var(--txt)';
  } else {
    landBtn.style.background = 'var(--gold)'; landBtn.style.color = '#000';
    portBtn.style.background = 'transparent'; portBtn.style.color = 'var(--txt)';
  }
  populateGenSizes(ori);
  if (prevOri !== ori && S.genUsed && S.file && S.genSeed && S.genTranslated) { if ($('tmgGenSize') && $('tmgGenSize').value) S.size = $('tmgGenSize').value; regenerateWithSeed(); } // flip the generated design to the new orientation
}

$('tmgGenOriPortrait').addEventListener('click', () => setGenOrientation('portrait'));
$('tmgGenOriLandscape').addEventListener('click', () => setGenOrientation('landscape'));

// When the gen size dropdown changes, update state
$('tmgGenSize').addEventListener('change', () => {
  setPickSize($('tmgGenSize').value);
});

// Quick-pick chips fill the textarea
document.querySelectorAll('.tmg-quickpick').forEach(chip => {
  chip.addEventListener('click', () => {
    const text = chip.dataset.prompt;
    $('tmgGenPrompt').value = text;
    $('tmgGenBtn').disabled = false;
    // Visual feedback
    document.querySelectorAll('.tmg-quickpick').forEach(c => c.style.background = 'var(--sf2)');
    chip.style.background = 'rgba(240,83,34,0.15)';
  });
});

// Shared compositing function — used by both first generation and orientation flip
// Takes the /preview JSON response and:
//   1. Loads the AI background image
//   2. Cleans the band area
//   3. Overlays the text in real Montserrat
//   4. Replaces S.file with the composited result and updates state
async function applyAiResult(data) {
  // Cache the raw Ideogram image (pre-text-overlay) for Remix — base64 data URL is permanent
  // Don't rely on Ideogram's ephemeral original_url which expires after ~1 hour
  const rawIdeogramDataUrl = data.preview_url;
  
  // Pre-load Barlow Condensed Black before drawing to canvas — without this, the first
  // generation might fall back to Arial because the font hasn't downloaded yet
  if (document.fonts && document.fonts.load) {
    try {
      await document.fonts.load("900 100px 'Barlow Condensed'");
    } catch(e) { /* non-fatal — fall back to system font */ }
  }
  
  // Load the AI background image
  const bgImg = new Image();
  await new Promise((resolve, reject) => {
    bgImg.onload = resolve;
    bgImg.onerror = reject;
    bgImg.src = data.preview_url;
  });
  
  // Composite text overlay onto the AI background using HTML5 Canvas (real browser fonts)
  const composeCanvas = document.createElement('canvas');
  composeCanvas.width = bgImg.naturalWidth;
  composeCanvas.height = bgImg.naturalHeight;
  const cctx = composeCanvas.getContext('2d');
  cctx.drawImage(bgImg, 0, 0);
  
  // Only run band detection + wipe + text overlay if there's actually meaningful text to show
  const overlayMainText = (data.overlay_text?.main || '').trim();
  const hasRealText = overlayMainText.length >= 2;
  
  if (hasRealText) {
    const mainText = overlayMainText.toUpperCase();
    const subText = (data.overlay_text.subtitle || '').trim().toUpperCase();
    const W = composeCanvas.width;
    const H = composeCanvas.height;
    
    cctx.textAlign = 'center';
    cctx.textBaseline = 'middle';
    
    // Dynamic font sizing — fit main text to ~75% of width
    let mainFontSize = Math.floor(H * 0.16);
    cctx.font = `900 ${mainFontSize}px 'Barlow Condensed', 'Tw Cen MT Condensed Extra Bold', Arial, sans-serif`;
    while (cctx.measureText(mainText).width > W * 0.75 && mainFontSize > 20) {
      mainFontSize -= 4;
      cctx.font = `900 ${mainFontSize}px 'Barlow Condensed', 'Tw Cen MT Condensed Extra Bold', Arial, sans-serif`;
    }
    
    const subFontSize = Math.floor(mainFontSize * 0.4);
    
    // ── Smart band detection ──
    // Scan the image vertically to find the LARGEST contiguous run of uniform-colour strips
    // (i.e. the actual empty band Ideogram left for text). The text gets sized to fit INSIDE
    // that band — we never wipe over motif areas, so motifs stay intact.
    const stripCount = 40;
    const stripHeight = Math.floor(H / stripCount);
    const stripStats = [];
    
    for (let s = 0; s < stripCount; s++) {
      const stripY = s * stripHeight;
      const stripSample = cctx.getImageData(0, stripY, W, stripHeight);
      
      let sumR = 0, sumG = 0, sumB = 0, n = 0;
      for (let i = 0; i < stripSample.data.length; i += 4 * 16) {
        sumR += stripSample.data[i];
        sumG += stripSample.data[i + 1];
        sumB += stripSample.data[i + 2];
        n++;
      }
      const meanR = sumR / n;
      const meanG = sumG / n;
      const meanB = sumB / n;
      
      let varSum = 0;
      for (let i = 0; i < stripSample.data.length; i += 4 * 16) {
        const dr = stripSample.data[i]     - meanR;
        const dg = stripSample.data[i + 1] - meanG;
        const db = stripSample.data[i + 2] - meanB;
        varSum += dr*dr + dg*dg + db*db;
      }
      const variance = varSum / n;
      stripStats.push({ y: stripY, meanR, meanG, meanB, variance });
    }
    
    // genband1016 (16 Oct 2026): where the business name goes on an AI design.
    // The old pick weighted "near the vertical centre" 5x over band height and only searched the middle 70%, so a
    // 1-strip gap between motif parts (e.g. between a paw's toes and pad) won, and the name printed ~2% high in a thin
    // stripe across the motif. Now: the band must fit legible text (>= 9% of the design height), the biggest clear space
    // wins (centre only breaks ties), the search covers 4-96% of the height, and if there is no clear space at all the
    // artwork is shrunk and a text band in the background colour is added at the bottom.
    const allVariances = stripStats.map(s => s.variance).sort((a, b) => a - b);
    const medianVariance = allVariances[Math.floor(allVariances.length / 2)];
    const uniformThreshold = Math.max(medianVariance * 0.4, 500);
    const searchLo = Math.floor(stripCount * 0.04), searchHi = Math.ceil(stripCount * 0.96);
    const neededPx = H * 0.09 * (subText ? 1.4 : 1) / 0.8;               // text at >= 9% of H, 80% of the band
    const neededStrips = Math.max(3, Math.ceil(neededPx / stripHeight));
    const runs = [];
    let runStart = -1;
    for (let i = searchLo; i < searchHi; i++) {
      if (stripStats[i].variance < uniformThreshold) { if (runStart < 0) runStart = i; }
      else { if (runStart >= 0) runs.push({ start: runStart, length: i - runStart }); runStart = -1; }
    }
    if (runStart >= 0) runs.push({ start: runStart, length: searchHi - runStart });
    let bestRun = null, bestScore = -Infinity;
    for (const run of runs) {
      if (run.length < neededStrips) continue;                            // too thin for legible text
      const centreness = 1 - Math.abs(run.start + run.length / 2 - stripCount / 2) / (stripCount / 2);
      const score = run.length / stripCount + centreness * 0.35;          // space first, centre as a tie-break
      if (score > bestScore) { bestScore = score; bestRun = { ...run }; }
    }
    let bandTop, bandBottom, r, g, b;
    if (bestRun) {
      if (bestRun.length > neededStrips + 2) { bestRun.start += 1; bestRun.length -= 2; }   // keep clear of motif edges
      const want = Math.min(bestRun.length, Math.ceil(neededStrips * 1.6)), off = Math.floor((bestRun.length - want) / 2);
      bestRun.start += off; bestRun.length = want;                        // centre a sensibly sized band in the space
      const midStrip = stripStats[bestRun.start + Math.floor(bestRun.length / 2)];
      bandTop = bestRun.start * stripHeight; bandBottom = (bestRun.start + bestRun.length) * stripHeight;
      r = Math.round(midStrip.meanR); g = Math.round(midStrip.meanG); b = Math.round(midStrip.meanB);
    } else {
      // No clear space: background colour = median of the border pixels; shrink the art into the top and add the band below
      const px = cctx.getImageData(0, 0, W, H).data, at = (x, y) => { const i = (y * W + x) * 4; return [px[i], px[i + 1], px[i + 2]]; };
      const pts = [];
      for (let k = 0; k < 20; k++) { const t = k / 19; pts.push(at(Math.round(t * (W - 1)), 2), at(Math.round(t * (W - 1)), H - 3), at(2, Math.round(t * (H - 1))), at(W - 3, Math.round(t * (H - 1)))); }
      const med = ch => pts.map(p => p[ch]).sort((p, q) => p - q)[pts.length >> 1];
      r = med(0); g = med(1); b = med(2);
      const scale = 1 - (subText ? 0.28 : 0.22), art = document.createElement('canvas');
      art.width = W; art.height = H; art.getContext('2d').drawImage(composeCanvas, 0, 0);
      cctx.fillStyle = 'rgb(' + r + ',' + g + ',' + b + ')'; cctx.fillRect(0, 0, W, H);
      cctx.drawImage(art, W * (1 - scale) / 2, 0, W * scale, H * scale);
      bandTop = Math.round(H * scale); bandBottom = H;
    }
    const bandActualHeight = bandBottom - bandTop;
    const bandCentreY = (bandTop + bandBottom) / 2;
    const bandLuminance = 0.299*r + 0.587*g + 0.114*b;
    const bandColorHex = '#' + [r, g, b].map(c => c.toString(16).padStart(2, '0')).join('');
    
    // Resize text to fit INSIDE the empty band (no spilling into motif areas)
    // Reserve 80% of the band height for text content (10% padding top + 10% bottom)
    const maxTextHeight = bandActualHeight * 0.8;
    const totalLines = subText ? 1.4 : 1;
    let resizedMainFontSize = Math.min(mainFontSize, Math.floor(maxTextHeight / totalLines));
    
    // Re-check width constraint with the new size
    cctx.font = `900 ${resizedMainFontSize}px 'Barlow Condensed', 'Tw Cen MT Condensed Extra Bold', Arial, sans-serif`;
    while (cctx.measureText(mainText).width > W * 0.75 && resizedMainFontSize > 16) {
      resizedMainFontSize -= 2;
      cctx.font = `900 ${resizedMainFontSize}px 'Barlow Condensed', 'Tw Cen MT Condensed Extra Bold', Arial, sans-serif`;
    }
    const resizedSubFontSize = Math.floor(resizedMainFontSize * 0.4);
    
    const mainY = subText ? bandCentreY - resizedMainFontSize*0.3 : bandCentreY;
    const subY = mainY + resizedMainFontSize * 0.75;
    
    // ── Wipe ONLY within the detected empty band — never cut into motif areas ──
    cctx.fillStyle = bandColorHex;
    cctx.fillRect(0, bandTop, W, bandActualHeight);
    
    // Pick text colour from PMS palette
    const pmsColors = (data.pms_colors && data.pms_colors.length) ? data.pms_colors :
      [{hex: '#1B2A4A'}, {hex: '#F5F0E8'}];
    const lum = (hex) => {
      const r2 = parseInt(hex.slice(1,3), 16);
      const g2 = parseInt(hex.slice(3,5), 16);
      const b2 = parseInt(hex.slice(5,7), 16);
      return 0.299*r2 + 0.587*g2 + 0.114*b2;
    };
    const sorted = [...pmsColors].sort((a, b) => lum(a.hex) - lum(b.hex));
    const textColor = bandLuminance > 128 ? sorted[0].hex : sorted[sorted.length - 1].hex;
    
    cctx.fillStyle = textColor;
    cctx.font = `900 ${resizedMainFontSize}px 'Barlow Condensed', 'Tw Cen MT Condensed Extra Bold', Arial, sans-serif`;
    cctx.fillText(mainText, W/2, mainY);
    
    if (subText) {
      cctx.font = `500 ${resizedSubFontSize}px 'Barlow Condensed', 'Tw Cen MT Condensed Extra Bold', Arial, sans-serif`;
      cctx.fillText(subText, W/2, subY);
    }
  }
  
  // Snap the entire composited image to PMS colours before saving the artwork file.
  // This makes Artwork File and Mat Preview show the same colours — production team
  // sees the actual PMS-matched version everywhere.
  try {
    if (!S.genFamily) quantiseImageToPMS(composeCanvas, cctx, composeCanvas.width, composeCanvas.height, true);
  } catch(e) {
    console.warn('PMS quantisation on AI artwork failed:', e);
  }
  
  // a mat with a base: the background becomes the base colour the customer chose (after the text overlay, so the band detector still sees the real image)
  if (S.genFamily && GRADES[S.genFamily] && GRADES[S.genFamily].bgSeparate && S.selectedBg && S.selectedBg.hex) applyGenBase(cctx, composeCanvas.width, composeCanvas.height, S.selectedBg.hex);
  // Convert final composited canvas to a File
  const blob = await new Promise(resolve => composeCanvas.toBlob(resolve, 'image/png'));
  const file = new File([blob], 'generated-design.png', { type: 'image/png' });
  
  // Cache everything we need for seed-based regeneration on orientation flip + remix
  S.genUsed = true;
  S.genSeed = data.seed || null;
  S.genOriginalUrl = data.original_url || null;  // raw Ideogram URL (ephemeral, ~1hr expiry)
  S.genRawImageDataUrl = rawIdeogramDataUrl;     // permanent base64 — preferred for Remix
  S.genCachedPromptText = $('tmgGenPrompt').value.trim();
  S.genTranslated = data.translated_prompt;
  S.genNegative = data.negative_prompt;
  S.genPmsColors = (data.pms_colors || []).slice(0, 12); // Standard Grade ceiling: at most 12 print colours
  S.genOverlayText = data.overlay_text || null;
  
  // Sync the chosen size to Step 3's size dropdown so it matches the generated design.
  // The Step 3 dropdown only lists portrait sizes by default — if this is a landscape
  // size (e.g. 1150x850), add the option so the value selects correctly.
  if ($('tmgSize') && S.size) {
    const sizeSel = $('tmgSize');
    if (![...sizeSel.options].some(o => o.value === S.size)) {
      const [w, h] = S.size.split('x');
      const opt = document.createElement('option');
      opt.value = S.size;
      opt.textContent = `${w} × ${h}mm`;
      sizeSel.appendChild(opt);
    }
    sizeSel.value = S.size;
    // LOCK the size — the design was generated to fit this exact shape. Changing it
    // would stretch the artwork. Keep it visible (so they can confirm) but disabled.
    sizeSel.disabled = true;
    sizeSel.style.opacity = '0.6';
    sizeSel.style.cursor = 'not-allowed';
    sizeSel.title = 'Size is locked to match your generated design';
    // Show a small lock note under the size dropdown
    let lockNote = $('tmgSizeLockNote');
    if (!lockNote) {
      lockNote = document.createElement('div');
      lockNote.id = 'tmgSizeLockNote';
      lockNote.style.cssText = 'font-size:11px;color:var(--muted);margin-top:6px;line-height:1.4';
      lockNote.textContent = '🔒 Size is locked to match your generated design. To change it, regenerate with a different size.';
      sizeSel.closest('.tmg-field').appendChild(lockNote);
    }
    lockNote.style.display = 'block';
  }
  
  // HIDE the orientation dropdown entirely for AI-gen — they chose size up front,
  // orientation is derived and locked, so there's nothing for them to change here.
  if ($('tmgOri')) {
    $('tmgOri').value = S.genOrientation || 'portrait';
    const oriField = $('tmgOri').closest('.tmg-field');
    if (oriField) oriField.style.display = 'none';
  }
  
  handleFile(file);
  
  $('tmgGenThumb').src = URL.createObjectURL(blob);
  $('tmgGenTW').style.display = 'flex';
  $('tmgGenStatus').style.display = 'none';
  
  $('tmgGenBtn').disabled = false;
  $('tmgGenBtn').style.opacity = '1';
  $('tmgGenBtn').textContent = '✨ Regenerate';
  $('tmgTo2').disabled = false;
  genConfigureLayout(); // the Configure step asks only for what is still needed
}

// Generate design via Ideogram (first time, or fresh regenerate)
$('tmgGenBtn').addEventListener('click', async () => {
  const rawPrompt = $('tmgGenPrompt').value.trim();
  if(rawPrompt.length < 5) return;
  
  // Clear seed so each Generate click produces a fresh design
  S.genSeed = null;
  // A fresh generation supersedes any preserved (pre-upload) design
  S.preservedGenFile = null;
  S.preservedGenState = null;
  
  $('tmgGenBtn').disabled = true;
  $('tmgGenBtn').style.opacity = '0.5';
  $('tmgGenStatus').style.display = 'block';
  $('tmgGenStatus').textContent = '✨ Designing your mat... (10-30 seconds)';
  $('tmgGenTW').style.display = 'none';
  
  try {
    const res = await fetch(API + '/preview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        raw_customer_prompt: rawPrompt,
        mat_size: S.size || '850x1200',
        orientation: S.genOrientation || 'landscape',
        mat: genMatContext(), // the mat the customer picked: family, chart, cap, base, thresholds
      }),
    });
    
    if(!res.ok) {
      const errData = await res.json().catch(()=>({}));
      throw new Error(errData.error || 'Generation failed');
    }
    
    const data = await res.json();
    if(!data.preview_url) {
      throw new Error('No image returned');
    }
    
    await applyAiResult(data);
    
  } catch(e) {
    console.warn('Generate failed:', e);
    $('tmgGenStatus').textContent = 'Generation failed: ' + (e.message || 'please try again');
    $('tmgGenStatus').style.color = '#f05322';
    $('tmgGenBtn').disabled = false;
    $('tmgGenBtn').style.opacity = '1';
  }
});

// Remove generated design
$('tmgGenRM').addEventListener('click', () => {
  S.genUsed = false;
  genConfigureLayout(); // back to the full Configure step
  S.genAutoBg = null;
  S.genSeed = null;
  S.genCachedPromptText = null;
  S.genTranslated = null;
  S.genNegative = null;
  S.file = null;
  S.originalFile = null;
  $('tmgGenThumb').src = '';
  $('tmgGenTW').style.display = 'none';
  $('tmgGenBtn').textContent = '✨ Generate Design';
  $('tmgGenPrompt').value = '';
  $('tmgTo2').disabled = true;
  // Re-show + re-enable orientation dropdown
  if ($('tmgOri')) {
    $('tmgOri').disabled = false;
    $('tmgOri').style.opacity = '1';
    $('tmgOri').title = '';
    const oriField = $('tmgOri').closest('.tmg-field');
    if (oriField) oriField.style.display = '';
  }
  // Unlock the size dropdown
  if ($('tmgSize')) {
    $('tmgSize').disabled = false;
    $('tmgSize').style.opacity = '1';
    $('tmgSize').style.cursor = '';
    $('tmgSize').title = '';
    if ($('tmgSizeLockNote')) $('tmgSizeLockNote').style.display = 'none';
  }
});
const drop=$('tmgDrop');
drop.addEventListener('dragover',e=>{e.preventDefault();drop.classList.add('over');});
drop.addEventListener('dragleave',()=>drop.classList.remove('over'));
drop.addEventListener('drop',e=>{e.preventDefault();drop.classList.remove('over');S.genUsed=false;S.genAutoBg=null;handleFile(e.dataTransfer.files[0]);});

function handleFileReady(f){
  if(!f)return;
  if(RASTER_TYPES.indexOf(f.type) < 0){alert('Please upload JPG, PNG or WebP.');return;} // 7 Oct 2026: the one list of browser-decoded formats (adds BMP, AVIF)
  if(f.size>50*1024*1024){alert('File too large. Max 50MB.');return;}
  // Clear previous state when new file uploaded
  S.file=f;
  S.originalFile=null;
  S.validation=null;
  if (!(S.genFamily && GRADES[S.genFamily] && GRADES[S.genFamily].bgSeparate)) S.selectedBg=null; // a generated design keeps the base colour chosen with its mat
  S.artworkFile=null;
  S.useArtworkAsBg = false;
  S.bgRemoved = false;
  S.logoX = null; S.logoY = null; S.logoScale = 80;
  S.clientDetectedTransparency = false;
  S.trail = {};
  S.grade = 'standard'; S.colourStats = null; S.gradeManual = false; S.gradeAutoKey = null; S.colourOverrides = null; S.logoBg = null; S.bgFromLogo = null; S.dropLogoBg = false; S.logoBgFile = null;
  if (S.genUsed && S.genFamily && GRADES[S.genFamily]) { S.grade = S.genFamily; S.gradeManual = true; } // gen keeps the chosen mat
  cachedLogo = null;
  // A new upload has no render palette yet — never let a previous file's colours leak into this one.
  // (AI-generated files keep the palette recorded when the composite was quantised.)
  if (!S.genUsed || S.genFamily) S.actualPmsUsed = []; // re-recorded by the quantiser for the chosen mat
  if($('tmgArtworkName'))$('tmgArtworkName').textContent='Choose artwork file';
  try{$('tmgThumb').src=URL.createObjectURL(f);$('tmgTW').classList.add('vis');}catch(e){}
  $('tmgTo2').disabled=false;
  // Reset background picker selection
  if($('tmgSelDisp'))$('tmgSelDisp').classList.remove('vis');
  if($('tmgLW'))$('tmgLW').classList.remove('vis');
  if($('tmgTo3'))$('tmgTo3').disabled=true;
  document.querySelectorAll('.tmg-sw').forEach(s=>s.classList.remove('sel'));
}
$('tmgRM').addEventListener('click',()=>{
  S.file=null;
  $('tmgFile').value='';$('tmgThumb').src='';
  $('tmgTW').classList.remove('vis');
  
  // If there was a generated design before this upload, restore it
  if (S.preservedGenFile && S.preservedGenState) {
    S.file = S.preservedGenFile;
    S.genUsed = true;
    S.actualPmsUsed = []; // the restored generated file is re-quantised at the preview step
    S.genSeed = S.preservedGenState.genSeed;
    S.genOriginalUrl = S.preservedGenState.genOriginalUrl;
    S.genRawImageDataUrl = S.preservedGenState.genRawImageDataUrl;
    S.genCachedPromptText = S.preservedGenState.genCachedPromptText;
    S.genTranslated = S.preservedGenState.genTranslated;
    S.genNegative = S.preservedGenState.genNegative;
    S.genPmsColors = S.preservedGenState.genPmsColors;
    S.genOverlayText = S.preservedGenState.genOverlayText;
    S.genOrientation = S.preservedGenState.genOrientation;
    setPickSize(S.preservedGenState.size);
    
    // Restore the generated design's thumbnail in the gen panel
    const genUrl = URL.createObjectURL(S.preservedGenFile);
    if ($('tmgGenThumb')) $('tmgGenThumb').src = genUrl;
    if ($('tmgGenTW')) $('tmgGenTW').style.display = 'flex';
    if ($('tmgGenBtn')) $('tmgGenBtn').textContent = '✨ Regenerate';
    
    // Switch back to Generate mode visually
    if ($('tmgModeGen')) $('tmgModeGen').click();
    
    // Clear the preserved state now that it's restored
    S.preservedGenFile = null;
    S.preservedGenState = null;
    
    // Enable Continue — the generated design is usable again
    $('tmgTo2').disabled = false;
  } else {
    $('tmgTo2').disabled=true;
  }
});

// Step 1 → 2
// The /validate request (Railway, Claude vision, ~10 s). Started early at "Analyse Artwork" and reused at Continue when it
// is for the same file; a failure here is handled exactly where it always was (the Continue handler's catch).
function validateRequest(){
  const fd=new FormData();fd.append('artwork',S.file);fd.append('notes','');fd.append('size',S.size);fd.append('orientation',$('tmgOri')?$('tmgOri').value:'landscape');
  return fetch(`${API}/validate`,{method:'POST',body:fd}).then(r=>r.json());
}
function validatePrefetch(){
  if(!S.file||S.genUsed){S.validatePending=null;return;}
  const file=S.file; const p=validateRequest(); p.catch(()=>{}); // the error surfaces at Continue, not here
  S.validatePending={file,promise:p};
}
$('tmgTo2').addEventListener('click',async()=>{
  // Always clear previous state so fresh analysis runs
  S.validation=null;
  if (!(S.genFamily && GRADES[S.genFamily] && GRADES[S.genFamily].bgSeparate)) S.selectedBg=null; // a generated design keeps the base colour chosen with its mat
  S.useArtworkAsBg=false;
  if($('tmgSelDisp'))$('tmgSelDisp').classList.remove('vis');
  if($('tmgLW'))$('tmgLW').classList.remove('vis');
  if($('tmgTo3'))$('tmgTo3').disabled=true;
  if($('tmgBgToggle'))$('tmgBgToggle').style.display='flex';
  if($('tmgUseAsIs'))$('tmgUseAsIs').style.background='var(--sf2)';
  if($('tmgUseAsIsCheck'))$('tmgUseAsIsCheck').textContent='';
  if($('tmgRemoveWhite')) {
    $('tmgRemoveWhite').disabled = false;
    $('tmgRemoveWhite').style.opacity = '1';
    $('tmgRemoveWhite').style.background = 'var(--sf2)';
  }
  if($('tmgRemoveWhiteCheck'))$('tmgRemoveWhiteCheck').textContent='';
  document.querySelectorAll('.tmg-sw').forEach(s=>s.classList.remove('sel'));
  // 5 Oct 2026: size and orientation come first, so the colour analysis below runs from the Configure step's Continue
  goTo(3);fetchPricing();
  validatePrefetch(); // 7 Oct 2026: the 10 s artwork check runs while the customer picks placement and size
  if(S.file && $('tmgStep3Preview')){ $('tmgStep3Preview').style.display='block'; renderMiniCanvas('tmgStep3Canvas', true); }
});

// Configure -> Background: analyse the artwork at the chosen size, then show colours + print grades
$('tmgTo4').addEventListener('click',async()=>{
  goTo(2);$('tmgSpin').classList.add('vis');$('tmgBgPanel').style.display='none';
  if($('tmgTo3'))$('tmgTo3').disabled=true;
  try{
    const pre=S.validatePending; S.validatePending=null;
    const data=await ((pre&&pre.file===S.file)?pre.promise:validateRequest()); // the early answer when it is for this file, else the call as before
    $('tmgSpin').classList.remove('vis');
    S.validation=data.success&&data.validation?data.validation:{needs_background_selection:true,warnings:[],suggestions:[],colour_mappings:[]};
    S.validationKey = (data.success && data.validation) ? validationKey() : null;
    renderBgPanel(S.validation);
    applyLogoBgDefault(); // default Background Colour = the logo's own background
    showPmsNotice(S.validation);
    renderGradeCards();
  }catch(err){
    $('tmgSpin').classList.remove('vis');
    S.validation={needs_background_selection:true,warnings:[],suggestions:[],colour_mappings:[]};
    renderBgPanel(S.validation);
    applyLogoBgDefault(); // default Background Colour = the logo's own background
    // The colour swatches no longer depend on the API (they come from the quantised artwork), so show them anyway
    try { showPmsNotice(S.validation); } catch(e) {}
    try { renderGradeCards(); } catch(e) {}
  }
  $('tmgBgPanel').style.display='block';
  if (S.genUsed && S.genFamily) goTo(4); // generated design: the mat was chosen before generating, straight to the preview
});

function renderBgPanel(v){
  // Detection messages and colour count are intentionally hidden from customer
  // The PMS notice card handles the messaging instead
  buildGrid('all');
  
  // Show "My design fills the whole mat" button only for uploaded files (NOT AI-generated)
  // AI-generated designs are already designed to fill the mat — toggle adds confusion
  if($('tmgUseAsIsWrap')) {
    $('tmgUseAsIsWrap').style.display = (S.file && !S.genUsed) ? 'block' : 'none';
  }
  // Show "Remove background" button whenever there's a file
  // BUT not for AI-generated artwork — the gen output IS the design, removing bg makes no sense
  const showRemoveBg = !!S.file && !S.genUsed;
  if($('tmgRemoveWhiteWrap')) {
    $('tmgRemoveWhiteWrap').style.display = showRemoveBg ? 'block' : 'none';
  }
  updateTranspBtn();
  // Reset use-as-is state on each new validation
  S.useArtworkAsBg = false;
  if($('tmgUseAsIsCheck')) $('tmgUseAsIsCheck').textContent = '';
  if($('tmgUseAsIs')) $('tmgUseAsIs').style.borderColor = 'var(--gold)';
  
  // ── AI-generated path: design fills the whole mat, no separate bg ──
  if (S.genUsed) {
    // Force "use artwork as bg" mode — the AI design IS the entire mat
    const genOnBase = !!(S.genFamily && gradeOf().bgSeparate); // a mat with a base: the design sits ON the real base (its background was recoloured to the base colour and is dropped), not painted edge to edge
    S.useArtworkAsBg = !genOnBase;
    if (genOnBase) { S.logoScale = 100; S.logoX = null; S.logoY = null; } else S.selectedBg = null;
    
    // Hide all bg-selection UI elements
    const bgToggle = $('tmgBgToggle');
    if (bgToggle) bgToggle.style.display = 'none';
    const bgCollapsible = $('tmgBgCollapsible');
    if (bgCollapsible) bgCollapsible.style.display = 'none';
    const selDisp = $('tmgSelDisp');
    if (selDisp) selDisp.classList.remove('vis');
    const lwarn = $('tmgLW');
    if (lwarn) lwarn.classList.remove('vis');
    
    // Hide the "Choose mat background colour" heading
    const bgPanel = $('tmgBgPanel');
    if (bgPanel) {
      const heading = bgPanel.querySelector('.tmg-slbl');
      if (heading && heading.textContent.includes('background colour')) {
        heading.style.display = 'none';
      }
    }
    
    // Hide notice if it was previously shown
    const aiBgNotice = document.getElementById('tmgAiBgNotice');
    if (aiBgNotice) aiBgNotice.style.display = 'none';
    
    // Enable Continue (the print grade is still chosen on this step, so no auto-advance since 5 Oct 2026)
    if($('tmgTo3')) $('tmgTo3').disabled = false;
    if (S.grade === 'hd') S.grade = 'standard'; // High Definition is not offered for generated designs
    return;
  }
  
  // Standard upload path: hide AI notice if previously shown, show picker normally
  const aiBgNotice = document.getElementById('tmgAiBgNotice');
  if (aiBgNotice) aiBgNotice.style.display = 'none';
  const bgToggle = $('tmgBgToggle');
  if (bgToggle) bgToggle.style.display = 'flex';
  const bgPanel = $('tmgBgPanel');
  if (bgPanel) {
    const heading = bgPanel.querySelector('.tmg-slbl');
    if (heading) heading.style.display = '';
  }
  
  if(v.suggested_background_mm){
    const m=MM.find(c=>c[0]===v.suggested_background_mm);
    if(m && !(S.whiteBgAuto && S.dropLogoBg)){ let pick = m; { const pal = (v.colour_mappings || []).map(cm => String(cm.pms_hex || cm.original_hex || '')).filter(h => /^#[0-9a-f]{6}$/i.test(h)).map(h => ({ r: parseInt(h.slice(1, 3), 16), g: parseInt(h.slice(3, 5), 16), b: parseInt(h.slice(5, 7), 16), share: 1 })).filter(c => !(c.r > 235 && c.g > 235 && c.b > 235)); const ml = rgbToLab(parseInt(m[1].slice(1, 3), 16), parseInt(m[1].slice(3, 5), 16), parseInt(m[1].slice(5, 7), 16)); const weak = pal.some(c => deltaE2000(ml, rgbToLab(c.r, c.g, c.b)) < DARK_BG_MIN_DE); /* 14 Oct 2026: a light suggestion, or one the logo would disappear into (navy logo -> Black) */ const row = (pal.length && (m[3] === 'light' || weak)) ? pickBgForPalette(pal) : null; if (row && row[0] !== m[0]) { pick = row; trail('bg', 'AI suggested ' + m[2] + ' (' + (m[3] === 'light' ? 'light' : 'too close to the logo') + ') - ' + row[2] + ' instead'); } } S.aiBgMm = pick[0]; S.bgSrc = pick === m ? 'AI suggested' : 'dark background recommended'; selectBg(pick[0],pick[1],pick[2],pick[3]==='light'); } // 14 Oct 2026: never over a see-through white background's contrast pick
  }
}

/* ux1014i 14 Oct 2026: readable carousel + no-colour tile CSS, and whether "my design fills the mat" is allowed here */
function uxiCss(){ if (document.getElementById('tmgUxiCss')) return; const st = document.createElement('style'); st.id = 'tmgUxiCss'; st.textContent = "\n/* ux1014i 14 Oct 2026: readable full-screen carousel + no-colour tile + card grid that never clips */\n/* ux1014k: uniform cards - fixed header height, footer pinned, picked card never widens */\n/* ux1014l: the mat name never gets squeezed by the size note in the price column */\n.tmg-grade .tmg-grade-top{flex-wrap:nowrap}.tmg-grade .tmg-grade-name{flex:1 1 55%;min-width:55%;overflow-wrap:normal;word-break:normal;hyphens:none}.tmg-grade .tmg-grade-price{flex:0 1 auto;max-width:45%;min-width:0;white-space:normal}.tmg-grade .tmg-grade-price>:not(.tmg-grade-size){white-space:nowrap}.tmg-grade .tmg-grade-size{white-space:normal;text-align:right;line-height:1.3}\n@media(min-width:641px){.tmg-grades:has(.tmg-grade-size) .tmg-grade-top{min-height:76px}}\n.tmg-grade{display:flex;flex-direction:column}.tmg-grade-wide{grid-column:auto!important}.tmg-grade-wide .tmg-grade-prev{max-width:100%!important}\n.tmg-grade-top{align-items:flex-start}.tmg-grade-name{flex:1 1 auto;min-width:0}.tmg-grade-price{flex:0 0 auto;text-align:right;display:flex;flex-direction:column;align-items:flex-end;line-height:1.25}.tmg-grade-price>*{display:block}\n.tmg-grade-from{font-size:11px;font-weight:600;color:var(--muted)}\n.tmg-grade-lead{margin-top:auto;padding-top:8px}\n@media(min-width:641px){.tmg-grade-top{min-height:58px}}\n/* ux1014k: edge / drainage choices stacked inside a card (they were built for the old full-width card) */\n.tmg-grade .tmg-drain-opts{display:flex!important;flex-direction:column!important;gap:6px}.tmg-grade .tmg-drain-opt{width:100%!important;display:flex!important;flex-direction:row!important;align-items:center;gap:10px;text-align:left;padding:9px 10px;font-size:13px;line-height:1.3;min-height:44px}.tmg-grade .tmg-drain-opt,.tmg-grade .tmg-drain-opt *{overflow-wrap:normal!important;word-break:normal!important}.tmg-grade .tmg-drain-swatch{flex:0 0 auto}.tmg-grade .tmg-edge-price{margin-left:auto;font-size:11px;white-space:nowrap}.tmg-grade .tmg-drain-lbl{font-size:13px;line-height:1.35}\n.tmg-grades{grid-template-columns:repeat(auto-fill,minmax(min(100%,250px),1fr))!important}\n.tmg-grade{min-width:0}.tmg-grade canvas.tmg-grade-prev{max-width:100%;height:auto}\n.tmg-grade *{overflow-wrap:anywhere}\n.tmg-sw-fill{grid-column:1 / -1;aspect-ratio:auto!important;display:flex!important;align-items:center;gap:10px;width:auto!important;height:auto!important;min-height:44px;border-radius:10px!important;padding:6px 10px;background:var(--sf2)!important;border:2px dashed var(--bd)!important;cursor:pointer;text-align:left}\n.tmg-sw-fill:hover{border-color:var(--gold)!important}\n.tmg-sw-fill img{width:40px;height:40px;object-fit:contain;border-radius:6px;background:#fff;box-shadow:inset 0 0 0 1px rgba(0,0,0,.1);flex:0 0 auto}\n.tmg-sw-fill b{display:block;font-size:13px;color:var(--txt)}.tmg-sw-fill small{display:block;font-size:11.5px;color:var(--muted);line-height:1.3}\n.tmg-sw-fill .tmg-tt{display:none!important}\n#tmgLightbox .tmg-lb-fill{border-radius:12px!important;background:#2a2a2a!important;display:flex;align-items:center;justify-content:center;overflow:visible}\n#tmgLightbox .tmg-lb-fill img{width:76%;height:76%;object-fit:contain;border-radius:6px;background:#fff}\n#tmgLightbox .tmg-lb-title{font-size:17px}\n#tmgLightbox .tmg-lb-cap{font-size:14px;color:#eee}\n#tmgLightbox .tmg-lb-rail-lbl{font-size:12.5px;color:#ddd;font-weight:700}\n#tmgLightbox .tmg-lb-btn{font-size:14px}\n#tmgLightbox .tmg-lb-tog{font-size:13px}\n#tmgLightbox .tmg-lb-strip{scrollbar-width:thin;scrollbar-color:#6a6a6a transparent;padding-bottom:40px}\n#tmgLightbox .tmg-lb-strip::-webkit-scrollbar{display:block;width:6px}#tmgLightbox .tmg-lb-strip::-webkit-scrollbar-thumb{background:#5a5a5a;border-radius:3px}\n#tmgLightbox .tmg-lb-rail{position:relative}\n#tmgLightbox .tmg-lb-rail.tmg-lb-more-dn::after{content:\"More below\";position:absolute;left:0;right:0;bottom:0;height:46px;display:flex;align-items:flex-end;justify-content:center;padding-bottom:6px;font-size:12px;font-weight:700;color:#fff;background:linear-gradient(to bottom,rgba(12,12,12,0),rgba(12,12,12,.95) 70%);pointer-events:none}\n#tmgLightbox .tmg-lb-rail.tmg-lb-more-up::before{content:\"\";position:absolute;left:0;right:0;top:22px;height:26px;background:linear-gradient(to top,rgba(12,12,12,0),rgba(12,12,12,.95));pointer-events:none;z-index:1}\n@media(min-width:641px){\n  #tmgLightbox .tmg-lb-body{grid-template-columns:132px minmax(0,1fr) 196px;gap:16px}\n  #tmgLightbox .tmg-lb-bg{width:62px;height:62px}\n  #tmgLightbox .tmg-lb-bg span{font-size:12px;color:#f2f2f2;max-width:124px;overflow:hidden;text-overflow:ellipsis}\n  #tmgLightbox .tmg-lb-strip{gap:30px}\n  #tmgLightbox .tmg-lb-mat{width:180px;padding:6px 6px 8px;background:#262626}\n  #tmgLightbox .tmg-lb-mat b{font-size:14px;line-height:1.25;margin-top:6px;color:#fff}\n  #tmgLightbox .tmg-lb-mat i{font-size:13px;font-weight:700;margin-top:3px}\n  #tmgLightbox .tmg-use-c{font-size:11px;padding:4px 7px}\n  #tmgLightbox .tmg-use-c i{font-size:12px}\n  #tmgLightbox .tmg-colnote{font-size:12px;margin:4px 0 2px}\n  #tmgLightbox .tmg-lb-mi{width:24px;height:24px;font-size:12px}\n}\n@media(max-width:640px){\n  #tmgLightbox .tmg-lb-body{grid-template-columns:70px minmax(0,1fr) 104px}\n  #tmgLightbox .tmg-lb-title{font-size:13.5px;white-space:normal;overflow:visible;line-height:1.25}\n  #tmgLightbox .tmg-lb-cap{font-size:12px}\n  #tmgLightbox .tmg-lb-bg{width:46px;height:46px}\n  #tmgLightbox .tmg-lb-bg span{font-size:10.5px;color:#f2f2f2;max-width:68px;overflow:hidden;text-overflow:ellipsis}\n  #tmgLightbox .tmg-lb-mat{width:100px;min-height:44px;padding:4px 4px 6px}\n  #tmgLightbox .tmg-lb-mat b{font-size:11.5px;line-height:1.2;color:#fff}\n  #tmgLightbox .tmg-lb-mat i{font-size:11px;font-weight:700}\n  #tmgLightbox .tmg-use-c{font-size:10px;padding:3px 5px}\n  #tmgLightbox .tmg-colnote{font-size:10.5px}\n  #tmgLightbox .tmg-lb-btn{font-size:13px}\n}\n"; document.head.appendChild(st); }
function fillAllowed(){ try { return !!S.file && !S.genUsed && !(isCut() || isRaised() || gradeOf().noFill) && !!$('tmgUseAsIs'); } catch (e) { return false; } }
function artThumbSrc(){ const t = $('tmgThumb'); return (t && t.src) || ''; }
function uxiMore(){ try { document.querySelectorAll('#tmgLightbox .tmg-lb-rail').forEach(r => { const st = r.querySelector('.tmg-lb-strip'); if (!st) return; const upd = () => { r.classList.toggle('tmg-lb-more-dn', st.scrollTop + st.clientHeight < st.scrollHeight - 8); r.classList.toggle('tmg-lb-more-up', st.scrollTop > 8); }; if (!st.__uxi) { st.__uxi = 1; st.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); } upd(); }); } catch (e) {} }
function setFillMode(on){ const ua = $('tmgUseAsIs'); if (!ua || !!S.useArtworkAsBg === !!on) return; ua.click(); }
function buildGrid(filter){
  const grid=$('tmgBgGrid');grid.innerHTML=''; uxiCss();
  if (fillAllowed()) { const f = document.createElement('div'); f.className = 'tmg-sw tmg-sw-fill'; f.setAttribute('role', 'button'); f.setAttribute('tabindex', '0');
    f.innerHTML = (artThumbSrc() ? '<img alt="" src="' + artThumbSrc() + '">' : '') + '<span><b>No mat colour</b><small>My design fills the whole mat, edge to edge</small></span>';
    f.addEventListener('click', () => setFillMode(true)); f.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setFillMode(true); } }); grid.appendChild(f); }
  familyChart().forEach(([mm,hex,name,cat])=>{ // v2: the family's own chart (or base colours)
    if(filter!=='all'&&cat!==filter)return;
    const sw=document.createElement('div');sw.className='tmg-sw';sw.style.cssText += swatchCss(mm, hex);
    sw.innerHTML=`<span class="tmg-tt">${name}</span>`;
    if(S.selectedBg&&S.selectedBg.mm===mm)sw.classList.add('sel');
    sw.addEventListener('click',()=>{selectBg(mm,hex,name,cat==='light');});
    grid.appendChild(sw);
  });
}

function selectBg(mm,hex,name,isLight){
  const src = S.bgSrc || 'customer clicked'; S.bgSrc = null;
  trail('bg', src + ' ' + trailBgName(mm, name));
  // Clear use-as-is mode if user picks a colour
  if(S.useArtworkAsBg) {
    trail('asis', 'off (' + src + ' a background)');
    S.useArtworkAsBg = false;
    if($('tmgUseAsIsCheck')) $('tmgUseAsIsCheck').textContent = '';
    if($('tmgUseAsIs')) $('tmgUseAsIs').style.background = 'var(--sf2)';
    if($('tmgBgToggle')) $('tmgBgToggle').style.display = 'flex';
    cachedLogo = null; S.actualPmsUsed = []; S.shaded = null; S.logoX = null; S.logoY = null; S.logoScale = 80; S._uxiRefresh = true; /* ux1014i: the fill-the-mat artwork (white kept, cover layout) is rebuilt as a centred logo at the default size */
  }
  S.selectedBg={mm,hex,name,is_light:isLight};
  if (S._uxiRefresh) { S._uxiRefresh = false; if (typeof refreshArtworkForBudget === 'function') refreshArtworkForBudget(); }
  if (typeof onBgPicked === 'function') onBgPicked(mm); // a different background than the logo's own: the logo background drops out
  if (typeof isCut === 'function' && (isCut() || isRaised())) { cachedLogo = null; S.actualPmsUsed = []; S.shaded = null; if (S.file && typeof showPmsNotice === 'function') showPmsNotice(S.validation); }
  if (gradeOf().alwaysMint && typeof fetchPricing === 'function') fetchPricing(); // coir inlay: the base coir sets the rate and the product
  $('tmgSelDot').style.cssText += swatchCss(mm, hex);
  // Show PMS name + chart number (e.g. "Deep Navy PMS 2768c (118)"; PrintScraper "PMS 2768c (118/C9)")
  const chartNum = mmRef(mm);
  const pmsMatch = name.match(/\(PMS [^)]+\)/);
  const baseName = pmsMatch ? name.replace(pmsMatch[0], '').trim() + ' ' + pmsMatch[0] : name;
  const displayName = baseName; // ux1015b: no chart code on screen
  $('tmgSelMm').textContent = displayName;
  $('tmgSelDisp').classList.add('vis');$('tmgLW').classList.toggle('vis',isLight);
  $('tmgTo3').disabled=false;
  document.querySelectorAll('#tmgBgGrid .tmg-sw').forEach(s=>{
    s.classList.toggle('sel',s.querySelector('.tmg-tt')&&s.querySelector('.tmg-tt').textContent.startsWith(mm));
  });
  if(S.step===4&&S.file)renderCanvas();
  // Re-render Step 2 mini preview if visible
  if(miniPreviewVisible()) {
    renderMiniCanvas('tmgStep2Canvas');
  }
  updateBgLabel();
  if (typeof gradeOf === 'function' && gradeOf().whiteWarn && typeof renderGradeCards === 'function') renderGradeCards();
  // Show selected colour in toggle button and close picker
  if($('tmgBgCollapsible')) {
    $('tmgBgCollapsible').style.display = 'none';
    if($('tmgBgChevron')) $('tmgBgChevron').style.transform = '';
  }
}

document.querySelectorAll('.tmg-ftab').forEach(t=>{
  t.addEventListener('click',()=>{
    document.querySelectorAll('.tmg-ftab').forEach(x=>x.classList.remove('active'));t.classList.add('active');
    buildGrid(t.dataset.f);
  });
});

// Collapsible colour swatch panel
const tmgBgToggle = $('tmgBgToggle');
if(tmgBgToggle) {
  let bgOpen = false;
  tmgBgToggle.addEventListener('click', () => {
    bgOpen = !bgOpen;
    $('tmgBgCollapsible').style.display = bgOpen ? 'block' : 'none';
    $('tmgBgChevron').style.transform = bgOpen ? 'rotate(180deg)' : '';
  });
}

// "Use my full design as-is" button — skips background colour requirement, omits from cart
const tmgUseAsIs = $('tmgUseAsIs');
if(tmgUseAsIs) {
  tmgUseAsIs.addEventListener('click', () => {
    if (!S.useArtworkAsBg && S.bgRemoved && S.originalFile && $('tmgRemoveWhite')) $('tmgRemoveWhite').click(); // a design that fills the mat needs its own background: the original artwork goes back first (the undo runs straight away)
    S.useArtworkAsBg = !S.useArtworkAsBg;
    trail('asis', S.useArtworkAsBg ? 'on (customer)' : 'off (customer)');
    if(S.useArtworkAsBg) {
      // Toggle ON — use AI-suggested colour as placeholder bg (so any edge bleed matches the artwork)
      let placeholderBg = null;
      if(S.validation && S.validation.suggested_background_mm) {
        const m = MM.find(c => c[0] === S.validation.suggested_background_mm);
        if(m) placeholderBg = { mm: m[0], hex: m[1], name: m[2], is_light: m[3]==='light', isArtworkBg: true };
      }
      if(!placeholderBg) {
        placeholderBg = { mm: 'ARTWORK', hex: '#808080', name: '', is_light: false, isArtworkBg: true };
      }
      S.selectedBg = placeholderBg;
      if($('tmgUseAsIsCheck')) $('tmgUseAsIsCheck').textContent = '✓ Selected';
      if($('tmgUseAsIs')) $('tmgUseAsIs').style.background = 'rgba(240,83,34,0.15)';
      if($('tmgBgToggle')) $('tmgBgToggle').style.display = 'none';
      if($('tmgBgCollapsible')) $('tmgBgCollapsible').style.display = 'none';
      if($('tmgSelDisp')) $('tmgSelDisp').classList.remove('vis');
      if($('tmgLW')) $('tmgLW').classList.remove('vis');
      document.querySelectorAll('.tmg-sw').forEach(s => s.classList.remove('sel'));
      if($('tmgBgCurrentLabel')) $('tmgBgCurrentLabel').textContent = '';
      if($('tmgTo3')) $('tmgTo3').disabled = false;
    } else {
      S.selectedBg = null;
      if($('tmgUseAsIsCheck')) $('tmgUseAsIsCheck').textContent = '';
      if($('tmgUseAsIs')) $('tmgUseAsIs').style.background = 'var(--sf2)';
      if($('tmgBgToggle')) $('tmgBgToggle').style.display = 'flex';
      if($('tmgTo3')) $('tmgTo3').disabled = true;
    }
    // Re-render Step 2 mini preview to reflect new mode (stretch vs centred). The colour budget changed too
    // (a design that fills the mat has no separate background colour), so the artwork is re-quantised (5 Oct 2026).
    if (typeof refreshArtworkForBudget === 'function') refreshArtworkForBudget();
    else if(miniPreviewVisible()) {
      renderMiniCanvas('tmgStep2Canvas');
    }
  });
}

// "Remove background" button — calls remove.bg via Railway backend (toggles to undo)
const tmgRemoveWhite = $('tmgRemoveWhite');
if(tmgRemoveWhite) {
  tmgRemoveWhite.addEventListener('click', async () => {
    if(!S.file) return;
    if (transpLocalToggle()) return; // 14 Oct 2026: transparent already / white background: handled locally
    
    // If already removed, undo by restoring the original file
    if(S.bgRemoved && S.originalFile) {
      S.file = S.originalFile;
      S.bgRemoved = false;
      S.clientDetectedTransparency = false;
      cachedLogo = null;
      S.actualPmsUsed = []; // re-quantised from the restored file before anything reads it
      
      try { $('tmgThumb').src = URL.createObjectURL(S.file); } catch(e) {}
      
      if($('tmgRemoveWhiteCheck')) $('tmgRemoveWhiteCheck').textContent = '';
      tmgRemoveWhite.style.background = 'var(--sf2)';
      
      if($('tmgUseAsIsWrap')) $('tmgUseAsIsWrap').style.display = 'block';

      // Re-render the mini preview AND the colour swatches for the restored file
      showPmsNotice(S.validation);
      return;
    }
    
    if(!S.originalFile) S.originalFile = S.file;
    
    tmgRemoveWhite.disabled = true;
    tmgRemoveWhite.style.opacity = '0.5';
    if($('tmgRemoveWhiteCheck')) $('tmgRemoveWhiteCheck').textContent = 'Removing...';
    
    try {
      // Call Railway backend which proxies to remove.bg
      const fd = new FormData();
      fd.append('artwork', S.originalFile);
      
      const response = await fetch(API + '/remove-bg', {
        method: 'POST',
        body: fd,
      });
      
      if(!response.ok) {
        let errorMsg = 'Background removal failed.';
        try {
          const errData = await response.json();
          if(errData.error) errorMsg = errData.error;
        } catch(e) {}
        throw new Error(errorMsg);
      }
      
      // Get the transparent PNG blob from the response
      const blob = await response.blob();
      const newFile = new File([blob], 'artwork-bg-removed.png', { type: 'image/png' });
      
      S.file = newFile;
      S.bgRemoved = true;
      S.clientDetectedTransparency = true;
      cachedLogo = null;
      S.actualPmsUsed = []; // re-quantised from the background-removed file before anything reads it
      
      // Update preview thumbnail
      try { 
        const url = URL.createObjectURL(blob);
        $('tmgThumb').src = url;
      } catch(e) {}
      
      tmgRemoveWhite.disabled = false;
      tmgRemoveWhite.style.opacity = '1';
      if($('tmgRemoveWhiteCheck')) $('tmgRemoveWhiteCheck').textContent = '✓ Removed (click to undo)';
      tmgRemoveWhite.style.background = 'rgba(240,83,34,0.15)';
      
      if (S.useArtworkAsBg) { S.useArtworkAsBg = false; S.selectedBg = null; if($('tmgUseAsIsCheck')) $('tmgUseAsIsCheck').textContent = ''; if($('tmgUseAsIs')) $('tmgUseAsIs').style.background = 'var(--sf2)'; if($('tmgBgToggle')) $('tmgBgToggle').style.display = 'flex'; if($('tmgBgCollapsible')) $('tmgBgCollapsible').style.display = ''; if($('tmgTo3')) $('tmgTo3').disabled = true; }

      // Re-render the mini preview AND the colour swatches (the removed background colour drops out)
      showPmsNotice(S.validation);
    } catch(e) {
      console.warn('Background removal failed:', e);
      tmgRemoveWhite.disabled = false;
      tmgRemoveWhite.style.opacity = '1';
      if($('tmgRemoveWhiteCheck')) $('tmgRemoveWhiteCheck').textContent = '';
      alert(e.message || 'Background removal failed. Please try again or contact support.');
    }
  });
}


function updateBgLabel() {
  if(S.selectedBg && $('tmgBgCurrentLabel')) {
    const chartNum = mmRef(S.selectedBg.mm);
    const namePart = S.selectedBg.name.split('(')[0].trim();
    $('tmgBgCurrentLabel').textContent = '— ' + namePart; // ux1015b: no chart code on screen
  }
  if (typeof logoBgNote === 'function') logoBgNote();
}

$('tmgBack1').addEventListener('click',()=>{
  // Background -> Configure (5 Oct 2026). The analysis is kept; it re-runs if they come forward again.
  goTo(3);fetchPricing();
  if(S.file && $('tmgStep3Preview')){ $('tmgStep3Preview').style.display='block'; renderMiniCanvas('tmgStep3Canvas', true); }
});

// Background -> Preview
$('tmgTo3').addEventListener('click',()=>{ goTo(4); });

// Resolve the REAL Shopify variant for the chosen size (the exact one add-to-cart uses) so the configurator can
// quote the ACTUAL charged price (already on-sale via the 506 app), not the full /pricing table. Cached per session.
let _dyoProduct=null;
// 5 Oct 2026: the product carries a "Grade" option (Standard Grade / Commercial Grade / High Definition) with the
// real PrintPlush / High Def SKUs; the variant is matched on size AND grade. No fallback to another variant: a
// missing match returns null so the price shows "—" and add-to-cart refuses, never a wrong charge.
// GRADE_OPT_RE now lives in the v2 families module
async function getMatchedVariant(grade){
  try{
    const g = grade || S.grade || 'standard';
    if ((isCustomSize() || alwaysMint(g)) && customOf(g)) return customVariantFor(g);
    if(!_dyoProduct){ const pr=await fetch('/products/design-your-own-logo-mat.js'); _dyoProduct=await pr.json(); }
    const vs=(_dyoProduct&&_dyoProduct.variants)||[]; if(!vs.length) return null;
    const [sw,sh]=familySize(g).split('x'); // the size this family is made in (nearest to the chosen size)
    const a=(sw+'mm x '+sh+'mm').toLowerCase(), b=(sw+' x '+sh+'mm').toLowerCase();
    // option2 = the card's Grade value, with the colour folded in for families made per colour: "Superguard Inlay - Denim"
    const want3 = variantColour(g); const want2 = (GRADES[g].opt + (want3 ? ' - ' + want3 : '')).toLowerCase();
    const gm = v => v.option2 ? String(v.option2).toLowerCase() === want2 : (g==='standard');
    const cm = () => true;
    // Exact size title only: a loose match once let 1800x1800 match "1150mm x 1800mm" and under-charge. No match = no price, no add.
    const hit = vs.find(function(v){ if(!v.option1) return false; var o=v.option1.toLowerCase(); return (o===a||o===b)&&gm(v)&&cm(v); }) || null;
    if (!hit && customOf(g) && /^\d+x\d+$/.test(sw + 'x' + sh)) return customVariantFor(g); // size1020: no preset for this size/colour -> made to measure at the picked size
    return hit;
  }catch(e){ return null; }
}async function fetchPricing(){
  const[w,h]=S.size.split('x');
  try{
    let d={}; try { const r=await fetch(`${API}/pricing?width=${w}&height=${h}&qty=${S.qty}`); d=await r.json(); } catch(e) {} S.pricing=d;
    if($('tmgSizeDisplay')) $('tmgSizeDisplay').textContent = d.size_label || S.size.replace('x',' × ')+'mm';
    // Price shown = the REAL variant we add to cart (25%-off via the sale app), so the quote ALWAYS equals the
    // checkout charge and the sale is visible. /pricing is used only for the size label. The qty-break "discounts"
    // are not applied at checkout, so they are no longer displayed (quote==charge at every quantity).
    const mv = await getMatchedVariant();
    const unitFull = mv ? (Number(mv.price)/100) : (d.unit_price_aud||0);      // Shopify .js prices are in cents
    S.unitFull = unitFull;
    const pmsAdd = pmsSurcharge() + (typeof edgingSurcharge === 'function' ? edgingSurcharge() * S.qty : 0); renderPmsPriceRow(); if (typeof renderEdgePriceRow === 'function') renderEdgePriceRow();
    const grossTotal = unitFull*S.qty + pmsAdd; // Pantone matching is once per colour, not per mat
    const tierOff = typeof tierPctFor === 'function' ? tierPctFor(grossTotal, S.qty) : 0; // 13 Oct 2026: quantity ladder 2/3/5 mats = 5/10/15%, or the store's "Spend $600, 15% Off" - whichever the cart will apply (mats AND the PMS / edging lines)
    const unit = Math.round(unitFull * (100 - tierOff)) / 100;
    const full = (mv && Number(mv.compare_at_price)>Number(mv.price)) ? (Number(mv.compare_at_price)/100) : (tierOff ? unitFull : 0);
    const total = Math.round(grossTotal * (100 - tierOff)) / 100, fullTotal = full ? (full*S.qty + pmsAdd) : (tierOff ? grossTotal : 0);
    S.unitPrice = unit; S.totalPrice = total;
    if (typeof renderTierBox === 'function') renderTierBox();
    if (typeof lbPaintCentre === 'function' && typeof LB !== 'undefined' && LB.open) lbPaintCentre(); // the full-screen title carries the price
    const unitHtml = (full>unit ? '<s>'+fmt(full)+'</s> ' : '') + fmt(unit);
    const totalHtml = (fullTotal>total ? '<s>'+fmt(fullTotal)+'</s> ' : '') + fmt(total);
    if($('tmgPriceDisplay')) $('tmgPriceDisplay').innerHTML = unit ? unitHtml : '—';
    $('tmgPS').textContent=d.size_label||(S.size.replace('x',' × ')+'mm');
    $('tmgPU').innerHTML = unit ? unitHtml : '—';
    if($('tmgPG')) $('tmgPG').textContent = gradeOf().title;
    try { const sv = await getMatchedVariant('standard'); if($('tmgFromPrice')) $('tmgFromPrice').textContent = sv ? fmt(Number(sv.price)/100) : '—'; } catch(e) {}
    $('tmgPT').innerHTML = total ? totalHtml : '—';
    if (typeof renderPreviewPrice === 'function') renderPreviewPrice(); // the Preview step shows the price + edging choice
    $('tmgDR').style.display='none';
  }catch(e){console.warn(e);}
}

$('tmgQty').addEventListener('change',()=>{S.qty=parseInt($('tmgQty').value);fetchPricing();});

// When size or orientation changes — mark validation as stale so step 4 re-analyses
// Render a small PMS-adjusted canvas preview for steps 2 and 3
function miniPreviewVisible(){ const el = $('tmgStep2Preview'); if (!el || el.style.display === 'none') return false; if (S.step !== 2) { S._miniDirty = true; return false; } return true; } // 13 Oct 2026 perf: the hidden step-2 preview is repainted when the customer comes back to it
function renderMiniCanvas(canvasId, raw) {
  // raw = draw the artwork untouched (Configure step, before a grade is chosen) — High Definition is always raw
  if(!S.file) return;
  const canvas = $(canvasId);
  if(!canvas) return;
  canvas.style.display = 'block';

  const W = 480, H = 320;
  canvas.width = W; canvas.height = H;
  const ctx = canvas.getContext('2d', { willReadFrequently: true });

  loadSourceImage(S.file, img => {
    // Draw background
    const hv = S._edgeHover, savedEdging = S.edging; if (!raw && hv !== undefined) S.edging = hv; // hovering Edged / No edging previews it
    try {
    const edgePx = Math.round(W * (20 / 900)), ins = raw ? 0 : edgeInsetPx(W, edgePx);
    if(S.selectedBg) {
      if (raw) { ctx.fillStyle = surfaceFill(ctx, S.selectedBg.hex, (S.matWmm || 900) / 720); ctx.fillRect(0, 0, W, H); }
      else drawMatBg(ctx, W, H, S.selectedBg.hex, true, (S.matWmm || 900) / W); // v2: the family's edge band + surface, as the Preview step paints them
    }
    
    // ARTWORK-AS-BACKGROUND MODE: stretch artwork to fill entire mini canvas
    if(S.useArtworkAsBg) {
      const offscreen = document.createElement('canvas');
      offscreen.width = W - ins * 2; offscreen.height = H - ins * 2;
      const octx = offscreen.getContext('2d', { willReadFrequently: true });
      drawCover(octx, img, 0, 0, offscreen.width, offscreen.height); // cover-crop, never stretch; inside the edge band
      superSample(offscreen, (x, w, h) => drawCover(x, img, 0, 0, w, h), (offscreen, octx, W2, H2) => {
      if (!raw && !asSupplied()) { try { if (isCut() || isRaised() || dropBgNow()) { dropArtworkBackground(octx, W2, H2); dropDominantFill(octx, W2, H2, logoCap()); } quantiseImageToPMS(offscreen, octx, W2, H2); } catch(e) {} } else if (!raw && dropBgNow()) { try { dropArtworkBackground(octx, W2, H2); } catch(e) {} }
      }); // ux1014m
      ctx.drawImage(artCanvas(offscreen), ins, ins);
      if (!raw) { drawStudRelief(ctx, W, H, (S.matWmm || 900) / W); drawEdgeDim(ctx, W, H, (S.matWmm || 900) / W); } // Rubber Scraper studs + rim / Rubber Promotional weave, as the Preview step shows them; the edge width
      return;
    }
    
    // Scale and centre artwork
    let dw=img.width, dh=img.height;
    const mw=W*0.9, mh=H*0.9;
    if(dw>mw){dh=dh*(mw/dw);dw=mw;}
    if(dh>mh){dw=dw*(mh/dh);dh=mh;}
    const offscreen = document.createElement('canvas');
    offscreen.width = Math.round(dw); offscreen.height = Math.round(dh);
    const octx = offscreen.getContext('2d', { willReadFrequently: true });
    octx.drawImage(img, 0, 0, Math.round(dw), Math.round(dh));
    superSample(offscreen, (x, w, h) => x.drawImage(img, 0, 0, w, h), (offscreen, octx, W2, H2) => {
    if (!raw && !asSupplied()) { try { if (isCut() || isRaised() || dropBgNow()) { dropArtworkBackground(octx, W2, H2); dropDominantFill(octx, W2, H2, logoCap()); } quantiseImageToPMS(offscreen, octx, W2, H2); } catch(e) {} } else if (!raw && dropBgNow()) { try { dropArtworkBackground(octx, W2, H2); } catch(e) {} }
    }); // ux1014m
    ctx.drawImage(artCanvas(offscreen), Math.round((W-dw)/2), Math.round((H-dh)/2));
    if (!raw) { drawStudRelief(ctx, W, H, (S.matWmm || 900) / W); drawEdgeDim(ctx, W, H, (S.matWmm || 900) / W); } // Rubber Scraper studs + rim / Rubber Promotional weave, as the Preview step shows them; the edge width
    } finally { S.edging = savedEdging; }
  });
}

// Standard Grade ceiling helper: de-duplicate colour mappings by PMS hex (first-seen order) so the
// on-screen swatch lists show the SAME colours the cart records (parity) and never repeat a colour.
function dedupeColourMappings(arr) {
  const seen = new Set(); const out = [];
  for (const cm of (arr || [])) {
    const h = ((cm && cm.pms_hex) || '').toLowerCase();
    if (!h || seen.has(h)) continue;
    seen.add(h); out.push(cm);
  }
  return out;
}

// ── DESIGN PALETTE: single source of truth for the colours of a design ──
// The colours the customer approves are the ones IN the rendered preview. quantiseImageToPMS reduces
// the artwork to its <=12 most-used chart colours and remaps every pixel to them, recording that
// palette in S.actualPmsUsed (recordUsage pass on the full-resolution artwork). The step-2 swatches,
// the step-4 "Colour Mappings" legend and the cart "Design Colours" line ALL read this list, so what
// the customer sees, what they approve and what production receives are the same colours.
// The validate API's colour_mappings (a vision ESTIMATE of the original upload, which can name colours
// that are not in the artwork at all) and the AI generator's pms_colors (the palette it was ASKED for)
// are only fallbacks for when no render has happened.
function designPalette() {
  const seen = new Set(); const out = [];
  for (const c of (S.actualPmsUsed || [])) {
    const h = (c && c.hex || '').toLowerCase();
    if (!h || seen.has(h)) continue;
    if (S.bgFromLogo && !S.dropLogoBg && S.selectedBg && c.mm === S.selectedBg.mm && !S.useArtworkAsBg) continue; // the logo's own background prints as the mat background, not as a design colour
    seen.add(h); out.push({ mm: c.mm, hex: c.hex, name: c.name, share: c.share, raw: !!c.raw, pms: !!c.pms });
  }
  return out.slice(0, logoCap() || 12);
}
function paletteLabel(c) { return c.name; } // on screen: the name only (ux1015b: codes live behind the "Show colour names and codes" toggle)
function paletteLabelCode(c) { // order lines: name + chart code, what production reads
  const num = mmRef(c.mm);
  return num ? c.name + ' (' + num + ')' : c.name;
}

// ── PRINT CHECK: printability of the design at the chosen mat size, in real millimetres ──
// Uses assets/tmg-printcheck.js (window.TMGPrintCheck). Re-composites the CURRENT design (flat background +
// quantised logo at its placed size) on an offscreen canvas at 1 px = 1 mm, measures it against the PrintPlush
// guidelines (text >= 50mm, lines >= 10mm, spacing >= 5mm, no border) with a stricter "warn" tier that matches
// what production actually re-sets (text caps < 28mm or text strokes < 10mm; a colour that is mostly under 4mm),
// calibrated 2026-09-18 against 26 order/proof pairs + 71 approved proofs, lifted to 28/10 on 2026-09-24 from 49
// customer-file vs shipped-proof pairs (every file under those was adjusted), and shows a NON-BLOCKING banner that
// says we WILL adjust, never that we cannot print (Zac: never say no to a good order).
// Thresholds are absolute mm at the chosen mat size (the guideline applies to every size); the banner also names
// the next larger mat the design would pass at.
// The same summary is written to the cart as "Print Check" so production sees what the customer saw.
let printCheckTimer = null, _pcIdle = null, _pcToken = 0, _pcSig = null, _pcWaiters = [], _pcWorker;
// 13 Oct 2026 perf: the check (~0.5 s of pixel work) runs in a Web Worker on a copy of the composite, scheduled in idle time
// after a render, and only when something it reads has changed. The order line waits for it (flushPrintCheck), never the UI.
function printCheckSig(){ const f = S.file || {}, b = S.selectedBg || {}; return JSON.stringify([f.name, f.size, f.lastModified, S.grade, S.size, S.custom && S.custom.L, S.custom && S.custom.W, S.matWmm, S.matHmm, S.canvasW, S.canvasH, S.logoX, S.logoY, S.logoDw, S.logoDh, !!S.useArtworkAsBg, !!S.dropLogoBg, b.hex, S.colourOverrides, cachedLogo && cachedLogo.grade, S.placement, S.edging, S.drainage, !!S.genUsed]); }
function pcSettle(){ const w = _pcWaiters; _pcWaiters = []; w.forEach(r => { try { r(); } catch (e) {} }); }
function printCheckWorker(){
  if (_pcWorker !== undefined) return _pcWorker;
  _pcWorker = null;
  try {
    const tag = document.querySelector('script[src*="tmg-printcheck"]'); const src = tag && tag.src; if (!src || typeof Worker === 'undefined' || typeof Blob === 'undefined') return _pcWorker;
    const code = 'self.window=self;importScripts(' + JSON.stringify(src) + ');self.onmessage=function(e){var d=e.data;try{var rep=self.TMGPrintCheck.printCheck(d.rgba,d.w,d.h,d.k,d.opts);self.postMessage({id:d.id,rep:rep});}catch(err){self.postMessage({id:d.id,error:String(err&&err.message||err)});}};';
    const w = new Worker(URL.createObjectURL(new Blob([code], { type: 'application/javascript' })));
    w._jobs = {}; w._seq = 0;
    w.onmessage = e => { const j = w._jobs[e.data.id]; if (!j) return; delete w._jobs[e.data.id]; e.data.error ? j.reject(new Error(e.data.error)) : j.resolve(e.data.rep); };
    w.onerror = () => { const jobs = w._jobs; w._jobs = {}; for (const k in jobs) jobs[k].reject(new Error('print check worker error')); _pcWorker = null; try { w.terminate(); } catch (e) {} };
    _pcWorker = w;
  } catch (e) { _pcWorker = null; }
  return _pcWorker;
}
function printCheckAsync(rgba, w, h, k, opts){
  const wk = printCheckWorker();
  if (!wk) return new Promise((res, rej) => { try { res(window.TMGPrintCheck.printCheck(rgba, w, h, k, opts)); } catch (e) { rej(e); } });
  const id = ++wk._seq, copy = new Uint8ClampedArray(rgba);
  return new Promise((res, rej) => { wk._jobs[id] = { resolve: res, reject: rej }; wk.postMessage({ id, rgba: copy, w, h, k, opts }, [copy.buffer]); });
}
function schedulePrintCheck(){
  clearTimeout(printCheckTimer); if (_pcIdle && typeof cancelIdleCallback === 'function') { try { cancelIdleCallback(_pcIdle); } catch (e) {} } _pcIdle = null;
  printCheckTimer = setTimeout(() => { const go = () => { _pcIdle = null; flushPrintCheck(); }; if (typeof requestIdleCallback === 'function') _pcIdle = requestIdleCallback(go, { timeout: 1500 }); else go(); }, 300);
}
function flushPrintCheck(){ // resolves once S.printCheck matches the current state (or after 3 s: an order is never held up)
  const sig = printCheckSig();
  if (sig === _pcSig && !_pcWaiters.length) return Promise.resolve();
  const p = new Promise(res => _pcWaiters.push(res));
  if (sig !== _pcSig) { _pcSig = sig; runPrintCheck(); }
  return Promise.race([p, new Promise(res => setTimeout(res, 3000))]);
}
function colourNameForHex(hex) {
  const row = MM.find(m => m[1].toLowerCase() === (hex || '').toLowerCase());
  return row ? row[2].replace(/\s*\(PMS[^)]*\)/i, '') : (hex || 'a colour');
}
function summarisePrintCheck(rep) {
  const warn = rep.issues.filter(i => i.level === 'warn'), note = rep.issues.filter(i => i.level === 'note');
  const lines = [], cartWarn = [], cartNote = [];
  const wText = warn.filter(i => i.type === 'small-text'), nText = note.filter(i => i.type === 'small-text');
  const wThin = warn.filter(i => i.type === 'thin-stroke'), nThin = note.filter(i => i.type === 'thin-stroke');
  const nGap = note.filter(i => i.type === 'tight-spacing');
  const wSmall = wText.filter(t => t.reason === 'small' || t.reason === 'small+light'), wLight = wText.filter(t => t.reason === 'light');
  if (wSmall.length) {
    const h = Math.min(...wSmall.map(t => t.capMm || t.heightMm));
    lines.push(`Some text is only about ${h}mm tall. Our designers will enlarge it a little before printing so it reads clearly (we aim for ${(familyCheckOpts().textWarnMm || 28) > 28 ? familyCheckOpts().textWarnMm : 30}mm or more).`);
    cartWarn.push(`text ${h}mm tall (min ${familyCheckOpts().textWarnMm || 28})`);
  }
  if (wLight.length) {
    const sw = Math.min(...wLight.map(t => t.strokeMm));
    lines.push(`Some text has thin strokes (about ${sw}mm). Our designers will set it a touch bolder before printing (we aim for strokes of ${familyCheckOpts().strokeWarnMm >= 8 ? 8 : 10}mm or more).`);
    cartWarn.push(`text strokes ${sw}mm (min 10)`);
  }
  if (wThin.length) {
    const names = wThin.slice(0, 3).map(t => colourNameForHex(t.hex));
    lines.push(`Fine lines or thin strokes under ${wThin[0].minMm}mm in ${names.join(', ')}. Thin details can blur or disappear on the plush surface.`);
    wThin.forEach(t => cartWarn.push(`${colourNameForHex(t.hex)} lines under ${t.minMm}mm (${Math.round(t.share * 100)}% of that colour)`));
  }
  if (warn.some(i => i.type === 'border')) {
    lines.push('A border or frame line close to the edge of the mat. Printed borders can look uneven, so we recommend removing it.');
    cartWarn.push('border line at edge');
  }
  if (nText.length) cartNote.push(`text ${Math.min(...nText.map(t => t.capMm || t.heightMm))}mm (guideline 50)`);
  nThin.forEach(t => cartNote.push(`${colourNameForHex(t.hex)} under ${t.minMm}mm (${Math.round(t.share * 100)}%)`));
  if (nGap.length) cartNote.push(`gaps under ${nGap[0].minMm}mm`);
  const size = `${S.matWmm}x${S.matHmm}mm`;
  let summary;
  if (cartWarn.length) summary = `ADJUST BEFORE PRINT at ${size}: ${cartWarn.join('; ')}` + (cartNote.length ? ` | Notes: ${cartNote.join('; ')}` : '');
  else summary = cartNote.length ? `Passed at ${size} (notes: ${cartNote.join('; ')})` : `Passed at ${size}`;
  return { ok: !cartWarn.length, warnCount: warn.length, noteCount: note.length, lines, summary: summary.slice(0, 400), size,
    rects: wText.map(t => t.bbox) };
}
function runPrintCheck() {
  try {
    if (!window.TMGPrintCheck || !S.file || !cachedLogo || cachedLogo.fileRef !== S.file || S.logoDw == null || !S.matWmm) { _pcSig = null; pcSettle(); return; }
    if (typeof isHD === 'function' && asSupplied() && typeof isGradientArt === 'function' && isGradientArt(colourStatsNow())) {
      const sz = S.matWmm + 'x' + S.matHmm + 'mm'; const pc0 = resolutionCheck({ ok: true, lines: [], summary: 'Passed at ' + sz, size: sz, warnCount: 0, noteCount: 0, rects: [] });
      S.printCheck = pc0.ok ? null : pc0; const box = $('tmgPrintCheck'); if (box) box.innerHTML = ''; pcSettle(); return; // continuous tone: only the resolution is measurable
    }
    const W = S.canvasW, H = S.canvasH, mmPerPx = S.matWmm / W;
    const edgePx = Math.round(W * (20 / 900));
    const aw = Math.max(8, Math.round((W - 2 * edgePx) * mmPerPx)), ah = Math.max(8, Math.round((H - 2 * edgePx) * mmPerPx));
    const cv = document.createElement('canvas'); cv.width = aw; cv.height = ah;
    const ctx = cv.getContext('2d', { willReadFrequently: true });
    ctx.imageSmoothingEnabled = false;
    if (!S.useArtworkAsBg && S.selectedBg && S.selectedBg.hex) { ctx.fillStyle = S.selectedBg.hex; ctx.fillRect(0, 0, aw, ah); }
    ctx.drawImage(cachedLogo.canvas, (S.logoX - edgePx) * mmPerPx, (S.logoY - edgePx) * mmPerPx, S.logoDw * mmPerPx, S.logoDh * mmPerPx);
    const id = ctx.getImageData(0, 0, aw, ah);
    const token = ++_pcToken, opts = Object.assign({ checkBorder: !!S.useArtworkAsBg }, familyCheckOpts());
    printCheckAsync(id.data, aw, ah, 1, opts).then(rep => {
      if (token !== _pcToken) return; // a newer render superseded this one; that one settles the waiters
      const pc = resolutionCheck(summarisePrintCheck(rep));
      pc.overlay = rep.overlay; pc.ow = aw; pc.oh = ah; pc.edgePx = edgePx; pc.mmPerPx = mmPerPx; pc.ms = rep.ms;
      S.printCheck = pc;
      renderPrintCheckUI();
      if (S.showPrintOverlay) drawPrintOverlay();
      if (!pc.ok) schedulePassesAt(id.data, aw, ah); else pc.passesAt = null;
      pcSettle();
    }).catch(e => { console.warn('Print check failed:', e); if (token === _pcToken) { _pcSig = null; pcSettle(); } });
  } catch (e) { console.warn('Print check failed:', e); _pcSig = null; pcSettle(); }
}
// Which larger mat (same orientation) would this design pass at? Thresholds are absolute mm, so scaling the
// composite by k = the smaller of the width/height ratios is what choosing that mat does to the placed logo.
// Runs after the banner (each size is one more check, ~0.2-1 s), stops at the first pass, tries at most 3 sizes.
let passesAtToken = 0;
function schedulePassesAt(rgba, w, h) {
  const token = ++passesAtToken;
  const curW = S.matWmm, curH = S.matHmm, landscape = curW > curH, square = curW === curH;
  const cands = [];
  TMG_BASE_SIZES.forEach(b => {
    const [p, q] = b.split('x').map(Number), small = Math.min(p, q), large = Math.max(p, q);
    const W = square ? small : (landscape ? large : small), H = square ? small : (landscape ? small : large);
    if (small === large && !square) return; // squares only offered for square mats
    const k = Math.min(W / curW, H / curH);
    if (k > 1.05) cands.push({ W, H, k });
  });
  cands.sort((a, b) => a.k - b.k || a.W * a.H - b.W * b.H);
  for (let i = cands.length - 1; i > 0; i--) if (Math.abs(cands[i].k - cands[i - 1].k) < 0.02) cands.splice(i, 1); // same scale = same verdict, keep the smaller mat
  const tryNext = (i) => {
    if (token !== passesAtToken || !S.printCheck || S.printCheck.ok) return;
    if (i >= Math.min(3, cands.length)) { S.printCheck.passesAt = false; renderPrintCheckUI(); return; }
    const c = cands[i];
    printCheckAsync(rgba, w, h, c.k, Object.assign({ checkBorder: !!S.useArtworkAsBg }, familyCheckOpts())).then(rep => {
      if (token !== passesAtToken || !S.printCheck || S.printCheck.ok) return;
      if (rep.ok) { S.printCheck.passesAt = `${c.W} × ${c.H}mm`; renderPrintCheckUI(); return; }
      setTimeout(() => tryNext(i + 1), 50);
    }).catch(e => console.warn('passes-at check failed:', e));
  };
  setTimeout(() => tryNext(0), 250);
}
function renderPrintCheckUI() {
  const box = $('tmgPrintCheck'); const pc = S.printCheck;
  if (!box) return;
  // The print check is for the production team only: nothing is shown to the customer.
  box.style.display = 'none'; box.innerHTML = ''; return;
  if (!pc) { box.style.display = 'none'; return; }
  const sizeTxt = pc.size.replace('x', ' × ');
  if (!pc.ok) {
    box.innerHTML = `<div style="background:rgba(240,83,34,.06);border:1px solid rgba(240,83,34,.3);border-radius:8px;padding:12px 14px">
      <div style="font-size:14px;font-weight:700;color:var(--gold);margin-bottom:6px">✓ Good to go. Our designers will fine-tune a few details before printing at ${sizeTxt}</div>
      <ul style="margin:0 0 8px 18px;padding:0;font-size:12px;color:var(--txt);line-height:1.5">${pc.lines.map(l => `<li>${l}</li>`).join('')}</ul>
      <div style="font-size:12px;color:var(--txt);line-height:1.55;margin-bottom:8px">No action needed: add the mat to your cart as it is. Our team checks every design before printing and will make these small adjustments for you, or refund you if we cannot print it exactly like this.</div>
      <div style="font-size:11px;color:var(--muted);line-height:1.5;margin-bottom:8px">Tip: enlarge the logo with the size slider, choose a larger mat, or remove very small text and fine lines.${pc.passesAt ? ` <b style="color:var(--txt)">This design passes our print check at ${pc.passesAt} or larger.</b>` : ''}</div>
      <button type="button" id="tmgPrintOverlayBtn" style="background:transparent;border:1px solid var(--gold);color:var(--gold);font-size:11px;font-weight:600;padding:6px 10px;border-radius:5px;cursor:pointer">${S.showPrintOverlay ? 'Hide highlights' : 'Show on preview'}</button>
    </div>`;
    const btn = $('tmgPrintOverlayBtn');
    if (btn) btn.addEventListener('click', () => {
      S.showPrintOverlay = !S.showPrintOverlay;
      btn.textContent = S.showPrintOverlay ? 'Hide highlights' : 'Show on preview';
      if (S.showPrintOverlay) drawPrintOverlay(); else renderCanvas();
    });
  } else if (pc.noteCount) {
    box.innerHTML = `<div style="background:rgba(46,160,67,.07);border:1px solid rgba(46,160,67,.3);border-radius:8px;padding:10px 14px;font-size:12px;color:var(--txt);line-height:1.5"><b style="color:#2e8b47">✓ Print check passed at ${sizeTxt}.</b> A few fine details sit under our published guideline (lines 10mm, text 50mm); they normally print fine and our team will double-check them on your proof.</div>`;
  } else {
    box.innerHTML = `<div style="background:rgba(46,160,67,.07);border:1px solid rgba(46,160,67,.3);border-radius:8px;padding:10px 14px;font-size:12px;color:var(--txt);line-height:1.5"><b style="color:#2e8b47">✓ Print check passed at ${sizeTxt}.</b> Text, lines and spacing meet our PrintPlush guidelines at this size.</div>`;
  }
  box.style.display = 'block';
}
// Paint the parts that failed the warn tier in red on the 720px preview (thin strokes + boxes around small text)
function drawPrintOverlay() {
  const canvas = $('tmgCanvas'); const pc = S.printCheck;
  if (!canvas || !pc || !pc.overlay) return;
  const ctx = canvas.getContext('2d'); const W = canvas.width, H = canvas.height;
  const ov = document.createElement('canvas'); ov.width = pc.ow; ov.height = pc.oh;
  const octx = ov.getContext('2d'); const id = octx.createImageData(pc.ow, pc.oh);
  for (let i = 0; i < pc.ow * pc.oh; i++) if (pc.overlay[i]) { id.data[i * 4] = 255; id.data[i * 4 + 1] = 30; id.data[i * 4 + 2] = 30; id.data[i * 4 + 3] = 190; }
  octx.putImageData(id, 0, 0);
  ctx.save();
  ctx.drawImage(ov, pc.edgePx, pc.edgePx, W - 2 * pc.edgePx, H - 2 * pc.edgePx);
  ctx.strokeStyle = 'rgba(255,30,30,.95)'; ctx.lineWidth = 2;
  const s = 1 / pc.mmPerPx; // mm -> canvas px
  (pc.rects || []).forEach(r => ctx.strokeRect(pc.edgePx + r.x0 * s - 3, pc.edgePx + r.y0 * s - 3, (r.x1 - r.x0 + 1) * s + 6, (r.y1 - r.y0 + 1) * s + 6));
  ctx.restore();
}

// Load S.file at its native resolution, quantise it to the <=12 print palette (recording the palette
// in S.actualPmsUsed) and cache the result in cachedLogo. Shared by the step-2 swatches and the
// step-4 preview so both always describe the same pixels. onReady(canvas, w, h) runs once ready.
// The decoded upload, kept for the file's lifetime so the full-size pass and the mini previews decode it ONCE
// (7 Oct 2026: it was decoded from a fresh object URL on every pass). cb(img) runs once the bitmap is ready.
let _srcImg = null;
function loadSourceImage(fileRef, cb) {
  if (_srcImg && _srcImg.fileRef === fileRef && _srcImg.img.naturalWidth) { cb(_srcImg.img); return; }
  const img = new Image(); const url = URL.createObjectURL(fileRef);
  img.onload = () => { if (_srcImg && _srcImg.url !== url) { try { URL.revokeObjectURL(_srcImg.url); } catch (e) {} } _srcImg = { fileRef, img, url }; cb(img); };
  img.onerror = () => URL.revokeObjectURL(url);
  img.src = url;
}
let _qInflight = null; // { fileRef, grade, cbs }: one full-size pass at a time per file + grade
// 13 Oct 2026 perf: the finished full-resolution quantise (canvas + the palette / stats it recorded) is kept per file and
// rule set, so swiping back to a mat or background rule already seen is instant and pixel-identical.
const _quantCache = new WeakMap();
function quantKey(){ const g = gradeOf(), tr = k => !!(k && _tiles[k] && _tiles[k].ready); return JSON.stringify([S.grade, !!S.dropLogoBg, !!S.useArtworkAsBg, !!S.genUsed, S.genFamily || '', logoCap(), overridesKey(S.grade), tr(g.chart), tr(g.bgChart), g.inlayFlush ? coirTexReady() : 0, (g.cut || g.raised) && S.selectedBg && !S.useArtworkAsBg ? S.selectedBg.mm : '']); } // 14 Oct 2026: cut / embossed palettes leave out the base colour, so the base is part of the key // tile sheets arriving later change the pixels: part of the key
function quantCacheGet(f, k){ const m = f && _quantCache.get(f); return m ? m.get(k) : null; }
function quantCachePut(f, k, e){ if (!f) return; let m = _quantCache.get(f); if (!m) { m = new Map(); _quantCache.set(f, m); } if (m.size >= 8) m.delete(m.keys().next().value); m.set(k, e); }
// ux1015b: the visible pixels, not the file's box, are what gets centred and scaled. Uneven transparent margins (or the
// white background we drop) used to push logos off-centre. A 2% breathing margin is kept so strokes never touch the box.
function trimToContent(cv){
  try {
    const W = cv.width, H = cv.height; if (!W || !H) return cv;
    const d = cv.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, W, H).data;
    let x0 = W, y0 = H, x1 = -1, y1 = -1;
    for (let y = 0; y < H; y++) { const row = y * W * 4; for (let x = 0; x < W; x++) { if (d[row + x * 4 + 3] > 16) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } } }
    if (x1 < 0) return cv;
    const bw = x1 - x0 + 1, bh = y1 - y0 + 1;
    if (bw < 8 || bh < 8 || (x0 === 0 && y0 === 0 && bw === W && bh === H)) return cv;
    const pad = Math.round(Math.max(bw, bh) * 0.02);
    const sx = Math.max(0, x0 - pad), sy = Math.max(0, y0 - pad), sw = Math.min(W - sx, bw + 2 * pad), sh = Math.min(H - sy, bh + 2 * pad);
    if (sx === 0 && sy === 0 && sw === W && sh === H) return cv;
    const out = document.createElement('canvas'); out.width = sw; out.height = sh; out.getContext('2d').drawImage(cv, sx, sy, sw, sh, 0, 0, sw, sh);
    return out;
  } catch (e) { return cv; }
}
function ensureQuantisedLogo(onReady) {
  if (!S.file) return;
  if (cachedLogo && cachedLogo.fileRef === S.file && cachedLogo.grade === S.grade) { onReady(cachedLogo.canvas, cachedLogo.w, cachedLogo.h); return; }
  const fileRef = S.file, qk = quantKey();
  const hit = quantCacheGet(fileRef, qk);
  if (hit) { cachedLogo = hit.cached; S.actualPmsUsed = hit.actualPmsUsed; S.matchedMms = hit.matchedMms; S.colourStats = hit.colourStats; S.shaded = hit.shaded; onReady(hit.cached.canvas, hit.cached.w, hit.cached.h); return; }
  if (_qInflight && _qInflight.fileRef === fileRef && _qInflight.grade === S.grade) { _qInflight.cbs.push(onReady); return; } // same pass already running: wait for it
  const job = _qInflight = { fileRef, grade: S.grade, cbs: [onReady] };
  loadSourceImage(fileRef, img => {
    if (_qInflight === job) _qInflight = null;
    if (S.file !== fileRef) return; // a newer file replaced this one while it was loading
    // Quantise on the full original-size logo for best quality
    let offscreen = document.createElement('canvas');
    offscreen.width = img.width;
    offscreen.height = img.height;
    let octx = offscreen.getContext('2d', { willReadFrequently: true });
    octx.drawImage(img, 0, 0);

    // One read of the pixels for the corner check, the edge ring and (flat artwork) the matcher (7 Oct 2026)
    let fullRead = null; try { fullRead = octx.getImageData(0, 0, img.width, img.height); } catch(e) {}
    // Client-side transparency check — sample image corners for alpha < 200
    try {
      const sampleData = fullRead ? fullRead.data : octx.getImageData(0, 0, img.width, img.height).data;
      const corners = [
        [0,0], [img.width-1, 0], [0, img.height-1], [img.width-1, img.height-1],
        [Math.floor(img.width/2), 0], [Math.floor(img.width/2), img.height-1]
      ];
      let transparentCorners = 0;
      corners.forEach(([x,y]) => {
        const idx = (y * img.width + x) * 4;
        if(sampleData[idx+3] < 200) transparentCorners++;
      });
      // If 2+ corners are transparent, it's a logo with transparent background
      if(transparentCorners >= 2 && !S.clientDetectedTransparency) {
        S.clientDetectedTransparency = true;
        if($('tmgLogoControls')) $('tmgLogoControls').style.display = 'block';
      }
      readLogoBg(octx, img.width, img.height, fullRead && fullRead.data); // the logo's own background, for the default Background Colour
    } catch(e) {}

    try {
      const modified = isCut() || isRaised() || dropBgNow();
      if (modified) { dropArtworkBackground(octx, img.width, img.height); if (!asSupplied()) dropDominantFill(octx, img.width, img.height, logoCap()); } // 14 Oct 2026: as-supplied mats keep every colour
      if (!S.useArtworkAsBg) { const t = trimToContent(offscreen); if (t !== offscreen) { offscreen = t; octx = offscreen.getContext('2d', { willReadFrequently: true }); fullRead = null; } } // ux1015b: centre the visible logo
      // untouched canvas: the matcher works on the pixels already read; its single write goes to the real canvas
      const qctx = (!modified && fullRead) ? { getImageData: () => fullRead, putImageData: (id, x, y) => octx.putImageData(id, x, y) } : octx;
      quantiseImageToPMS(offscreen, qctx, offscreen.width, offscreen.height, true);
    } catch(e) {
      console.warn('Quantisation skipped:', e.message);
    }

    // Cache the quantised logo
    cachedLogo = { fileRef: fileRef, canvas: offscreen, w: offscreen.width, h: offscreen.height, grade: S.grade };
    if (qk === quantKey()) /* 14 Oct 2026: a pass whose rules changed meanwhile (the white rule) is not cached under the old key */ quantCachePut(fileRef, qk, { cached: cachedLogo, actualPmsUsed: S.actualPmsUsed, matchedMms: S.matchedMms, colourStats: S.colourStats, shaded: S.shaded });
    for (const cb of job.cbs) cb(offscreen, offscreen.width, offscreen.height);
  });
}

// Step-2 swatch list = the design palette (fallback: the validate API's mappings if no render yet)
// Edit pencil on every colour chip the customer can tap (Zac, 12 Oct 2026: a bare swatch did not read as changeable).
function chipEditCss(){ if ($('tmgChipEditCss')) return; const st = document.createElement('style'); st.id = 'tmgChipEditCss';
  st.textContent = '.tmg-chip-edit{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:50%;background:var(--gold);color:#fff;flex-shrink:0;margin-left:auto;padding-left:0}' +
    '.tmg-chip-edit svg{width:10px;height:10px;fill:none;stroke:currentColor;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round;display:block}' +
    '.tmg-chip-pick:hover .tmg-chip-edit{background:var(--gold2)}' +
    '.tmg-mapitem.tmg-chip-pick{padding-right:5px}.tmg-mapitem .tmg-chip-edit{width:16px;height:16px;margin-left:4px}.tmg-mapitem .tmg-chip-edit svg{width:9px;height:9px}';
  document.head.appendChild(st); }
function chipEditBadge(c){ if (!c || !c.mm || asSupplied()) return ''; chipEditCss(); return '<span class="tmg-chip-edit" aria-hidden="true" title="Change this colour"><svg viewBox="0 0 24 24"><path d="M17 3a2.83 2.83 0 1 1 4 4L7.5 21.5 2 23l1.5-5.5Z"/></svg></span>'; }
function renderPaletteSwatches(container, palette) {
  container.innerHTML = '';
  palette.forEach(c => {
    const swHex = (c.hex || '').toUpperCase();
    const swatch = document.createElement('div'); if (c.mm) { swatch.dataset.mm = c.mm; swatch.className = 'tmg-chip-pick'; swatch.title = 'Print this colour as a different chart colour'; }
    swatch.style.cssText = 'display:flex;align-items:center;gap:8px;background:var(--sf);border:1px solid var(--bd);border-radius:6px;padding:5px 9px;font-size:11px';
    swatch.innerHTML = `<div style="width:24px;height:24px;border-radius:3px;${swatchCss(c.mm, c.hex)}box-shadow:inset 0 0 0 1px rgba(0,0,0,.18);flex-shrink:0"></div><div style="display:flex;flex-direction:column;line-height:1.35"><span style="color:var(--txt);font-weight:600">${paletteLabel(c)}</span><span style="color:var(--muted);font-size:10px">${swHex}${c.share != null ? ' · ' + c.share + '%' : ''}</span></div>${chipEditBadge(c)}`;
    container.appendChild(swatch);
  });
}

// Show PMS colour swatches and notice after validation
function showPmsNotice(validation) {
  // The Step 2 artwork preview should ALWAYS show when there's a file — independent
  // of whether there are colour mappings to display in the notice.
  if (S.file && $('tmgStep2Preview')) {
    $('tmgStep2Preview').style.display = 'block';
    if (S.step === 2) renderMiniCanvas('tmgStep2Canvas'); else S._miniDirty = true;
  }
  
  // For AI-generated designs, colours were chosen from the PMS chart at generation time —
  // no adjustment needed, hide the notice (but the preview above still shows)
  if (S.genUsed && !S.genFamily) { // legacy generated design (no mat chosen): colours were picked at generation time
    const notice = $('tmgPmsNotice');
    if (notice) notice.style.display = 'none';
    return;
  }
  const notice = $('tmgPmsNotice');
  const swatchContainer = $('tmgPmsSwatches');
  if(!notice || !swatchContainer) return;
  // High Definition: nothing is adjusted, the artwork prints as supplied (5 Oct 2026)
  const s2lbl = $('tmgStep2Preview') ? $('tmgStep2Preview').querySelector('.tmg-slbl') : null;
  if (s2lbl) s2lbl.textContent = s2LabelText();
  if (asSupplied()) {
    notice.style.display = 'none';
    ensureQuantisedLogo(() => { if (typeof renderGradeCards === 'function') renderGradeCards(); });
    return;
  }

  // PRIMARY: the colours actually in the rendered artwork (same quantise pass the preview uses).
  // The swatches appear as soon as the full-res quantisation finishes (cached after the first run).
  const fileAtCall = S.file;
  ensureQuantisedLogo(() => {
    if (S.file !== fileAtCall || (S.genUsed && !S.genFamily)) return; // a generated design for a chosen mat is checked like an upload
    if (typeof renderGradeCards === 'function') renderGradeCards(); // stats are ready now
    const pal = designPalette();
    if (!pal.length) return;
    renderPaletteSwatches(swatchContainer, pal);
    notice.style.display = 'block';
    bindColourPick();
  });
  if (cachedLogo && cachedLogo.fileRef === S.file && designPalette().length) return; // already shown synchronously above

  // FALLBACK (only until the render palette exists): the validate API's colour estimate.
  if(!validation || !validation.colour_mappings || !validation.colour_mappings.length) return;

  swatchContainer.innerHTML = '';
  // Standard Grade ceiling: de-dupe by PMS hex (so a colour never shows twice and the list matches
  // the cart exactly), then show only the 12 print colours.
  dedupeColourMappings(validation.colour_mappings).slice(0, logoCap()).forEach(cm => {
    // Look up the chart number from MM array by hex match
    const matchedMM = MM.find(c => c[1].toLowerCase() === (cm.pms_hex || '').toLowerCase());
    const chartNum = matchedMM ? matchedMM[0].replace(/^MM/, '') : '';
    const pmsLabel = cm.pms_name + (chartNum ? ' (' + chartNum + ')' : '');
    const swatch = document.createElement('div');
    const swHex = (cm.pms_hex || '').toUpperCase();
    swatch.style.cssText = 'display:flex;align-items:center;gap:8px;background:var(--sf);border:1px solid var(--bd);border-radius:6px;padding:5px 9px;font-size:11px';
    swatch.innerHTML = `<div style="width:24px;height:24px;border-radius:3px;background:${cm.pms_hex};box-shadow:inset 0 0 0 1px rgba(0,0,0,.18);flex-shrink:0"></div><div style="display:flex;flex-direction:column;line-height:1.35"><span style="color:var(--txt);font-weight:600">${pmsLabel}</span><span style="color:var(--muted);font-size:10px">${cm.role}${swHex ? ' • ' + swHex : ''}</span></div>`;
    swatchContainer.appendChild(swatch);
  });
  notice.style.display = 'block';
}

function validationKey(){ return [S.file && (S.file.name + ':' + S.file.size + ':' + S.file.lastModified), S.size, $('tmgOri') ? $('tmgOri').value : 'landscape'].join('|'); }
async function reAnalyse() {
  if(!S.file) return;
  // 7 Oct 2026: the Background step's answer is for this same file, size and orientation - reuse it (10 s saved)
  if (S.validation && S.validationKey === validationKey()) return;
  S.validation = null;
  try {
    const fd = new FormData();
    fd.append('artwork', S.file);
    fd.append('notes', $('tmgNotes') ? $('tmgNotes').value : '');
    fd.append('size', S.size);
    fd.append('orientation', $('tmgOri') ? $('tmgOri').value : 'landscape');
    fd.append('floor_type', $('tmgFloor') ? $('tmgFloor').value : 'unknown');
    const res = await fetch(`${API}/validate`, { method:'POST', body:fd });
    const data = await res.json();
    if(data.success && data.validation) { S.validation = data.validation; S.validationKey = validationKey(); }
  } catch(e) { console.warn('Re-analyse failed', e); }
}

// Full re-analyse and render — used when arriving at step 4 from any direction
async function reAnalyseAndRender() {
  // Clear old results and show spinner immediately
  const cr = $('tmgCR');
  const cvwrap = $('tmgCVW');
  if(cr) cr.innerHTML = '';

  // Show analysing spinner over the canvas area
  if(cvwrap) {
    // Hide canvas/prompt but preserve arrow elements
    const canvas = $('tmgCanvas');
    const cvp = $('tmgCVP');
    if(canvas) canvas.style.display = 'none';
    if(cvp) cvp.style.display = 'none';
    // Append spinner without wiping innerHTML
    let spinner = $('tmgAnalysingSpinner');
    if(!spinner) {
      spinner = document.createElement('div');
      spinner.id = 'tmgAnalysingSpinner';
      spinner.style.cssText = 'text-align:center;padding:40px;color:var(--muted);width:100%';
      spinner.innerHTML = `
        <div class="tmg-spin" style="margin:0 auto 12px"></div>
        <div style="font-size:13px;font-weight:600;color:var(--txt);margin-bottom:4px">Building your mat preview...</div>
        <div style="font-size:11px">Laying your design onto the mat and running the print check</div>`;
      cvwrap.appendChild(spinner);
    } else {
      spinner.style.display = 'block';
    }
  }

  // 7 Oct 2026: draw the mat NOW; the artwork check (reused when nothing changed, else ~10 s) settles alongside and
  // the text-size minimum is applied when it lands. Add to Cart opens only when both are done (previewReadyGate).
  const gate = previewReadyGate();
  const spinner = $('tmgAnalysingSpinner');
  if(spinner) spinner.style.display = 'none';
  renderResults();
  if (typeof enforceLogoScaleMinimum === 'function') enforceLogoScaleMinimum();
  setTimeout(() => renderCanvas(), 50);
  await reAnalyse();
  renderResults();
  if (typeof enforceLogoScaleMinimum === 'function') enforceLogoScaleMinimum();
  gate.checked();
}
// Add to Cart stays disabled until the mat is drawn and the artwork check has settled (7 Oct 2026). drawn() is
// called by the render, checked() when the check lands; a newer gate replaces an older one.
let _gateSeq = 0;
function previewReadyGate(){
  const seq = ++_gateSeq, st = { drawn: false, checked: false };
  const btn = $('tmgTo5'); if (btn) { btn.disabled = true; btn.dataset.gate = '1'; }
  const open = () => { if (seq !== _gateSeq) return; if (st.drawn && st.checked) { S.previewReady = true; if (btn && btn.dataset.gate) { delete btn.dataset.gate; btn.disabled = false; } } };
  S.previewReady = false; S._gate = { drawn: () => { st.drawn = true; open(); }, checked: () => { st.checked = true; open(); } };
  setTimeout(() => { st.drawn = true; st.checked = true; open(); }, 25000); // never leave the customer locked out: after 25 s the button opens whatever happened
  return S._gate;
}

// size1029: a typed custom size turns with the mat (length is left to right), so the preview, 'Orientation' and 'Custom size' agree
function onOriChanged(){
  if (isCustomSize()) {
    const L = S.custom.L, W = S.custom.W, ori = $('tmgOri');
    if (ori && L !== W && (W > L) !== (ori.value === 'portrait')) {
      if ($('tmgCustL')) $('tmgCustL').value = W; if ($('tmgCustW')) $('tmgCustW').value = L;
      setCustomDims(W, L); syncSizeSelect(); customDiagram(); fetchPricing(); renderGradeCards();
    }
  } else if ($('tmgSize').value !== 'custom') S.size=$('tmgSize').value;
  reAnalyse();
}
if($('tmgOri')) $('tmgOri').addEventListener('change', onOriChanged);
// Size picker is now in step 2 — listen for changes there
document.querySelectorAll('#tmgSize').forEach(el => {
  el.addEventListener('change', ()=>{ if (el.value === 'custom') return; S.custom = null; setPickSize(el.value); onGradeChanged(); fetchPricing(); renderGradeCards(); if(S.step===4) reAnalyse(); }); // v2: snap to a size the family makes; custom sizes come from the fields below
});
$('tmgBack2').addEventListener('click',()=>{
  // Configure -> Upload (5 Oct 2026): clear the analysis so it runs fresh when they come forward again
  S.validation=null;
  if (!(S.genFamily && GRADES[S.genFamily] && GRADES[S.genFamily].bgSeparate)) S.selectedBg=null; // a generated design keeps the base colour chosen with its mat
  if($('tmgSelDisp'))$('tmgSelDisp').classList.remove('vis');
  if($('tmgLW'))$('tmgLW').classList.remove('vis');
  if($('tmgTo3'))$('tmgTo3').disabled=true;
  if($('tmgPmsNotice'))$('tmgPmsNotice').style.display='none';
  if($('tmgStep2Preview'))$('tmgStep2Preview').style.display='none';
  document.querySelectorAll('.tmg-sw').forEach(s=>s.classList.remove('sel'));
  goTo(1);
});


function goTo(n){
  S.step=n;
  try { dsOnStep(n); } catch(e) {} // draft1021: remember the design in progress
  document.querySelectorAll('.tmg-panel').forEach(p=>p.classList.toggle('active',+p.dataset.p===n));
  // 5 Oct 2026: panels keep their numbers but the customer walks them as Upload(1) -> Configure(3) -> Background(2) -> Preview(4) -> Order(5)
  const STEP_ORDER=[1,3,2,4,5], pos=STEP_ORDER.indexOf(n);
  document.querySelectorAll('.tmg-step').forEach(s=>{const sn=+s.dataset.s, sp=STEP_ORDER.indexOf(sn);s.classList.toggle('active',sp===pos);s.classList.toggle('done',sp<pos);});
  // Every time customer reaches preview step — re-analyse and re-render
  // (For AI-gen mode, useArtworkAsBg is set instead of selectedBg)
  if (n === 2) { if (S._cardsDirty) { S._cardsDirty = false; renderGradeCards(); } if (S._miniDirty) { S._miniDirty = false; if (S.file && $('tmgStep2Canvas')) renderMiniCanvas('tmgStep2Canvas'); } } // 13 Oct 2026 perf: catch up on what was skipped while hidden
  if(n===4 && typeof renderPreviewPrice === 'function') renderPreviewPrice();
  if(n===4) { try { tmgEmailMeMount(); } catch(e) {} } // dyo-emailme: email yourself this design (Klaviyo)
  if(n===4 && $('tmgLogoControls') && S.useArtworkAsBg) $('tmgLogoControls').style.display = 'none'; // a design that fills the mat has no logo size to adjust (Zac 6 Oct: the slider did nothing)
  if(n===4 && $('tmgPmsBanner')) { $('tmgPmsBanner').style.display = asSupplied() ? 'none' : ''; const bt = $('tmgPmsBanner').querySelector('span'); if (bt) bt.textContent = bannerText(); }
  if(n===4 && S.file) { mintEarly(); artworkUploadFor(S.file); if (S.sourceFile && !S.sourceUrl && S.sourceFile.size <= CLOUD_MAX_BYTES) cloudinaryUpload(S.sourceFile).then(d => { S.sourceUrl = d.secure_url; }).catch(() => {}); } // artwork (and the original vector) upload starts now, not on the click
  if(n===4 && S.file && (S.selectedBg || S.useArtworkAsBg)) {
    if (S.genUsed) {
      // AI-gen: skip Claude re-analysis (we already know everything from generation step)
      // Just render the canvas directly
      const cr = $('tmgCR');
      if(cr) cr.innerHTML = '';
      const gate = previewReadyGate(); gate.checked();
      renderCanvas();
    } else {
      reAnalyseAndRender();
    }
    // Set the logo-scale minimum based on whether the design contains text
    // (runs on entry to Step 4, not just when the Adjust panel is opened)
    if (typeof enforceLogoScaleMinimum === 'function') enforceLogoScaleMinimum();
    // Show size arrows
    const [sw, sh] = S.size.split('x').map(Number);
    const ori = $('tmgOri') ? $('tmgOri').value : 'landscape';
    // Match the canvas orientation logic — landscape is always wider than tall, portrait taller than wide
    let matW = sw, matH = sh;
    if (ori === 'portrait' && sw > sh) { matW = sh; matH = sw; }
    if (ori === 'landscape' && sh > sw) { matW = sh; matH = sw; }
    if($('tmgArrowW')) $('tmgArrowW').textContent = matW + 'mm';
    if($('tmgArrowH')) $('tmgArrowH').textContent = matH + 'mm';
    // Arrows shown after canvas renders (in img.onload)
    // Trigger UploadLift to scan for widget after step is visible
    setTimeout(()=>{
      // Initialise UploadLift widget using window.Cloudlift.upload
      if(window.Cloudlift && window.Cloudlift.upload) {
        try {
          const cl = window.Cloudlift.upload;
          if(cl.init) cl.init();
          else if(cl.scan) cl.scan();
          else if(cl.render) cl.render();
          else if(cl.mount) cl.mount();
          else if(cl.start) cl.start();
          // Log available methods for debugging
          console.log('Cloudlift.upload methods:', Object.keys(cl));
        } catch(e) { console.warn('Cloudlift init error:', e); }
      }
    }, 500);
  }
  // Ensure Preview button starts disabled if no floor type
  if(n===3) checkFloorType();
}

// Floor type optional
function checkFloorType() { $('tmgTo4').disabled = false; }

// Step 3 → 4
// (tmgTo4 = Configure -> Background, wired next to the upload handler)

function renderResults(){
  const v=S.validation;
  const cr=$('tmgCR');
  if(!cr)return;
  if (asSupplied()) { // High Definition: no colour mapping, the artwork prints as supplied (5 Oct 2026)
    if (cr.dataset.sig === 'hd') return; cr.dataset.sig = 'hd';
    cr.innerHTML = '<div class="tmg-slbl">Colours</div><div style="font-size:13px;color:var(--txt);line-height:1.6">Printed in full colour' + (isHD() ? ' (High Definition)' : '') + ', exactly as supplied. No chart matching.</div>';
    return;
  }
  // PRIMARY: the colours in the rendered preview (designPalette) — identical to the cart line.
  const pal = designPalette();
  if (pal.length) {
    const sig = 'pal:' + pal.map(c => c.hex).join(',');
    if (cr.dataset.sig === sig) return; // unchanged — skip the DOM rebuild (renderCanvas redraws often)
    cr.dataset.sig = sig;
    cr.innerHTML='';
    const lbl=document.createElement('div');lbl.className='tmg-slbl';lbl.textContent=asSupplied() ? 'Colours in your artwork (printed as supplied)' : 'Colour Mappings';cr.appendChild(lbl);
    const list=document.createElement('div');list.className='tmg-maplist';
    pal.forEach(c=>{
      const item=document.createElement('div');item.className='tmg-mapitem tmg-chip-pick';if(c.mm){item.dataset.mm=c.mm;item.title='Print this colour as a different chart colour';}
      const mapHex=(c.hex||'').toUpperCase();
      item.innerHTML=`<div class="tmg-mapdot" style="${swatchCss(c.mm, c.hex)}"></div><span>${paletteLabel(c)}</span><span style="color:var(--muted);font-size:10px;margin-left:3px">${mapHex}${c.share != null ? ' · ' + c.share + '%' : ''}</span>${chipEditBadge(c)}`;
      list.appendChild(item);
    });
    cr.appendChild(list);
    return;
  }
  cr.dataset.sig = '';
  cr.innerHTML='';
  // FALLBACK (no render palette yet): the validate API's colour estimate — no alerts
  if(v && v.colour_mappings && v.colour_mappings.length){
    const lbl=document.createElement('div');lbl.className='tmg-slbl';lbl.textContent=asSupplied() ? 'Colours in your artwork (printed as supplied)' : 'Colour Mappings';cr.appendChild(lbl);
    const list=document.createElement('div');list.className='tmg-maplist';
    // Standard Grade ceiling: de-dupe by PMS hex (parity with the cart), then list only the 12 print colours.
    dedupeColourMappings(v.colour_mappings).slice(0, logoCap()).forEach(cm=>{
      const matchedMM = MM.find(c => c[1].toLowerCase() === (cm.pms_hex || '').toLowerCase());
      const chartNum = matchedMM ? matchedMM[0].replace(/^MM/, '') : '';
      const pmsLabel = cm.pms_name + (chartNum ? ' (' + chartNum + ')' : '');
      const item=document.createElement('div');item.className='tmg-mapitem';
      const mapHex=(cm.pms_hex||'').toUpperCase();
      item.innerHTML=`<div class="tmg-mapdot" style="background:${cm.pms_hex}"></div><span>${pmsLabel}</span><span style="color:var(--muted);font-size:10px;margin-left:3px">${cm.role}${mapHex ? ' • ' + mapHex : ''}</span>`;
      list.appendChild(item);
    });
    cr.appendChild(list);
  }
}

function drawMatBg(ctx, W, H, hex, flat, mmPerPxIn) {
  // 20mm edge band, proportional to canvas width (real mat ~900mm wide, 720px canvas). The band's look and the
  // surface inside it come from the family (v2): nitrile / bevel / vinyl / raised / thin / none, plush / fibre / loop /
  // yarn / coir / flock / rubber / felt, drawn at the real physical scale when mmPerPx is known.
  const edgePx = Math.round(W * (20 / 900));
  const mmPerPx = mmPerPxIn || ((S.matWmm || parseInt((S.size || '850x1150').split('x')[0], 10)) / W);
  drawEdge(ctx, W, H, edgePx);
  const ins = edgeInsetPx(W, edgePx);
  const ix = ins, iy = ins, iw = W - ins * 2, ih = H - ins * 2;
  ctx.fillStyle = surfaceFill(ctx, hex, mmPerPx);
  ctx.fillRect(ix, iy, iw, ih);
  // Carpet grain on plush only (skipped for the hi-res proof: flat colour compresses 50x smaller)
  if (flat || gradeOf().surface !== 'plush') return;
  try{
    const id=ctx.getImageData(ix,iy,iw,ih);const d=id.data;
    for(let i=0;i<d.length;i+=4){
      const n=(Math.random()-.5)*14;
      d[i]=Math.min(255,Math.max(0,d[i]+n));
      d[i+1]=Math.min(255,Math.max(0,d[i+1]+n));
      d[i+2]=Math.min(255,Math.max(0,d[i+2]+n));
    }
    ctx.putImageData(id,ix,iy);
  }catch(e){}
}
// Cache for the loaded + quantised logo so dragging is fast
let cachedLogo = null;

// === High-resolution preview builder ===
// The on-screen #tmgCanvas stays at 720px so dragging/resizing stay smooth. For the
// saved order proof ("Mat Preview") and the Expand lightbox we re-composite the SAME
// design at much higher resolution from stored state. This touches NOTHING in the
// colour/PMS path: it only redraws the already-quantised cached logo (kept at full
// original resolution) onto a larger mat, so swatches/Design Colours are unaffected.
const HIRES_MAX_W = 3000;        // hard width cap (tunable)
const HIRES_MAX_AREA = 12000000; // stay safely under mobile canvas pixel limits (~16.7M)

// ── Proof encoding off the main thread (5 Oct 2026) ──
const PROOF_MAX_BYTES = 9.5 * 1024 * 1024;   // Cloudinary unsigned upload limit is 10 MB
let _proofWorker = null;
function proofWorker() {
  if (_proofWorker) return _proofWorker;
  try {
    const src = "self.onmessage=async e=>{const {id,bmp,type,quality}=e.data;try{const oc=new OffscreenCanvas(bmp.width,bmp.height);oc.getContext('2d').drawImage(bmp,0,0);bmp.close();const blob=await oc.convertToBlob(quality!=null?{type,quality}:{type});self.postMessage({id,blob});}catch(err){self.postMessage({id,error:String(err&&err.message||err)});}};";
    _proofWorker = new Worker(URL.createObjectURL(new Blob([src], { type: 'application/javascript' })));
    _proofWorker._jobs = {}; _proofWorker._seq = 0;
    _proofWorker.onmessage = e => { const j = _proofWorker._jobs[e.data.id]; if (!j) return; delete _proofWorker._jobs[e.data.id]; e.data.error ? j.reject(new Error(e.data.error)) : j.resolve(e.data.blob); };
    _proofWorker.onerror = () => { for (const k in _proofWorker._jobs) { _proofWorker._jobs[k].reject(new Error('worker error')); } _proofWorker._jobs = {}; };
  } catch (e) { _proofWorker = null; }
  return _proofWorker;
}
// Encode a canvas to a Blob without freezing the page: ImageBitmap -> Worker/OffscreenCanvas. Falls back to toBlob.
async function proofEncode(cv, type, quality) {
  const canWorker = typeof OffscreenCanvas !== 'undefined' && OffscreenCanvas.prototype && typeof OffscreenCanvas.prototype.convertToBlob === 'function' && typeof createImageBitmap === 'function';
  if (canWorker) {
    try {
      const w = proofWorker();
      if (w) {
        const bmp = await createImageBitmap(cv);
        const id = ++w._seq;
        const blob = await new Promise((resolve, reject) => { w._jobs[id] = { resolve, reject }; w.postMessage({ id, bmp, type, quality }, [bmp]); });
        if (blob) return blob;
      }
    } catch (e) { console.warn('[TMG] worker encode failed, falling back:', e && e.message); }
  }
  return new Promise(r => { try { cv.toBlob(r, type, quality); } catch (e) { r(null); } });
}
// What the proof depends on: a change to any of these invalidates a prepared proof.
function proofSignature() {
  const f = S.file || {};
  return JSON.stringify([f.name, f.size, f.lastModified, S.size, $('tmgOri') ? $('tmgOri').value : '', S.grade, S.selectedBg && S.selectedBg.hex, !!S.useArtworkAsBg, S.drainage, S.edging, S.custom && S.custom.L, S.custom && S.custom.W, S.placement, S.logoX, S.logoY, S.logoDw, S.logoDh, S.logoScale]);
}
// Build + encode the proof for the current state. HD = JPEG (continuous tone); PrintPlush = PNG, JPEG if the PNG is too big.
async function buildProofBlob() {
  const hiCanvas = buildHiResPreviewCanvas();
  if (!hiCanvas) return null;
  const t0 = performance.now(), done = (b, name) => { console.info('[TMG] proof ' + name + ' ' + (b ? b.size : 0) + ' bytes, ' + hiCanvas.width + 'x' + hiCanvas.height + ', encoded in ' + Math.round(performance.now() - t0) + ' ms'); return b ? { blob: b, name } : null; };
  if (asSupplied() || gradeOf().tiled || gradeOf().surface === 'coir') { const b = await proofEncode(hiCanvas, 'image/jpeg', 0.92); return done(b, 'mat-preview-' + gradeOf().key + '.jpg'); }
  let b = await proofEncode(hiCanvas, 'image/png');
  if (b && b.size <= PROOF_MAX_BYTES) return done(b, 'mat-preview-pms.png');
  console.warn('[TMG] PNG proof ' + (b ? b.size : 0) + ' bytes, over the upload limit: encoding as JPEG instead');
  b = await proofEncode(hiCanvas, 'image/jpeg', 0.95);
  return done(b, 'mat-preview-pms.jpg');
}
let _proofTimer = null, _proofPrepared = null; // { sig, promise }
// The prepared proof is uploaded in the background too (7 Oct 2026), 2.5 s after it is ready and only if it is still the
// current one, so Add to Cart has nothing left to send. { sig, promise -> url or '' }
let _proofUpload = null, _proofUploadTimer = null;
function scheduleProofUpload(sig, r) {
  clearTimeout(_proofUploadTimer);
  if (!r || !r.blob || r.blob.size > PROOF_MAX_BYTES) return;
  _proofUploadTimer = setTimeout(() => {
    if (S.step !== 4 || !S.file || proofSignature() !== sig) return; // something changed: the next prepared proof gets its own upload
    if (_proofUpload && _proofUpload.sig === sig) return;
    const file = new File([r.blob], r.name, { type: r.blob.type || 'image/png' });
    _proofUpload = { sig, promise: uploadArtworkToShopify(file).then(u => u || '').catch(() => '') };
  }, 2500);
}
function scheduleProof() {
  clearTimeout(_proofTimer);
  _proofTimer = setTimeout(() => {
    if (S.step !== 4 || !S.file) return;
    const sig = proofSignature();
    if (_proofPrepared && _proofPrepared.sig === sig) return;
    const promise = buildProofBlob().catch(e => { console.warn('[TMG] proof prepare failed', e); return null; });
    _proofPrepared = { sig, promise };
    promise.then(r => { if (_proofPrepared && _proofPrepared.sig === sig) scheduleProofUpload(sig, r); });
  }, 700);
}
// The prepared proof if it still matches the current state, otherwise build it now.
async function getProofBlob() {
  const sig = proofSignature();
  if (_proofPrepared && _proofPrepared.sig === sig) { const r = await _proofPrepared.promise; if (r) return r; }
  const r = await buildProofBlob();
  _proofPrepared = { sig, promise: Promise.resolve(r) };
  return r;
}
// The original artwork goes to Cloudinary once per file, started when the preview step opens.
let _artworkUpload = null; // { file, promise }
function artworkUploadFor(file) {
  if (!file) return Promise.resolve('');
  if (_artworkUpload && _artworkUpload.file === file) return _artworkUpload.promise;
  _artworkUpload = { file, promise: uploadArtworkToShopify(file).then(u => u || '').catch(() => '') };
  return _artworkUpload.promise;
}
function buildHiResPreviewCanvas(maxW){
  try {
    if(!S.file) return null;
    if(!cachedLogo || cachedLogo.fileRef !== S.file || !cachedLogo.canvas) return null;
    if(!S.useArtworkAsBg && !(S.selectedBg && S.selectedBg.hex)) return null;

    // Same mat dimensions / orientation logic as renderCanvas()
    const [sw, sh] = S.size.split('x').map(Number);
    const orientation = $('tmgOri') ? $('tmgOri').value : 'landscape';
    let matW = sw, matH = sh;
    if (orientation === 'portrait'  && sw > sh) { matW = sh; matH = sw; }
    if (orientation === 'landscape' && sh > sw) { matW = sh; matH = sw; }

    // Target ~150 DPI of the real mat; never below the on-screen 720px, capped for safety
    const cap = maxW || HIRES_MAX_W;
    const targetW = Math.round((matW / 25.4) * 150);
    let W = Math.max(720, Math.min(targetW, cap));
    const ratio = matH / matW;
    let H = Math.round(W * ratio);
    if (W * H > HIRES_MAX_AREA) {              // guard mobile canvas area limits
      const f = Math.sqrt(HIRES_MAX_AREA / (W * H));
      W = Math.round(W * f); H = Math.round(W * ratio);
    }
    const scale = W / 720;                     // stored logo coords live in 720px space

    const cv = document.createElement('canvas');
    cv.width = W; cv.height = H;
    const ctx = cv.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    if ('imageSmoothingQuality' in ctx) ctx.imageSmoothingQuality = 'high';

    // Background: drawMatBg is fully proportional to W, so it scales cleanly
    if (S.selectedBg && S.selectedBg.hex && !S.useArtworkAsBg) {
      drawMatBg(ctx, W, H, S.selectedBg.hex, true, matW / W); // flat grain; textured families draw their real surface at scale
    } else {
      ctx.fillStyle = '#2a2a2a';
      ctx.fillRect(0, 0, W, H);
    }

    // Logo / artwork: cachedLogo.canvas holds it at full original resolution
    if (S.useArtworkAsBg) {
      const edgePx = Math.round(W * (20 / 900));
      drawCover(ctx, artCanvas(cachedLogo.canvas), edgePx, edgePx, W - edgePx*2, H - edgePx*2); // cover-crop, never stretch
    } else if (S.logoX != null && S.logoY != null && S.logoDw != null) {
      ctx.drawImage(artCanvas(cachedLogo.canvas),
        Math.round(S.logoX*scale), Math.round(S.logoY*scale),
        Math.round(S.logoDw*scale), Math.round(S.logoDh*scale));
    } else {
      return null;
    }
    if (drainageOn()) { const e = Math.round(W * (20 / 900)); drawDrainageHoles(ctx, e, e, W - 2 * e, H - 2 * e, matW / W); }
    drawStudRelief(ctx, W, H, matW / W);
    return cv;
  } catch(e) {
    console.warn('Hi-res preview build failed:', e);
    return null;
  }
}

function renderCanvas(){
  // Need a file. We need EITHER a selectedBg colour OR useArtworkAsBg mode (AI-gen / "design fills mat")
  if(!S.file) return;
  if(!S.selectedBg && !S.useArtworkAsBg) return;
  // Hide arrows and expand button until canvas finishes
  if($('tmgWidthArrow')) $('tmgWidthArrow').style.display = 'none';
  if($('tmgHeightArrow')) $('tmgHeightArrow').style.display = 'none';
  if($('tmgExpandBtn')) $('tmgExpandBtn').style.display = 'none';
  if($('tmgDownloadBtn')) $('tmgDownloadBtn').style.display = 'none';
  const wrap=$('tmgCVW');let canvas=$('tmgCanvas');
  if(!canvas){
    if(wrap) wrap.innerHTML='<canvas id="tmgCanvas" style="display:none"></canvas>';
    canvas=$('tmgCanvas');
  }
  if(!canvas)return;
  const cvp=$('tmgCVP');if(cvp)cvp.style.display='none';
  canvas.style.display='block';

  // Calculate canvas dimensions based on selected size and orientation
  const [sw, sh] = S.size.split('x').map(Number);
  const orientation = $('tmgOri') ? $('tmgOri').value : 'landscape';
  let matW = sw, matH = sh;
  if (orientation === 'portrait' && sw > sh) { matW = sh; matH = sw; }
  if (orientation === 'landscape' && sh > sw) { matW = sh; matH = sw; }

  // Scale to canvas — max width 720px
  const maxW = 720;
  const ratio = matH / matW;
  const W = maxW;
  const H = Math.round(W * ratio);
  canvas.width=W;canvas.height=H;
  // Real-world scale of this render, used by the print check (1 canvas px = matW/W mm)
  S.matWmm = matW; S.matHmm = matH; S.canvasW = W; S.canvasH = H;
  const ctx=canvas.getContext('2d');

  // Detect transparent background from validation OR file extension as a fallback
  const isPNG = S.file && /\.png$/i.test(S.file.name);
  const isTransparent = logoAdjustable();
  if($('tmgLogoControls')) {
    $('tmgLogoControls').style.display = isTransparent ? 'block' : 'none';
  }

  // Step 1: Draw background — solid colour from selectedBg, or skip if artwork covers the mat
  if (S.selectedBg && S.selectedBg.hex && !S.useArtworkAsBg) {
    drawMatBg(ctx, W, H, S.selectedBg.hex);
  } else {
    // Fill with neutral grey behind in case artwork has any transparency
    ctx.fillStyle = '#2a2a2a';
    ctx.fillRect(0, 0, W, H);
  }

  // Helper to draw the logo at current position/scale and finalise
  function drawLogoAndFinish(logoCanvas, logoW, logoH) {
    const edgePx = Math.round(W * (20 / 900));
    
    // Safe zone — inside the black edge with extra 50mm safety margin
    const safeMm = gradeOf().safeMm; // per family, real mm in from the rubber edge (validation-rules-from-team.md: printed 25, inlay/embossed 40, promotional 30, Rubber Scraper 100)
    const safetyPx = safeMm ? Math.round(safeMm / ((S.matWmm || 900) / W)) : Math.round(W * (50 / 900));
    const safeX = edgePx + safetyPx;
    const safeY = edgePx + safetyPx;
    const safeW = W - (edgePx + safetyPx) * 2;
    const safeH = H - (edgePx + safetyPx) * 2;

    // ARTWORK-AS-BACKGROUND MODE: stretch to fill full mat area (inside black edge, no safety margin)
    // The customer's artwork IS the mat design, so we want edge-to-edge fill regardless of aspect ratio
    if(S.useArtworkAsBg) {
      const innerX = edgePx;
      const innerY = edgePx;
      const innerW = W - edgePx * 2;
      const innerH = H - edgePx * 2;
      drawCover(ctx, artCanvas(logoCanvas), innerX, innerY, innerW, innerH); // cover-crop, never stretch
      
      S.logoX = innerX;
      S.logoY = innerY;
      S.logoDw = innerW;
      S.logoDh = innerH;
      
      if (drainageOn()) { const eH = Math.round(W * (20 / 900)); drawDrainageHoles(ctx, eH, eH, W - 2 * eH, H - 2 * eH, (S.matWmm || 900) / W); }
      drawStudRelief(ctx, W, H, (S.matWmm || 900) / W);
      try{S.previewUrl=canvas.toDataURL('image/png');}catch(e){}
      drawEdgeDim(ctx, W, H, (S.matWmm || 900) / W); // the edge width, on screen only (Zac, 12 Oct 2026)
      if (S._gate) S._gate.drawn();
      if (typeof lbAfterRender === 'function') lbAfterRender();
      if($('tmgExpandBtn')) $('tmgExpandBtn').style.display = 'inline-flex'; if($('tmgDownloadBtn')) $('tmgDownloadBtn').style.display = 'inline-flex';
      if($('tmgWidthArrow')) $('tmgWidthArrow').style.display = 'block';
      if($('tmgHeightArrow')) { $('tmgHeightArrow').style.display = 'flex'; alignHeightArrow(); }
      return;
    }

    // Calculate scale: % of safe zone the logo should fill
    const scalePct = (S.logoScale != null ? S.logoScale : 80) / 100;
    let logoScale = scalePct;
    // Fit logo into safe zone at scaled size
    let dw = logoW, dh = logoH;
    const maxDw = safeW * scalePct;
    const maxDh = safeH * scalePct;
    if(dw > maxDw) { dh = dh * (maxDw / dw); dw = maxDw; }
    if(dh > maxDh) { dw = dw * (maxDh / dh); dh = maxDh; }
    dw = Math.round(dw); dh = Math.round(dh);

    // Position: default centre, or use stored offset
    let dx, dy;
    if(S.logoKeepCentre) { dx = Math.round(S.logoKeepCentre[0] - dw / 2); dy = Math.round(S.logoKeepCentre[1] - dh / 2); S.logoKeepCentre = null; } // ux1015b: same centre at the new size
    else if(S.logoX != null && S.logoY != null) {
      dx = S.logoX;
      dy = S.logoY;
    } else {
      dx = Math.round((W - dw) / 2);
      dy = Math.round((H - dh) / 2);
    }

    // Constrain to safe zone
    dx = Math.max(safeX, Math.min(safeX + safeW - dw, dx));
    dy = Math.max(safeY, Math.min(safeY + safeH - dh, dy));

    // Save constrained position so future renders use the clamped value
    S.logoX = dx;
    S.logoY = dy;
    S.logoDw = dw;
    S.logoDh = dh;

    ctx.drawImage(artCanvas(logoCanvas), dx, dy, dw, dh);

    if (drainageOn()) { const eH = Math.round(W * (20 / 900)); drawDrainageHoles(ctx, eH, eH, W - 2 * eH, H - 2 * eH, (S.matWmm || 900) / W); }
    drawStudRelief(ctx, W, H, (S.matWmm || 900) / W);
      try{S.previewUrl=canvas.toDataURL('image/png');}catch(e){}
      drawEdgeDim(ctx, W, H, (S.matWmm || 900) / W); // the edge width, on screen only (Zac, 12 Oct 2026)
    if (S._gate) S._gate.drawn();
    if (typeof lbAfterRender === 'function') lbAfterRender();
    if($('tmgExpandBtn')) $('tmgExpandBtn').style.display = 'inline-flex'; if($('tmgDownloadBtn')) $('tmgDownloadBtn').style.display = 'inline-flex';
    if($('tmgWidthArrow')) $('tmgWidthArrow').style.display = 'block';
    if($('tmgHeightArrow')) { $('tmgHeightArrow').style.display = 'flex'; alignHeightArrow(); }
  }

  // Cached quantised logo = instant redraw (drag/resize); otherwise load + quantise at native size,
  // which also records the design palette (S.actualPmsUsed) that the legend and cart read.
  ensureQuantisedLogo((logoCanvas, logoW, logoH) => {
    drawLogoAndFinish(logoCanvas, logoW, logoH);
    // Keep the step-4 "Colour Mappings" legend in step with the pixels just drawn
    try { renderResults(); } catch(e) {}
    try { renderLegends(); } catch(e) {}
    // Re-measure printability for this placement / scale / mat size (debounced: drag redraws often)
    schedulePrintCheck();
    // Encode the hi-res proof now, in the background, so Add to Cart only has to upload it (5 Oct 2026)
    scheduleProof();
  });
}

$('tmgBack3').addEventListener('click',()=>{
  if (S.genUsed && S.genFamily) { goTo(3); return; } // generated design: back to floor type + notes, never to a mat change
  // Reset logo position/scale when leaving preview
  S.logoX = null;
  S.logoY = null;
  S.logoScale = 80;
  S.adjustMode = false;
  if($('tmgLogoSize')) $('tmgLogoSize').value = 80;
  if($('tmgLogoSizeLabel')) $('tmgLogoSizeLabel').textContent = '80%';
  if($('tmgAdjustSwitch')) { $('tmgAdjustSwitch').style.background = '#333'; }
  if($('tmgAdjustKnob')) { $('tmgAdjustKnob').style.left = '2px'; }
  if($('tmgAdjustPanel')) { $('tmgAdjustPanel').style.display = 'none'; }
  // Preview -> Background (5 Oct 2026): colours, grade and background are all on that step
  goTo(2);
  if(S.file && S.validation) showPmsNotice(S.validation);
  renderGradeCards();
});

// UploadLift handles artwork file upload

// Step 4 → 5
// Upload artwork file to Cloudinary and return permanent URL
async function uploadArtworkToShopify(file) {
  try {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', 'mat config');
    fd.append('folder', 'mat-configurator');

    const res = await fetch('https://api.cloudinary.com/v1_1/dmqkxg0qo/auto/upload', {
      method: 'POST',
      body: fd,
    });

    const data = await res.json();
    console.log('[TMG Cloudinary] Status:', res.status, 'Response:', data);
    if(data.secure_url) {
      console.log('[TMG Cloudinary] Artwork uploaded:', data.secure_url);
      return data.secure_url;
    }
    console.error('[TMG Cloudinary] Upload returned no URL. Error:', data.error?.message || JSON.stringify(data));
    throw new Error(data.error?.message || 'Upload failed');
  } catch(e) {
    console.error('[TMG Cloudinary] Upload exception:', e.message, e);
    return null;
  }
}

$('tmgTo5').addEventListener('click', async () => {
  const bg=S.selectedBg, p=S.pricing, v=S.validation;
  const floorType=$('tmgFloor')?$('tmgFloor').value:'';


  $('tmgTo5').disabled=true;
  $('tmgTo5').textContent='Uploading artwork...';
  const sizeFix = syncLineSize(); // size1029: the proof, print check and 'Mat Size' are taken at the size the line is priced and made at

  try {
    // Step 1: the original artwork upload was started when the preview opened; just await it (5 Oct 2026)
    let fileUrl = '';
    if(S.file) {
      fileUrl = await artworkUrlForOrder(); // the original vector / document when there is one
    }

    // Step 2: Upload PMS-adjusted canvas rendition to Cloudinary.
    // Build a HIGH-RESOLUTION proof from stored state (the on-screen canvas is only
    // 720px wide for smooth dragging). Falls back to the 720px preview if the hi-res
    // build is unavailable, so this can never be worse than before.
    // Cloudinary's unsigned upload limit is 10 MB (10485760 bytes). A 12M-pixel portrait proof with the
    // carpet-noise background can encode past that (order TMG12437: 13.0 MB), and the failed upload was
    // swallowed, leaving the order with an EMPTY Mat Preview. So: build the hi-res proof, and if the PNG
    // is over the limit rebuild it smaller until it fits; if the hi-res path still fails for any reason,
    // upload the 720px on-screen preview rather than nothing.
    let previewUrl = '';
    try {
      // 5 Oct 2026: the proof was encoded in the background while the customer looked at the preview (getProofBlob
      // rebuilds it only if something changed in the last moment). HD = JPEG, PrintPlush = PNG (JPEG if over the limit).
      const sigNow = proofSignature();
      const proof = await getProofBlob();
      if(proof && proof.blob && proof.blob.size <= PROOF_MAX_BYTES) {
        clearTimeout(_proofUploadTimer);
        if (_proofUpload && _proofUpload.sig === sigNow) previewUrl = await _proofUpload.promise; // uploaded in the background while the customer looked at the preview
        if (!previewUrl) { const previewFile = new File([proof.blob], proof.name, { type: proof.blob.type || 'image/png' }); previewUrl = await uploadArtworkToShopify(previewFile) || ''; }
      }
      if(!previewUrl && S.previewUrl) {
        // Fallback: the 720px on-screen preview (also covers a failed hi-res upload, so an order never loses its proof)
        const res = await fetch(S.previewUrl);
        const fallbackBlob = await res.blob();
        previewUrl = await uploadArtworkToShopify(new File([fallbackBlob], 'mat-preview-pms.png', { type: 'image/png' })) || '';
      }
    } catch(e) { console.warn('Preview upload failed:', e); }

    $('tmgTo5').textContent='Adding to cart...';

    // Step 2: Add to cart with all specs as line item properties.
    //
    // Design Colours = the COLOURS THE CUSTOMER WANTS, i.e. the validated/approved
    // palette they were shown on screen — NOT a raw pixel re-quantisation, which
    // tangles genuine design colours with mat-texture/anti-alias grain and can
    // bury or fragment intended colours. Priority:
    //   1. AI-generated artwork -> the generated palette (S.genPmsColors)
    //   2. Uploaded artwork     -> the validated swatch list (colour_mappings) =
    //                              the exact list rendered in the on-screen swatches
    //   3. Fallback             -> de-noised pixel quantiser (S.actualPmsUsed)
    // Each source is de-duplicated by PMS so one colour is never listed twice, then HARD-CAPPED
    // to 12 — Standard Grade prints at most 12 spot colours, so the cart line can never list more
    // (matches the <=12 the artwork was reduced to and the swatches the customer was shown).
    let colourMapping = '';
    const MAX_DESIGN_COLOURS = gradeCap(); // Standard Grade ceiling: a PrintPlush mat prints at most 12 spot colours

    // chart number (M&A code) for a hex, via the MM palette
    const chartNumForHex = (hex) => {
      const row = MM.find(m => m[1].toLowerCase() === (hex || '').toLowerCase());
      return row ? row[0].replace(/^MM/, '') : '';
    };
    // de-dupe a list by lower-cased hex, preserving first-seen order
    const dedupeByHex = (arr, hexOf) => {
      const seen = new Set(); const out = [];
      for (const x of arr) {
        const h = (hexOf(x) || '').toLowerCase();
        if (!h || seen.has(h)) continue;
        seen.add(h); out.push(x);
      }
      return out;
    };

    // Source 0 (PRIMARY for EVERY design, uploaded or AI-generated): the colours IN the rendered
    // preview the customer approved. quantiseImageToPMS remapped every pixel of the artwork to this
    // <=12 palette, so the Mat Preview / Artwork File contain exactly these chart colours and nothing
    // else. (The validate API's mappings and the AI generator's palette are estimates and can name
    // colours that never appear in the picture — e.g. order TMG12326 listed Hot Pink + Bright Green
    // for a black/purple/off-white logo — so they are fallbacks only.)
    if (!colourMapping) {
      colourMapping = colourReport(); // most coverage first, with the share
    }

    // Source 1 (fallback for AI-generated artwork): the palette the generator was asked for.
    if (!colourMapping && S.genUsed && S.genPmsColors && S.genPmsColors.length) {
      colourMapping = dedupeByHex(S.genPmsColors, c => c.hex || c.pms_hex)
        .slice(0, MAX_DESIGN_COLOURS).map(c => {
          const name = c.name || c.pms_name || c.pms || c.description || c.hex || 'colour';
          const num = mmRef(c.mm || c.mm_code) || chartNumForHex(c.hex || c.pms_hex);
          return num ? `${name} (${num})` : name;
        }).join(', ');
    }

    // Source 2 (PRIMARY for uploaded artwork): the validated swatch palette the customer saw + approved.
    // Use the SAME hex->MM chart lookup the on-screen swatches use (tmgPmsSwatches), so the cart
    // line item matches exactly what the customer was shown — the API's mm_code can differ from the
    // front-end chart (e.g. Off-White hex #F5F0E8 -> chart MM447, but API mm_code MM140).
    if (!colourMapping && v && v.colour_mappings && v.colour_mappings.length) {
      colourMapping = dedupeByHex(v.colour_mappings, c => c.pms_hex)
        .slice(0, MAX_DESIGN_COLOURS).map(c => {
          const name = c.pms_name || c.name || c.description || c.pms_hex || 'colour';
          const num = mmRef('MM' + chartNumForHex(c.pms_hex)) || mmRef(c.mm_code || c.mm);
          return num ? `${name} (${num})` : name;
        }).join(', ');
    }

    // Source 3 (FALLBACK): de-noised pixel quantiser — only when no approved palette is available.
    if (!colourMapping && S.actualPmsUsed && S.actualPmsUsed.length) {
      const usedSet = new Set(S.actualPmsUsed.map(c => c.mm));
      let combined = [...S.actualPmsUsed];
      // The chosen background is itself a printed colour: give it the first of the 12 slots and fill
      // the rest with the most-prominent design colours, so the total stays within the 12 budget.
      if (!S.useArtworkAsBg && bg && bg.mm && !usedSet.has(bg.mm)) {
        const mmRow = MM.find(m => m[0] === bg.mm);
        if (mmRow) combined = [{ mm: bg.mm, hex: mmRow[1], name: mmRow[2] }, ...combined.slice(0, MAX_DESIGN_COLOURS - 1)];
      }
      colourMapping = combined.slice(0, MAX_DESIGN_COLOURS).map(c => {
        const chartNum = mmRef(c.mm);
        return chartNum ? `${c.name} (${chartNum})` : c.name;
      }).join(', ');
    }

    // Source 4: Just the selected background (last-resort fallback so cart isn't empty)
    if (!colourMapping && bg && bg.name) {
      const mm = mmRef(bg.mm);
      colourMapping = mm ? `${bg.name} (${mm})` : bg.name;
    }
    
    // Source 5: If everything failed but we have a file, flag it for the proofing team
    if (!colourMapping) {
      colourMapping = 'Pending — our team will confirm PMS colours from your artwork';
    }

    const props = {
      'Mat Size':          S.size.replace('x',' × ')+'mm',
      'Orientation':       $('tmgOri')?$('tmgOri').value:'landscape',
      'Design Colours':    colourMapping,
      'Floor Type':        floorType==='hard_floor'?'Hard Floor':floorType==='carpeted'?'Carpeted Floor':'',

      'Notes':             $('tmgNotes')?$('tmgNotes').value:'',
      'Artwork File':      fileUrl,
      'Mat Preview':       previewUrl,
      'Configurator':      'Yes',
    };
    // 2026-10-26, Zac (Preeti could not use the JPG/SVG files): the reps always get a PNG as 'Artwork File',
    // rendered by Cloudinary from the same upload (SVG at 4000px wide); the untouched original stays on the order too.
    var artExt = (fileUrl.match(/\.(svg|jpe?g|webp|gif|bmp|avif)(\?|$)/i) || [])[1];
    if (artExt && /res\.cloudinary\.com\/[^/]+\/image\/upload\//.test(fileUrl)) {
      props['Artwork original (' + artExt.toUpperCase() + ')'] = fileUrl;
      var png = fileUrl.replace(/\.(svg|jpe?g|webp|gif|bmp|avif)(\?.*)?$/i, '.png');
      props['Artwork File'] = /svg/i.test(artExt) ? png.replace(/\/image\/upload\/(?!w_)/, '/image/upload/w_4000/') : png;
    }
    
    // Flag AI-generated designs for the proofing team
    if(S.genUsed) {
      props['AI Generated'] = 'Yes';
      if($('tmgGenPrompt')?.value) props['Customer Description'] = $('tmgGenPrompt').value.trim();
    }
    
    // Only include Background Colour if NOT using artwork as full background
    if(!S.useArtworkAsBg && bg && bg.name) {
      const chartNum = mmRef(bg.mm);
      props['Background Colour'] = bg.name + (chartNum ? ' (' + chartNum + ')' : '');
    }
    // A see-through logo sent "as-is" sits on the dark fill the preview paints behind it. That fill is what the customer
    // saw and approved, so the order line says so (TMG12598, 7 Oct 2026: no background on the line, proofed on the wrong colour).
    else if (S.useArtworkAsBg && !S.genUsed && ((S.validation && S.validation.has_transparent_background) || S.clientDetectedTransparency)) {
      props['Background Colour'] = 'Black (108) - shown behind a see-through logo sent as-is, the customer did not pick it';
    }

    // Match the variant via the same resolver the price quote uses, so the charged variant == the quoted one.
    let variantId = 0;
    try { const mv = await getMatchedVariant(); if(mv && mv.custom) { const m = await mintCustomVariant(); if (m) { variantId = m.id; props['SKU'] = m.sku || 'custom'; props['_configured_price'] = String(m.configured != null ? m.configured : (m.price / 100)); const md = mintDims(S.grade); if (isCustomSize()) props['Custom size'] = customSizeLabel(); props['Size'] = md.L + 'mm x ' + md.W + 'mm'; } } else if(mv) { variantId = mv.id; if (mv.sku) props['SKU'] = mv.sku; } }
    catch(e) { console.warn('Variant fetch failed', e); if (e && e.message === 'VARIANT_NOT_READY') { alert('Almost there - your custom size is still being prepared. Please click Add to Cart again in a few seconds.'); $('tmgTo5').textContent='Add to Cart →'; return; } }
    try { await flushPrintCheck(); } catch (e) {} // the check runs off-thread after a swipe: the line carries the current one
    if (S.printCheck && S.printCheck.summary) props['_Print Check'] = S.printCheck.summary;
    trailProps(props); // hidden audit fields: who set the background / grade / colours
    if (sizeFix) props['_Size check'] = sizeFix; // size1029: only when the guard had to redraw the preview
    familyCartProps(props); // v2: Placement, Drainage holes, Edging, Base Mat Colour, Colour Quantity, as-supplied wording
    if(!variantId) { alert('Could not find matching product variant. Please call 1800 300 311.'); return; }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartPayload(variantId, props)) // + one PMS colour match line per matched colour
    });

    if(res.ok) {
      // Step 3: Show success and prompt to checkout
      $('tmgOS').textContent = S.size.replace('x',' × ')+'mm';
      $('tmgOB').textContent = bg?bg.name:'—';
      if($('tmgOG')) $('tmgOG').textContent = gradeOf().title;
      $('tmgOQ').textContent = S.qty+' mat'+(S.qty>1?'s':'');
      $('tmgOT').textContent = (S.totalPrice!=null)?fmt(S.totalPrice):(p?fmt(p.total_price_aud):'—');
      goTo(5);
      try { dsClear(); } catch(e) {} // draft1021: in the cart now, nothing to continue
    } else {
      const err = await res.json();
      alert(err.description || 'Could not add to cart. Please try again or call 1800 300 311.');
      $('tmgTo5').textContent='Add to Cart →';
    }
  } catch(e) {
    console.error(e);
    alert('Could not add to cart. Please try again or call 1800 300 311.');
    $('tmgTo5').textContent='Add to Cart →';
  }
}); 

// ── Logo adjust mode (transparent backgrounds only) ──
S.adjustMode = false;

const tmgAdjustToggle = $('tmgAdjustToggle');
if(tmgAdjustToggle) {
  tmgAdjustToggle.addEventListener('click', () => {
    S.adjustMode = !S.adjustMode; setTimeout(alignHeightArrow, 0); // ux1015b: the panel changes the column height
    const sw = $('tmgAdjustSwitch');
    const kn = $('tmgAdjustKnob');
    const panel = $('tmgAdjustPanel');
    if(S.adjustMode) {
      sw.style.background = 'var(--gold)';
      kn.style.left = '20px';
      panel.style.display = 'block';
      enforceLogoScaleMinimum();
    } else {
      sw.style.background = '#333';
      kn.style.left = '2px';
      panel.style.display = 'none';
    }
  });
}
 
// Enforce a minimum logo scale when the design contains text — based on PrintPlush
// gold-standard: text must stay large enough to print clearly (≥50mm). Scaling a
// text-containing logo too small drops the text below the printable threshold.
function enforceLogoScaleMinimum() {
  const slider = $('tmgLogoSize');
  if (!slider) return;
  // Don't interfere while the user is actively dragging the slider
  if (S.sliderActive) return;
  
  // Does the current design contain text?
  // AI-gen designs with overlay text always do.
  const aiHasText = S.genUsed && S.genOverlayText && (S.genOverlayText.main || '').trim().length >= 2;
  
  // Uploaded designs: check multiple signals from Claude validation
  let uploadHasText = false;
  if (!S.genUsed && S.validation) {
    const v = S.validation;
    // Direct flags
    if (v.contains_text === true || v.has_small_text === true) uploadHasText = true;
    // Colour mappings that mention text/logo roles
    if (Array.isArray(v.colour_mappings)) {
      if (v.colour_mappings.some(cm => /text|word|letter|writing|logo/i.test((cm.role||'') + ' ' + (cm.original_description||'')))) {
        uploadHasText = true;
      }
    }
    // Warnings/suggestions/brief that mention text or legibility
    const textBlob = [
      ...(v.warnings||[]),
      ...(v.suggestions||[]),
      v.design_brief || ''
    ].join(' ').toLowerCase();
    if (/\btext\b|\bletter|\bword|legib|readable|font|typeface|small text|wording/.test(textBlob)) {
      uploadHasText = true;
    }
  }
  
  const hasText = aiHasText || uploadHasText;
  
  const MIN_WITH_TEXT = 50;
  const MIN_NO_TEXT = 20;
  const minScale = hasText ? MIN_WITH_TEXT : MIN_NO_TEXT;
  
  slider.min = minScale;
  if (parseInt(slider.value) < minScale) {
    slider.value = minScale;
    S.logoScale = minScale;
    if ($('tmgLogoSizeLabel')) $('tmgLogoSizeLabel').textContent = minScale + '%';
    S.logoX = null; S.logoY = null;
    renderCanvas();
  }
  
  // Show/hide the text-minimum note
  let note = $('tmgScaleTextNote');
  if (hasText) {
    if (!note) {
      note = document.createElement('div');
      note.id = 'tmgScaleTextNote';
      note.style.cssText = 'font-size:11px;color:var(--muted);margin-top:8px;line-height:1.4;padding:8px 10px;background:rgba(240,83,34,.06);border-radius:6px';
      note.textContent = '🔒 Your design contains text, so the minimum size is limited to keep the text large enough to print clearly.';
      const panel = $('tmgAdjustPanel');
      if (panel) panel.appendChild(note);
    }
    note.style.display = 'block';
  } else if (note) {
    note.style.display = 'none';
  }
}

// ── Logo drag and resize ──
let dragState = null;

function setupCanvasDrag() {
  const canvas = $('tmgCanvas');
  if(!canvas || canvas.dataset.dragWired) return;
  canvas.dataset.dragWired = '1';

  function getCanvasPoint(e) {
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return {
      x: (clientX - rect.left) * scaleX,
      y: (clientY - rect.top) * scaleY
    };
  }

  function isOverLogo(p) {
    if(S.logoX == null || S.logoDw == null) return false;
    return p.x >= S.logoX && p.x <= S.logoX + S.logoDw &&
           p.y >= S.logoY && p.y <= S.logoY + S.logoDh;
  }

  canvas.addEventListener('mousemove', e => {
    const allowAdjust = logoAdjustable();
    if(!S.adjustMode || !allowAdjust) {
      canvas.style.cursor = 'zoom-in';
      return;
    }
    const p = getCanvasPoint(e);
    canvas.style.cursor = isOverLogo(p) ? (dragState ? 'grabbing' : 'grab') : 'zoom-in';
  });

  function onStart(e) {
    const allowAdjust = logoAdjustable();
    if(!S.adjustMode || !allowAdjust) return;
    const p = getCanvasPoint(e);
    if(!isOverLogo(p)) return;
    e.preventDefault();
    e.stopPropagation();
    dragState = { startX: p.x, startY: p.y, origX: S.logoX, origY: S.logoY };
    canvas.style.cursor = 'grabbing';
  }

  function onMove(e) {
    if(!dragState) return;
    e.preventDefault();
    const p = getCanvasPoint(e);
    S.logoX = dragState.origX + (p.x - dragState.startX);
    S.logoY = dragState.origY + (p.y - dragState.startY);
    renderCanvas();
  }

  function onEnd() {
    dragState = null;
  }

  canvas.addEventListener('mousedown', onStart);
  canvas.addEventListener('touchstart', onStart, {passive: false});
  document.addEventListener('mousemove', onMove);
  document.addEventListener('touchmove', onMove, {passive: false});
  document.addEventListener('mouseup', onEnd);
  document.addEventListener('touchend', onEnd);
}

// Set up drag handlers once
setupCanvasDrag();

// Logo size slider
if($('tmgLogoSize')) {
  const sizeSlider = $('tmgLogoSize');
  sizeSlider.addEventListener('mousedown', () => { S.sliderActive = true; });
  sizeSlider.addEventListener('touchstart', () => { S.sliderActive = true; });
  document.addEventListener('mouseup', () => { S.sliderActive = false; });
  document.addEventListener('touchend', () => { S.sliderActive = false; });
  sizeSlider.addEventListener('input', e => {
    // The slider's min attribute (set by enforceLogoScaleMinimum) handles the floor natively
    S.logoScale = parseInt(e.target.value);
    if($('tmgLogoSizeLabel')) $('tmgLogoSizeLabel').textContent = S.logoScale + '%';
    // ux1015b: resizing keeps the logo's centre where the customer put it (the safe-zone clamp still applies)
    if (S.logoX != null && S.logoDw) S.logoKeepCentre = [S.logoX + S.logoDw / 2, S.logoY + S.logoDh / 2];
    else { S.logoX = null; S.logoY = null; }
    renderCanvas();
  });
}

// Reset logo button
if($('tmgResetLogo')) {
  $('tmgResetLogo').addEventListener('click', () => {
    S.logoX = null;
    S.logoY = null;
    S.logoScale = 80;
    if($('tmgLogoSize')) $('tmgLogoSize').value = 80;
    if($('tmgLogoSizeLabel')) $('tmgLogoSizeLabel').textContent = '80%';
    renderCanvas();
  });
}

// Mat preview lightbox
const tmgExpandBtn = $('tmgExpandBtn');
const tmgLightbox = $('tmgLightbox');
const tmgLightboxImg = $('tmgLightboxImg');
const tmgLightboxClose = $('tmgLightboxClose');

// Show the lightbox at a crisp resolution (moderate cap, plenty for the on-screen
// modal) and fall back to the 720px preview if the hi-res build is unavailable.
function showMatLightbox() {
  if (typeof openLightbox === 'function' && $('tmgLbCanvas')) { openLightbox(); return; }
  let src = S.previewUrl;
  try {
    const hi = buildHiResPreviewCanvas(2000);
    if(hi) src = hi.toDataURL('image/png');
  } catch(e) {}
  if(!src) return;
  tmgLightboxImg.src = src;
  tmgLightbox.style.display = 'flex';
}

if(tmgExpandBtn) {
  tmgExpandBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    if(S.previewUrl) showMatLightbox();
  });
}

if(tmgLightbox) {
  tmgLightbox.addEventListener('click', (e) => {
    if (e.target === tmgLightbox) tmgLightbox.style.display = 'none';
  });
}

if(tmgLightboxClose) {
  tmgLightboxClose.addEventListener('click', (e) => {
    e.stopPropagation();
    tmgLightbox.style.display = 'none';
  });
}

// Show expand button when canvas is rendered
const tmgCVWel = $('tmgCVW');
if(tmgCVWel) {
  tmgCVWel.addEventListener('click', (e) => {
    // Don't open lightbox while user is in adjust mode (drag/resize)
    if(S.adjustMode) return;
    if($('tmgCanvas').style.display === 'block' && S.previewUrl) {
      showMatLightbox();
    }
  });
}

// ── 13 Oct 2026 (Zac): full-screen preview with background + mat carousels, colour-name download, multi-mat tiers ──
// Injected into the asset's IIFE just before the boot calls (renderPlacement();). Everything here reads the same S and
// helpers the Preview step uses; a swipe applies the choice for real (selectBg / applyGrade), so the preview the
// customer sees in the lightbox IS the order.

/* ---- multi-mat pricing (13 Oct 2026 evening, Zac: quantity ladder, never over 15%, chosen on the order data):
   three Shopify automatic discounts on the logo-mat products (Design Your Own + the custom-size family products):
   2 mats = 5% (1295513616551), 3+ = 10% (1295513649319), 5+ = 15% (1295513682087). The store's "Spend $600, 15% Off"
   (1216757104807) still exists; none of the four combine with anything, so the cart applies the single best one. The
   configurator prices with the same rule: the quantity step, or 15% once the configured lines reach A$600. ---- */
const TIERS = [{ min: 2, pct: 5 }, { min: 3, pct: 10 }, { min: 5, pct: 15 }];
// Store spend rules on the discountable-items collection (anything eligible in the cart counts): "Spend $600, 15% Off"
// 1216757104807 and, 13 Oct 2026 (Zac, threshold chosen on the order data), "Spend $1,000, 20% Off" - the only place 20% exists.
const SPEND_RULES = [{ min: 600, pct: 15 }, { min: 1000, pct: 20 }];
const SPEND_RULE = SPEND_RULES[0];
const MAX_PCT = 20;
function spendPct(gross){ let p = 0; SPEND_RULES.forEach(r => { if (gross >= r.min) p = Math.max(p, r.pct); }); return p; }
function tierFor(q){ let t = null; TIERS.forEach(x => { if ((q || 1) >= x.min) t = x; }); return t; }
function tierExtras(){ let x = 0; try { x += pmsSurcharge(); } catch (e) {} try { if (typeof edgingSurcharge === 'function') x += edgingSurcharge() * (S.qty || 1); } catch (e) {} return x; }
function tierPctFor(gross, q){ if (gradeOf().noDiscount) return 0; const t = tierFor(q == null ? S.qty : q); const byQty = t ? t.pct : 0; return Math.max(byQty, spendPct(gross)); }
function tierPct(q){ return tierPctFor((S.unitFull || S.unitPrice || 0) * (q || S.qty || 1) + tierExtras(), q); }
function tierTableHtml(){
  if (gradeOf().noDiscount) return ''; // Coir Logo Inlay: no multi-mat or spend discount applies to these products
  const q = S.qty || 1, unit = S.unitFull || S.unitPrice; if (!unit) return '';
  const extras = tierExtras(), gross = unit * q + extras, eff = tierPctFor(gross, q), cur = tierFor(q);
  // one row per DISTINCT saving: steps whose % is the same for this mat (e.g. the A$600 rule already gives 15% from 2 mats) merge into one
  const raw = [1, 2, 3, 5].map(n => ({ min: n, pct: tierPctFor(unit * n + extras, n) }));
  const steps = []; raw.forEach(r => { const last = steps[steps.length - 1]; if (last && last.pct === r.pct) last.max = (r.min === 5 ? Infinity : r.min === 3 ? 4 : r.min); else steps.push({ min: r.min, max: r.min === 5 ? Infinity : r.min === 3 ? 4 : r.min, pct: r.pct }); });
  if (steps.length && steps[steps.length - 1].max !== Infinity) steps[steps.length - 1].max = Infinity;
  const label = t => t.max === Infinity ? (t.min === 1 ? 'Any quantity' : t.min + ' or more') : t.min === t.max ? t.min + ' mat' + (t.min > 1 ? 's' : '') : t.min + '&ndash;' + t.max + ' mats';
  const rows = steps.map(t => {
    const active = q >= t.min && q <= t.max, each = unit * (1 - t.pct / 100);
    return '<div class="tmg-tier' + (active ? ' on' : '') + (t.pct ? ' tmg-tier-best' : '') + '" data-q="' + t.min + '" role="button" tabindex="0" aria-pressed="' + active + '">' +
      '<span class="tmg-tier-q">' + label(t) + '</span>' +
      '<span class="tmg-tier-p">' + fmt(each) + ' <small>each</small></span>' +
      '<span class="tmg-tier-s">' + (t.pct ? 'Save ' + t.pct + '%' : '&nbsp;') + '</span></div>';
  }).join('');
  let nudge = '';
  const nextStep = steps.find(t => t.min > q);
  if (eff >= MAX_PCT) nudge = '<div class="tmg-tier-nudge on">&#10003; ' + eff + '% off applied in the cart: you save ' + fmt(gross * eff / 100) + '. Every extra mat is ' + fmt(unit * (1 - eff / 100)) + ' instead of ' + fmt(unit) + ' &ndash; most businesses take one for each entrance.</div>'; // at the cap, so the nudge is the per-mat value, not a bigger discount
  else if (nextStep) { const need = nextStep.min - q, nq = nextStep.min, npct = tierPctFor(unit * nq + extras, nq); nudge = '<div class="tmg-tier-nudge">' + (eff ? '&#10003; ' + eff + '% off applied. ' : '') + 'Add ' + need + ' more mat' + (need > 1 ? 's' : '') + ' and every mat is ' + npct + '% off &ndash; ' + fmt((unit * nq + extras) * npct / 100) + ' saved, taken automatically in the cart.</div>'; }
  else { const top = SPEND_RULES[SPEND_RULES.length - 1]; if (gross < top.min) { const need = Math.max(1, Math.ceil((top.min - gross) / unit)); nudge = '<div class="tmg-tier-nudge">' + (eff ? '&#10003; ' + eff + '% off applied. ' : '') + 'Add ' + need + ' more mat' + (need > 1 ? 's' : '') + ' to pass A$' + top.min.toLocaleString('en-AU') + ' and every mat is ' + top.pct + '% off.</div>'; } }
  return '<div class="tmg-tiers"><div class="tmg-tiers-lbl">Multi-mat pricing <span>15% off orders over A$600, 20% off over A$1,000</span></div><div class="tmg-tier-rows tmg-tier-rows' + Math.min(4, Math.max(2, steps.length)) + '">' + rows + '</div>' + nudge + '</div>';
}
function bindTiers(root){ if (!root) return; root.querySelectorAll('.tmg-tier').forEach(el => { const go = () => setQty(parseInt(el.dataset.q, 10)); el.addEventListener('click', go); el.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } }); }); }
function renderTierBox(){ const tb = $('tmgTiersBox'); if (!tb) return; tb.innerHTML = tierTableHtml(); bindTiers(tb); }

/* ---- customer-facing colour names (no PMS / chart codes) ---- */
function friendlyName(name){ return String(name || '').replace(/\s*\((PMS|Pantone)[^)]*\)/ig, '').replace(/\s*PMS\s+[0-9A-Za-z\-]+\s*[cu]?\b/g, '').replace(/\s+/g, ' ').trim(); }

/* ---- download: optional legend strip with the colour names ---- */
function legendLines(){
  const g = gradeOf();
  const size = (typeof isCustomSize === 'function' && isCustomSize() && customOf(g.key)) ? (S.custom.L + ' x ' + S.custom.W + ' mm') : String(familySize(g.key) || S.size).replace('x', ' x ') + ' mm';
  const code = mm => { const r = mmRef(mm); return r ? ' ' + r : ''; };
  const head = g.title + '  |  ' + size + (S.selectedBg && !S.useArtworkAsBg ? '  |  ' + (g.option3 || g.bgSeparate ? 'Base' : 'Background') + ': ' + (friendlyName(S.selectedBg.name) || S.selectedBg.name) + code(S.selectedBg.mm) : '');
  let chips = [];
  if (!asSupplied()) { try { chips = designPalette().map(c => ({ hex: c.hex, name: (friendlyName(c.name) || c.name) + code(c.mm) })); } catch (e) {} }
  return { head, chips, asIs: asSupplied() };
}
function withLegend(src){
  const L = legendLines(); const W = src.width, pad = Math.round(W * 0.02), rowH = Math.max(22, Math.round(W * 0.034)), chipS = Math.round(rowH * 0.62), fontPx = Math.round(rowH * 0.46);
  const probe = document.createElement('canvas').getContext('2d'); probe.font = '600 ' + fontPx + 'px Montserrat, Arial, sans-serif';
  const lines = []; let cur = [], x = pad;
  L.chips.forEach(c => { const w = chipS + Math.round(chipS * 0.35) + probe.measureText(c.name).width + rowH; if (x + w > W - pad && cur.length) { lines.push(cur); cur = []; x = pad; } cur.push(c); x += w; });
  if (cur.length) lines.push(cur);
  const extra = L.asIs ? 1 : lines.length;
  const H = src.height + pad + rowH + extra * rowH + pad;
  const out = document.createElement('canvas'); out.width = W; out.height = H;
  const ctx = out.getContext('2d'); ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, W, H); ctx.drawImage(src, 0, 0);
  let y = src.height + pad;
  ctx.fillStyle = '#1a1a1a'; ctx.font = '700 ' + fontPx + 'px Montserrat, Arial, sans-serif'; ctx.textBaseline = 'middle'; ctx.fillText(L.head, pad, y + rowH / 2); y += rowH;
  ctx.font = '600 ' + fontPx + 'px Montserrat, Arial, sans-serif';
  if (L.asIs) { ctx.fillStyle = '#555'; ctx.fillText('Printed in full colour, exactly as supplied', pad, y + rowH / 2); return out; }
  lines.forEach(row => { let cx = pad; row.forEach(c => { ctx.fillStyle = c.hex; ctx.beginPath(); ctx.arc(cx + chipS / 2, y + rowH / 2, chipS / 2, 0, Math.PI * 2); ctx.fill(); ctx.strokeStyle = 'rgba(0,0,0,.25)'; ctx.lineWidth = 1; ctx.stroke(); ctx.fillStyle = '#1a1a1a'; ctx.fillText(c.name, cx + chipS + Math.round(chipS * 0.35), y + rowH / 2); cx += chipS + Math.round(chipS * 0.35) + ctx.measureText(c.name).width + rowH; }); y += rowH; });
  return out;
}
function namesWanted(){ const a = $('tmgDlNames'), b = $('tmgLbNames'); return !!((a && a.checked) || (b && b.checked)); }
function syncNamesToggles(on){ const a = $('tmgDlNames'), b = $('tmgLbNames'); if (a) a.checked = on; if (b) b.checked = on; renderLegends(); }
/* ux1015a: every colour on the mat, named as the customer sees it, with the chart code production uses */
function legendItems(){
  const g = gradeOf(); const items = [];
  if (S.selectedBg && S.selectedBg.hex && !S.useArtworkAsBg) items.push({ hex: S.selectedBg.hex, name: friendlyName(S.selectedBg.name) || S.selectedBg.name, code: mmRef(S.selectedBg.mm), role: (g.option3 || g.bgSeparate) ? 'Base' : 'Background' });
  if (!asSupplied()) { try { designPalette().forEach(c => items.push({ hex: c.hex, name: friendlyName(c.name) || c.name, code: mmRef(c.mm), role: '' })); } catch (e) {} }
  return items;
}
function legendHtml(){
  if (asSupplied()) return '<span class="tmg-leg-note">Printed in full colour, exactly as supplied</span>';
  const it = legendItems(); if (!it.length) return '';
  return it.map(c => '<span class="tmg-leg"><i style="background:' + c.hex + '"></i><b>' + (c.role ? c.role + ': ' : '') + lbEsc(c.name) + '</b>' + (c.code ? '<small>' + lbEsc(c.code) + '</small>' : '') + '</span>').join('');
}
function renderLegends(){ const on = namesWanted(); ['tmgCvLegend', 'tmgLbLegend'].forEach(id => { const el = $(id); if (!el) return; el.style.display = on ? 'flex' : 'none'; if (on) el.innerHTML = legendHtml(); }); }
function downloadPreviewNamed(withNames){
  try {
    let hi = (typeof buildHiResPreviewCanvas === 'function' && buildHiResPreviewCanvas(2400)) || $('tmgCanvas');
    if (!hi || !hi.width) return;
    if (withNames) hi = withLegend(hi);
    const g = gradeOf(); const size = (typeof isCustomSize === 'function' && isCustomSize() && customOf(g.key)) ? (S.custom.L + 'x' + S.custom.W) : String(familySize(g.key) || S.size);
    const name = 'mat-preview-' + g.key + '-' + size + 'mm' + (withNames ? '-colours' : '') + '.png';
    hi.toBlob(b => { if (!b) return; const u = URL.createObjectURL(b); const a = document.createElement('a'); a.href = u; a.download = name; document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(u), 4000); }, 'image/png');
  } catch (e) { console.warn('[TMG] preview download failed', e); }
}

/* ---- about this mat: a brief sheet from an "i" on every card / tile; the spec sheet + colour chart are the extended reading ---- */
const MAT_ABOUT = {
  standard: 'Printed nylon pile on a natural and nitrile rubber blend backing. The everyday indoor logo mat: up to 12 chart colours, spot clean.',
  commercial: 'The same printed pile on a 100% nitrile rubber backing that survives commercial laundering. Up to 25 chart colours.',
  hd: 'Photographic print with no colour limit: gradients, photos and your exact colours. Nitrile rubber backing, launderable.',
  printscraper: 'Coarse scraper fibre that takes the weather and heavy traffic: hose it clean, chart colours, optional drainage holes.',
  rubberscraper: 'All-rubber moulded mat with raised studs and a raised border that traps dirt and water. Full colour print, inside or out.',
  spiralloop: 'PVC loop matting for wet areas, pools and drains: UV stable, water drains straight through. The logo is cut and inlaid, up to 3 colours.',
  superguard: 'Our most durable mat, made in Melbourne: the logo is cut from solid yarn and inlaid, so it never fades. Up to 4 colours on 15 base colours.',
  coirembossed: 'Natural, grey or black coir with one embossed logo colour. Classic entrance look, biodegradable fibre.',
  coirinlay: '17 mm coir on a PVC backing: your logo is laser-cut from solid dyed coir and inlaid flush, so it never wears away. Natural, grey or black base with the logo in one of the other two coirs, made to measure up to 2 m wide, ideal for recesses. Black rubber edging optional.',
  dirtstopper: 'A raised, embossed logo that stands proud of the mat: 1 or 2 colours on black or charcoal. Indoors, two sizes.',
  promotional: '2 mm felt top on a rubber back, full colour with very fine detail. Made for events and short-term use.',
  rubberpromotional: 'Thin, flat rubber with a full colour photo print. Lies anywhere, up to 1200 mm wide.'
};
function matInfoHtml(k){
  const g = GRADES[k]; if (!g) return ''; const sel = k === S.grade;
  return '<div class="tmg-mi-head"><div><div class="tmg-mi-title">' + lbEsc(g.title) + '</div><div class="tmg-mi-tag">' + lbEsc(g.tag || '') + '</div>' + useChipsHtml(k, 'tmg-use tmg-mi-use') + '</div><button type="button" class="tmg-mi-x" data-mi-close aria-label="Close">&#10005;</button></div>' +
    '<p class="tmg-mi-about">' + lbEsc(MAT_ABOUT[k] || '') + '</p>' + colourMapHtml(k) +
    '<ul class="tmg-mi-list">' + (g.bullets || []).map(b => '<li>' + b + '</li>').join('') + '</ul>' +
    '<div class="tmg-mi-lead">Lead time approx. ' + lbEsc(leadOf(k)) + ' from proof approval</div>' +
    '<div class="tmg-mi-links">' + (g.spec ? '<a href="' + g.spec + '" target="_blank" rel="noopener">Spec sheet (PDF) &rarr;</a>' : '') + (g.chartUrl ? '<a href="' + g.chartUrl + '" target="_blank" rel="noopener">Colour chart &rarr;</a>' : '') + '</div>' +
    '<button type="button" class="tmg-mi-pick" data-mi-pick="' + k + '"' + (sel ? ' disabled' : '') + '>' + (sel ? '&#10003; This is your mat' : 'Choose ' + lbEsc(g.title)) + '</button>';
}
function liftOverHeader(){ // 14 Oct 2026: the overlays live inside #site-main (z 500) and the sticky header is z 700 - lift main while one is open
  const m = document.getElementById('site-main'); if (!m) return; const mi = $('tmgMatInfo'), on = LB.open || (mi && mi.style.display !== 'none');
  if (!$('tmgOverlayCss')) { const st = document.createElement('style'); st.id = 'tmgOverlayCss'; st.textContent = 'html.tmg-overlay-on #tmgc-launcher,html.tmg-overlay-on #tmgc-peek{display:none!important}'; document.head.appendChild(st); }
  document.documentElement.classList.toggle('tmg-overlay-on', !!on); // 14 Oct 2026: nothing floats over the full-screen view (AI concierge bubble hidden while it is open)
  if (on) { if (m.dataset.tmgZ == null) m.dataset.tmgZ = m.style.zIndex || ''; m.style.zIndex = '1000'; }
  else if (m.dataset.tmgZ != null) { m.style.zIndex = m.dataset.tmgZ; delete m.dataset.tmgZ; }
}
function openMatInfo(k){ const el = $('tmgMatInfo'); if (!el || !GRADES[k]) return; const sheet = el.querySelector('.tmg-mi-sheet'); if (!sheet) return; useCss(); sheet.innerHTML = matInfoHtml(k); sheet.scrollTop = 0; el.style.display = 'flex'; liftOverHeader(); try { sheet.querySelector('.tmg-mi-x').focus(); } catch (e) {} }
function closeMatInfo(){ const el = $('tmgMatInfo'); if (el) el.style.display = 'none'; liftOverHeader(); }
document.addEventListener('click', e => {
  const i = e.target.closest && e.target.closest('[data-info]');
  if (i) { e.preventDefault(); e.stopPropagation(); openMatInfo(i.dataset.info); return; }
  const el = $('tmgMatInfo'); if (!el || el.style.display === 'none') return;
  if (e.target === el || (e.target.closest && e.target.closest('[data-mi-close]'))) { e.preventDefault(); e.stopPropagation(); closeMatInfo(); return; }
  const p = e.target.closest && e.target.closest('[data-mi-pick]');
  if (p) { e.preventDefault(); e.stopPropagation(); const k = p.dataset.miPick; closeMatInfo(); if (LB.open) lbPickMat(k); else selectGrade(k); }
}, true);

/* ---- the full-screen preview ---- */
// Smoothness rules (Zac, 13 Oct 2026 "it jitters"): the centre canvas is CSS-sized from the mat's shape and the stage,
// never from its pixel size, so the crisp copy landing later changes nothing on screen; repaints coalesce to one per
// frame; the rails are rebuilt only when their content changes (a tap just moves the highlight); nothing dims.
const LB = { open: false, bgs: [], mats: [], hiTimer: null, hiSeq: 0, pending: false, bgChart: null, matKeys: '', thumbSeq: 0 };
function lbEsc(s){ return String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }
function lbLab(h){ return rgbToLab(parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)); }
function lbBgList(){ // the family's chart, nearest to the current background first
  let rows = []; try { rows = familyChart(); } catch (e) {} if (!rows.length) return [];
  const cur = S.selectedBg && S.selectedBg.hex, want = cur ? lbLab(cur) : null;
  return rows.map(r => ({ mm: r[0], hex: r[1], name: r[2], light: r[3] === 'light', d: want ? deltaE2000(want, lbLab(r[1])) : 0 })).sort((a, b) => a.d - b.d);
}
function lbNearestFor(k, hex){ // nearest base/background colour on family k, with its distance
  const saved = S.grade; S.grade = k;
  try { const rows = familyChart(); if (!hex || !rows.length) return null; const want = lbLab(hex); let near = null, bd = Infinity; for (const r of rows) { const d = deltaE2000(want, lbLab(r[1])); if (d < bd) { bd = d; near = r; } } return near ? { mm: near[0], hex: near[1], name: near[2], d: bd } : null; }
  catch (e) { return null; } finally { S.grade = saved; }
}
const LB_BG_DE_MAX = 16; // a mat only shows when it is made in (close to) the chosen background colour
function lbMatList(){ // mats that make this design as it is, in a colour close to the chosen background
  const st = colourStatsNow(), hex = (S.selectedBg && !S.useArtworkAsBg) ? S.selectedBg.hex : null, pl = placementOf().grades, out = [];
  GRADE_ORDER.forEach(k => {
    if (k !== S.grade) { if (gradeBlocked(k, st) || !gradeFits(k, st)) return; }
    let near = null; if (hex) { near = lbNearestFor(k, hex); if (k !== S.grade && (!near || near.d > LB_BG_DE_MAX)) return; }
    out.push({ k, near });
  });
  out.sort((a, b) => (pl.indexOf(a.k) > -1 ? 0 : 1) - (pl.indexOf(b.k) > -1 ? 0 : 1)); // 14 Oct 2026: stable order, the swiped mat stays where it is
  return out;
}
function lbSizeLabel(){ const g = gradeOf(); return (typeof isCustomSize === 'function' && isCustomSize() && customOf(g.key)) ? (S.custom.L + ' × ' + S.custom.W + ' mm') : String(familySize(g.key) || S.size).replace('x', ' × ') + ' mm'; }
function lbFit(cv, w, h){ // CSS size from the mat's shape and the stage, independent of the canvas pixel size (no jump when the crisp copy lands)
  const stage = $('tmgLbStage'); if (!stage || !w || !h) return;
  const sw = Math.max(1, stage.clientWidth), sh = Math.max(1, stage.clientHeight), r = (S.matWmm && S.matHmm) ? S.matWmm / S.matHmm : w / h; // the mat's real shape: the 720 px and 1600 px copies fit to the same pixel
  let cw = sw, ch = sw / r; if (ch > sh) { ch = sh; cw = sh * r; }
  cv.style.width = Math.round(cw) + 'px'; cv.style.height = Math.round(ch) + 'px';
}
function lbPaintCentre(){
  const src = $('tmgCanvas'), cv = $('tmgLbCanvas'); if (!src || !cv || !src.width) return;
  if (cv.width !== src.width || cv.height !== src.height) { cv.width = src.width; cv.height = src.height; }
  cv.getContext('2d').drawImage(src, 0, 0); lbFit(cv, src.width, src.height); cv.style.opacity = '1';
  const g = gradeOf(); const t = $('tmgLbTitle'); if (t) t.textContent = g.title + ' · ' + lbSizeLabel() + (S.totalPrice ? ' · ' + fmt(S.totalPrice) : '');
  const cap = $('tmgLbCap'); if (cap) cap.textContent = (S.selectedBg && !S.useArtworkAsBg) ? ((g.option3 || g.bgSeparate ? 'Base: ' : 'Background: ') + friendlyName(S.selectedBg.name) + ' – swipe the colours on the left, the mats on the right') : 'Your design fills the mat – swipe the mats on the right';
  try { renderLegends(); } catch (e) {}
}
function lbHiRes(){ // crisp copy a moment later, only if nothing changed meanwhile; same CSS size, so nothing moves
  clearTimeout(LB.hiTimer); const seq = ++LB.hiSeq;
  LB.hiTimer = setTimeout(() => { if (!LB.open || seq !== LB.hiSeq) return; try { const stage = $('tmgLbStage'), dpr = Math.min(3, window.devicePixelRatio || 1); const want = stage ? Math.round(stage.clientWidth * dpr) : 1600; const hi = buildHiResPreviewCanvas(Math.max(720, Math.min(1600, want))); const cv = $('tmgLbCanvas'); if (hi && cv) { cv.width = hi.width; cv.height = hi.height; cv.getContext('2d').drawImage(hi, 0, 0); lbFit(cv, hi.width, hi.height); } } catch (e) {} }, 400); // sized to the real screen pixels: no wasted work on a phone, no softness on a desktop
}
function lbAfterRender(){ if (!LB.open || LB.pending) return; LB.pending = true; nextFrame(() => { LB.pending = false; if (!LB.open) return; lbPaintCentre(); lbHiRes(); lbRenderRails(); }); }
function lbPickBg(b){ if (!b || (S.selectedBg && S.selectedBg.mm === b.mm && !S.useArtworkAsBg)) return; uxiCss(); S.bgSrc = 'full-screen preview swipe'; selectBg(b.mm, b.hex, b.name, b.light); lbAfterRender(); }
function lbFollowPlacement(k){ // 14 Oct 2026: the rail offers every mat; a pick outside the chosen placement moves the placement with it (else reconcileGradeWithPlacement snaps it back)
  if (visibleGrades().indexOf(k) > -1) return;
  // 14 Oct 2026 (Zac): never change the customer's placement answer - open "all mat types" so the pick stands; the tiles say where each mat belongs
  S.showOther = true;
  trail('grade', GRADES[k].title + ' picked in the full-screen view (outside the ' + (S.placement || 'inside') + ' list)');
}
// Where each mat is made for: the placement lists, plus the mats that sit under "See all mat types"
const MAT_USE_EXTRA = { coirembossed: ['inside'], dirtstopper: ['inside'], promotional: ['inside'], rubberpromotional: ['inside', 'outside'] };
const USE_LABEL = { inside: ['&#8962;', 'Inside'], outside: ['&#9729;', 'Outside'], wet: ['&#8767;', 'Wet'] };
function matUses(k){ const u = Object.keys(PLACEMENTS).filter(p => PLACEMENTS[p].grades.indexOf(k) > -1); return u.length ? u : (MAT_USE_EXTRA[k] || []); }
function useChipsHtml(k, cls){ return '<span class="' + (cls || 'tmg-use') + '">' + matUses(k).map(u => '<span class="tmg-use-c tmg-use-' + u + '" title="Made for ' + USE_LABEL[u][1].toLowerCase() + '"><i aria-hidden="true">' + USE_LABEL[u][0] + '</i>' + USE_LABEL[u][1] + '</span>').join('') + '</span>'; }
function useCss(){ if ($('tmgUseCss')) return; const st = document.createElement('style'); st.id = 'tmgUseCss';
  st.textContent = '.tmg-use{display:flex;flex-wrap:wrap;justify-content:center;gap:3px;margin:4px 0 2px}' +
    '.tmg-use-c{display:inline-flex;align-items:center;gap:2px;font-size:9px;font-weight:600;line-height:1;padding:3px 5px;border-radius:99px;letter-spacing:.01em;white-space:nowrap}' +
    '.tmg-use-c i{font-style:normal;font-size:10px;line-height:1}' +
    '.tmg-use-inside{background:rgba(255,255,255,.12);color:#e9e9e9}.tmg-use-outside{background:rgba(94,168,50,.22);color:#b7e59a}.tmg-use-wet{background:rgba(42,166,160,.24);color:#9fe3df}' +
    '#tmgLightbox.tmg-lb{background:#0c0c0c}.tmg-lb-mat.tmg-mine{box-shadow:inset 0 0 0 1px rgba(255,255,255,.28)}' +
    '.tmg-lb-mine-lbl{display:block;font-size:8.5px;color:#aaa;margin-top:1px;line-height:1.2}' +
    '.tmg-mi-use{display:flex;flex-wrap:wrap;gap:4px;margin:6px 0 2px}.tmg-mi-use .tmg-use-inside{background:#ececec;color:#333}.tmg-mi-use .tmg-use-outside{background:#e3f2da;color:#2f6b12}.tmg-mi-use .tmg-use-wet{background:#d9f1ef;color:#13625d}' +
    '@media(max-width:640px){.tmg-use{gap:2px}.tmg-use-c{font-size:8px;padding:2px 4px}.tmg-use-c i{font-size:9px}.tmg-lb-mine-lbl{font-size:8px}}';
  document.head.appendChild(st); }
function lbPickMat(k){
  if (!GRADES[k] || k === (LB.pickWant || S.grade)) return;
  if (gradeBlocked(k, colourStatsNow())) return;
  // 14 Oct 2026 perf: the tile answers the tap at once; the render runs after that paint, and only for the last of rapid taps
  LB.pickWant = k; _warmSeq++;
  const mats = $('tmgLbMats'); if (mats) mats.querySelectorAll('.tmg-lb-mat').forEach(el => { const on = el.dataset.k === k; el.classList.toggle('sel', on); el.setAttribute('aria-pressed', on); });
  nextFrame(() => setTimeout(() => {
    if (LB.pickWant !== k) return; LB.pickWant = null;
    if (!GRADES[k] || k === S.grade) return;
    lbFollowPlacement(k);
    applyGrade(k); // fits already (lbMatList filtered), so no colour-reduction confirmation is needed
    if (S.step === 4 && S.file) renderCanvas();
    lbAfterRender();
    lbWarm(); // carry on warming the rest from the new mat
  }, 0));
}
// 14 Oct 2026 perf: quantise the rail's other mats in idle time (state swapped and restored exactly as for the card previews)
let _warmSeq = 0;
function lbWarm(){
  if (!LB.open || !S.file || !LB.mats || !LB.mats.length) return;
  const ks = LB.mats.map(m => m.k), at = Math.max(0, ks.indexOf(S.grade)), order = [];
  for (let d = 1; d < ks.length; d++) { if (ks[at + d]) order.push(ks[at + d]); if (ks[at - d]) order.push(ks[at - d]); } // the neighbours get swiped to first
  const seq = ++_warmSeq, idle = cb => (window.requestIdleCallback && !document.hidden) ? requestIdleCallback(cb, { timeout: 1200 }) : setTimeout(cb, 80);
  const step = () => {
    if (seq !== _warmSeq || !LB.open || LB.pickWant || !S.file) return;
    if (!_srcImg || _srcImg.fileRef !== S.file || !_srcImg.img.naturalWidth || _qInflight) return idle(step); // only the synchronous path, never alongside a real pass
    const k = order.shift(); if (!k) return;
    const snap = Object.assign({}, S), savedLogo = cachedLogo;
    try { S.grade = k; const lm = (LB.mats || []).find(x => x.k === k); if (lm && lm.near && S.selectedBg && !S.useArtworkAsBg && (GRADES[k].cut || GRADES[k].raised) && !familyChart().some(r => r[0] === S.selectedBg.mm)) S.selectedBg = { mm: lm.near.mm, hex: lm.near.hex, name: lm.near.name }; /* the base afterFamilyChange will carry it to: the palette leaves the base colour out, so it is part of the cache key */ if (GRADES[k] && !quantCacheGet(S.file, quantKey())) { cachedLogo = null; ensureQuantisedLogo(() => {}); } }
    catch (e) {}
    finally { for (const p in S) if (!(p in snap)) delete S[p]; Object.assign(S, snap); cachedLogo = savedLogo; }
    if (order.length) idle(step);
  };
  idle(step);
}
function lbMarkSelection(){
  const bgs = $('tmgLbBgs'), mats = $('tmgLbMats'); const curMm = (S.selectedBg && !S.useArtworkAsBg) ? S.selectedBg.mm : null;
  if (bgs) bgs.querySelectorAll('.tmg-lb-bg').forEach(el => { const on = el.dataset.fill ? !!S.useArtworkAsBg : el.dataset.mm === curMm; el.classList.toggle('sel', on); el.setAttribute('aria-pressed', on); });
  if (mats) mats.querySelectorAll('.tmg-lb-mat').forEach(el => { const on = el.dataset.k === S.grade; el.classList.toggle('sel', on); el.setAttribute('aria-pressed', on); });
}
function lbScrollTo(el, smooth){ if (!el) return; try { el.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: smooth ? 'smooth' : 'auto' }); } catch (e) {} }
function lbPaintThumbs(mats){
  if (!S.file) return; const seq = ++LB.thumbSeq;
  loadSourceImage(S.file, img => { const els = Array.prototype.slice.call(mats.querySelectorAll('.tmg-lb-mat')); let i = 0; const step = () => { if (seq !== LB.thumbSeq || !LB.open) return; const el = els[i++]; if (!el) return; const k = el.dataset.k, cv = el.querySelector('canvas'); if (cv && GRADES[k]) { const key = cardPrevKey(k); let src = _cardPrev.map.get(key); if (!src) { src = document.createElement('canvas'); src.width = 240; src.height = 160; paintCardPreview(k, src, img); if (_cardPrev.map.size > 80) _cardPrev.map.clear(); _cardPrev.map.set(key, src); } cv.getContext('2d').drawImage(src, 0, 0); cv.classList.add('on'); } if (els[i]) nextFrame(step); }; nextFrame(step); });
}
function lbRenderRails(force){
  const bgs = $('tmgLbBgs'), mats = $('tmgLbMats'); if (!bgs || !mats) return;
  const g = gradeOf(), chart = g.bgChart || 'mm', curMm = (S.selectedBg && !S.useArtworkAsBg) ? S.selectedBg.mm : null;
  // colours: rebuilt only when the chart changes (a new family) or on open; a tap keeps the order the customer is swiping through
  if (force || LB.bgChart !== chart || !bgs.children.length) {
    LB.bgs = lbBgList(); LB.bgChart = chart;
    bgs.innerHTML = (fillAllowed() ? '<button type="button" class="tmg-lb-bg tmg-lb-fill" data-fill="1" title="No mat colour - my design fills the mat" aria-label="No mat colour - my design fills the mat">' + (artThumbSrc() ? '<img alt="" src="' + artThumbSrc() + '">' : '') + '<span>No colour</span></button>' : '') + LB.bgs.map(b => { const nm = friendlyName(b.name); return '<button type="button" class="tmg-lb-bg" data-mm="' + lbEsc(b.mm) + '" style="' + swatchCss(b.mm, b.hex) + '" title="' + lbEsc(nm) + '" aria-label="' + lbEsc(nm) + '"><span>' + lbEsc(nm.length > 14 ? nm.slice(0, 13) + '…' : nm) + '</span></button>'; }).join('');
    bgs.querySelectorAll('.tmg-lb-bg').forEach(el => el.addEventListener('click', () => { if (el.dataset.fill) { if (!S.useArtworkAsBg) { setFillMode(true); if (S.step === 4 && S.file) renderCanvas(); lbAfterRender(); } return; } const b = LB.bgs.find(x => x.mm === el.dataset.mm); if (b) lbPickBg(b); }));
    lbMarkSelection(); lbScrollTo(bgs.querySelector('.sel'), false);
  }
  // mats: rebuilt only when the eligible list changes (the chosen colour moved to another family's range)
  const list = lbMatList(), keys = list.map(m => m.k).join(',') + '|' + curMm;
  if (force || LB.matKeys !== keys || !mats.children.length) {
    LB.mats = list; LB.matKeys = keys;
    useCss(); const mine = placementOf().grades; mats.innerHTML = list.map(m => '<button type="button" class="tmg-lb-mat' + (mine.indexOf(m.k) > -1 ? ' tmg-mine' : '') + '" data-k="' + m.k + '" aria-label="' + lbEsc(GRADES[m.k].title) + ' - made for ' + matUses(m.k).map(u => USE_LABEL[u][1].toLowerCase()).join(', ') + '"><canvas width="240" height="160" aria-hidden="true"></canvas><span class="tmg-lb-mi" data-info="' + m.k + '" role="button" aria-label="About ' + lbEsc(GRADES[m.k].title) + '">i</span><b>' + lbEsc(GRADES[m.k].title) + '</b>' + useChipsHtml(m.k) + colourNoteHtml(m.k) + '<i data-price="' + m.k + '">' + (m.near && m.k !== S.grade && m.near.name && S.selectedBg && m.near.mm !== S.selectedBg.mm ? 'on ' + lbEsc(friendlyName(m.near.name)) : '') + '</i></button>').join('');
    mats.querySelectorAll('.tmg-lb-mat').forEach(el => el.addEventListener('click', () => lbPickMat(el.dataset.k)));
    lbPaintThumbs(mats); lbWarm();
    gradePrices().then(prices => { mats.querySelectorAll('i[data-price]').forEach(el => { const p = prices[el.dataset.price]; if (p != null && el.textContent.indexOf('A$') < 0) el.textContent = (el.textContent ? el.textContent + ' · ' : '') + fmt(p); }); }).catch(() => {});
    lbMarkSelection(); lbScrollTo(mats.querySelector('.sel'), false);
  } else { lbMarkSelection(); lbScrollTo(mats.querySelector('.sel'), true); lbScrollTo(bgs.querySelector('.sel'), true); }
  setTimeout(uxiMore, 60);
}
function openLightbox(){
  const lb = $('tmgLightbox'); if (!lb || !S.file || !$('tmgCanvas') || !$('tmgCanvas').width) return;
  LB.open = true; lb.style.display = 'flex'; uxiCss(); document.body.style.overflow = 'hidden'; liftOverHeader();
  syncNamesToggles(namesWanted());
  lbPaintCentre(); lbRenderRails(true); lbHiRes();
  try { const x = $('tmgLightboxClose'); if (x) x.focus(); } catch (e) {}
}
function closeLightbox(){ LB.open = false; clearTimeout(LB.hiTimer); closeMatInfo(); const lb = $('tmgLightbox'); if (lb) lb.style.display = 'none'; document.body.style.overflow = ''; liftOverHeader(); }
function lbStep(list, cur, dir){ const i = list.indexOf(cur); if (i < 0) return list[0]; return list[Math.max(0, Math.min(list.length - 1, i + dir))]; }
(function bindLightbox(){
  const lb = $('tmgLightbox'); if (!lb) return;
  const x = $('tmgLightboxClose'); if (x) x.addEventListener('click', e => { e.stopPropagation(); closeLightbox(); });
  const done = $('tmgLbDone'); if (done) done.addEventListener('click', e => { e.stopPropagation(); closeLightbox(); });
  const dl = $('tmgLbDownload'); if (dl) dl.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); downloadPreviewNamed(namesWanted()); });
  const n1 = $('tmgLbNames'), n2 = $('tmgDlNames');
  if (n1) n1.addEventListener('change', () => syncNamesToggles(n1.checked));
  if (n2) n2.addEventListener('change', () => syncNamesToggles(n2.checked));
  lb.addEventListener('click', e => { if (e.target === lb) closeLightbox(); });
  window.addEventListener('resize', () => { if (!LB.open) return; const cv = $('tmgLbCanvas'); if (cv && cv.width) lbFit(cv, cv.width, cv.height); });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { const mi = $('tmgMatInfo'); if (mi && mi.style.display !== 'none') { closeMatInfo(); return; } }
    if (!LB.open) return;
    if (e.key === 'Escape') { closeLightbox(); return; }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); const mms = LB.bgs.map(b => b.mm); const cur = S.selectedBg ? S.selectedBg.mm : null; const mm = lbStep(mms, cur, e.key === 'ArrowDown' ? 1 : -1); lbPickBg(LB.bgs.find(b => b.mm === mm)); }
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); const ks = LB.mats.map(m => m.k); lbPickMat(lbStep(ks, LB.pickWant || S.grade, e.key === 'ArrowRight' ? 1 : -1)); }
  });
  // the Download button on the Preview step honours the colour-name toggle too
  const b = $('tmgDownloadBtn'); if (b) { b.dataset.bound = '1'; b.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); downloadPreviewNamed(namesWanted()); }, true); }
})();

renderPlacement();
bindCustomSize();
bindColourPick();
bindGenMats();
bindDownloadPreview();
// Init pricing
setPickSize($('tmgSize').value);S.qty=parseInt($('tmgQty').value);

// ---------------------------------------------------------------------------------------------------------------------
// dyo-emailme (16 Oct 2026): "Email me my design" -> Klaviyo "Designed Logo Mat" event (TMG account YvAftR, client API).
// The image is the 720 px on-screen preview, uploaded once per design. Nothing here can block Add to Cart.
const KL_COMPANY = 'YvAftR', KL_METRIC = 'Designed Logo Mat', KL_LIST = 'W7jPrt';
const EM = { sent: {}, url: {}, autoTimer: null };
function emDesignKey(){ try { return proofSignature(); } catch(e) { return String(S.grade) + '|' + String(S.size) + '|' + (S.file ? S.file.name + S.file.size : ''); } }
async function emPreviewImageUrl(){
  const k = emDesignKey();
  if (EM.url[k]) return EM.url[k];
  if (!S.previewUrl) return '';
  const blob = await (await fetch(S.previewUrl)).blob();
  const url = await uploadArtworkToShopify(new File([blob], 'my-logo-mat-design.png', { type: 'image/png' })) || '';
  if (url) EM.url[k] = url;
  return url;
}
async function emProps(img){
  const g = GRADES[S.grade] || {};
  const page = location.origin + location.pathname;
  return {
    ProofImageURL: img, Family: g.title || g.opt || String(S.grade || ''), Grade: g.opt || '',
    Size: (typeof isCustomSize === 'function' && isCustomSize() && typeof customSizeLabel === 'function') ? customSizeLabel() : (S.size ? sizeLabel(S.size) : ''),
    Quantity: S.qty || 1, ArtworkName: S.file ? S.file.name : '', PageURL: page,
    ResumeURL: page + '?' + (await rsQuery()) + 'utm_source=klaviyo&utm_medium=email&utm_campaign=designed-logo-mat', // dyo-resume: the link restores this design
    $value: (S.pricing && Number(S.pricing.total_price_aud)) || undefined
  };
}
async function emSendEvent(email, props){
  const body = { data: { type: 'event', attributes: { properties: props,
    metric: { data: { type: 'metric', attributes: { name: KL_METRIC } } },
    profile: { data: { type: 'profile', attributes: email ? { email } : {} } } } } };
  if (!email) { // identified visitor: the onsite object knows who they are
    if (window.klaviyo && typeof window.klaviyo.track === 'function') { window.klaviyo.track(KL_METRIC, props); return true; }
    return false;
  }
  const r = await fetch('https://a.klaviyo.com/client/events/?company_id=' + KL_COMPANY, { method: 'POST',
    headers: { 'content-type': 'application/vnd.api+json', revision: '2025-07-15' }, body: JSON.stringify(body) });
  return r.ok;
}
async function emSubscribe(email){
  const body = { data: { type: 'subscription', attributes: { custom_source: 'Logo mat configurator', profile: { data: { type: 'profile', attributes: {
    email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
    relationships: { list: { data: { type: 'list', id: KL_LIST } } } } };
  try { await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KL_COMPANY, { method: 'POST',
    headers: { 'content-type': 'application/vnd.api+json', revision: '2025-07-15' }, body: JSON.stringify(body) }); } catch(e) {}
}
function tmgEmailMeMount(){
  if (!S.file) return;
  let box = $('tmgEmailMe');
  if (!box) {
    const notes = $('tmgNotes'); const field = notes && notes.closest('.tmg-field'); if (!field) return;
    box = document.createElement('div'); box.id = 'tmgEmailMe'; box.className = 'tmg-field';
    box.style.cssText = 'margin-bottom:14px;padding:12px 14px;border:1px dashed var(--bd);border-radius:8px;background:var(--sf)';
    box.innerHTML = '<div style="font-size:13px;font-weight:700;margin-bottom:6px">Not ready to order? Email yourself this design</div>' +
      '<div style="display:flex;gap:8px;flex-wrap:wrap"><input class="tmg-input" type="email" id="tmgEmailMeAddr" placeholder="you@company.com.au" autocomplete="email" style="flex:1 1 200px">' +
      '<button type="button" class="tmg-btn" id="tmgEmailMeBtn" style="flex:0 0 auto;background:#1a1a1a;color:#fff;padding:9px 14px;border-radius:6px;border:none;font-weight:700;cursor:pointer">Email me my design</button></div>' +
      '<label style="display:flex;gap:6px;align-items:center;font-size:11px;color:var(--muted);margin-top:8px"><input type="checkbox" id="tmgEmailMeNews"> Also send me tips and offers from The Mat Group</label>' +
      '<div id="tmgEmailMeMsg" style="font-size:11px;color:var(--muted);margin-top:6px;line-height:1.4">We will email you a picture of this mat so you can share it or come back to it. Unsubscribe any time.</div>';
    field.parentNode.insertBefore(box, field);
    $('tmgEmailMeBtn').addEventListener('click', emClick);
    $('tmgEmailMeAddr').addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); emClick(); } });
  }
  const k = emDesignKey(), msg = $('tmgEmailMeMsg');
  if (EM.sent[k] && msg) msg.innerHTML = '<b style="color:var(--green)">Sent.</b> Check your inbox in a minute. Change anything and you can send the new version too.';
  emAutoForKnownVisitor();
}
async function emClick(){
  const addr = ($('tmgEmailMeAddr').value || '').trim(), msg = $('tmgEmailMeMsg'), btn = $('tmgEmailMeBtn');
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)) { msg.innerHTML = '<span style="color:var(--red)">Please check the email address.</span>'; return; }
  btn.disabled = true; btn.textContent = 'Sending...';
  try {
    const img = await emPreviewImageUrl();
    const ok = await emSendEvent(addr, await emProps(img));
    if ($('tmgEmailMeNews') && $('tmgEmailMeNews').checked) emSubscribe(addr);
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: addr }); } catch(e) {}
    if (!ok) throw new Error('not sent');
    EM.sent[emDesignKey()] = true;
    msg.innerHTML = '<b style="color:var(--green)">Sent.</b> Check your inbox in a minute. Change anything and you can send the new version too.';
  } catch(e) {
    msg.innerHTML = '<span style="color:var(--red)">Sorry, that did not send. Please try again, or use Download to save the picture.</span>';
  } finally { btn.disabled = false; btn.textContent = 'Email me my design'; }
}
// a visitor Klaviyo already knows: the same event, once per design, 30 s after the preview opens (they have looked at it)
function emAutoForKnownVisitor(){
  clearTimeout(EM.autoTimer);
  EM.autoTimer = setTimeout(async () => {
    try {
      if (S.step !== 4 || !S.file || !window.klaviyo || typeof window.klaviyo.isIdentified !== 'function') return;
      if (!(await window.klaviyo.isIdentified())) return;
      const k = emDesignKey(); if (EM.sent[k] || EM.sent['auto|' + k]) return;
      EM.sent['auto|' + k] = true;
      const img = await emPreviewImageUrl(); if (!img) return;
      await emSendEvent('', Object.assign(await emProps(img), { Source: 'auto - known visitor' }));
    } catch(e) {}
  }, 30000);
}

// ---------------------------------------------------------------------------------------------------------------------
// dyo-resume (19 Oct 2026): the emailed design comes back. ?design=<token> = the artwork's Cloudinary upload + every
// choice; the page replays the customer's own flow with those choices and lands on the Preview step. Any failure leaves
// a note and the normal flow (nothing here can break a visit without the parameter).
const RS_PARAM = 'design', RS_V = 1, RS_CLOUD = 'https://res.cloudinary.com/dmqkxg0qo/image/upload/';
const rsB64 = s => btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
const rsUnB64 = s => decodeURIComponent(escape(atob(s.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice(0, (4 - s.length % 4) % 4))));
const rsShort = u => (u && u.indexOf(RS_CLOUD) === 0) ? u.slice(RS_CLOUD.length) : (u || '');
const rsLong = u => (u && !/^https?:/.test(u)) ? RS_CLOUD + u : (u || '');
async function rsToken(){
  try {
    if (!S.file) return '';
    const a = await artworkUploadFor(S.file); if (!a) return '';
    const fill = !!S.useArtworkAsBg, b = (!fill && S.selectedBg && S.selectedBg.hex) ? S.selectedBg : null;
    const t = { v: RS_V, a: rsShort(a), n: String(S.file.name || 'logo.png').slice(0, 80), g: S.grade, s: S.size, r: $('tmgOri') ? $('tmgOri').value : 'landscape', q: S.qty || 1, p: S.placement || 'inside' };
    if (S.sourceUrl) t.o = rsShort(S.sourceUrl);
    if (isCustomSize()) t.c = [S.custom.L, S.custom.W];
    if (fill) t.f = 1; else if (b) t.b = [b.mm, b.hex, b.name || '', b.is_light ? 1 : 0];
    if (S.drainage != null) t.d = S.drainage ? 1 : 0;
    if (S.edging != null) t.e = S.edging ? 1 : 0;
    if (S.whiteBgKept) t.w = 1;
    if (S.colourOverrides && S.colourOverrides.map && Object.keys(S.colourOverrides.map).length) t.co = [S.colourOverrides.chart, S.colourOverrides.map];
    if (!fill && S.logoX != null && S.logoDw != null) t.l = [Math.round(S.logoX), Math.round(S.logoY), S.logoScale != null ? S.logoScale : 80];
    if (S.genUsed) t.ai = 1;
    if (S.step && S.step !== 1) t.st = S.step; // draft1021: where they were (3 Configure, 2 Background, 4 Preview, 5 Order)
    return rsB64(JSON.stringify(t));
  } catch(e) { return ''; }
}
async function rsQuery(){ const tk = await rsToken(); return tk ? RS_PARAM + '=' + tk + '&' : ''; }
function rsParse(){ try { const m = new URLSearchParams(location.search).get(RS_PARAM); if (!m) return null; const t = JSON.parse(rsUnB64(m)); return (t && t.v === RS_V && t.a) ? t : null; } catch(e) { return null; } }
const rsWait = ms => new Promise(r => setTimeout(r, ms));
async function rsUntil(fn, ms, step){ const t0 = Date.now(); while (Date.now() - t0 < (ms || 20000)) { try { if (fn()) return true; } catch(e) {} await rsWait(step || 150); } return false; }
function rsNote(){
  let el = $('tmgResumeNote');
  if (!el) {
    el = document.createElement('div'); el.id = 'tmgResumeNote';
    el.style.cssText = 'margin:0 0 14px;padding:12px 14px;border-radius:8px;border:1px solid #f05322;background:rgba(240,83,34,0.10);color:var(--txt,#fff);font-size:13px;line-height:1.5';
    const host = $('tmgHdr') || $('tmgUploadSection') || $('tmgGetStarted');
    if (host && host.parentNode) host.parentNode.insertBefore(el, host); else document.body.insertBefore(el, document.body.firstChild);
  }
  return { set(html, kind){ el.innerHTML = html; el.style.borderColor = kind === 'warn' ? '#e0b000' : kind === 'ok' ? '#2ea043' : '#f05322'; el.style.background = kind === 'warn' ? 'rgba(224,176,0,0.12)' : kind === 'ok' ? 'rgba(46,160,67,0.12)' : 'rgba(240,83,34,0.10)'; }, el };
}
async function rsResume(t){
  const note = rsNote(); note.set('<b>Bringing your saved design back&hellip;</b> This takes about 15 seconds while we check the artwork again.');
  window.__tmgResume = { state: 'running', at: Date.now() };
  try {
    if ($('tmgGetStarted') && $('tmgGetStarted').style.display !== 'none') $('tmgStartBtn').click();
    // 1. the artwork, from the upload made for the emailed design
    const res = await fetch(rsLong(t.a), { mode: 'cors' }); if (!res.ok) throw new Error('artwork ' + res.status);
    const blob = await res.blob(); if (!blob || !blob.size) throw new Error('artwork empty');
    const file = new File([blob], t.n || 'logo.png', { type: blob.type || 'image/png' });
    S.genUsed = false; S.genAutoBg = null; S.genFamily = null;
    if (typeof genConfigureLayout === 'function') genConfigureLayout(); // an upload gets the full Configure step (as prepareArtwork)
    S.sourceFile = null; S.sourceUrl = t.o ? rsLong(t.o) : null; S.sourceNote = null;
    handleFileReady(file);
    if (!S.file) throw new Error('file not accepted');
    await rsWait(300);
    // 2. Configure: size / custom size, orientation, placement
    $('tmgTo2').click();
    if (!(await rsUntil(() => S.step === 3, 5000))) throw new Error('configure step');
    if ($('tmgOri') && t.r) $('tmgOri').value = t.r;
    if (t.c && t.c[0] && t.c[1]) {
      try { openCustomSize(true); } catch(e) {}
      if ($('tmgCustL')) $('tmgCustL').value = t.c[0]; if ($('tmgCustW')) $('tmgCustW').value = t.c[1];
      setCustomDims(t.c[0], t.c[1]); syncSizeSelect(); try { renderCustomHint(); customDiagram(); } catch(e) {}
    } else if (t.s && /^\d+x\d+$/.test(t.s)) { ensureSizeOption(t.s); S.custom = null; setPickSize(t.s); }
    if (t.p && PLACEMENTS[t.p] && S.placement !== t.p) setPlacement(t.p);
    fetchPricing();
    await rsWait(200);
    if (t.st === 3) { dsDone(note, t); return; } // draft1021: they were on Configure
    // 3. the artwork check (Railway, ~10 s) -> Background step
    $('tmgTo4').click();
    if (!(await rsUntil(() => S.step === 2 && $('tmgBgPanel') && $('tmgBgPanel').style.display === 'block', 60000, 200))) throw new Error('analysis');
    await rsWait(300);
    // 4. the choices the customer made
    if (t.g && GRADES[t.g] && S.grade !== t.g) applyGrade(t.g);
    if (t.d != null) setDrainage(!!t.d);
    if (t.e != null) setEdging(!!t.e);
    if (t.w && S.whiteBgDetected && S.dropLogoBg && typeof transpLocalToggle === 'function') transpLocalToggle();
    if (t.f) { if (!S.useArtworkAsBg) setFillMode(true); }
    else if (t.b && t.b[1]) { S.bgSrc = 'saved design'; selectBg(t.b[0], t.b[1], t.b[2] || '', !!t.b[3]); }
    if (t.co && t.co[1]) { try { S.colourOverrides = { chart: t.co[0], map: t.co[1] }; cachedLogo = null; refreshArtworkForBudget(); } catch(e) {} }
    if (t.q) setQty(t.q);
    await rsWait(500);
    if (t.st === 2) { dsDone(note, t); return; } // draft1021: they were on Background (a colour may not be chosen yet)
    if (!S.selectedBg && !S.useArtworkAsBg) throw new Error('no background');
    // 5. Preview, then the logo where they left it
    $('tmgTo3').click();
    if (!(await rsUntil(() => S.step === 4 && S.logoDw != null, 30000, 150))) throw new Error('preview');
    if (t.l && !S.useArtworkAsBg) {
      S.logoScale = Math.max(20, Math.min(100, Math.round(+t.l[2]) || 80));
      if ($('tmgLogoSize')) $('tmgLogoSize').value = S.logoScale; if ($('tmgLogoSizeLabel')) $('tmgLogoSizeLabel').textContent = S.logoScale + '%';
      S.logoX = Math.round(+t.l[0]); S.logoY = Math.round(+t.l[1]); renderCanvas();
      await rsWait(300);
    }
    dsDone(note, t);
    try { const c = $('tmgCVW') || $('tmgCanvas'); if (c) c.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch(e) {}
  } catch(e) {
    console.warn('[TMG] resume failed', e);
    window.__tmgResume = { state: 'failed', why: String(e && e.message || e), at: Date.now() };
    note.set('<b>We could not bring your saved design back automatically.</b> Please upload your logo again below, or reply to our email and we will set it up for you.', 'warn');
  }
}
// ---------------------------------------------------------------------------------------------------------------------
// draft1021 (20 Oct 2026): "Continue your design". The design in progress lives in this browser as the same token the
// emailed link uses (rsToken) plus the step; a card offers to bring it back on the next visit. Cleared on Add to Cart.
// Nothing here can block a visit: every call is wrapped, and a replay failure leaves the normal flow (rsResume).
const DS_KEY = 'tmg_dyo_draft', DS_MAX_AGE = 30 * 86400000;
let _dsSig = '', _dsTimer = null;
function dsEsc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }
function dsRead(){ try { const d = JSON.parse(localStorage.getItem(DS_KEY) || 'null'); return (d && d.v === 1 && d.t && d.at && Date.now() - d.at < DS_MAX_AGE) ? d : null; } catch(e) { return null; } }
function dsClear(){ try { localStorage.removeItem(DS_KEY); } catch(e) {} _dsSig = 'cleared'; const c = $('tmgDraftCard'); if (c) c.remove(); }
function dsSig(){ return [S.step, S.grade, S.size, S.qty, S.placement, S.useArtworkAsBg ? 1 : 0, S.selectedBg && S.selectedBg.hex, S.drainage, S.edging, S.whiteBgKept ? 1 : 0, S.logoX, S.logoY, S.logoScale, S.custom && S.custom.L, S.custom && S.custom.W, S.file && S.file.name, S.file && S.file.size, $('tmgOri') ? $('tmgOri').value : ''].join('|'); }
async function dsSave(){
  try {
    if (!S.file || !S.step || S.step === 1 || S.step === 5) return;
    if (window.__tmgResume && window.__tmgResume.state === 'running') return;
    const sig = dsSig(); if (sig === _dsSig) return;
    const tk = await rsToken(); if (!tk) return;
    _dsSig = sig;
    const g = GRADES[S.grade] || {};
    const size = (typeof isCustomSize === 'function' && isCustomSize() && typeof customSizeLabel === 'function') ? customSizeLabel() : (S.size ? sizeLabel(S.size) : '');
    localStorage.setItem(DS_KEY, JSON.stringify({ v: 1, t: tk, step: S.step, at: Date.now(), name: String(S.file.name || '').slice(0, 80), family: g.title || g.opt || '', size }));
  } catch(e) {}
}
function dsOnStep(){ clearTimeout(_dsTimer); _dsTimer = setTimeout(dsSave, 1200); }
setInterval(() => { try { dsSave(); } catch(e) {} }, 5000);
document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') { try { dsSave(); } catch(e) {} } });
function dsRelTime(at){ const m = Math.round((Date.now() - at) / 60000); if (m < 60) return m <= 1 ? 'a minute ago' : m + ' minutes ago'; const h = Math.round(m / 60); if (h < 24) return h === 1 ? 'an hour ago' : h + ' hours ago'; const d = Math.round(h / 24); return d === 1 ? 'yesterday' : d + ' days ago'; }
function dsDone(note, t){
  note.set(t && t.src === 'draft' ? '<b>Welcome back.</b> This is the design you were working on. Carry on from here.' : '<b>Welcome back.</b> This is the design you emailed yourself. Check it over, change anything you like, then <b>Add to Cart</b>.', 'ok');
  window.__tmgResume = { state: 'done', at: Date.now(), step: S.step, src: (t && t.src) || 'email' };
  setTimeout(() => { try { note.el.style.display = 'none'; } catch(e) {} }, 20000);
}
function dsCard(){
  try {
    const d = dsRead(); if (!d || rsParse() || $('tmgDraftCard')) return;
    let t; try { t = JSON.parse(rsUnB64(d.t)); } catch(e) { return; } if (!t || t.v !== RS_V || !t.a) return;
    const gate = $('tmgGetStarted'), drop = $('tmgDrop');
    const anchor = (gate && gate.style.display !== 'none') ? gate : drop; if (!anchor || !anchor.parentNode) return;
    const card = document.createElement('div'); card.id = 'tmgDraftCard';
    card.style.cssText = 'display:flex;gap:14px;align-items:center;flex-wrap:wrap;margin:0 0 16px;padding:14px 16px;border:1px solid #f05322;border-radius:10px;background:rgba(240,83,34,0.08)';
    card.innerHTML = '<img src="' + dsEsc(rsLong(t.a)) + '" alt="" style="width:64px;height:64px;object-fit:contain;border-radius:8px;background:#fff;flex:0 0 64px">' +
      '<div style="flex:1 1 200px;min-width:0"><div style="font-weight:700;font-size:15px">Continue your design?</div>' +
      '<div style="font-size:12.5px;color:var(--muted);margin-top:3px;overflow-wrap:anywhere">' + dsEsc(d.name || 'Your artwork') + (d.family ? ' on ' + dsEsc(d.family) : '') + (d.size ? ', ' + dsEsc(d.size) : '') + ' - saved ' + dsRelTime(d.at) + '</div></div>' +
      '<div style="display:flex;gap:8px;flex:0 0 auto;flex-wrap:wrap"><button type="button" id="tmgDraftGo" style="background:#f05322;color:#fff;border:none;padding:10px 16px;border-radius:6px;cursor:pointer;font:inherit;font-weight:700">Continue</button>' +
      '<button type="button" id="tmgDraftNo" style="background:transparent;color:var(--muted);border:1px solid var(--bd);padding:10px 12px;border-radius:6px;cursor:pointer;font:inherit">Start fresh</button></div>';
    anchor.parentNode.insertBefore(card, anchor);
    $('tmgDraftNo').addEventListener('click', () => dsClear());
    $('tmgDraftGo').addEventListener('click', () => { card.remove(); t.src = 'draft'; if (!t.st) t.st = d.step; rsResume(t); });
  } catch(e) {}
}
window.__tmgDraft = { read: dsRead, clear: dsClear, save: dsSave, card: dsCard, key: DS_KEY };
const _rsT = rsParse();
if (_rsT) { const go = () => setTimeout(() => rsResume(_rsT), 500); if (document.readyState === 'complete') go(); else window.addEventListener('load', go); }
else { const goD = () => setTimeout(dsCard, 300); if (document.readyState === 'complete') goD(); else window.addEventListener('load', goD); }

})();

// cache-bump 2026-10-14: new asset ?v so browsers that cached a stale CDN copy during the coir / ux1014e rollout fetch the current build
